// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptFasPredictions, acceptLedgerPredictions, acceptTerms, acknowledgeAgbwIssues, addAccountMappingLevel3Target, addDepartmentAdmin, addEmailWhitelistPattern, addProjectMember, analyzeWorkflowActionSqlParameters, approve, approveIndividualWorkflow, approvePromotionRequest, archiveProject, archiveStatementTaxonomy, assignUserRole, batchCreateClients, bulkCreateOriginDatasources, bulkUpdateClientTags, cancel, cancelPromotionRequest, cancelRun, classifyAccountMappings, classifyScopedAccountMappings, clearAccountMappings, clearBatchFiles, clearCamtFiles, clearLedgerClassifications, cloneWorkflow, cloneWorkflowAction, cloneWorkflowSet, compareDocuments, confirmAuditPreviousReportStage, confirmAuditStatementExtractionStage, confirmStatementExtractionStage, confirmUpload, copyAccountMappings, copyClassifications, copyLedgerClassifications, copyWorkflowAction, createArticle, createArticleTemplate, createBugReport, createChatFromExecution, createClassificationTemplate, createClientTag, createCollection, createDashboard, createDashboardChainWidget, createDashboardWidget, createDatasource, createDepartment, createDocumentAnalysisTemplate, createFaq, createFeedback, createFinancialExplorerChat, createLedgerClassificationTemplate, createOrganization, createOrigin, createOrUpdateComment, createOrUpdateConfirmation, createProject, createProjectHierarchy, createPromotionRequest, createPrompt, createReleaseNote, createSchedule, createStatementTaxonomy, createTemplateVersion, createTopic, createWidgetChat, createWorkflow, createWorkflowAction, createWorkflowSet, deconfirmAuditPreviousReportStage, deconfirmAuditStatementExtractionStage, deconfirmStatementExtractionStage, deleteAllTrialBalanceEntries, deleteAnalysisRun, deleteArticle, deleteArticleTemplate, deleteAuditCheck, deleteAuditFiles, deleteClassificationTemplate, deleteClientTag, deleteCollection, deleteComment, deleteConfirmation, deleteConversation, deleteDashboard, deleteDashboardWidget, deleteDatasources, deleteDocumentAnalysisTemplate, deleteFaq, deleteMedia, deleteOrganization, deleteOrganizationFile, deleteOrigin, deleteProject, deletePrompt, deleteReleaseNote, deleteSchedule, deleteTopic, deleteTrainingCompletion, deleteTrialBalanceEntry, deleteUser, deleteWorkflow, deleteWorkflowAction, deleteWorkflowSet, demote, disconnectProjectVectorizedDatasource, dislikeArticle, documentAnalysisSearch, downloadAuditFile, downloadMedia, duplicateDocumentAnalysisTemplate, exportAccountMappings, exportAccountsDrilldown, exportAgbwOutput, exportAuditReconciliation, exportAuditReconciliationExcel, exportBatchDrilldown, exportChangedIbanDrilldown, exportClassificationResultsExcel, exportClassifications, exportContinuousAuditorTransactions, exportCorporateFinanceWorkbook, exportCpiPaymentsDrilldown, exportCpiReceivedDrilldown, exportCreditcardStatementsDrilldown, exportData, exportDatasource, exportDocumentAnalysisRunResultsAsExcel, exportDocumentAnalysisRunResultsAsPdf, exportForeignCurrencyDrilldown, exportGovernmentDrilldown, exportIbanSalaryOtherPaymentsDrilldown, exportIntercompanyPaymentsDrilldown, exportLedgerClassifications, exportMissingIbanPaymentsDrilldown, exportMissingIbanReceivedDrilldown, exportNameChangeDrilldown, exportNewPartyDrilldown, exportNotableDescriptionDrilldown, exportRecurrentPaymentsDrilldown, exportSameIbanTransactionsDrilldown, exportTrialBalance, exportValidationResults, exportWeekVacationDaysDrilldown, generateActionTechnicalExplanation, generateTwoFa, getAccountMappingExportStatus, getAccountsDrilldown, getAccountsSummary, getActiveProjectPipeline, getAgbwContinueAcknowledgment, getAgbwPipelineStatus, getAgbwProgress, getAllOrganizations, getAllUsers, getAnalysisRunResults, getAnnualReportPipelineStatus, getArticle, getArticles, getArticleTemplate, getArticleTemplates, getAuditChecks, getAuditReconciliationExportStatus, getBatchDrilldown, getBatchPurchaseOverview, getBatchSalaryOverview, getBatchSummary, getChangedIbanAggregation, getChangedIbanDrilldown, getClassificationPipelineStatus, getClassificationStats, getClassificationTemplate, getClientAnalysisRuns, getCollection, getCollectionFilters, getCollectionShare, getComment, getCommentsForDashboard, getConfirmation, getConfirmationsForDashboard, getContinuousAuditorRefreshPipelineStatus, getConversations, getCpiPaymentsAggregation, getCpiPaymentsDrilldown, getCpiPreference, getCpiReceivementsAggregation, getCpiReceivementsDrilldown, getCreditcardStatementsAggregation, getCreditcardStatementsDrilldown, getCurrentTerms, getCurrentUser, getCurrentUserInvitations, getCurrentUserPermission, getDashboard, getDashboardFilterValues, getDashboards, getDatasourceById, getDatasourceFile, getDatasourceFilters, getDatasources, getDatasourcesPage, getDocumentAnalysisSettings, getDocumentAnalysisTemplate, getDocumentAnalysisTemplates, getEmailWhitelistPatterns, getEvents, getExecutionReport, getExecutionResults, getFaqs, getFinancialExplorer, getFinancialExplorerReconciliation, getFinancialExplorerTransactionFilterValues, getFinancialExplorerTransactions, getForeignCurrencyAggregation, getForeignCurrencyDrilldown, getGovernmentAggregation, getGovernmentDrilldown, getIbanSalaryOtherPaymentsAggregation, getIbanSalaryOtherPaymentsDrilldown, getIntercompanyPaymentsAggregation, getIntercompanyPaymentsDrilldown, getLatestClassificationTemplateVersion, getLedgerExportStatus, getLedgerStats, getMaterialityPreference, getMediaMetadata, getMissingIbanPaymentsAggregation, getMissingIbanPaymentsDrilldown, getMissingIbanReceivedAggregation, getMissingIbanReceivedDrilldown, getMultipleIbansPerKvk, getNameChangeAggregation, getNameChangeDrilldown, getNewPartyAggregation, getNewPartyDrilldown, getOrganization, getOrganizationDepartments, getOrganizationFile, getOrganizationInvitations, getOrganizationProjectParameters, getOrganizationUserPermissions, getOrganizationUserProfile, getOrganizationUserProfiles, getOrganizationUsers, getOrgReviewSessionDetail, getOrgReviewToolOutput, getOrgReviewTurnInspector, getOrigin, getPaymentCategoryPivot, getPaymentOverview, getPaymentTypes, getPendingDocumentAnalysisTemplateForPromotionReview, getPermissions, getPersonalAnalysisRuns, getPossibleDuplicatePayments, getPreview, getProjectAuditFileGlCoverage, getProjectDatasources, getProjectExecutionHistory, getProjectFilters, getProjectHierarchy, getProjectMembers, getProjectParameters, getProjects, getPromotionRequest, getPrompt, getPromptLibrary, getPromptShares, getReceivablesByCounterpartyOverview, getRecurrentPaymentsAggregation, getRecurrentPaymentsDrilldown, getRefreshAfasDataPipelineStatus, getRefreshAuditFilePipelineStatus, getReleaseNoteById, getReleaseNotes, getRoles, getRun, getSameIbanTransactionsAggregation, getSameIbanTransactionsDrilldown, getSchedule, getSharedDashboard, getSharedDatasource, getSourceStatus, getSpecialDescriptionAggregation, getSpecialDescriptionDrilldown, getTemplateAnalysisRuns, getTermsAcceptanceStatus, getTermsDocument, getTopics, getTrainingOverview, getTransactionDrilldown, getTransactionFilterValues, getTransactionOverview, getTransactions, getTrialBalanceEntries, getTrialBalancePipelineStatus, getUniqueCounterpartiesMultipleIbans, getUsageSessionDetail, getUsageToolOutput, getUsageTurnInspector, getUser, getWeekVacationDaysAggregation, getWeekVacationDaysDrilldown, getWorkflowAction, getWorkflowActions, getWorkflowSets, hardDeletePromotionRequest, health, importPriorYearClassifications, improvePrompt, incrementArticleViews, incrementFaqViews, info, inviteUserToOrganizationByEmail, jwtForgotPassword, jwtLogin, jwtLogout, jwtRefresh, jwtRegister, jwtRequestVerifyToken, jwtResetPassword, jwtVerify, latestAuditBudgetReconciliation, latestAuditStatementExtraction, latestAuditStatementExtractionJobs, latestAuditStatementReferenceReconciliation, latestStatementExtraction, likeArticle, listAccountMappings, listAuditFiles, listClassifications, listClassificationTemplates, listClassificationTemplateVersions, listClientTags, listCollections, listCollectionsPage, listCopyClassificationSources, listDepartmentAdmins, listGroupedAuditOriginGroups, listLedgerAccounts, listLedgerCopySources, listLedgerTargets, listNotifications, listOrgReviewSessions, listOrgReviewSessionUsers, listOrgRuns, listOrigins, listOriginTables, listProjectTypes, listProjectVectorizedDatasources, listPromotionRequests, listRuns, listSchedules, listStatementTaxonomies, listUsageSessions, listUsageSessionUsers, liveness, markAllRead, markRead, moveResourcesToOrganization, moveUserToOrganization, moveWorkflowAction, newMessageFeedback, type Options, patchCollectionShare, patchPromptShares, patchSharedDashboard, patchSharedDatasource, placeWorkflow, placeWorkflowSet, predictClassifications, predictFasClassifications, predictLedgerClassifications, publishArticle, publishFaq, publishPrompt, publishReleaseNote, publishStatementTaxonomy, putOrgReviewFeedback, putUsageReviewFeedback, queryClassificationTemplateData, readDefaultStatementTaxonomy, readFasClassifications, readiness, readLedgerTemplateQuery, readProjectStatementTaxonomy, readStatementTaxonomy, recordTrainingCompletions, recoverTwoFa, refreshClassifications, refreshDashboard, refreshDashboardWidget, refreshLedgerAccounts, reindexPdfDatasources, reject, rejectIndividualWorkflow, rejectPromotionRequest, removeDepartmentAdmin, removeEmailWhitelistPattern, removeInvitation, removeProjectMember, removeUserFromOrganization, renameClientTag, reorderWorkflow, reorderWorkflowAction, reorderWorkflowSet, replaceAllTrialBalanceEntries, replaceAuditPreviousReportStage, replaceAuditStatementExtractionCategories, replaceAuditStatementExtractionStage, replaceStatementExtractionStage, requestUploadUrls, rerunClientChecks, rerunSingleCheckForClient, rerunValidationCheck, resetIndividualWorkflowApproval, resetOrganizationUserTwoFa, resetUserAiLimit, resetUserTwoFa, responseUserToInvitation, restartAuditStatementExtractionJob, restoreProject, restoreUser, resume, revertPromotionRequest, revokeUserRole, runContinuousAuditorRefreshPipeline, runDebugQuery, runDocumentAnalysisPipeline, runRefreshAfasDataPipeline, runRefreshAuditFilePipeline, saveAccountMappings, saveAgbwProgress, saveClassifications, saveFasClassifications, saveLedgerClassifications, searchProjectEntities, selectProjectStatementTaxonomy, sendContactMessage, setAuditCheck, setClientTags, setDepartmentMembers, setPipelineExecutionStatus, setWorkflowClientTags, setWorkflowExcelTemplate, snapshotClassifications, snapshotLedgerAccounts, startAgbwPrechecksPipeline, startAuditPreviousReportExtraction, startAuditStatementExtraction, startStatementExtraction, startStatementExtractionDeepStage, submitForApproval, submitIndividualWorkflow, testOriginConnection, toggleConfirmation, toggleHelpdeskAgentStatus, toggleSuperuserStatus, toMaintenance, triggerManualRun, unapprove, unpublishArticle, unpublishFaq, unpublishReleaseNote, unreadCount, unsuspendUser, updateArticle, updateArticleTemplate, updateCollection, updateConversation, updateCpiPreference, updateCurrentUser, updateDashboard, updateDashboardWidgetName, updateDashboardWidgetPosition, updateDashboardWidgetType, updateDatasource, updateDepartment, updateDocumentAnalysisRecord, updateDocumentAnalysisSettings, updateDocumentAnalysisTemplate, updateFaq, updateLedgerTemplateQuery, updateMaterialityPreference, updateMaterialityThresholds, updateOrganization, updateOrganizationUserContext, updateOrganizationWorkosId, updateOrigin, updatePendingDocumentAnalysisTemplateForPromotionReview, updateProject, updateProjectStatus, updatePrompt, updateReleaseNote, updateSchedule, updateStatementTaxonomy, updateTopic, updateUser, updateUserEmail, updateUserInOrganization, updateWorkflow, updateWorkflowAction, updateWorkflowSet, uploadAuditFiles, uploadHelpCenterMedia, upsertProjectFileDatasource, useArticleTemplate, verifyTwoFa, verifyTwoFaSignin, verifyUser, workosAuthorize, workosCallback, workosLogout, workosRefresh } from '../sdk.gen';
import type { AcceptFasPredictionsData, AcceptFasPredictionsError, AcceptFasPredictionsResponse, AcceptLedgerPredictionsData, AcceptLedgerPredictionsError, AcceptLedgerPredictionsResponse, AcceptTermsData, AcceptTermsError, AcceptTermsResponse, AcknowledgeAgbwIssuesData, AcknowledgeAgbwIssuesError, AcknowledgeAgbwIssuesResponse, AddAccountMappingLevel3TargetData, AddAccountMappingLevel3TargetError, AddAccountMappingLevel3TargetResponse, AddDepartmentAdminData, AddDepartmentAdminError, AddDepartmentAdminResponse, AddEmailWhitelistPatternData, AddEmailWhitelistPatternError, AddEmailWhitelistPatternResponse, AddProjectMemberData, AddProjectMemberError, AddProjectMemberResponse, AnalyzeWorkflowActionSqlParametersData, AnalyzeWorkflowActionSqlParametersError, AnalyzeWorkflowActionSqlParametersResponse, ApproveData, ApproveError, ApproveIndividualWorkflowData, ApproveIndividualWorkflowError, ApproveIndividualWorkflowResponse, ApprovePromotionRequestData, ApprovePromotionRequestError, ApprovePromotionRequestResponse, ApproveResponse, ArchiveProjectData, ArchiveProjectError, ArchiveProjectResponse, ArchiveStatementTaxonomyData, ArchiveStatementTaxonomyError, ArchiveStatementTaxonomyResponse, AssignUserRoleData, AssignUserRoleError, AssignUserRoleResponse, BatchCreateClientsData, BatchCreateClientsError, BatchCreateClientsResponse, BulkCreateOriginDatasourcesData, BulkCreateOriginDatasourcesError, BulkCreateOriginDatasourcesResponse, BulkUpdateClientTagsData, BulkUpdateClientTagsError, BulkUpdateClientTagsResponse, CancelData, CancelError, CancelPromotionRequestData, CancelPromotionRequestError, CancelPromotionRequestResponse, CancelResponse, CancelRunData, CancelRunError, CancelRunResponse, ClassifyAccountMappingsData, ClassifyAccountMappingsError, ClassifyAccountMappingsResponse, ClassifyScopedAccountMappingsData, ClassifyScopedAccountMappingsError, ClassifyScopedAccountMappingsResponse, ClearAccountMappingsData, ClearAccountMappingsError, ClearAccountMappingsResponse, ClearBatchFilesData, ClearBatchFilesError, ClearCamtFilesData, ClearCamtFilesError, ClearLedgerClassificationsData, ClearLedgerClassificationsError, ClearLedgerClassificationsResponse2, CloneWorkflowActionData, CloneWorkflowActionError, CloneWorkflowActionResponse, CloneWorkflowData, CloneWorkflowError, CloneWorkflowResponse, CloneWorkflowSetData, CloneWorkflowSetError, CloneWorkflowSetResponse, CompareDocumentsData, CompareDocumentsError, CompareDocumentsResponse, ConfirmAuditPreviousReportStageData, ConfirmAuditPreviousReportStageError, ConfirmAuditPreviousReportStageResponse, ConfirmAuditStatementExtractionStageData, ConfirmAuditStatementExtractionStageError, ConfirmAuditStatementExtractionStageResponse, ConfirmStatementExtractionStageData, ConfirmStatementExtractionStageError, ConfirmStatementExtractionStageResponse, ConfirmUploadData, ConfirmUploadError, ConfirmUploadResponse, CopyAccountMappingsData, CopyAccountMappingsError, CopyAccountMappingsResponse, CopyClassificationsData, CopyClassificationsError, CopyClassificationsResponse2, CopyLedgerClassificationsData, CopyLedgerClassificationsError, CopyLedgerClassificationsResponse, CopyWorkflowActionData, CopyWorkflowActionError, CopyWorkflowActionResponse, CreateArticleData, CreateArticleError, CreateArticleResponse, CreateArticleTemplateData, CreateArticleTemplateError, CreateArticleTemplateResponse, CreateBugReportData, CreateBugReportError, CreateBugReportResponse, CreateChatFromExecutionData, CreateChatFromExecutionError, CreateChatFromExecutionResponse, CreateClassificationTemplateData, CreateClassificationTemplateError, CreateClassificationTemplateResponse, CreateClientTagData, CreateClientTagError, CreateClientTagResponse, CreateCollectionData, CreateCollectionError, CreateCollectionResponse, CreateDashboardChainWidgetData, CreateDashboardChainWidgetError, CreateDashboardChainWidgetResponse, CreateDashboardData, CreateDashboardError, CreateDashboardResponse, CreateDashboardWidgetData, CreateDashboardWidgetError, CreateDashboardWidgetResponse, CreateDatasourceData, CreateDatasourceError, CreateDatasourceResponse, CreateDepartmentData, CreateDepartmentError, CreateDepartmentResponse, CreateDocumentAnalysisTemplateData, CreateDocumentAnalysisTemplateError, CreateDocumentAnalysisTemplateResponse, CreateFaqData, CreateFaqError, CreateFaqResponse, CreateFeedbackData, CreateFeedbackError, CreateFeedbackResponse, CreateFinancialExplorerChatData, CreateFinancialExplorerChatError, CreateFinancialExplorerChatResponse, CreateLedgerClassificationTemplateData, CreateLedgerClassificationTemplateError, CreateLedgerClassificationTemplateResponse, CreateOrganizationData, CreateOrganizationError, CreateOrganizationResponse, CreateOriginData, CreateOriginError, CreateOriginResponse, CreateOrUpdateCommentData, CreateOrUpdateCommentError, CreateOrUpdateCommentResponse, CreateOrUpdateConfirmationData, CreateOrUpdateConfirmationError, CreateOrUpdateConfirmationResponse, CreateProjectData, CreateProjectError, CreateProjectHierarchyData, CreateProjectHierarchyError, CreateProjectHierarchyResponse, CreateProjectResponse, CreatePromotionRequestData, CreatePromotionRequestError, CreatePromotionRequestResponse, CreatePromptData, CreatePromptError, CreatePromptResponse, CreateReleaseNoteData, CreateReleaseNoteError, CreateReleaseNoteResponse, CreateScheduleData, CreateScheduleError, CreateScheduleResponse, CreateStatementTaxonomyData, CreateStatementTaxonomyError, CreateStatementTaxonomyResponse, CreateTemplateVersionData, CreateTemplateVersionError, CreateTemplateVersionResponse, CreateTopicData, CreateTopicError, CreateTopicResponse, CreateWidgetChatData, CreateWidgetChatError, CreateWidgetChatResponse, CreateWorkflowActionData, CreateWorkflowActionError, CreateWorkflowActionResponse, CreateWorkflowData, CreateWorkflowError, CreateWorkflowResponse, CreateWorkflowSetData, CreateWorkflowSetError, CreateWorkflowSetResponse, DeconfirmAuditPreviousReportStageData, DeconfirmAuditPreviousReportStageError, DeconfirmAuditPreviousReportStageResponse, DeconfirmAuditStatementExtractionStageData, DeconfirmAuditStatementExtractionStageError, DeconfirmAuditStatementExtractionStageResponse, DeconfirmStatementExtractionStageData, DeconfirmStatementExtractionStageError, DeconfirmStatementExtractionStageResponse, DeleteAllTrialBalanceEntriesData, DeleteAllTrialBalanceEntriesError, DeleteAllTrialBalanceEntriesResponse, DeleteAnalysisRunData, DeleteAnalysisRunError, DeleteArticleData, DeleteArticleError, DeleteArticleResponse, DeleteArticleTemplateData, DeleteArticleTemplateError, DeleteArticleTemplateResponse, DeleteAuditCheckData, DeleteAuditCheckError, DeleteAuditFilesData, DeleteAuditFilesError, DeleteClassificationTemplateData, DeleteClassificationTemplateError, DeleteClientTagData, DeleteClientTagError, DeleteCollectionData, DeleteCollectionError, DeleteCollectionResponse, DeleteCommentData, DeleteCommentError, DeleteCommentResponse, DeleteConfirmationData, DeleteConfirmationError, DeleteConfirmationResponse, DeleteConversationData, DeleteConversationError, DeleteDashboardData, DeleteDashboardError, DeleteDashboardWidgetData, DeleteDashboardWidgetError, DeleteDatasourcesData, DeleteDatasourcesError, DeleteDocumentAnalysisTemplateData, DeleteDocumentAnalysisTemplateError, DeleteFaqData, DeleteFaqError, DeleteFaqResponse, DeleteMediaData, DeleteMediaError, DeleteMediaResponse, DeleteOrganizationData, DeleteOrganizationError, DeleteOrganizationFileData, DeleteOrganizationFileError, DeleteOrganizationFileResponse, DeleteOriginData, DeleteOriginError, DeleteProjectData, DeleteProjectError, DeletePromptData, DeletePromptError, DeleteReleaseNoteData, DeleteReleaseNoteError, DeleteReleaseNoteResponse, DeleteScheduleData, DeleteScheduleError, DeleteScheduleResponse, DeleteTopicData, DeleteTopicError, DeleteTopicResponse, DeleteTrainingCompletionData, DeleteTrainingCompletionError, DeleteTrainingCompletionResponse, DeleteTrialBalanceEntryData, DeleteTrialBalanceEntryError, DeleteUserData, DeleteUserError, DeleteUserResponse, DeleteWorkflowActionData, DeleteWorkflowActionError, DeleteWorkflowData, DeleteWorkflowError, DeleteWorkflowSetData, DeleteWorkflowSetError, DemoteData, DemoteError, DemoteResponse, DisconnectProjectVectorizedDatasourceData, DisconnectProjectVectorizedDatasourceError, DislikeArticleData, DislikeArticleError, DislikeArticleResponse, DocumentAnalysisSearchData, DocumentAnalysisSearchError, DocumentAnalysisSearchResponse, DownloadAuditFileData, DownloadAuditFileError, DownloadMediaData, DownloadMediaError, DuplicateDocumentAnalysisTemplateData, DuplicateDocumentAnalysisTemplateError, DuplicateDocumentAnalysisTemplateResponse, ExportAccountMappingsData, ExportAccountMappingsError, ExportAccountMappingsResponse, ExportAccountsDrilldownData, ExportAccountsDrilldownError, ExportAgbwOutputData, ExportAgbwOutputError, ExportAuditReconciliationData, ExportAuditReconciliationError, ExportAuditReconciliationExcelData, ExportAuditReconciliationExcelError, ExportAuditReconciliationExcelResponse, ExportAuditReconciliationResponse, ExportBatchDrilldownData, ExportBatchDrilldownError, ExportChangedIbanDrilldownData, ExportChangedIbanDrilldownError, ExportClassificationResultsExcelData, ExportClassificationResultsExcelError, ExportClassificationsData, ExportClassificationsError, ExportContinuousAuditorTransactionsData, ExportContinuousAuditorTransactionsError, ExportContinuousAuditorTransactionsResponse, ExportCorporateFinanceWorkbookData, ExportCorporateFinanceWorkbookError, ExportCorporateFinanceWorkbookResponse, ExportCpiPaymentsDrilldownData, ExportCpiPaymentsDrilldownError, ExportCpiReceivedDrilldownData, ExportCpiReceivedDrilldownError, ExportCreditcardStatementsDrilldownData, ExportCreditcardStatementsDrilldownError, ExportDataData, ExportDataError, ExportDataResponse, ExportDatasourceData, ExportDatasourceError, ExportDatasourceResponse, ExportDocumentAnalysisRunResultsAsExcelData, ExportDocumentAnalysisRunResultsAsExcelError, ExportDocumentAnalysisRunResultsAsPdfData, ExportDocumentAnalysisRunResultsAsPdfError, ExportForeignCurrencyDrilldownData, ExportForeignCurrencyDrilldownError, ExportGovernmentDrilldownData, ExportGovernmentDrilldownError, ExportIbanSalaryOtherPaymentsDrilldownData, ExportIbanSalaryOtherPaymentsDrilldownError, ExportIntercompanyPaymentsDrilldownData, ExportIntercompanyPaymentsDrilldownError, ExportLedgerClassificationsData, ExportLedgerClassificationsError, ExportMissingIbanPaymentsDrilldownData, ExportMissingIbanPaymentsDrilldownError, ExportMissingIbanReceivedDrilldownData, ExportMissingIbanReceivedDrilldownError, ExportNameChangeDrilldownData, ExportNameChangeDrilldownError, ExportNewPartyDrilldownData, ExportNewPartyDrilldownError, ExportNotableDescriptionDrilldownData, ExportNotableDescriptionDrilldownError, ExportRecurrentPaymentsDrilldownData, ExportRecurrentPaymentsDrilldownError, ExportSameIbanTransactionsDrilldownData, ExportSameIbanTransactionsDrilldownError, ExportTrialBalanceData, ExportTrialBalanceError, ExportTrialBalanceResponse2, ExportValidationResultsData, ExportValidationResultsError, ExportWeekVacationDaysDrilldownData, ExportWeekVacationDaysDrilldownError, GenerateActionTechnicalExplanationData, GenerateActionTechnicalExplanationError, GenerateActionTechnicalExplanationResponse, GenerateTwoFaData, GenerateTwoFaError, GenerateTwoFaResponse, GetAccountMappingExportStatusData, GetAccountMappingExportStatusError, GetAccountMappingExportStatusResponse, GetAccountsDrilldownData, GetAccountsDrilldownError, GetAccountsDrilldownResponse, GetAccountsSummaryData, GetAccountsSummaryError, GetAccountsSummaryResponse, GetActiveProjectPipelineData, GetActiveProjectPipelineError, GetActiveProjectPipelineResponse, GetAgbwContinueAcknowledgmentData, GetAgbwContinueAcknowledgmentError, GetAgbwContinueAcknowledgmentResponse, GetAgbwPipelineStatusData, GetAgbwPipelineStatusError, GetAgbwPipelineStatusResponse, GetAgbwProgressData, GetAgbwProgressError, GetAgbwProgressResponse, GetAllOrganizationsData, GetAllOrganizationsError, GetAllOrganizationsResponse, GetAllUsersData, GetAllUsersError, GetAllUsersResponse, GetAnalysisRunResultsData, GetAnalysisRunResultsError, GetAnalysisRunResultsResponse, GetAnnualReportPipelineStatusData, GetAnnualReportPipelineStatusError, GetAnnualReportPipelineStatusResponse, GetArticleData, GetArticleError, GetArticleResponse, GetArticlesData, GetArticlesError, GetArticlesResponse, GetArticleTemplateData, GetArticleTemplateError, GetArticleTemplateResponse, GetArticleTemplatesData, GetArticleTemplatesError, GetArticleTemplatesResponse, GetAuditChecksData, GetAuditChecksError, GetAuditChecksResponse, GetAuditReconciliationExportStatusData, GetAuditReconciliationExportStatusError, GetAuditReconciliationExportStatusResponse, GetBatchDrilldownData, GetBatchDrilldownError, GetBatchDrilldownResponse, GetBatchPurchaseOverviewData, GetBatchPurchaseOverviewError, GetBatchPurchaseOverviewResponse, GetBatchSalaryOverviewData, GetBatchSalaryOverviewError, GetBatchSalaryOverviewResponse, GetBatchSummaryData, GetBatchSummaryError, GetBatchSummaryResponse, GetChangedIbanAggregationData, GetChangedIbanAggregationError, GetChangedIbanAggregationResponse, GetChangedIbanDrilldownData, GetChangedIbanDrilldownError, GetChangedIbanDrilldownResponse, GetClassificationPipelineStatusData, GetClassificationPipelineStatusError, GetClassificationPipelineStatusResponse, GetClassificationStatsData, GetClassificationStatsError, GetClassificationStatsResponse, GetClassificationTemplateData, GetClassificationTemplateError, GetClassificationTemplateResponse, GetClientAnalysisRunsData, GetClientAnalysisRunsError, GetClientAnalysisRunsResponse, GetCollectionData, GetCollectionError, GetCollectionFiltersData, GetCollectionFiltersError, GetCollectionFiltersResponse, GetCollectionResponse, GetCollectionShareData, GetCollectionShareError, GetCollectionShareResponse, GetCommentData, GetCommentError, GetCommentResponse, GetCommentsForDashboardData, GetCommentsForDashboardError, GetCommentsForDashboardResponse, GetConfirmationData, GetConfirmationError, GetConfirmationResponse, GetConfirmationsForDashboardData, GetConfirmationsForDashboardError, GetConfirmationsForDashboardResponse, GetContinuousAuditorRefreshPipelineStatusData, GetContinuousAuditorRefreshPipelineStatusError, GetContinuousAuditorRefreshPipelineStatusResponse, GetConversationsData, GetConversationsError, GetConversationsResponse, GetCpiPaymentsAggregationData, GetCpiPaymentsAggregationError, GetCpiPaymentsAggregationResponse, GetCpiPaymentsDrilldownData, GetCpiPaymentsDrilldownError, GetCpiPaymentsDrilldownResponse, GetCpiPreferenceData, GetCpiPreferenceError, GetCpiPreferenceResponse, GetCpiReceivementsAggregationData, GetCpiReceivementsAggregationError, GetCpiReceivementsAggregationResponse, GetCpiReceivementsDrilldownData, GetCpiReceivementsDrilldownError, GetCpiReceivementsDrilldownResponse, GetCreditcardStatementsAggregationData, GetCreditcardStatementsAggregationError, GetCreditcardStatementsAggregationResponse, GetCreditcardStatementsDrilldownData, GetCreditcardStatementsDrilldownError, GetCreditcardStatementsDrilldownResponse, GetCurrentTermsData, GetCurrentTermsError, GetCurrentTermsResponse, GetCurrentUserData, GetCurrentUserError, GetCurrentUserInvitationsData, GetCurrentUserInvitationsError, GetCurrentUserInvitationsResponse, GetCurrentUserPermissionData, GetCurrentUserPermissionError, GetCurrentUserPermissionResponse, GetCurrentUserResponse, GetDashboardData, GetDashboardError, GetDashboardFilterValuesData, GetDashboardFilterValuesError, GetDashboardFilterValuesResponse, GetDashboardResponse, GetDashboardsData, GetDashboardsError, GetDashboardsResponse, GetDatasourceByIdData, GetDatasourceByIdError, GetDatasourceByIdResponse, GetDatasourceFileData, GetDatasourceFileError, GetDatasourceFileResponse, GetDatasourceFiltersData, GetDatasourceFiltersError, GetDatasourceFiltersResponse, GetDatasourcesData, GetDatasourcesError, GetDatasourcesPageData, GetDatasourcesPageError, GetDatasourcesPageResponse, GetDatasourcesResponse, GetDocumentAnalysisSettingsData, GetDocumentAnalysisSettingsError, GetDocumentAnalysisSettingsResponse, GetDocumentAnalysisTemplateData, GetDocumentAnalysisTemplateError, GetDocumentAnalysisTemplateResponse, GetDocumentAnalysisTemplatesData, GetDocumentAnalysisTemplatesError, GetDocumentAnalysisTemplatesResponse, GetEmailWhitelistPatternsData, GetEmailWhitelistPatternsError, GetEmailWhitelistPatternsResponse, GetEventsData, GetEventsError, GetEventsResponse, GetExecutionReportData, GetExecutionReportError, GetExecutionResultsData, GetExecutionResultsError, GetExecutionResultsResponse, GetFaqsData, GetFaqsError, GetFaqsResponse, GetFinancialExplorerData, GetFinancialExplorerError, GetFinancialExplorerReconciliationData, GetFinancialExplorerReconciliationError, GetFinancialExplorerReconciliationResponse, GetFinancialExplorerResponse, GetFinancialExplorerTransactionFilterValuesData, GetFinancialExplorerTransactionFilterValuesError, GetFinancialExplorerTransactionFilterValuesResponse, GetFinancialExplorerTransactionsData, GetFinancialExplorerTransactionsError, GetFinancialExplorerTransactionsResponse, GetForeignCurrencyAggregationData, GetForeignCurrencyAggregationError, GetForeignCurrencyAggregationResponse, GetForeignCurrencyDrilldownData, GetForeignCurrencyDrilldownError, GetForeignCurrencyDrilldownResponse, GetGovernmentAggregationData, GetGovernmentAggregationError, GetGovernmentAggregationResponse, GetGovernmentDrilldownData, GetGovernmentDrilldownError, GetGovernmentDrilldownResponse, GetIbanSalaryOtherPaymentsAggregationData, GetIbanSalaryOtherPaymentsAggregationError, GetIbanSalaryOtherPaymentsAggregationResponse, GetIbanSalaryOtherPaymentsDrilldownData, GetIbanSalaryOtherPaymentsDrilldownError, GetIbanSalaryOtherPaymentsDrilldownResponse, GetIntercompanyPaymentsAggregationData, GetIntercompanyPaymentsAggregationError, GetIntercompanyPaymentsAggregationResponse, GetIntercompanyPaymentsDrilldownData, GetIntercompanyPaymentsDrilldownError, GetIntercompanyPaymentsDrilldownResponse, GetLatestClassificationTemplateVersionData, GetLatestClassificationTemplateVersionError, GetLatestClassificationTemplateVersionResponse, GetLedgerExportStatusData, GetLedgerExportStatusError, GetLedgerExportStatusResponse, GetLedgerStatsData, GetLedgerStatsError, GetLedgerStatsResponse, GetMaterialityPreferenceData, GetMaterialityPreferenceError, GetMaterialityPreferenceResponse, GetMediaMetadataData, GetMediaMetadataError, GetMediaMetadataResponse, GetMissingIbanPaymentsAggregationData, GetMissingIbanPaymentsAggregationError, GetMissingIbanPaymentsAggregationResponse, GetMissingIbanPaymentsDrilldownData, GetMissingIbanPaymentsDrilldownError, GetMissingIbanPaymentsDrilldownResponse, GetMissingIbanReceivedAggregationData, GetMissingIbanReceivedAggregationError, GetMissingIbanReceivedAggregationResponse, GetMissingIbanReceivedDrilldownData, GetMissingIbanReceivedDrilldownError, GetMissingIbanReceivedDrilldownResponse, GetMultipleIbansPerKvkData, GetMultipleIbansPerKvkError, GetMultipleIbansPerKvkResponse, GetNameChangeAggregationData, GetNameChangeAggregationError, GetNameChangeAggregationResponse, GetNameChangeDrilldownData, GetNameChangeDrilldownError, GetNameChangeDrilldownResponse, GetNewPartyAggregationData, GetNewPartyAggregationError, GetNewPartyAggregationResponse, GetNewPartyDrilldownData, GetNewPartyDrilldownError, GetNewPartyDrilldownResponse, GetOrganizationData, GetOrganizationDepartmentsData, GetOrganizationDepartmentsError, GetOrganizationDepartmentsResponse, GetOrganizationError, GetOrganizationFileData, GetOrganizationFileError, GetOrganizationFileResponse, GetOrganizationInvitationsData, GetOrganizationInvitationsError, GetOrganizationInvitationsResponse, GetOrganizationProjectParametersData, GetOrganizationProjectParametersError, GetOrganizationProjectParametersResponse, GetOrganizationResponse, GetOrganizationUserPermissionsData, GetOrganizationUserPermissionsError, GetOrganizationUserPermissionsResponse, GetOrganizationUserProfileData, GetOrganizationUserProfileError, GetOrganizationUserProfileResponse, GetOrganizationUserProfilesData, GetOrganizationUserProfilesError, GetOrganizationUserProfilesResponse, GetOrganizationUsersData, GetOrganizationUsersError, GetOrganizationUsersResponse, GetOrgReviewSessionDetailData, GetOrgReviewSessionDetailError, GetOrgReviewSessionDetailResponse, GetOrgReviewToolOutputData, GetOrgReviewToolOutputError, GetOrgReviewToolOutputResponse, GetOrgReviewTurnInspectorData, GetOrgReviewTurnInspectorError, GetOrgReviewTurnInspectorResponse, GetOriginData, GetOriginError, GetOriginResponse, GetPaymentCategoryPivotData, GetPaymentCategoryPivotError, GetPaymentCategoryPivotResponse, GetPaymentOverviewData, GetPaymentOverviewError, GetPaymentOverviewResponse, GetPaymentTypesData, GetPaymentTypesError, GetPaymentTypesResponse, GetPendingDocumentAnalysisTemplateForPromotionReviewData, GetPendingDocumentAnalysisTemplateForPromotionReviewError, GetPendingDocumentAnalysisTemplateForPromotionReviewResponse, GetPermissionsData, GetPermissionsError, GetPermissionsResponse, GetPersonalAnalysisRunsData, GetPersonalAnalysisRunsError, GetPersonalAnalysisRunsResponse, GetPossibleDuplicatePaymentsData, GetPossibleDuplicatePaymentsError, GetPossibleDuplicatePaymentsResponse, GetPreviewData, GetPreviewError, GetPreviewResponse, GetProjectAuditFileGlCoverageData, GetProjectAuditFileGlCoverageError, GetProjectAuditFileGlCoverageResponse, GetProjectDatasourcesData, GetProjectDatasourcesError, GetProjectDatasourcesResponse, GetProjectExecutionHistoryData, GetProjectExecutionHistoryError, GetProjectExecutionHistoryResponse, GetProjectFiltersData, GetProjectFiltersError, GetProjectFiltersResponse, GetProjectHierarchyData, GetProjectHierarchyError, GetProjectHierarchyResponse, GetProjectMembersData, GetProjectMembersError, GetProjectMembersResponse, GetProjectParametersData, GetProjectParametersError, GetProjectParametersResponse, GetProjectsData, GetProjectsError, GetProjectsResponse, GetPromotionRequestData, GetPromotionRequestError, GetPromotionRequestResponse, GetPromptData, GetPromptError, GetPromptLibraryData, GetPromptLibraryError, GetPromptLibraryResponse, GetPromptResponse, GetPromptSharesData, GetPromptSharesError, GetPromptSharesResponse, GetReceivablesByCounterpartyOverviewData, GetReceivablesByCounterpartyOverviewError, GetReceivablesByCounterpartyOverviewResponse, GetRecurrentPaymentsAggregationData, GetRecurrentPaymentsAggregationError, GetRecurrentPaymentsAggregationResponse, GetRecurrentPaymentsDrilldownData, GetRecurrentPaymentsDrilldownError, GetRecurrentPaymentsDrilldownResponse, GetRefreshAfasDataPipelineStatusData, GetRefreshAfasDataPipelineStatusError, GetRefreshAfasDataPipelineStatusResponse, GetRefreshAuditFilePipelineStatusData, GetRefreshAuditFilePipelineStatusError, GetRefreshAuditFilePipelineStatusResponse, GetReleaseNoteByIdData, GetReleaseNoteByIdError, GetReleaseNoteByIdResponse, GetReleaseNotesData, GetReleaseNotesError, GetReleaseNotesResponse, GetRolesData, GetRolesError, GetRolesResponse, GetRunData, GetRunError, GetRunResponse, GetSameIbanTransactionsAggregationData, GetSameIbanTransactionsAggregationError, GetSameIbanTransactionsAggregationResponse, GetSameIbanTransactionsDrilldownData, GetSameIbanTransactionsDrilldownError, GetSameIbanTransactionsDrilldownResponse, GetScheduleData, GetScheduleError, GetScheduleResponse, GetSharedDashboardData, GetSharedDashboardError, GetSharedDashboardResponse, GetSharedDatasourceData, GetSharedDatasourceError, GetSharedDatasourceResponse, GetSourceStatusData, GetSourceStatusError, GetSourceStatusResponse, GetSpecialDescriptionAggregationData, GetSpecialDescriptionAggregationError, GetSpecialDescriptionAggregationResponse, GetSpecialDescriptionDrilldownData, GetSpecialDescriptionDrilldownError, GetSpecialDescriptionDrilldownResponse, GetTemplateAnalysisRunsData, GetTemplateAnalysisRunsError, GetTemplateAnalysisRunsResponse, GetTermsAcceptanceStatusData, GetTermsAcceptanceStatusError, GetTermsAcceptanceStatusResponse, GetTermsDocumentData, GetTermsDocumentError, GetTopicsData, GetTopicsError, GetTopicsResponse, GetTrainingOverviewData, GetTrainingOverviewError, GetTrainingOverviewResponse, GetTransactionDrilldownData, GetTransactionDrilldownError, GetTransactionDrilldownResponse, GetTransactionFilterValuesData, GetTransactionFilterValuesError, GetTransactionFilterValuesResponse, GetTransactionOverviewData, GetTransactionOverviewError, GetTransactionOverviewResponse, GetTransactionsData, GetTransactionsError, GetTransactionsResponse, GetTrialBalanceEntriesData, GetTrialBalanceEntriesError, GetTrialBalanceEntriesResponse, GetTrialBalancePipelineStatusData, GetTrialBalancePipelineStatusError, GetTrialBalancePipelineStatusResponse, GetUniqueCounterpartiesMultipleIbansData, GetUniqueCounterpartiesMultipleIbansError, GetUniqueCounterpartiesMultipleIbansResponse, GetUsageSessionDetailData, GetUsageSessionDetailError, GetUsageSessionDetailResponse, GetUsageToolOutputData, GetUsageToolOutputError, GetUsageToolOutputResponse, GetUsageTurnInspectorData, GetUsageTurnInspectorError, GetUsageTurnInspectorResponse, GetUserData, GetUserError, GetUserResponse, GetWeekVacationDaysAggregationData, GetWeekVacationDaysAggregationError, GetWeekVacationDaysAggregationResponse, GetWeekVacationDaysDrilldownData, GetWeekVacationDaysDrilldownError, GetWeekVacationDaysDrilldownResponse, GetWorkflowActionData, GetWorkflowActionError, GetWorkflowActionResponse, GetWorkflowActionsData, GetWorkflowActionsError, GetWorkflowActionsResponse, GetWorkflowSetsData, GetWorkflowSetsError, GetWorkflowSetsResponse, HardDeletePromotionRequestData, HardDeletePromotionRequestError, HardDeletePromotionRequestResponse, HealthData, HealthError, ImportPriorYearClassificationsData, ImportPriorYearClassificationsError, ImportPriorYearClassificationsResponse, ImprovePromptData, ImprovePromptError, ImprovePromptResponse, IncrementArticleViewsData, IncrementArticleViewsError, IncrementArticleViewsResponse, IncrementFaqViewsData, IncrementFaqViewsError, IncrementFaqViewsResponse, InfoData, InfoError, InfoResponse, InviteUserToOrganizationByEmailData, InviteUserToOrganizationByEmailError, JwtForgotPasswordData, JwtForgotPasswordError, JwtLoginData, JwtLoginError, JwtLoginResponse, JwtLogoutData, JwtLogoutError, JwtRefreshData, JwtRefreshError, JwtRefreshResponse, JwtRegisterData, JwtRegisterError, JwtRegisterResponse, JwtRequestVerifyTokenData, JwtRequestVerifyTokenError, JwtResetPasswordData, JwtResetPasswordError, JwtVerifyData, JwtVerifyError, JwtVerifyResponse, LatestAuditBudgetReconciliationData, LatestAuditBudgetReconciliationError, LatestAuditBudgetReconciliationResponse, LatestAuditStatementExtractionData, LatestAuditStatementExtractionError, LatestAuditStatementExtractionJobsData, LatestAuditStatementExtractionJobsError, LatestAuditStatementExtractionJobsResponse, LatestAuditStatementExtractionResponse, LatestAuditStatementReferenceReconciliationData, LatestAuditStatementReferenceReconciliationError, LatestAuditStatementReferenceReconciliationResponse, LatestStatementExtractionData, LatestStatementExtractionError, LatestStatementExtractionResponse, LikeArticleData, LikeArticleError, LikeArticleResponse, ListAccountMappingsData, ListAccountMappingsError, ListAccountMappingsResponse, ListAuditFilesData, ListAuditFilesError, ListAuditFilesResponse2, ListClassificationsData, ListClassificationsError, ListClassificationsResponse, ListClassificationTemplatesData, ListClassificationTemplatesError, ListClassificationTemplatesResponse, ListClassificationTemplateVersionsData, ListClassificationTemplateVersionsError, ListClassificationTemplateVersionsResponse, ListClientTagsData, ListClientTagsError, ListClientTagsResponse, ListCollectionsData, ListCollectionsError, ListCollectionsPageData, ListCollectionsPageError, ListCollectionsPageResponse, ListCollectionsResponse, ListCopyClassificationSourcesData, ListCopyClassificationSourcesError, ListCopyClassificationSourcesResponse, ListDepartmentAdminsData, ListDepartmentAdminsError, ListDepartmentAdminsResponse, ListGroupedAuditOriginGroupsData, ListGroupedAuditOriginGroupsError, ListGroupedAuditOriginGroupsResponse, ListLedgerAccountsData, ListLedgerAccountsError, ListLedgerAccountsResponse, ListLedgerCopySourcesData, ListLedgerCopySourcesError, ListLedgerCopySourcesResponse, ListLedgerTargetsData, ListLedgerTargetsError, ListLedgerTargetsResponse, ListNotificationsData, ListNotificationsError, ListNotificationsResponse, ListOrgReviewSessionsData, ListOrgReviewSessionsError, ListOrgReviewSessionsResponse, ListOrgReviewSessionUsersData, ListOrgReviewSessionUsersError, ListOrgReviewSessionUsersResponse, ListOrgRunsData, ListOrgRunsError, ListOrgRunsResponse, ListOriginsData, ListOriginsError, ListOriginsResponse, ListOriginTablesData, ListOriginTablesError, ListOriginTablesResponse, ListProjectTypesData, ListProjectTypesError, ListProjectTypesResponse, ListProjectVectorizedDatasourcesData, ListProjectVectorizedDatasourcesError, ListProjectVectorizedDatasourcesResponse, ListPromotionRequestsData, ListPromotionRequestsError, ListPromotionRequestsResponse, ListRunsData, ListRunsError, ListRunsResponse, ListSchedulesData, ListSchedulesError, ListSchedulesResponse, ListStatementTaxonomiesData, ListStatementTaxonomiesError, ListStatementTaxonomiesResponse, ListUsageSessionsData, ListUsageSessionsError, ListUsageSessionsResponse, ListUsageSessionUsersData, ListUsageSessionUsersError, ListUsageSessionUsersResponse, LivenessData, LivenessError, MarkAllReadData, MarkAllReadError, MarkAllReadResponse2, MarkReadData, MarkReadError, MarkReadResponse, MoveResourcesToOrganizationData, MoveResourcesToOrganizationError, MoveResourcesToOrganizationResponse, MoveUserToOrganizationData, MoveUserToOrganizationError, MoveUserToOrganizationResponse, MoveWorkflowActionData, MoveWorkflowActionError, MoveWorkflowActionResponse, NewMessageFeedbackData, NewMessageFeedbackError, NewMessageFeedbackResponse, PatchCollectionShareData, PatchCollectionShareError, PatchCollectionShareResponse, PatchPromptSharesData, PatchPromptSharesError, PatchPromptSharesResponse, PatchSharedDashboardData, PatchSharedDashboardError, PatchSharedDashboardResponse, PatchSharedDatasourceData, PatchSharedDatasourceError, PatchSharedDatasourceResponse, PlaceWorkflowData, PlaceWorkflowError, PlaceWorkflowSetData, PlaceWorkflowSetError, PredictClassificationsData, PredictClassificationsError, PredictClassificationsResponse2, PredictFasClassificationsData, PredictFasClassificationsError, PredictFasClassificationsResponse, PredictLedgerClassificationsData, PredictLedgerClassificationsError, PredictLedgerClassificationsResponse, PublishArticleData, PublishArticleError, PublishArticleResponse, PublishFaqData, PublishFaqError, PublishFaqResponse, PublishPromptData, PublishPromptError, PublishPromptResponse, PublishReleaseNoteData, PublishReleaseNoteError, PublishReleaseNoteResponse, PublishStatementTaxonomyData, PublishStatementTaxonomyError, PublishStatementTaxonomyResponse, PutOrgReviewFeedbackData, PutOrgReviewFeedbackError, PutOrgReviewFeedbackResponse, PutUsageReviewFeedbackData, PutUsageReviewFeedbackError, PutUsageReviewFeedbackResponse, QueryClassificationTemplateDataData, QueryClassificationTemplateDataError, QueryClassificationTemplateDataResponse, ReadDefaultStatementTaxonomyData, ReadDefaultStatementTaxonomyError, ReadDefaultStatementTaxonomyResponse, ReadFasClassificationsData, ReadFasClassificationsError, ReadFasClassificationsResponse, ReadinessData, ReadinessError, ReadLedgerTemplateQueryData, ReadLedgerTemplateQueryError, ReadLedgerTemplateQueryResponse, ReadProjectStatementTaxonomyData, ReadProjectStatementTaxonomyError, ReadProjectStatementTaxonomyResponse, ReadStatementTaxonomyData, ReadStatementTaxonomyError, ReadStatementTaxonomyResponse, RecordTrainingCompletionsData, RecordTrainingCompletionsError, RecordTrainingCompletionsResponse, RecoverTwoFaData, RecoverTwoFaError, RecoverTwoFaResponse, RefreshClassificationsData, RefreshClassificationsError, RefreshClassificationsResponse2, RefreshDashboardData, RefreshDashboardError, RefreshDashboardResponse, RefreshDashboardWidgetData, RefreshDashboardWidgetError, RefreshDashboardWidgetResponse, RefreshLedgerAccountsData, RefreshLedgerAccountsError, RefreshLedgerAccountsResponse, ReindexPdfDatasourcesData, ReindexPdfDatasourcesError, ReindexPdfDatasourcesResponse, RejectData, RejectError, RejectIndividualWorkflowData, RejectIndividualWorkflowError, RejectIndividualWorkflowResponse, RejectPromotionRequestData, RejectPromotionRequestError, RejectPromotionRequestResponse, RejectResponse, RemoveDepartmentAdminData, RemoveDepartmentAdminError, RemoveDepartmentAdminResponse, RemoveEmailWhitelistPatternData, RemoveEmailWhitelistPatternError, RemoveEmailWhitelistPatternResponse, RemoveInvitationData, RemoveInvitationError, RemoveProjectMemberData, RemoveProjectMemberError, RemoveUserFromOrganizationData, RemoveUserFromOrganizationError, RenameClientTagData, RenameClientTagError, RenameClientTagResponse, ReorderWorkflowActionData, ReorderWorkflowActionError, ReorderWorkflowActionResponse, ReorderWorkflowData, ReorderWorkflowError, ReorderWorkflowResponse, ReorderWorkflowSetData, ReorderWorkflowSetError, ReorderWorkflowSetResponse, ReplaceAllTrialBalanceEntriesData, ReplaceAllTrialBalanceEntriesError, ReplaceAllTrialBalanceEntriesResponse, ReplaceAuditPreviousReportStageData, ReplaceAuditPreviousReportStageError, ReplaceAuditPreviousReportStageResponse, ReplaceAuditStatementExtractionCategoriesData, ReplaceAuditStatementExtractionCategoriesError, ReplaceAuditStatementExtractionCategoriesResponse, ReplaceAuditStatementExtractionStageData, ReplaceAuditStatementExtractionStageError, ReplaceAuditStatementExtractionStageResponse, ReplaceStatementExtractionStageData, ReplaceStatementExtractionStageError, ReplaceStatementExtractionStageResponse, RequestUploadUrlsData, RequestUploadUrlsError, RequestUploadUrlsResponse, RerunClientChecksData, RerunClientChecksError, RerunSingleCheckForClientData, RerunSingleCheckForClientError, RerunValidationCheckData, RerunValidationCheckError, ResetIndividualWorkflowApprovalData, ResetIndividualWorkflowApprovalError, ResetIndividualWorkflowApprovalResponse, ResetOrganizationUserTwoFaData, ResetOrganizationUserTwoFaError, ResetOrganizationUserTwoFaResponse, ResetUserAiLimitData, ResetUserAiLimitError, ResetUserAiLimitResponse, ResetUserTwoFaData, ResetUserTwoFaError, ResetUserTwoFaResponse, ResponseUserToInvitationData, ResponseUserToInvitationError, RestartAuditStatementExtractionJobData, RestartAuditStatementExtractionJobError, RestartAuditStatementExtractionJobResponse, RestoreProjectData, RestoreProjectError, RestoreProjectResponse, RestoreUserData, RestoreUserError, RestoreUserResponse, ResumeData, ResumeError, ResumeResponse, RevertPromotionRequestData, RevertPromotionRequestError, RevertPromotionRequestResponse, RevokeUserRoleData, RevokeUserRoleError, RevokeUserRoleResponse, RunContinuousAuditorRefreshPipelineData, RunContinuousAuditorRefreshPipelineError, RunDebugQueryData, RunDebugQueryError, RunDebugQueryResponse, RunDocumentAnalysisPipelineData, RunDocumentAnalysisPipelineError, RunRefreshAfasDataPipelineData, RunRefreshAfasDataPipelineError, RunRefreshAuditFilePipelineData, RunRefreshAuditFilePipelineError, SaveAccountMappingsData, SaveAccountMappingsError, SaveAccountMappingsResponse, SaveAgbwProgressData, SaveAgbwProgressError, SaveAgbwProgressResponse, SaveClassificationsData, SaveClassificationsError, SaveClassificationsResponse, SaveFasClassificationsData, SaveFasClassificationsError, SaveFasClassificationsResponse, SaveLedgerClassificationsData, SaveLedgerClassificationsError, SaveLedgerClassificationsResponse2, SearchProjectEntitiesData, SearchProjectEntitiesError, SearchProjectEntitiesResponse, SelectProjectStatementTaxonomyData, SelectProjectStatementTaxonomyError, SelectProjectStatementTaxonomyResponse, SendContactMessageData, SendContactMessageError, SendContactMessageResponse, SetAuditCheckData, SetAuditCheckError, SetAuditCheckResponse, SetClientTagsData, SetClientTagsError, SetClientTagsResponse, SetDepartmentMembersData, SetDepartmentMembersError, SetDepartmentMembersResponse, SetPipelineExecutionStatusData, SetPipelineExecutionStatusError, SetPipelineExecutionStatusResponse, SetWorkflowClientTagsData, SetWorkflowClientTagsError, SetWorkflowClientTagsResponse, SetWorkflowExcelTemplateData, SetWorkflowExcelTemplateError, SetWorkflowExcelTemplateResponse, SnapshotClassificationsData, SnapshotClassificationsError, SnapshotClassificationsResponse, SnapshotLedgerAccountsData, SnapshotLedgerAccountsError, SnapshotLedgerAccountsResponse, StartAgbwPrechecksPipelineData, StartAgbwPrechecksPipelineError, StartAuditPreviousReportExtractionData, StartAuditPreviousReportExtractionError, StartAuditPreviousReportExtractionResponse, StartAuditStatementExtractionData, StartAuditStatementExtractionError, StartAuditStatementExtractionResponse, StartStatementExtractionData, StartStatementExtractionDeepStageData, StartStatementExtractionDeepStageError, StartStatementExtractionDeepStageResponse, StartStatementExtractionError, StartStatementExtractionResponse, SubmitForApprovalData, SubmitForApprovalError, SubmitForApprovalResponse, SubmitIndividualWorkflowData, SubmitIndividualWorkflowError, SubmitIndividualWorkflowResponse, TestOriginConnectionData, TestOriginConnectionError, TestOriginConnectionResponse, ToggleConfirmationData, ToggleConfirmationError, ToggleConfirmationResponse, ToggleHelpdeskAgentStatusData, ToggleHelpdeskAgentStatusError, ToggleHelpdeskAgentStatusResponse, ToggleSuperuserStatusData, ToggleSuperuserStatusError, ToggleSuperuserStatusResponse, ToMaintenanceData, ToMaintenanceError, ToMaintenanceResponse, TriggerManualRunData, TriggerManualRunError, TriggerManualRunResponse, UnapproveData, UnapproveError, UnapproveResponse, UnpublishArticleData, UnpublishArticleError, UnpublishArticleResponse, UnpublishFaqData, UnpublishFaqError, UnpublishFaqResponse, UnpublishReleaseNoteData, UnpublishReleaseNoteError, UnpublishReleaseNoteResponse, UnreadCountData, UnreadCountError, UnreadCountResponse2, UnsuspendUserData, UnsuspendUserError, UnsuspendUserResponse, UpdateArticleData, UpdateArticleError, UpdateArticleResponse, UpdateArticleTemplateData, UpdateArticleTemplateError, UpdateArticleTemplateResponse, UpdateCollectionData, UpdateCollectionError, UpdateCollectionResponse, UpdateConversationData, UpdateConversationError, UpdateCpiPreferenceData, UpdateCpiPreferenceError, UpdateCpiPreferenceResponse, UpdateCurrentUserData, UpdateCurrentUserError, UpdateCurrentUserResponse, UpdateDashboardData, UpdateDashboardError, UpdateDashboardResponse, UpdateDashboardWidgetNameData, UpdateDashboardWidgetNameError, UpdateDashboardWidgetNameResponse, UpdateDashboardWidgetPositionData, UpdateDashboardWidgetPositionError, UpdateDashboardWidgetPositionResponse, UpdateDashboardWidgetTypeData, UpdateDashboardWidgetTypeError, UpdateDashboardWidgetTypeResponse, UpdateDatasourceData, UpdateDatasourceError, UpdateDatasourceResponse, UpdateDepartmentData, UpdateDepartmentError, UpdateDepartmentResponse, UpdateDocumentAnalysisRecordData, UpdateDocumentAnalysisRecordError, UpdateDocumentAnalysisRecordResponse, UpdateDocumentAnalysisSettingsData, UpdateDocumentAnalysisSettingsError, UpdateDocumentAnalysisSettingsResponse, UpdateDocumentAnalysisTemplateData, UpdateDocumentAnalysisTemplateError, UpdateDocumentAnalysisTemplateResponse, UpdateFaqData, UpdateFaqError, UpdateFaqResponse, UpdateLedgerTemplateQueryData, UpdateLedgerTemplateQueryError, UpdateLedgerTemplateQueryResponse, UpdateMaterialityPreferenceData, UpdateMaterialityPreferenceError, UpdateMaterialityPreferenceResponse, UpdateMaterialityThresholdsData, UpdateMaterialityThresholdsError, UpdateMaterialityThresholdsResponse, UpdateOrganizationData, UpdateOrganizationError, UpdateOrganizationResponse, UpdateOrganizationUserContextData, UpdateOrganizationUserContextError, UpdateOrganizationUserContextResponse, UpdateOrganizationWorkosIdData, UpdateOrganizationWorkosIdError, UpdateOrganizationWorkosIdResponse, UpdateOriginData, UpdateOriginError, UpdateOriginResponse, UpdatePendingDocumentAnalysisTemplateForPromotionReviewData, UpdatePendingDocumentAnalysisTemplateForPromotionReviewError, UpdatePendingDocumentAnalysisTemplateForPromotionReviewResponse, UpdateProjectData, UpdateProjectError, UpdateProjectResponse, UpdateProjectStatusData, UpdateProjectStatusError, UpdateProjectStatusResponse, UpdatePromptData, UpdatePromptError, UpdatePromptResponse, UpdateReleaseNoteData, UpdateReleaseNoteError, UpdateReleaseNoteResponse, UpdateScheduleData, UpdateScheduleError, UpdateScheduleResponse, UpdateStatementTaxonomyData, UpdateStatementTaxonomyError, UpdateStatementTaxonomyResponse, UpdateTopicData, UpdateTopicError, UpdateTopicResponse, UpdateUserData, UpdateUserEmailData, UpdateUserEmailError, UpdateUserEmailResponse, UpdateUserError, UpdateUserInOrganizationData, UpdateUserInOrganizationError, UpdateUserInOrganizationResponse, UpdateUserResponse, UpdateWorkflowActionData, UpdateWorkflowActionError, UpdateWorkflowActionResponse, UpdateWorkflowData, UpdateWorkflowError, UpdateWorkflowResponse, UpdateWorkflowSetData, UpdateWorkflowSetError, UpdateWorkflowSetResponse, UploadAuditFilesData, UploadAuditFilesError, UploadAuditFilesResponse2, UploadHelpCenterMediaData, UploadHelpCenterMediaError, UploadHelpCenterMediaResponse, UpsertProjectFileDatasourceData, UpsertProjectFileDatasourceError, UpsertProjectFileDatasourceResponse, UseArticleTemplateData, UseArticleTemplateError, UseArticleTemplateResponse, VerifyTwoFaData, VerifyTwoFaError, VerifyTwoFaResponse, VerifyTwoFaSigninData, VerifyTwoFaSigninError, VerifyTwoFaSigninResponse, VerifyUserData, VerifyUserError, VerifyUserResponse, WorkosAuthorizeData, WorkosAuthorizeError, WorkosAuthorizeResponse, WorkosCallbackData, WorkosCallbackError, WorkosCallbackResponse, WorkosLogoutData, WorkosLogoutError, WorkosLogoutResponse, WorkosRefreshData, WorkosRefreshError, WorkosRefreshResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
  QueryKey<TOptions>[0]
] => {
  const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const livenessQueryKey = (options?: Options<LivenessData>) => createQueryKey('liveness', options);

/**
 * Liveness
 *
 * Liveness probe. 200 means the process is running.
 *
 * Kept intentionally trivial so a downstream blip (DB, Redis) does not
 * cascade into kubelet restarting every pod. Use /readyz for dependency
 * awareness.
 */
export const livenessOptions = (options?: Options<LivenessData>) => queryOptions<unknown, LivenessError, unknown, ReturnType<typeof livenessQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await liveness({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: livenessQueryKey(options)
});

export const healthQueryKey = (options?: Options<HealthData>) => createQueryKey('health', options);

/**
 * Health
 *
 * Liveness probe. 200 means the process is running.
 *
 * Kept intentionally trivial so a downstream blip (DB, Redis) does not
 * cascade into kubelet restarting every pod. Use /readyz for dependency
 * awareness.
 */
export const healthOptions = (options?: Options<HealthData>) => queryOptions<unknown, HealthError, unknown, ReturnType<typeof healthQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await health({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: healthQueryKey(options)
});

export const readinessQueryKey = (options?: Options<ReadinessData>) => createQueryKey('readiness', options);

/**
 * Readiness
 *
 * Readiness probe. 200 only when Postgres responds.
 *
 * 503 here removes the pod from Service endpoints (no traffic) but does
 * not restart the container; if the dependency returns the pod rejoins.
 *
 * The probe runs on its own single-connection engine: through the shared app
 * pool, pool exhaustion 503s every pod at once and turns degradation into a
 * total outage (2026-08-10 incident). Only postgres itself being down should
 * fail readiness.
 *
 * Redis is probed for observability only and never fails readiness: it is
 * a shared dependency, so failing on it pulls every pod out of rotation at
 * once and turns a redis blip into a total outage (2026-07-21 incident).
 */
export const readinessOptions = (options?: Options<ReadinessData>) => queryOptions<unknown, ReadinessError, unknown, ReturnType<typeof readinessQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await readiness({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: readinessQueryKey(options)
});

export const infoQueryKey = (options?: Options<InfoData>) => createQueryKey('info', options);

/**
 * Info
 */
export const infoOptions = (options?: Options<InfoData>) => queryOptions<InfoResponse, InfoError, InfoResponse, ReturnType<typeof infoQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await info({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: infoQueryKey(options)
});

/**
 * Delete Conversation
 */
export const deleteConversationMutation = (options?: Partial<Options<DeleteConversationData>>): UseMutationOptions<unknown, DeleteConversationError, Options<DeleteConversationData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteConversationError, Options<DeleteConversationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteConversation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getEventsQueryKey = (options: Options<GetEventsData>) => createQueryKey('getEvents', options);

/**
 * Get Events
 */
export const getEventsOptions = (options: Options<GetEventsData>) => queryOptions<GetEventsResponse, GetEventsError, GetEventsResponse, ReturnType<typeof getEventsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getEvents({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEventsQueryKey(options)
});

/**
 * Update Conversation
 */
export const updateConversationMutation = (options?: Partial<Options<UpdateConversationData>>): UseMutationOptions<unknown, UpdateConversationError, Options<UpdateConversationData>> => {
  const mutationOptions: UseMutationOptions<unknown, UpdateConversationError, Options<UpdateConversationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateConversation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getConversationsQueryKey = (options?: Options<GetConversationsData>) => createQueryKey('getConversations', options);

/**
 * Get Conversations
 */
export const getConversationsOptions = (options?: Options<GetConversationsData>) => queryOptions<GetConversationsResponse, GetConversationsError, GetConversationsResponse, ReturnType<typeof getConversationsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getConversations({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getConversationsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...queryKey[0].body as any,
      ...page.body as any
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers
    };
  }
  if (page.path) {
    params.path = {
      ...queryKey[0].path as any,
      ...page.path as any
    };
  }
  if (page.query) {
    params.query = {
      ...queryKey[0].query as any,
      ...page.query as any
    };
  }
  return params as unknown as typeof page;
};

export const getConversationsInfiniteQueryKey = (options?: Options<GetConversationsData>): QueryKey<Options<GetConversationsData>> => createQueryKey('getConversations', options, true);

/**
 * Get Conversations
 */
export const getConversationsInfiniteOptions = (options?: Options<GetConversationsData>) => {
  const opts = infiniteQueryOptions<GetConversationsResponse, GetConversationsError, InfiniteData<GetConversationsResponse>, QueryKey<Options<GetConversationsData>>, number | Pick<QueryKey<Options<GetConversationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetConversationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getConversations({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getConversationsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Improve Prompt
 *
 * Rewrite the user's prompt against the context they attached.
 *
 * Nothing is executed and nothing is stored: the caller keeps the original and
 * can discard the result at any point before sending it.
 */
export const improvePromptMutation = (options?: Partial<Options<ImprovePromptData>>): UseMutationOptions<ImprovePromptResponse, ImprovePromptError, Options<ImprovePromptData>> => {
  const mutationOptions: UseMutationOptions<ImprovePromptResponse, ImprovePromptError, Options<ImprovePromptData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await improvePrompt({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCurrentUserInvitationsQueryKey = (options?: Options<GetCurrentUserInvitationsData>) => createQueryKey('getCurrentUserInvitations', options);

/**
 * Get Current User Invitations
 */
export const getCurrentUserInvitationsOptions = (options?: Options<GetCurrentUserInvitationsData>) => queryOptions<GetCurrentUserInvitationsResponse, GetCurrentUserInvitationsError, GetCurrentUserInvitationsResponse, ReturnType<typeof getCurrentUserInvitationsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCurrentUserInvitations({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCurrentUserInvitationsQueryKey(options)
});

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) => createQueryKey('getCurrentUser', options);

/**
 * Get Current User
 */
export const getCurrentUserOptions = (options?: Options<GetCurrentUserData>) => queryOptions<GetCurrentUserResponse, GetCurrentUserError, GetCurrentUserResponse, ReturnType<typeof getCurrentUserQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCurrentUser({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCurrentUserQueryKey(options)
});

/**
 * Update Current User
 */
export const updateCurrentUserMutation = (options?: Partial<Options<UpdateCurrentUserData>>): UseMutationOptions<UpdateCurrentUserResponse, UpdateCurrentUserError, Options<UpdateCurrentUserData>> => {
  const mutationOptions: UseMutationOptions<UpdateCurrentUserResponse, UpdateCurrentUserError, Options<UpdateCurrentUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCurrentUser({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCurrentUserPermissionQueryKey = (options?: Options<GetCurrentUserPermissionData>) => createQueryKey('getCurrentUserPermission', options);

/**
 * Get Current User Permission
 */
export const getCurrentUserPermissionOptions = (options?: Options<GetCurrentUserPermissionData>) => queryOptions<GetCurrentUserPermissionResponse, GetCurrentUserPermissionError, GetCurrentUserPermissionResponse, ReturnType<typeof getCurrentUserPermissionQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCurrentUserPermission({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCurrentUserPermissionQueryKey(options)
});

export const getUserQueryKey = (options: Options<GetUserData>) => createQueryKey('getUser', options);

/**
 * Get User
 */
export const getUserOptions = (options: Options<GetUserData>) => queryOptions<GetUserResponse, GetUserError, GetUserResponse, ReturnType<typeof getUserQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getUser({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getUserQueryKey(options)
});

/**
 * Update User
 */
export const updateUserMutation = (options?: Partial<Options<UpdateUserData>>): UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> => {
  const mutationOptions: UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUser({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Register
 */
export const jwtRegisterMutation = (options?: Partial<Options<JwtRegisterData>>): UseMutationOptions<JwtRegisterResponse, JwtRegisterError, Options<JwtRegisterData>> => {
  const mutationOptions: UseMutationOptions<JwtRegisterResponse, JwtRegisterError, Options<JwtRegisterData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtRegister({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Request Verify Token
 */
export const jwtRequestVerifyTokenMutation = (options?: Partial<Options<JwtRequestVerifyTokenData>>): UseMutationOptions<unknown, JwtRequestVerifyTokenError, Options<JwtRequestVerifyTokenData>> => {
  const mutationOptions: UseMutationOptions<unknown, JwtRequestVerifyTokenError, Options<JwtRequestVerifyTokenData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtRequestVerifyToken({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Verify
 */
export const jwtVerifyMutation = (options?: Partial<Options<JwtVerifyData>>): UseMutationOptions<JwtVerifyResponse, JwtVerifyError, Options<JwtVerifyData>> => {
  const mutationOptions: UseMutationOptions<JwtVerifyResponse, JwtVerifyError, Options<JwtVerifyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtVerify({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Forgot Password
 */
export const jwtForgotPasswordMutation = (options?: Partial<Options<JwtForgotPasswordData>>): UseMutationOptions<unknown, JwtForgotPasswordError, Options<JwtForgotPasswordData>> => {
  const mutationOptions: UseMutationOptions<unknown, JwtForgotPasswordError, Options<JwtForgotPasswordData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtForgotPassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Reset Password
 */
export const jwtResetPasswordMutation = (options?: Partial<Options<JwtResetPasswordData>>): UseMutationOptions<unknown, JwtResetPasswordError, Options<JwtResetPasswordData>> => {
  const mutationOptions: UseMutationOptions<unknown, JwtResetPasswordError, Options<JwtResetPasswordData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtResetPassword({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Generate Two Fa
 */
export const generateTwoFaMutation = (options?: Partial<Options<GenerateTwoFaData>>): UseMutationOptions<GenerateTwoFaResponse, GenerateTwoFaError, Options<GenerateTwoFaData>> => {
  const mutationOptions: UseMutationOptions<GenerateTwoFaResponse, GenerateTwoFaError, Options<GenerateTwoFaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateTwoFa({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Verify Two Fa
 */
export const verifyTwoFaMutation = (options?: Partial<Options<VerifyTwoFaData>>): UseMutationOptions<VerifyTwoFaResponse, VerifyTwoFaError, Options<VerifyTwoFaData>> => {
  const mutationOptions: UseMutationOptions<VerifyTwoFaResponse, VerifyTwoFaError, Options<VerifyTwoFaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyTwoFa({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Verify Two Fa Signin
 */
export const verifyTwoFaSigninMutation = (options?: Partial<Options<VerifyTwoFaSigninData>>): UseMutationOptions<VerifyTwoFaSigninResponse, VerifyTwoFaSigninError, Options<VerifyTwoFaSigninData>> => {
  const mutationOptions: UseMutationOptions<VerifyTwoFaSigninResponse, VerifyTwoFaSigninError, Options<VerifyTwoFaSigninData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyTwoFaSignin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Recover Two Fa
 */
export const recoverTwoFaMutation = (options?: Partial<Options<RecoverTwoFaData>>): UseMutationOptions<RecoverTwoFaResponse, RecoverTwoFaError, Options<RecoverTwoFaData>> => {
  const mutationOptions: UseMutationOptions<RecoverTwoFaResponse, RecoverTwoFaError, Options<RecoverTwoFaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await recoverTwoFa({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Login
 */
export const jwtLoginMutation = (options?: Partial<Options<JwtLoginData>>): UseMutationOptions<JwtLoginResponse, JwtLoginError, Options<JwtLoginData>> => {
  const mutationOptions: UseMutationOptions<JwtLoginResponse, JwtLoginError, Options<JwtLoginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtLogin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Logout
 */
export const jwtLogoutMutation = (options?: Partial<Options<JwtLogoutData>>): UseMutationOptions<unknown, JwtLogoutError, Options<JwtLogoutData>> => {
  const mutationOptions: UseMutationOptions<unknown, JwtLogoutError, Options<JwtLogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtLogout({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Jwt Refresh
 */
export const jwtRefreshMutation = (options?: Partial<Options<JwtRefreshData>>): UseMutationOptions<JwtRefreshResponse, JwtRefreshError, Options<JwtRefreshData>> => {
  const mutationOptions: UseMutationOptions<JwtRefreshResponse, JwtRefreshError, Options<JwtRefreshData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await jwtRefresh({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCurrentTermsQueryKey = (options?: Options<GetCurrentTermsData>) => createQueryKey('getCurrentTerms', options);

/**
 * Get Current Terms
 *
 * Metadata of the currently effective user terms.
 *
 * Unauthenticated on purpose: the registration page and the blocking
 * login modal both need it before the user can proceed. Fetch the document
 * itself from `/terms/{version}/document`.
 */
export const getCurrentTermsOptions = (options?: Options<GetCurrentTermsData>) => queryOptions<GetCurrentTermsResponse, GetCurrentTermsError, GetCurrentTermsResponse, ReturnType<typeof getCurrentTermsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCurrentTerms({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCurrentTermsQueryKey(options)
});

export const getTermsDocumentQueryKey = (options: Options<GetTermsDocumentData>) => createQueryKey('getTermsDocument', options);

/**
 * Get Terms Document
 *
 * Serve a terms version as the PDF legal signed off on.
 *
 * Unauthenticated for the same reason as `/current`, and served inline so
 * the acceptance modal can embed it rather than downloading it. Any
 * published version is readable, so a user can re-read what they accepted.
 */
export const getTermsDocumentOptions = (options: Options<GetTermsDocumentData>) => queryOptions<unknown, GetTermsDocumentError, unknown, ReturnType<typeof getTermsDocumentQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTermsDocument({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTermsDocumentQueryKey(options)
});

/**
 * Accept Terms
 *
 * Record the current user's acceptance of a terms version.
 *
 * Idempotent per version (a repeat returns the original acceptance), and
 * rejects versions older than the currently effective one so a stale modal
 * cannot accept outdated terms.
 */
export const acceptTermsMutation = (options?: Partial<Options<AcceptTermsData>>): UseMutationOptions<AcceptTermsResponse, AcceptTermsError, Options<AcceptTermsData>> => {
  const mutationOptions: UseMutationOptions<AcceptTermsResponse, AcceptTermsError, Options<AcceptTermsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptTerms({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getAllOrganizationsQueryKey = (options?: Options<GetAllOrganizationsData>) => createQueryKey('getAllOrganizations', options);

/**
 * Get All Organizations
 */
export const getAllOrganizationsOptions = (options?: Options<GetAllOrganizationsData>) => queryOptions<GetAllOrganizationsResponse, GetAllOrganizationsError, GetAllOrganizationsResponse, ReturnType<typeof getAllOrganizationsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAllOrganizations({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAllOrganizationsQueryKey(options)
});

/**
 * Delete Organization
 *
 * Delete an organization (superuser only).
 */
export const deleteOrganizationMutation = (options?: Partial<Options<DeleteOrganizationData>>): UseMutationOptions<unknown, DeleteOrganizationError, Options<DeleteOrganizationData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteOrganizationError, Options<DeleteOrganizationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Organization Workos Id
 *
 * Set or clear the WorkOS organization ID for SSO auto-linking (superuser only).
 */
export const updateOrganizationWorkosIdMutation = (options?: Partial<Options<UpdateOrganizationWorkosIdData>>): UseMutationOptions<UpdateOrganizationWorkosIdResponse, UpdateOrganizationWorkosIdError, Options<UpdateOrganizationWorkosIdData>> => {
  const mutationOptions: UseMutationOptions<UpdateOrganizationWorkosIdResponse, UpdateOrganizationWorkosIdError, Options<UpdateOrganizationWorkosIdData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOrganizationWorkosId({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getAllUsersQueryKey = (options?: Options<GetAllUsersData>) => createQueryKey('getAllUsers', options);

/**
 * Get All Users
 *
 * Get all users + pending invitations across the system (superuser only).
 */
export const getAllUsersOptions = (options?: Options<GetAllUsersData>) => queryOptions<GetAllUsersResponse, GetAllUsersError, GetAllUsersResponse, ReturnType<typeof getAllUsersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAllUsers({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAllUsersQueryKey(options)
});

/**
 * Toggle Superuser Status
 *
 * Toggle the is_superuser flag on `user_id`.
 */
export const toggleSuperuserStatusMutation = (options?: Partial<Options<ToggleSuperuserStatusData>>): UseMutationOptions<ToggleSuperuserStatusResponse, ToggleSuperuserStatusError, Options<ToggleSuperuserStatusData>> => {
  const mutationOptions: UseMutationOptions<ToggleSuperuserStatusResponse, ToggleSuperuserStatusError, Options<ToggleSuperuserStatusData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await toggleSuperuserStatus({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Toggle Helpdesk Agent Status
 *
 * Toggle help-center authorship on `user_id`.
 *
 * Superuser-only by design: the content it governs is global, so this is not
 * delegated to org admins the way org-scoped roles are.
 */
export const toggleHelpdeskAgentStatusMutation = (options?: Partial<Options<ToggleHelpdeskAgentStatusData>>): UseMutationOptions<ToggleHelpdeskAgentStatusResponse, ToggleHelpdeskAgentStatusError, Options<ToggleHelpdeskAgentStatusData>> => {
  const mutationOptions: UseMutationOptions<ToggleHelpdeskAgentStatusResponse, ToggleHelpdeskAgentStatusError, Options<ToggleHelpdeskAgentStatusData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await toggleHelpdeskAgentStatus({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Verify User
 *
 * Toggle the is_verified flag on `user_id`.
 */
export const verifyUserMutation = (options?: Partial<Options<VerifyUserData>>): UseMutationOptions<VerifyUserResponse, VerifyUserError, Options<VerifyUserData>> => {
  const mutationOptions: UseMutationOptions<VerifyUserResponse, VerifyUserError, Options<VerifyUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await verifyUser({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update User Email
 *
 * Move a user's account to a different email address (superuser only).
 *
 * Refused for SSO-linked accounts: WorkOS is the source of truth for those,
 * and `_upsert_user` overwrites `User.email` from the profile on the next
 * login, so a local change would silently revert. Change it in WorkOS instead.
 *
 * The account is marked unverified, pending invitations follow the address,
 * and existing sessions are revoked; an email change is an identity change.
 */
export const updateUserEmailMutation = (options?: Partial<Options<UpdateUserEmailData>>): UseMutationOptions<UpdateUserEmailResponse, UpdateUserEmailError, Options<UpdateUserEmailData>> => {
  const mutationOptions: UseMutationOptions<UpdateUserEmailResponse, UpdateUserEmailError, Options<UpdateUserEmailData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUserEmail({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reset User Ai Limit
 */
export const resetUserAiLimitMutation = (options?: Partial<Options<ResetUserAiLimitData>>): UseMutationOptions<ResetUserAiLimitResponse, ResetUserAiLimitError, Options<ResetUserAiLimitData>> => {
  const mutationOptions: UseMutationOptions<ResetUserAiLimitResponse, ResetUserAiLimitError, Options<ResetUserAiLimitData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetUserAiLimit({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reset User Two Fa
 *
 * Reset a user's 2FA enrollment and invalidate their active sessions.
 */
export const resetUserTwoFaMutation = (options?: Partial<Options<ResetUserTwoFaData>>): UseMutationOptions<ResetUserTwoFaResponse, ResetUserTwoFaError, Options<ResetUserTwoFaData>> => {
  const mutationOptions: UseMutationOptions<ResetUserTwoFaResponse, ResetUserTwoFaError, Options<ResetUserTwoFaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetUserTwoFa({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete User
 *
 * Soft-delete a user and hard-delete their sessions / invitations / RBAC grants.
 */
export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>): UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> => {
  const mutationOptions: UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteUser({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Restore User
 *
 * Restore a soft-deleted user; optionally re-invite them to `organization_id`.
 */
export const restoreUserMutation = (options?: Partial<Options<RestoreUserData>>): UseMutationOptions<RestoreUserResponse, RestoreUserError, Options<RestoreUserData>> => {
  const mutationOptions: UseMutationOptions<RestoreUserResponse, RestoreUserError, Options<RestoreUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await restoreUser({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Unsuspend User
 *
 * Lift a security suspension after manual review (superuser only).
 */
export const unsuspendUserMutation = (options?: Partial<Options<UnsuspendUserData>>): UseMutationOptions<UnsuspendUserResponse, UnsuspendUserError, Options<UnsuspendUserData>> => {
  const mutationOptions: UseMutationOptions<UnsuspendUserResponse, UnsuspendUserError, Options<UnsuspendUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await unsuspendUser({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Move User To Organization
 *
 * Move a user into another organization (superuser only).
 *
 * Drops the user's membership, roles and per-resource grants in their current
 * organization and re-creates membership in `organization_id` with `roles`
 * (defaulting to `org_member`). Personal prompts, workflow sets and document
 * analysis templates move with them. The transfer is rejected while the user
 * owns department- or organization-placed prompts in the source organization.
 */
export const moveUserToOrganizationMutation = (options?: Partial<Options<MoveUserToOrganizationData>>): UseMutationOptions<MoveUserToOrganizationResponse, MoveUserToOrganizationError, Options<MoveUserToOrganizationData>> => {
  const mutationOptions: UseMutationOptions<MoveUserToOrganizationResponse, MoveUserToOrganizationError, Options<MoveUserToOrganizationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await moveUserToOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Move Resources To Organization
 *
 * Move a batch of resources into another organization (superuser only).
 *
 * Datasources, collections, document analysis templates, workflow sets and
 * dashboards move together as one batch. Links *between* resources in the
 * batch survive; every link out of a moved resource into something left
 * behind is cut, because nothing else in the schema stops a moved resource
 * from reading the previous tenant's data.
 *
 * Workflow sets bring nested sets with them and templates bring their whole
 * version chain, so the returned id lists can be longer than the request.
 */
export const moveResourcesToOrganizationMutation = (options?: Partial<Options<MoveResourcesToOrganizationData>>): UseMutationOptions<MoveResourcesToOrganizationResponse, MoveResourcesToOrganizationError, Options<MoveResourcesToOrganizationData>> => {
  const mutationOptions: UseMutationOptions<MoveResourcesToOrganizationResponse, MoveResourcesToOrganizationError, Options<MoveResourcesToOrganizationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await moveResourcesToOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Revoke User Role
 *
 * Revoke a role from `user_id` in `organization_id` (superuser only).
 *
 * Pass `resource_type` + `resource_id` to revoke a scoped assignment;
 * omit both to revoke an org-wide one. `super_admin` is not a role
 * here, it's a flag on `User` toggled via `PATCH /user/{id}/superuser`.
 */
export const revokeUserRoleMutation = (options?: Partial<Options<RevokeUserRoleData>>): UseMutationOptions<RevokeUserRoleResponse, RevokeUserRoleError, Options<RevokeUserRoleData>> => {
  const mutationOptions: UseMutationOptions<RevokeUserRoleResponse, RevokeUserRoleError, Options<RevokeUserRoleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeUserRole({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getRolesQueryKey = (options: Options<GetRolesData>) => createQueryKey('getRoles', options);

/**
 * Get Roles
 *
 * List direct role assignments for a user in an organization.
 */
export const getRolesOptions = (options: Options<GetRolesData>) => queryOptions<GetRolesResponse, GetRolesError, GetRolesResponse, ReturnType<typeof getRolesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getRoles({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRolesQueryKey(options)
});

/**
 * Assign User Role
 *
 * Assign a role to `user_id` in `organization_id` (superuser only).
 *
 * Pass `resource_type` + `resource_id` for scoped-only roles
 * (e.g. `project_admin` scoped to `project_type.<audit type uuid>`).
 * Org-wide roles must omit both. `super_admin` is intentionally not a
 * role in this endpoint; it maps to `User.is_superuser` which is
 * toggled via `PATCH /user/{id}/superuser`.
 */
export const assignUserRoleMutation = (options?: Partial<Options<AssignUserRoleData>>): UseMutationOptions<AssignUserRoleResponse, AssignUserRoleError, Options<AssignUserRoleData>> => {
  const mutationOptions: UseMutationOptions<AssignUserRoleResponse, AssignUserRoleError, Options<AssignUserRoleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await assignUserRole({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPermissionsQueryKey = (options: Options<GetPermissionsData>) => createQueryKey('getPermissions', options);

/**
 * Get Permissions
 */
export const getPermissionsOptions = (options: Options<GetPermissionsData>) => queryOptions<GetPermissionsResponse, GetPermissionsError, GetPermissionsResponse, ReturnType<typeof getPermissionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPermissions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPermissionsQueryKey(options)
});

/**
 * Reindex Pdf Datasources
 *
 * Delete and re-index all PDF datasources (superuser only).
 *
 * Drops existing embeddings and queues a fresh vectorization job for every
 * active datasource with data_type == "vectorized". Optionally scoped to a
 * single organization via the organization_id query param.
 *
 * Soft-deleted datasources (deleted_at IS NOT NULL) are excluded by default;
 * pass include_deleted=true to reindex them too.
 *
 * Datasources whose processing job is still queued or running are skipped;
 * when that leaves nothing to queue the request fails with 409. A `pending`
 * row without a live job (e.g. its worker was killed) is reclaimed.
 */
export const reindexPdfDatasourcesMutation = (options?: Partial<Options<ReindexPdfDatasourcesData>>): UseMutationOptions<ReindexPdfDatasourcesResponse, ReindexPdfDatasourcesError, Options<ReindexPdfDatasourcesData>> => {
  const mutationOptions: UseMutationOptions<ReindexPdfDatasourcesResponse, ReindexPdfDatasourcesError, Options<ReindexPdfDatasourcesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await reindexPdfDatasources({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getTermsAcceptanceStatusQueryKey = (options?: Options<GetTermsAcceptanceStatusData>) => createQueryKey('getTermsAcceptanceStatus', options);

/**
 * Get Terms Acceptance Status
 *
 * Terms acceptance state of every non-deleted user (superuser only).
 */
export const getTermsAcceptanceStatusOptions = (options?: Options<GetTermsAcceptanceStatusData>) => queryOptions<GetTermsAcceptanceStatusResponse, GetTermsAcceptanceStatusError, GetTermsAcceptanceStatusResponse, ReturnType<typeof getTermsAcceptanceStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTermsAcceptanceStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTermsAcceptanceStatusQueryKey(options)
});

export const getEmailWhitelistPatternsQueryKey = (options?: Options<GetEmailWhitelistPatternsData>) => createQueryKey('getEmailWhitelistPatterns', options);

/**
 * Get Email Whitelist Patterns
 *
 * List all whitelisted email patterns (superuser only).
 */
export const getEmailWhitelistPatternsOptions = (options?: Options<GetEmailWhitelistPatternsData>) => queryOptions<GetEmailWhitelistPatternsResponse, GetEmailWhitelistPatternsError, GetEmailWhitelistPatternsResponse, ReturnType<typeof getEmailWhitelistPatternsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getEmailWhitelistPatterns({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getEmailWhitelistPatternsQueryKey(options)
});

/**
 * Add Email Whitelist Pattern
 *
 * Add an email pattern to the whitelist (superuser only).
 */
export const addEmailWhitelistPatternMutation = (options?: Partial<Options<AddEmailWhitelistPatternData>>): UseMutationOptions<AddEmailWhitelistPatternResponse, AddEmailWhitelistPatternError, Options<AddEmailWhitelistPatternData>> => {
  const mutationOptions: UseMutationOptions<AddEmailWhitelistPatternResponse, AddEmailWhitelistPatternError, Options<AddEmailWhitelistPatternData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addEmailWhitelistPattern({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Remove Email Whitelist Pattern
 *
 * Remove an email pattern from the whitelist (superuser only).
 */
export const removeEmailWhitelistPatternMutation = (options?: Partial<Options<RemoveEmailWhitelistPatternData>>): UseMutationOptions<RemoveEmailWhitelistPatternResponse, RemoveEmailWhitelistPatternError, Options<RemoveEmailWhitelistPatternData>> => {
  const mutationOptions: UseMutationOptions<RemoveEmailWhitelistPatternResponse, RemoveEmailWhitelistPatternError, Options<RemoveEmailWhitelistPatternData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeEmailWhitelistPattern({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listUsageSessionsQueryKey = (options?: Options<ListUsageSessionsData>) => createQueryKey('listUsageSessions', options);

/**
 * List Usage Sessions
 *
 * List conversations with turn counts, duration, and cost when tracing supplies it.
 *
 * ``org_id`` keeps only sessions of that organization's users.
 */
export const listUsageSessionsOptions = (options?: Options<ListUsageSessionsData>) => queryOptions<ListUsageSessionsResponse, ListUsageSessionsError, ListUsageSessionsResponse, ReturnType<typeof listUsageSessionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listUsageSessions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listUsageSessionsQueryKey(options)
});

export const listUsageSessionsInfiniteQueryKey = (options?: Options<ListUsageSessionsData>): QueryKey<Options<ListUsageSessionsData>> => createQueryKey('listUsageSessions', options, true);

/**
 * List Usage Sessions
 *
 * List conversations with turn counts, duration, and cost when tracing supplies it.
 *
 * ``org_id`` keeps only sessions of that organization's users.
 */
export const listUsageSessionsInfiniteOptions = (options?: Options<ListUsageSessionsData>) => {
  const opts = infiniteQueryOptions<ListUsageSessionsResponse, ListUsageSessionsError, InfiniteData<ListUsageSessionsResponse>, QueryKey<Options<ListUsageSessionsData>>, number | Pick<QueryKey<Options<ListUsageSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<ListUsageSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await listUsageSessions({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listUsageSessionsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const listUsageSessionUsersQueryKey = (options?: Options<ListUsageSessionUsersData>) => createQueryKey('listUsageSessionUsers', options);

/**
 * List Usage Session Users
 *
 * Users with at least one conversation, optionally only those of one organization.
 */
export const listUsageSessionUsersOptions = (options?: Options<ListUsageSessionUsersData>) => queryOptions<ListUsageSessionUsersResponse, ListUsageSessionUsersError, ListUsageSessionUsersResponse, ReturnType<typeof listUsageSessionUsersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listUsageSessionUsers({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listUsageSessionUsersQueryKey(options)
});

export const getUsageSessionDetailQueryKey = (options: Options<GetUsageSessionDetailData>) => createQueryKey('getUsageSessionDetail', options);

/**
 * Get Usage Session Detail
 *
 * Conversation drilldown: header context and transcript with per-turn chips.
 */
export const getUsageSessionDetailOptions = (options: Options<GetUsageSessionDetailData>) => queryOptions<GetUsageSessionDetailResponse, GetUsageSessionDetailError, GetUsageSessionDetailResponse, ReturnType<typeof getUsageSessionDetailQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getUsageSessionDetail({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getUsageSessionDetailQueryKey(options)
});

export const getUsageTurnInspectorQueryKey = (options: Options<GetUsageTurnInspectorData>) => createQueryKey('getUsageTurnInspector', options);

/**
 * Get Usage Turn Inspector
 *
 * Inspector for one chat turn: tool calls, data, context, and agents when traced.
 */
export const getUsageTurnInspectorOptions = (options: Options<GetUsageTurnInspectorData>) => queryOptions<GetUsageTurnInspectorResponse, GetUsageTurnInspectorError, GetUsageTurnInspectorResponse, ReturnType<typeof getUsageTurnInspectorQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getUsageTurnInspector({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getUsageTurnInspectorQueryKey(options)
});

export const getUsageToolOutputQueryKey = (options: Options<GetUsageToolOutputData>) => createQueryKey('getUsageToolOutput', options);

/**
 * Get Usage Tool Output
 *
 * Full, untruncated payload of one tool call for lazy modal loading.
 */
export const getUsageToolOutputOptions = (options: Options<GetUsageToolOutputData>) => queryOptions<GetUsageToolOutputResponse, GetUsageToolOutputError, GetUsageToolOutputResponse, ReturnType<typeof getUsageToolOutputQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getUsageToolOutput({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getUsageToolOutputQueryKey(options)
});

/**
 * Put Usage Review Feedback
 *
 * The superuser's own rating of an assistant turn; the owner's rating is untouched.
 */
export const putUsageReviewFeedbackMutation = (options?: Partial<Options<PutUsageReviewFeedbackData>>): UseMutationOptions<PutUsageReviewFeedbackResponse, PutUsageReviewFeedbackError, Options<PutUsageReviewFeedbackData>> => {
  const mutationOptions: UseMutationOptions<PutUsageReviewFeedbackResponse, PutUsageReviewFeedbackError, Options<PutUsageReviewFeedbackData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await putUsageReviewFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listOrgReviewSessionsQueryKey = (options: Options<ListOrgReviewSessionsData>) => createQueryKey('listOrgReviewSessions', options);

/**
 * List Org Review Sessions
 *
 * Conversations of the organization's users, with cost when tracing supplies it.
 *
 * When ``department_id`` is set, only sessions of that department's members are returned.
 */
export const listOrgReviewSessionsOptions = (options: Options<ListOrgReviewSessionsData>) => queryOptions<ListOrgReviewSessionsResponse, ListOrgReviewSessionsError, ListOrgReviewSessionsResponse, ReturnType<typeof listOrgReviewSessionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listOrgReviewSessions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listOrgReviewSessionsQueryKey(options)
});

export const listOrgReviewSessionsInfiniteQueryKey = (options: Options<ListOrgReviewSessionsData>): QueryKey<Options<ListOrgReviewSessionsData>> => createQueryKey('listOrgReviewSessions', options, true);

/**
 * List Org Review Sessions
 *
 * Conversations of the organization's users, with cost when tracing supplies it.
 *
 * When ``department_id`` is set, only sessions of that department's members are returned.
 */
export const listOrgReviewSessionsInfiniteOptions = (options: Options<ListOrgReviewSessionsData>) => {
  const opts = infiniteQueryOptions<ListOrgReviewSessionsResponse, ListOrgReviewSessionsError, InfiniteData<ListOrgReviewSessionsResponse>, QueryKey<Options<ListOrgReviewSessionsData>>, number | Pick<QueryKey<Options<ListOrgReviewSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<ListOrgReviewSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await listOrgReviewSessions({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listOrgReviewSessionsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const listOrgReviewSessionUsersQueryKey = (options: Options<ListOrgReviewSessionUsersData>) => createQueryKey('listOrgReviewSessionUsers', options);

/**
 * List Org Review Session Users
 *
 * The organization's users with at least one conversation, optionally of one department only.
 */
export const listOrgReviewSessionUsersOptions = (options: Options<ListOrgReviewSessionUsersData>) => queryOptions<ListOrgReviewSessionUsersResponse, ListOrgReviewSessionUsersError, ListOrgReviewSessionUsersResponse, ReturnType<typeof listOrgReviewSessionUsersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listOrgReviewSessionUsers({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listOrgReviewSessionUsersQueryKey(options)
});

export const getOrgReviewSessionDetailQueryKey = (options: Options<GetOrgReviewSessionDetailData>) => createQueryKey('getOrgReviewSessionDetail', options);

/**
 * Get Org Review Session Detail
 *
 * Conversation drilldown, only for sessions owned by the organization's users.
 */
export const getOrgReviewSessionDetailOptions = (options: Options<GetOrgReviewSessionDetailData>) => queryOptions<GetOrgReviewSessionDetailResponse, GetOrgReviewSessionDetailError, GetOrgReviewSessionDetailResponse, ReturnType<typeof getOrgReviewSessionDetailQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrgReviewSessionDetail({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrgReviewSessionDetailQueryKey(options)
});

export const getOrgReviewTurnInspectorQueryKey = (options: Options<GetOrgReviewTurnInspectorData>) => createQueryKey('getOrgReviewTurnInspector', options);

/**
 * Get Org Review Turn Inspector
 *
 * Inspector for a turn of an org-owned session.
 */
export const getOrgReviewTurnInspectorOptions = (options: Options<GetOrgReviewTurnInspectorData>) => queryOptions<GetOrgReviewTurnInspectorResponse, GetOrgReviewTurnInspectorError, GetOrgReviewTurnInspectorResponse, ReturnType<typeof getOrgReviewTurnInspectorQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrgReviewTurnInspector({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrgReviewTurnInspectorQueryKey(options)
});

export const getOrgReviewToolOutputQueryKey = (options: Options<GetOrgReviewToolOutputData>) => createQueryKey('getOrgReviewToolOutput', options);

/**
 * Get Org Review Tool Output
 *
 * Full tool payload for a turn of an org-owned session.
 */
export const getOrgReviewToolOutputOptions = (options: Options<GetOrgReviewToolOutputData>) => queryOptions<GetOrgReviewToolOutputResponse, GetOrgReviewToolOutputError, GetOrgReviewToolOutputResponse, ReturnType<typeof getOrgReviewToolOutputQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrgReviewToolOutput({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrgReviewToolOutputQueryKey(options)
});

/**
 * Put Org Review Feedback
 *
 * The reviewer's own rating of an assistant turn in an org-owned session; the owner's rating is untouched.
 */
export const putOrgReviewFeedbackMutation = (options?: Partial<Options<PutOrgReviewFeedbackData>>): UseMutationOptions<PutOrgReviewFeedbackResponse, PutOrgReviewFeedbackError, Options<PutOrgReviewFeedbackData>> => {
  const mutationOptions: UseMutationOptions<PutOrgReviewFeedbackResponse, PutOrgReviewFeedbackError, Options<PutOrgReviewFeedbackData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await putOrgReviewFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getOrganizationQueryKey = (options: Options<GetOrganizationData>) => createQueryKey('getOrganization', options);

/**
 * Get Organization
 *
 * Get organization by ID.
 */
export const getOrganizationOptions = (options: Options<GetOrganizationData>) => queryOptions<GetOrganizationResponse, GetOrganizationError, GetOrganizationResponse, ReturnType<typeof getOrganizationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganization({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationQueryKey(options)
});

/**
 * Update Organization
 *
 * Update organization details.
 *
 * Only fields present in the request body are touched, so an explicit `null`
 * clears `email`, `context` or `image_url` rather than being read as "omitted".
 */
export const updateOrganizationMutation = (options?: Partial<Options<UpdateOrganizationData>>): UseMutationOptions<UpdateOrganizationResponse, UpdateOrganizationError, Options<UpdateOrganizationData>> => {
  const mutationOptions: UseMutationOptions<UpdateOrganizationResponse, UpdateOrganizationError, Options<UpdateOrganizationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Remove User From Organization
 *
 * Remove a user from an organization.
 */
export const removeUserFromOrganizationMutation = (options?: Partial<Options<RemoveUserFromOrganizationData>>): UseMutationOptions<unknown, RemoveUserFromOrganizationError, Options<RemoveUserFromOrganizationData>> => {
  const mutationOptions: UseMutationOptions<unknown, RemoveUserFromOrganizationError, Options<RemoveUserFromOrganizationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeUserFromOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getOrganizationUsersQueryKey = (options: Options<GetOrganizationUsersData>) => createQueryKey('getOrganizationUsers', options);

/**
 * Get Organization Users
 *
 * Get all members and pending invitations for an organization.
 */
export const getOrganizationUsersOptions = (options: Options<GetOrganizationUsersData>) => queryOptions<GetOrganizationUsersResponse, GetOrganizationUsersError, GetOrganizationUsersResponse, ReturnType<typeof getOrganizationUsersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationUsers({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationUsersQueryKey(options)
});

export const getOrganizationUserProfilesQueryKey = (options: Options<GetOrganizationUserProfilesData>) => createQueryKey('getOrganizationUserProfiles', options);

/**
 * Get Organization User Profiles
 *
 * Return simplified profiles for every member of the organization.
 *
 * Used by the UI for sharing datasources, transferring ownership, and
 * assigning members to projects. Under the scoped role model any active
 * org member can be assigned to a project (their scoped role is set at
 * assignment time), so there's no longer an audit-roles-only filter.
 */
export const getOrganizationUserProfilesOptions = (options: Options<GetOrganizationUserProfilesData>) => queryOptions<GetOrganizationUserProfilesResponse, GetOrganizationUserProfilesError, GetOrganizationUserProfilesResponse, ReturnType<typeof getOrganizationUserProfilesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationUserProfiles({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationUserProfilesQueryKey(options)
});

export const getOrganizationInvitationsQueryKey = (options: Options<GetOrganizationInvitationsData>) => createQueryKey('getOrganizationInvitations', options);

/**
 * Get Organization Invitations
 *
 * Get all members and pending invitations for an organization.
 */
export const getOrganizationInvitationsOptions = (options: Options<GetOrganizationInvitationsData>) => queryOptions<GetOrganizationInvitationsResponse, GetOrganizationInvitationsError, GetOrganizationInvitationsResponse, ReturnType<typeof getOrganizationInvitationsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationInvitations({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationInvitationsQueryKey(options)
});

export const getOrganizationUserPermissionsQueryKey = (options: Options<GetOrganizationUserPermissionsData>) => createQueryKey('getOrganizationUserPermissions', options);

/**
 * Get Organization User Permissions
 *
 * Get user permissions within an organization.
 */
export const getOrganizationUserPermissionsOptions = (options: Options<GetOrganizationUserPermissionsData>) => queryOptions<GetOrganizationUserPermissionsResponse, GetOrganizationUserPermissionsError, GetOrganizationUserPermissionsResponse, ReturnType<typeof getOrganizationUserPermissionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationUserPermissions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationUserPermissionsQueryKey(options)
});

/**
 * Update User In Organization
 *
 * Update user information and roles in an organization.
 */
export const updateUserInOrganizationMutation = (options?: Partial<Options<UpdateUserInOrganizationData>>): UseMutationOptions<UpdateUserInOrganizationResponse, UpdateUserInOrganizationError, Options<UpdateUserInOrganizationData>> => {
  const mutationOptions: UseMutationOptions<UpdateUserInOrganizationResponse, UpdateUserInOrganizationError, Options<UpdateUserInOrganizationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUserInOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getOrganizationUserProfileQueryKey = (options: Options<GetOrganizationUserProfileData>) => createQueryKey('getOrganizationUserProfile', options);

/**
 * Get Organization User Profile
 *
 * Return a member profile and reveal context only to its owner.
 */
export const getOrganizationUserProfileOptions = (options: Options<GetOrganizationUserProfileData>) => queryOptions<GetOrganizationUserProfileResponse, GetOrganizationUserProfileError, GetOrganizationUserProfileResponse, ReturnType<typeof getOrganizationUserProfileQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationUserProfile({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationUserProfileQueryKey(options)
});

/**
 * Update Organization User Context
 *
 * Update a member's private context when the member is the caller.
 */
export const updateOrganizationUserContextMutation = (options?: Partial<Options<UpdateOrganizationUserContextData>>): UseMutationOptions<UpdateOrganizationUserContextResponse, UpdateOrganizationUserContextError, Options<UpdateOrganizationUserContextData>> => {
  const mutationOptions: UseMutationOptions<UpdateOrganizationUserContextResponse, UpdateOrganizationUserContextError, Options<UpdateOrganizationUserContextData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOrganizationUserContext({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reset Organization User Two Fa
 *
 * Reset a member's 2FA enrollment and invalidate their active sessions.
 */
export const resetOrganizationUserTwoFaMutation = (options?: Partial<Options<ResetOrganizationUserTwoFaData>>): UseMutationOptions<ResetOrganizationUserTwoFaResponse, ResetOrganizationUserTwoFaError, Options<ResetOrganizationUserTwoFaData>> => {
  const mutationOptions: UseMutationOptions<ResetOrganizationUserTwoFaResponse, ResetOrganizationUserTwoFaError, Options<ResetOrganizationUserTwoFaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetOrganizationUserTwoFa({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getOrganizationDepartmentsQueryKey = (options: Options<GetOrganizationDepartmentsData>) => createQueryKey('getOrganizationDepartments', options);

/**
 * Get Organization Departments
 *
 * Get the departments in an organization the caller may read.
 *
 * The permission check above is type-level, which a department-scoped role
 * satisfies for the type as a whole, so the caller's reach is narrowed here
 * rather than in the gate. Org-wide holders get `"*"` and see everything.
 */
export const getOrganizationDepartmentsOptions = (options: Options<GetOrganizationDepartmentsData>) => queryOptions<GetOrganizationDepartmentsResponse, GetOrganizationDepartmentsError, GetOrganizationDepartmentsResponse, ReturnType<typeof getOrganizationDepartmentsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationDepartments({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationDepartmentsQueryKey(options)
});

/**
 * Create Department
 *
 * Create a new department in an organization.
 */
export const createDepartmentMutation = (options?: Partial<Options<CreateDepartmentData>>): UseMutationOptions<CreateDepartmentResponse, CreateDepartmentError, Options<CreateDepartmentData>> => {
  const mutationOptions: UseMutationOptions<CreateDepartmentResponse, CreateDepartmentError, Options<CreateDepartmentData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDepartment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Department
 *
 * Update a department.
 */
export const updateDepartmentMutation = (options?: Partial<Options<UpdateDepartmentData>>): UseMutationOptions<UpdateDepartmentResponse, UpdateDepartmentError, Options<UpdateDepartmentData>> => {
  const mutationOptions: UseMutationOptions<UpdateDepartmentResponse, UpdateDepartmentError, Options<UpdateDepartmentData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDepartment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Set Department Members
 *
 * Replace the department's roster with the given organization members.
 *
 * The body is the department's full intended membership: anyone currently in
 * the department but not listed is removed from it, so an empty list empties
 * the department.
 */
export const setDepartmentMembersMutation = (options?: Partial<Options<SetDepartmentMembersData>>): UseMutationOptions<SetDepartmentMembersResponse, SetDepartmentMembersError, Options<SetDepartmentMembersData>> => {
  const mutationOptions: UseMutationOptions<SetDepartmentMembersResponse, SetDepartmentMembersError, Options<SetDepartmentMembersData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setDepartmentMembers({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listDepartmentAdminsQueryKey = (options: Options<ListDepartmentAdminsData>) => createQueryKey('listDepartmentAdmins', options);

/**
 * List Department Admins
 *
 * List the users administering one department.
 *
 * A delegated grant has to be discoverable to be revocable; without this the
 * only way to revoke is to already know who holds it.
 */
export const listDepartmentAdminsOptions = (options: Options<ListDepartmentAdminsData>) => queryOptions<ListDepartmentAdminsResponse, ListDepartmentAdminsError, ListDepartmentAdminsResponse, ReturnType<typeof listDepartmentAdminsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listDepartmentAdmins({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listDepartmentAdminsQueryKey(options)
});

/**
 * Remove Department Admin
 *
 * Revoke `user_id`'s administration of one department.
 */
export const removeDepartmentAdminMutation = (options?: Partial<Options<RemoveDepartmentAdminData>>): UseMutationOptions<RemoveDepartmentAdminResponse, RemoveDepartmentAdminError, Options<RemoveDepartmentAdminData>> => {
  const mutationOptions: UseMutationOptions<RemoveDepartmentAdminResponse, RemoveDepartmentAdminError, Options<RemoveDepartmentAdminData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeDepartmentAdmin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Add Department Admin
 *
 * Appoint `user_id` as an administrator of one department.
 *
 * Gated on `assign_role` for the specific department, which org_admin and
 * org_owner hold and `department_admin` deliberately does not, so the role
 * cannot appoint more of itself.
 */
export const addDepartmentAdminMutation = (options?: Partial<Options<AddDepartmentAdminData>>): UseMutationOptions<AddDepartmentAdminResponse, AddDepartmentAdminError, Options<AddDepartmentAdminData>> => {
  const mutationOptions: UseMutationOptions<AddDepartmentAdminResponse, AddDepartmentAdminError, Options<AddDepartmentAdminData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addDepartmentAdmin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Invite User To Organization By Email
 *
 * Invite a user to join an organization.
 */
export const inviteUserToOrganizationByEmailMutation = (options?: Partial<Options<InviteUserToOrganizationByEmailData>>): UseMutationOptions<unknown, InviteUserToOrganizationByEmailError, Options<InviteUserToOrganizationByEmailData>> => {
  const mutationOptions: UseMutationOptions<unknown, InviteUserToOrganizationByEmailError, Options<InviteUserToOrganizationByEmailData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await inviteUserToOrganizationByEmail({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Remove Invitation
 *
 * Delete an invitation.
 */
export const removeInvitationMutation = (options?: Partial<Options<RemoveInvitationData>>): UseMutationOptions<unknown, RemoveInvitationError, Options<RemoveInvitationData>> => {
  const mutationOptions: UseMutationOptions<unknown, RemoveInvitationError, Options<RemoveInvitationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Response User To Invitation
 *
 * Accept or decline an invitation.
 */
export const responseUserToInvitationMutation = (options?: Partial<Options<ResponseUserToInvitationData>>): UseMutationOptions<unknown, ResponseUserToInvitationError, Options<ResponseUserToInvitationData>> => {
  const mutationOptions: UseMutationOptions<unknown, ResponseUserToInvitationError, Options<ResponseUserToInvitationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await responseUserToInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Create Organization
 *
 * Create a new organization.
 */
export const createOrganizationMutation = (options?: Partial<Options<CreateOrganizationData>>): UseMutationOptions<CreateOrganizationResponse, CreateOrganizationError, Options<CreateOrganizationData>> => {
  const mutationOptions: UseMutationOptions<CreateOrganizationResponse, CreateOrganizationError, Options<CreateOrganizationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOrganization({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getTrainingOverviewQueryKey = (options: Options<GetTrainingOverviewData>) => createQueryKey('getTrainingOverview', options);

/**
 * Get Training Overview
 *
 * Who completed the training, their department, and the service lines they are active in.
 */
export const getTrainingOverviewOptions = (options: Options<GetTrainingOverviewData>) => queryOptions<GetTrainingOverviewResponse, GetTrainingOverviewError, GetTrainingOverviewResponse, ReturnType<typeof getTrainingOverviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTrainingOverview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTrainingOverviewQueryKey(options)
});

/**
 * Record Training Completions
 *
 * Record that the listed users completed the training on one day.
 */
export const recordTrainingCompletionsMutation = (options?: Partial<Options<RecordTrainingCompletionsData>>): UseMutationOptions<RecordTrainingCompletionsResponse, RecordTrainingCompletionsError, Options<RecordTrainingCompletionsData>> => {
  const mutationOptions: UseMutationOptions<RecordTrainingCompletionsResponse, RecordTrainingCompletionsError, Options<RecordTrainingCompletionsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await recordTrainingCompletions({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Training Completion
 *
 * Remove a completion that was recorded by mistake.
 */
export const deleteTrainingCompletionMutation = (options?: Partial<Options<DeleteTrainingCompletionData>>): UseMutationOptions<DeleteTrainingCompletionResponse, DeleteTrainingCompletionError, Options<DeleteTrainingCompletionData>> => {
  const mutationOptions: UseMutationOptions<DeleteTrainingCompletionResponse, DeleteTrainingCompletionError, Options<DeleteTrainingCompletionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTrainingCompletion({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getProjectsQueryKey = (options: Options<GetProjectsData>) => createQueryKey('getProjects', options);

/**
 * Get Projects
 */
export const getProjectsOptions = (options: Options<GetProjectsData>) => queryOptions<GetProjectsResponse, GetProjectsError, GetProjectsResponse, ReturnType<typeof getProjectsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjects({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectsQueryKey(options)
});

/**
 * Create Project
 */
export const createProjectMutation = (options?: Partial<Options<CreateProjectData>>): UseMutationOptions<CreateProjectResponse, CreateProjectError, Options<CreateProjectData>> => {
  const mutationOptions: UseMutationOptions<CreateProjectResponse, CreateProjectError, Options<CreateProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createProject({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const searchProjectEntitiesQueryKey = (options: Options<SearchProjectEntitiesData>) => createQueryKey('searchProjectEntities', options);

/**
 * Search Project Entities
 */
export const searchProjectEntitiesOptions = (options: Options<SearchProjectEntitiesData>) => queryOptions<SearchProjectEntitiesResponse, SearchProjectEntitiesError, SearchProjectEntitiesResponse, ReturnType<typeof searchProjectEntitiesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await searchProjectEntities({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: searchProjectEntitiesQueryKey(options)
});

export const getProjectParametersQueryKey = (options: Options<GetProjectParametersData>) => createQueryKey('getProjectParameters', options);

/**
 * Get Project Parameters
 *
 * deprecated: answers the organization-wide discovery; kept only until the frontend moves.
 *
 * @deprecated
 */
export const getProjectParametersOptions = (options: Options<GetProjectParametersData>) => queryOptions<GetProjectParametersResponse, GetProjectParametersError, GetProjectParametersResponse, ReturnType<typeof getProjectParametersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjectParameters({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectParametersQueryKey(options)
});

export const getOrganizationProjectParametersQueryKey = (options: Options<GetOrganizationProjectParametersData>) => createQueryKey('getOrganizationProjectParameters', options);

/**
 * Get Organization Project Parameters
 *
 * parameter key names of the projects the caller may read, for workflow action placeholders
 */
export const getOrganizationProjectParametersOptions = (options: Options<GetOrganizationProjectParametersData>) => queryOptions<GetOrganizationProjectParametersResponse, GetOrganizationProjectParametersError, GetOrganizationProjectParametersResponse, ReturnType<typeof getOrganizationProjectParametersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationProjectParameters({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationProjectParametersQueryKey(options)
});

export const getProjectFiltersQueryKey = (options: Options<GetProjectFiltersData>) => createQueryKey('getProjectFilters', options);

/**
 * Get Project Filters
 */
export const getProjectFiltersOptions = (options: Options<GetProjectFiltersData>) => queryOptions<GetProjectFiltersResponse, GetProjectFiltersError, GetProjectFiltersResponse, ReturnType<typeof getProjectFiltersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjectFilters({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectFiltersQueryKey(options)
});

export const getProjectHierarchyQueryKey = (options: Options<GetProjectHierarchyData>) => createQueryKey('getProjectHierarchy', options);

/**
 * Get Project Hierarchy
 */
export const getProjectHierarchyOptions = (options: Options<GetProjectHierarchyData>) => queryOptions<GetProjectHierarchyResponse, GetProjectHierarchyError, GetProjectHierarchyResponse, ReturnType<typeof getProjectHierarchyQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjectHierarchy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectHierarchyQueryKey(options)
});

/**
 * Create Project Hierarchy
 */
export const createProjectHierarchyMutation = (options?: Partial<Options<CreateProjectHierarchyData>>): UseMutationOptions<CreateProjectHierarchyResponse, CreateProjectHierarchyError, Options<CreateProjectHierarchyData>> => {
  const mutationOptions: UseMutationOptions<CreateProjectHierarchyResponse, CreateProjectHierarchyError, Options<CreateProjectHierarchyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createProjectHierarchy({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Batch Create Clients
 *
 * Batch create/update audit projects from a CSV-derived JSON array.
 *
 * Audit-only; the endpoint hardcodes `project_type="audit"` and uses
 * the audit type's UUID for the permission scope. Idempotent: re-running
 * with the same data updates existing projects (matched by company_id +
 * booking_year).
 *
 * The configured format requires a mode (create, update, or upsert). Null
 * fields preserve existing values; supplied project tags are appended without
 * duplicates. Other supplied lists replace existing values, including membership.
 * Empty tag lists preserve tags; other empty lists clear selected fields. New
 * dossiers default to the CompanyID as their name and AGBW as their module.
 * The legacy full-row format remains supported. Tasks ERP and Task Audit
 * File are mutually exclusive.
 */
export const batchCreateClientsMutation = (options?: Partial<Options<BatchCreateClientsData>>): UseMutationOptions<BatchCreateClientsResponse, BatchCreateClientsError, Options<BatchCreateClientsData>> => {
  const mutationOptions: UseMutationOptions<BatchCreateClientsResponse, BatchCreateClientsError, Options<BatchCreateClientsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await batchCreateClients({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Bulk Update Client Tags
 *
 * Add and remove tags across several root projects in one transaction.
 *
 * A delta rather than a replacement, so clients that start with different
 * tags keep their differences. Adding a tag a client already has, or removing
 * one it lacks, is a no-op; anything unknown, foreign, not a root or of
 * another type's vocabulary rejects the whole call and writes nothing. The
 * caller needs the tag management grant of every project type involved.
 */
export const bulkUpdateClientTagsMutation = (options?: Partial<Options<BulkUpdateClientTagsData>>): UseMutationOptions<BulkUpdateClientTagsResponse, BulkUpdateClientTagsError, Options<BulkUpdateClientTagsData>> => {
  const mutationOptions: UseMutationOptions<BulkUpdateClientTagsResponse, BulkUpdateClientTagsError, Options<BulkUpdateClientTagsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkUpdateClientTags({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Set Client Tags
 *
 * Replace one root project's tags. A dedicated sub-resource: the project payload is untouched.
 */
export const setClientTagsMutation = (options?: Partial<Options<SetClientTagsData>>): UseMutationOptions<SetClientTagsResponse, SetClientTagsError, Options<SetClientTagsData>> => {
  const mutationOptions: UseMutationOptions<SetClientTagsResponse, SetClientTagsError, Options<SetClientTagsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setClientTags({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Project
 */
export const deleteProjectMutation = (options?: Partial<Options<DeleteProjectData>>): UseMutationOptions<unknown, DeleteProjectError, Options<DeleteProjectData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteProjectError, Options<DeleteProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteProject({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Project
 */
export const updateProjectMutation = (options?: Partial<Options<UpdateProjectData>>): UseMutationOptions<UpdateProjectResponse, UpdateProjectError, Options<UpdateProjectData>> => {
  const mutationOptions: UseMutationOptions<UpdateProjectResponse, UpdateProjectError, Options<UpdateProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProject({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Project Status
 *
 * Update the status of a project dossier.
 *
 * Any team member with a project-scoped role (project_editor,
 * project_executor) or a project_admin scoped to the project's
 * type can open or close a dossier. The check is enforced by
 * `@check_permission` via the type-scope cascade; no manual fallback
 * needed. The action is logged for audit trail purposes.
 */
export const updateProjectStatusMutation = (options?: Partial<Options<UpdateProjectStatusData>>): UseMutationOptions<UpdateProjectStatusResponse, UpdateProjectStatusError, Options<UpdateProjectStatusData>> => {
  const mutationOptions: UseMutationOptions<UpdateProjectStatusResponse, UpdateProjectStatusError, Options<UpdateProjectStatusData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProjectStatus({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Archive Project
 *
 * Archive a top-level project together with its whole subtree.
 *
 * Rows, memberships and linked data stay untouched so `restore` is a pure
 * inverse; the tree simply leaves every normal listing and refuses writes.
 */
export const archiveProjectMutation = (options?: Partial<Options<ArchiveProjectData>>): UseMutationOptions<ArchiveProjectResponse, ArchiveProjectError, Options<ArchiveProjectData>> => {
  const mutationOptions: UseMutationOptions<ArchiveProjectResponse, ArchiveProjectError, Options<ArchiveProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await archiveProject({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Restore Project
 *
 * Bring an archived top-level project and its subtree back.
 */
export const restoreProjectMutation = (options?: Partial<Options<RestoreProjectData>>): UseMutationOptions<RestoreProjectResponse, RestoreProjectError, Options<RestoreProjectData>> => {
  const mutationOptions: UseMutationOptions<RestoreProjectResponse, RestoreProjectError, Options<RestoreProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await restoreProject({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Materiality Thresholds
 *
 * Update materiality thresholds for an audit project.
 *
 * Access is gated by `update_agbw_materiality_thresholds` scoped to the
 * specific project; granted to scoped editors/executors, plus
 * `project_admin` scoped to the audit project type via the cascade.
 */
export const updateMaterialityThresholdsMutation = (options?: Partial<Options<UpdateMaterialityThresholdsData>>): UseMutationOptions<UpdateMaterialityThresholdsResponse, UpdateMaterialityThresholdsError, Options<UpdateMaterialityThresholdsData>> => {
  const mutationOptions: UseMutationOptions<UpdateMaterialityThresholdsResponse, UpdateMaterialityThresholdsError, Options<UpdateMaterialityThresholdsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateMaterialityThresholds({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listGroupedAuditOriginGroupsQueryKey = (options: Options<ListGroupedAuditOriginGroupsData>) => createQueryKey('listGroupedAuditOriginGroups', options);

/**
 * List Grouped Audit Origin Groups
 *
 * Consume grouped validation checks per origin for a client.
 *
 * Only checks relevant to the client are listed unless `include_irrelevant` is set.
 */
export const listGroupedAuditOriginGroupsOptions = (options: Options<ListGroupedAuditOriginGroupsData>) => queryOptions<ListGroupedAuditOriginGroupsResponse, ListGroupedAuditOriginGroupsError, ListGroupedAuditOriginGroupsResponse, ReturnType<typeof listGroupedAuditOriginGroupsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listGroupedAuditOriginGroups({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listGroupedAuditOriginGroupsQueryKey(options)
});

export const exportValidationResultsQueryKey = (options: Options<ExportValidationResultsData>) => createQueryKey('exportValidationResults', options);

/**
 * Export Validation Results
 *
 * Export validation test results for a specific client as an Excel file.
 *
 * Only checks relevant to the client are exported unless `include_irrelevant` is set.
 */
export const exportValidationResultsOptions = (options: Options<ExportValidationResultsData>) => queryOptions<unknown, ExportValidationResultsError, unknown, ReturnType<typeof exportValidationResultsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportValidationResults({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportValidationResultsQueryKey(options)
});

export const getSourceStatusQueryKey = (options: Options<GetSourceStatusData>) => createQueryKey('getSourceStatus', options);

/**
 * Get Source Status
 *
 * Get the grouped data source freshness status for a client/year.
 *
 * Returns the single source group matching the client's enabled task
 * feature: the ERP group (DUO, DUS-I) for tasks_erp or the Audit File
 * group (GL Trial-Balance, Audit File Financial, Audit File HR) for
 * tasks_audit_file. The two features are mutually exclusive, so the
 * response never contains both groups. Clients with no applicable task
 * feature get an empty list; Continuous Audit is not exposed here yet.
 *
 * Args:
 *     client: The audit client (provides booking_year and company_id).
 *     source_status_service: Service for source freshness status.
 *
 * Returns:
 *     List with at most one SourceStatusGroup.
 */
export const getSourceStatusOptions = (options: Options<GetSourceStatusData>) => queryOptions<GetSourceStatusResponse, GetSourceStatusError, GetSourceStatusResponse, ReturnType<typeof getSourceStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSourceStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSourceStatusQueryKey(options)
});

/**
 * Rerun Client Checks
 *
 * Rerun the validation checks relevant to a specific client.
 */
export const rerunClientChecksMutation = (options?: Partial<Options<RerunClientChecksData>>): UseMutationOptions<unknown, RerunClientChecksError, Options<RerunClientChecksData>> => {
  const mutationOptions: UseMutationOptions<unknown, RerunClientChecksError, Options<RerunClientChecksData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await rerunClientChecks({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Rerun Single Check For Client
 *
 * Rerun a single validation check for a specific client only, relevant to it or not.
 *
 * this endpoint only executes the check using this client's parameters
 * and only updates this client's result. A check of another
 * organization answers exactly like an unknown check_id.
 */
export const rerunSingleCheckForClientMutation = (options?: Partial<Options<RerunSingleCheckForClientData>>): UseMutationOptions<unknown, RerunSingleCheckForClientError, Options<RerunSingleCheckForClientData>> => {
  const mutationOptions: UseMutationOptions<unknown, RerunSingleCheckForClientError, Options<RerunSingleCheckForClientData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await rerunSingleCheckForClient({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getProjectMembersQueryKey = (options: Options<GetProjectMembersData>) => createQueryKey('getProjectMembers', options);

/**
 * Get Project Members
 *
 * Project team members with their scoped role and task completion counts.
 *
 * Members are non-deleted members of the project's organization with a
 * project-scoped role assignment (`project_executor` or `project_editor`)
 * on this project.
 * `project_admin`s are NOT listed; they have access via the
 * project_type-scope cascade and are managed at the organization
 * level, not as team members.
 */
export const getProjectMembersOptions = (options: Options<GetProjectMembersData>) => queryOptions<GetProjectMembersResponse, GetProjectMembersError, GetProjectMembersResponse, ReturnType<typeof getProjectMembersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjectMembers({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectMembersQueryKey(options)
});

/**
 * Add Project Member
 *
 * Add a user as a project team member with the given scoped role.
 *
 * Membership and role are the same row under the new model: this writes
 * a UserRoleAssignment scoped to the project. If the user already has a
 * different scoped role on this project, the partial unique index causes
 * `assign_resource_role` to atomically replace the existing role
 * (UPSERT semantics).
 *
 * The user must be a member of the project's organization who is not
 * deleted before the role assignment is written; a user of another
 * organization answers exactly like an unknown user_id.
 */
export const addProjectMemberMutation = (options?: Partial<Options<AddProjectMemberData>>): UseMutationOptions<AddProjectMemberResponse, AddProjectMemberError, Options<AddProjectMemberData>> => {
  const mutationOptions: UseMutationOptions<AddProjectMemberResponse, AddProjectMemberError, Options<AddProjectMemberData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addProjectMember({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Remove Project Member
 *
 * Remove a user's membership from a project.
 *
 * Drops every scoped role row for (user, project); under the partial
 * unique index there's at most one anyway, but `revoke_resource_role`
 * with `role_name=None` covers any pre-existing duplicates.
 */
export const removeProjectMemberMutation = (options?: Partial<Options<RemoveProjectMemberData>>): UseMutationOptions<unknown, RemoveProjectMemberError, Options<RemoveProjectMemberData>> => {
  const mutationOptions: UseMutationOptions<unknown, RemoveProjectMemberError, Options<RemoveProjectMemberData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeProjectMember({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getProjectDatasourcesQueryKey = (options: Options<GetProjectDatasourcesData>) => createQueryKey('getProjectDatasources', options);

/**
 * Get Project Datasources
 *
 * Datasources linked to this project (dossier context).
 *
 * Used for document analysis within the dossier; not shown in the
 * general data management view. Access is gated by `read_project`
 * scoped to this project (handled by `@check_permission`); manual
 * team-membership fallback is no longer needed under the scoped role
 * model.
 */
export const getProjectDatasourcesOptions = (options: Options<GetProjectDatasourcesData>) => queryOptions<GetProjectDatasourcesResponse, GetProjectDatasourcesError, GetProjectDatasourcesResponse, ReturnType<typeof getProjectDatasourcesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjectDatasources({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectDatasourcesQueryKey(options)
});

/**
 * Delete All Trial Balance Entries
 *
 * Delete ALL trial balance entries for this client.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *     cache_service: API cache service.
 *
 * Returns:
 *     TrialBalanceDeleteResponse with deleted count.
 */
export const deleteAllTrialBalanceEntriesMutation = (options?: Partial<Options<DeleteAllTrialBalanceEntriesData>>): UseMutationOptions<DeleteAllTrialBalanceEntriesResponse, DeleteAllTrialBalanceEntriesError, Options<DeleteAllTrialBalanceEntriesData>> => {
  const mutationOptions: UseMutationOptions<DeleteAllTrialBalanceEntriesResponse, DeleteAllTrialBalanceEntriesError, Options<DeleteAllTrialBalanceEntriesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteAllTrialBalanceEntries({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getTrialBalanceEntriesQueryKey = (options: Options<GetTrialBalanceEntriesData>) => createQueryKey('getTrialBalanceEntries', options);

/**
 * Get Trial Balance Entries
 *
 * Get all trial balance entries for an audit client.
 *
 * Returns entries ordered by ledger account number.
 *
 * Args:
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *
 * Returns:
 *     TrialBalanceEntriesResponse containing all entries and count.
 */
export const getTrialBalanceEntriesOptions = (options: Options<GetTrialBalanceEntriesData>) => queryOptions<GetTrialBalanceEntriesResponse, GetTrialBalanceEntriesError, GetTrialBalanceEntriesResponse, ReturnType<typeof getTrialBalanceEntriesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTrialBalanceEntries({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTrialBalanceEntriesQueryKey(options)
});

/**
 * Delete Trial Balance Entry
 *
 * Delete a single trial balance entry.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *     cache_service: API cache service.
 *     entry_id: ID of the entry to delete.
 *
 * Raises:
 *     TrialBalanceEntryNotFoundException: If the entry is not found.
 */
export const deleteTrialBalanceEntryMutation = (options?: Partial<Options<DeleteTrialBalanceEntryData>>): UseMutationOptions<unknown, DeleteTrialBalanceEntryError, Options<DeleteTrialBalanceEntryData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteTrialBalanceEntryError, Options<DeleteTrialBalanceEntryData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTrialBalanceEntry({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Replace All Trial Balance Entries
 *
 * Replace ALL trial balance entries atomically.
 *
 * This deletes all existing entries and creates new ones in a single
 * transaction. If creation fails, deletion is also rolled back.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *     request: Replace request with new entries (can be empty to clear all).
 *
 * Returns:
 *     TrialBalanceEntriesResponse with new entries.
 *
 * Raises:
 *     TrialBalanceValidationException: If validation fails.
 */
export const replaceAllTrialBalanceEntriesMutation = (options?: Partial<Options<ReplaceAllTrialBalanceEntriesData>>): UseMutationOptions<ReplaceAllTrialBalanceEntriesResponse, ReplaceAllTrialBalanceEntriesError, Options<ReplaceAllTrialBalanceEntriesData>> => {
  const mutationOptions: UseMutationOptions<ReplaceAllTrialBalanceEntriesResponse, ReplaceAllTrialBalanceEntriesError, Options<ReplaceAllTrialBalanceEntriesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await replaceAllTrialBalanceEntries({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Export Trial Balance
 *
 * Export trial balance and trigger dbt pipeline.
 *
 * Args:
 *     client: Current audit client
 *     current_user: Current authenticated user
 *     request: Export trial balance request
 *     pipeline: Trial balance export pipeline
 *
 * Returns:
 *     ExportTrialBalanceResponse with execution details
 *
 * Raises:
 *     TrialBalanceClientMissingParametersException: If required client parameters are missing.
 *     TrialBalanceExportException: If export preparation or pipeline execution fails.
 */
export const exportTrialBalanceMutation = (options?: Partial<Options<ExportTrialBalanceData>>): UseMutationOptions<ExportTrialBalanceResponse2, ExportTrialBalanceError, Options<ExportTrialBalanceData>> => {
  const mutationOptions: UseMutationOptions<ExportTrialBalanceResponse2, ExportTrialBalanceError, Options<ExportTrialBalanceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportTrialBalance({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getTrialBalancePipelineStatusQueryKey = (options: Options<GetTrialBalancePipelineStatusData>) => createQueryKey('getTrialBalancePipelineStatus', options);

/**
 * Get Trial Balance Pipeline Status
 *
 * Get classification export pipeline execution status. Returns null when no execution exists.
 */
export const getTrialBalancePipelineStatusOptions = (options: Options<GetTrialBalancePipelineStatusData>) => queryOptions<GetTrialBalancePipelineStatusResponse, GetTrialBalancePipelineStatusError, GetTrialBalancePipelineStatusResponse, ReturnType<typeof getTrialBalancePipelineStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTrialBalancePipelineStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTrialBalancePipelineStatusQueryKey(options)
});

/**
 * Start Agbw Prechecks Pipeline
 *
 * Trigger the AGBW pipeline using the current version.
 *
 * This endpoint runs the pipeline with the existing progress data.
 * It does NOT create a new version - it uses the current version.
 *
 * The version represents the audit run, and all saves and pipeline
 * executions within that run use the same version number.
 *
 * The pipeline is triggered asynchronously. Use GET /progress/pipeline/status
 * to poll for the execution status.
 *
 * Args:
 *     client: The audit client from the path parameter.
 *     dao: Data access object for AGBW operations.
 *     agbw_full_pipeline: The AGBW pipeline instance.
 *     current_user: The currently authenticated user.
 *
 * Raises:
 *     AgbwLatestProgressNotFoundException: If no existing AGBW progress is found.
 *     AgbwPipelineTriggerException: If the pipeline fails to trigger.
 */
export const startAgbwPrechecksPipelineMutation = (options?: Partial<Options<StartAgbwPrechecksPipelineData>>): UseMutationOptions<unknown, StartAgbwPrechecksPipelineError, Options<StartAgbwPrechecksPipelineData>> => {
  const mutationOptions: UseMutationOptions<unknown, StartAgbwPrechecksPipelineError, Options<StartAgbwPrechecksPipelineData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await startAgbwPrechecksPipeline({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getAgbwPipelineStatusQueryKey = (options: Options<GetAgbwPipelineStatusData>) => createQueryKey('getAgbwPipelineStatus', options);

/**
 * Get Agbw Pipeline Status
 *
 * Get the status of AGBW child pipelines.
 *
 * Returns the current status of the 4 child pipelines (precheck, processing, export, dbt_run)
 * that are invoked by the parent agbw_full pipeline. This endpoint should be called
 * when visiting the AGBW overview page to display pipeline execution progress.
 *
 * The endpoint queries Fabric's Activity Runs API to get the status of each child
 * pipeline activity. If no execution exists or the run_id is not yet available,
 * all statuses will be returned as "not_started".
 *
 * Args:
 *     client: The audit client.
 *     agbw_full_pipeline: The AGBW full pipeline service.
 *
 * Returns:
 *     AGBWPipelineStatusResponse: Status of parent and child pipelines including:
 *         - parent_run_id: The Fabric run ID (if available)
 *         - parent_status: Overall status of the parent pipeline
 *         - has_active_execution: Whether polling should continue
 *         - children: List of 4 child pipeline statuses
 */
export const getAgbwPipelineStatusOptions = (options: Options<GetAgbwPipelineStatusData>) => queryOptions<GetAgbwPipelineStatusResponse, GetAgbwPipelineStatusError, GetAgbwPipelineStatusResponse, ReturnType<typeof getAgbwPipelineStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAgbwPipelineStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAgbwPipelineStatusQueryKey(options)
});

export const getAgbwProgressQueryKey = (options: Options<GetAgbwProgressData>) => createQueryKey('getAgbwProgress', options);

/**
 * Get Agbw Progress
 *
 * Get AGBW progress for a client.
 *
 * Retrieves the latest saved progress including file metadata (not actual file content).
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *
 * Returns:
 *     AGBWProgressResponse | None: The progress record if it exists, None otherwise.
 *
 * Raises:
 *     PermissionDeniedException: If the gate refuses the project, whatever the reason.
 */
export const getAgbwProgressOptions = (options: Options<GetAgbwProgressData>) => queryOptions<GetAgbwProgressResponse, GetAgbwProgressError, GetAgbwProgressResponse, ReturnType<typeof getAgbwProgressQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAgbwProgress({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAgbwProgressQueryKey(options)
});

/**
 * Save Agbw Progress
 *
 * Save AGBW progress for a client.
 *
 * Creates or updates progress records. Uses bulk replace strategy for
 * affiliate and trial_balance data to ensure JSONB changes are detected.
 *
 * Args:
 *     session: Database session.
 *     client: Audit client.
 *     dao: AGBW input DAO.
 *     fabric_service: Fabric upload service.
 *     file_service: Azure Blob Storage file service.
 *     current_user: Authenticated user.
 *     data: AGBW progress data to save.
 *
 * Returns:
 *     AGBWProgressResponse with version info.
 */
export const saveAgbwProgressMutation = (options?: Partial<Options<SaveAgbwProgressData>>): UseMutationOptions<SaveAgbwProgressResponse, SaveAgbwProgressError, Options<SaveAgbwProgressData>> => {
  const mutationOptions: UseMutationOptions<SaveAgbwProgressResponse, SaveAgbwProgressError, Options<SaveAgbwProgressData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveAgbwProgress({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getAgbwContinueAcknowledgmentQueryKey = (options: Options<GetAgbwContinueAcknowledgmentData>) => createQueryKey('getAgbwContinueAcknowledgment', options);

/**
 * Get Agbw Continue Acknowledgment
 *
 * Get the continue acknowledgment for an AGBW progress.
 *
 * Returns the acknowledgment record if issues have been acknowledged,
 * or None if no acknowledgment exists. Always queries the database
 * directly to ensure the guard reflects real-time state.
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     session: Database session.
 *
 * Returns:
 *     AGBWContinueAcknowledgmentResponse or None if not acknowledged.
 */
export const getAgbwContinueAcknowledgmentOptions = (options: Options<GetAgbwContinueAcknowledgmentData>) => queryOptions<GetAgbwContinueAcknowledgmentResponse, GetAgbwContinueAcknowledgmentError, GetAgbwContinueAcknowledgmentResponse, ReturnType<typeof getAgbwContinueAcknowledgmentQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAgbwContinueAcknowledgment({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAgbwContinueAcknowledgmentQueryKey(options)
});

/**
 * Acknowledge Agbw Issues
 *
 * Acknowledge AGBW issues and continue to full results.
 *
 * Records that an auditor has acknowledged issues (missing batches or
 * trial balance not reconciled) and chosen to continue viewing results.
 * This is a one-time acknowledgment per AGBW progress - once acknowledged,
 * all team members can view the full results.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     current_user: The authenticated user.
 *     data: Acknowledgment request with issue type and reason.
 *
 * Returns:
 *     AGBWContinueAcknowledgmentResponse with acknowledgment details.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const acknowledgeAgbwIssuesMutation = (options?: Partial<Options<AcknowledgeAgbwIssuesData>>): UseMutationOptions<AcknowledgeAgbwIssuesResponse, AcknowledgeAgbwIssuesError, Options<AcknowledgeAgbwIssuesData>> => {
  const mutationOptions: UseMutationOptions<AcknowledgeAgbwIssuesResponse, AcknowledgeAgbwIssuesError, Options<AcknowledgeAgbwIssuesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await acknowledgeAgbwIssues({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const exportAgbwOutputQueryKey = (options: Options<ExportAgbwOutputData>) => createQueryKey('exportAgbwOutput', options);

/**
 * Export Agbw Output
 *
 * Export AGBW output file from Fabric or generate custom Excel.
 *
 * Args:
 *     client: The audit client.
 *     organization: The organization.
 *     dao: AGBWInputDAO instance.
 *     fabric_service: Fabric upload service.
 *     overview_deps: DAOs + comment/confirmation services for the overview export.
 *     misc_daos: DAOs for the miscellaneous export.
 *     sessions: Warehouse + app database sessions.
 *     output_format: Export format ('legacy', 'lqm', 'agbw', 'data', 'miscellaneous').
 *     worksheets: List of worksheets to export (only for 'miscellaneous' format).
 *     page_size: Maximum number of rows to fetch per worksheet (default: 1000000).
 *
 * Returns:
 *     Excel file streamed from Fabric or generated Excel.
 */
export const exportAgbwOutputOptions = (options: Options<ExportAgbwOutputData>) => queryOptions<unknown, ExportAgbwOutputError, unknown, ReturnType<typeof exportAgbwOutputQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportAgbwOutput({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportAgbwOutputQueryKey(options)
});

export const getMaterialityPreferenceQueryKey = (options: Options<GetMaterialityPreferenceData>) => createQueryKey('getMaterialityPreference', options);

/**
 * Get Materiality Preference
 *
 * Get materiality preferences for the current AGBW progress.
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *
 * Returns:
 *     MaterialityPreferenceResponse with the preferences dict.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const getMaterialityPreferenceOptions = (options: Options<GetMaterialityPreferenceData>) => queryOptions<GetMaterialityPreferenceResponse, GetMaterialityPreferenceError, GetMaterialityPreferenceResponse, ReturnType<typeof getMaterialityPreferenceQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getMaterialityPreference({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMaterialityPreferenceQueryKey(options)
});

/**
 * Update Materiality Preference
 *
 * Update materiality preferences for the current AGBW progress.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     data: Request with new materiality preferences.
 *
 * Returns:
 *     MaterialityPreferenceResponse with the updated preferences.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const updateMaterialityPreferenceMutation = (options?: Partial<Options<UpdateMaterialityPreferenceData>>): UseMutationOptions<UpdateMaterialityPreferenceResponse, UpdateMaterialityPreferenceError, Options<UpdateMaterialityPreferenceData>> => {
  const mutationOptions: UseMutationOptions<UpdateMaterialityPreferenceResponse, UpdateMaterialityPreferenceError, Options<UpdateMaterialityPreferenceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateMaterialityPreference({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCpiPreferenceQueryKey = (options: Options<GetCpiPreferenceData>) => createQueryKey('getCpiPreference', options);

/**
 * Get Cpi Preference
 *
 * Get CPI score filter preferences for the current AGBW progress.
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *
 * Returns:
 *     CpiPreferenceResponse with the preferences dict.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const getCpiPreferenceOptions = (options: Options<GetCpiPreferenceData>) => queryOptions<GetCpiPreferenceResponse, GetCpiPreferenceError, GetCpiPreferenceResponse, ReturnType<typeof getCpiPreferenceQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCpiPreference({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCpiPreferenceQueryKey(options)
});

/**
 * Update Cpi Preference
 *
 * Update CPI score filter preferences for the current AGBW progress.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     data: Request with new CPI score preferences.
 *
 * Returns:
 *     CpiPreferenceResponse with the updated preferences.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const updateCpiPreferenceMutation = (options?: Partial<Options<UpdateCpiPreferenceData>>): UseMutationOptions<UpdateCpiPreferenceResponse, UpdateCpiPreferenceError, Options<UpdateCpiPreferenceData>> => {
  const mutationOptions: UseMutationOptions<UpdateCpiPreferenceResponse, UpdateCpiPreferenceError, Options<UpdateCpiPreferenceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCpiPreference({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Clear Camt Files
 *
 * Clear all CAMT files for the current AGBW progress.
 *
 * Removes all CAMT file metadata and resets the CAMT status to draft.
 * This allows users to start fresh with CAMT file uploads.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     current_user: The currently authenticated user.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const clearCamtFilesMutation = (options?: Partial<Options<ClearCamtFilesData>>): UseMutationOptions<unknown, ClearCamtFilesError, Options<ClearCamtFilesData>> => {
  const mutationOptions: UseMutationOptions<unknown, ClearCamtFilesError, Options<ClearCamtFilesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearCamtFiles({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Clear Batch Files
 *
 * Clear all batch files for the current AGBW progress.
 *
 * Removes all batch file metadata and resets the batch status to draft.
 * This allows users to start fresh with batch file uploads.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     current_user: The currently authenticated user.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const clearBatchFilesMutation = (options?: Partial<Options<ClearBatchFilesData>>): UseMutationOptions<unknown, ClearBatchFilesError, Options<ClearBatchFilesData>> => {
  const mutationOptions: UseMutationOptions<unknown, ClearBatchFilesError, Options<ClearBatchFilesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearBatchFiles({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCommentsForDashboardQueryKey = (options: Options<GetCommentsForDashboardData>) => createQueryKey('getCommentsForDashboard', options);

/**
 * Get Comments For Dashboard
 *
 * Get all comments for a specific dashboard.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row comment service.
 *     run: The run number.
 *     dashboard_name: The dashboard name.
 *
 * Returns:
 *     List of comments for the dashboard.
 */
export const getCommentsForDashboardOptions = (options: Options<GetCommentsForDashboardData>) => queryOptions<GetCommentsForDashboardResponse, GetCommentsForDashboardError, GetCommentsForDashboardResponse, ReturnType<typeof getCommentsForDashboardQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCommentsForDashboard({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCommentsForDashboardQueryKey(options)
});

/**
 * Create Or Update Comment
 *
 * Create a new comment or update an existing one.
 *
 * If a comment already exists for the same row, it will be updated.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     current_user: The current user.
 *     service: The AGBW row comment service.
 *     comment_data: The comment data.
 *
 * Returns:
 *     The created or updated comment.
 */
export const createOrUpdateCommentMutation = (options?: Partial<Options<CreateOrUpdateCommentData>>): UseMutationOptions<CreateOrUpdateCommentResponse, CreateOrUpdateCommentError, Options<CreateOrUpdateCommentData>> => {
  const mutationOptions: UseMutationOptions<CreateOrUpdateCommentResponse, CreateOrUpdateCommentError, Options<CreateOrUpdateCommentData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOrUpdateComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Comment
 *
 * Delete a specific comment by ID.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row comment service.
 *     comment_id: The comment ID to delete.
 */
export const deleteCommentMutation = (options?: Partial<Options<DeleteCommentData>>): UseMutationOptions<DeleteCommentResponse, DeleteCommentError, Options<DeleteCommentData>> => {
  const mutationOptions: UseMutationOptions<DeleteCommentResponse, DeleteCommentError, Options<DeleteCommentData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteComment({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCommentQueryKey = (options: Options<GetCommentData>) => createQueryKey('getComment', options);

/**
 * Get Comment
 *
 * Get a specific comment by ID.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row comment service.
 *     comment_id: The comment ID.
 *
 * Returns:
 *     The comment.
 */
export const getCommentOptions = (options: Options<GetCommentData>) => queryOptions<GetCommentResponse, GetCommentError, GetCommentResponse, ReturnType<typeof getCommentQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getComment({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCommentQueryKey(options)
});

/**
 * Delete Confirmation
 *
 * Delete a confirmation for a specific row.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row confirmation service.
 *     delete_request: The deletion request data.
 */
export const deleteConfirmationMutation = (options?: Partial<Options<DeleteConfirmationData>>): UseMutationOptions<DeleteConfirmationResponse, DeleteConfirmationError, Options<DeleteConfirmationData>> => {
  const mutationOptions: UseMutationOptions<DeleteConfirmationResponse, DeleteConfirmationError, Options<DeleteConfirmationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteConfirmation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getConfirmationsForDashboardQueryKey = (options: Options<GetConfirmationsForDashboardData>) => createQueryKey('getConfirmationsForDashboard', options);

/**
 * Get Confirmations For Dashboard
 *
 * Get all confirmations for a specific dashboard.
 *
 * Args:
 *     client: The audit client .
 *     organization: The organization .
 *     service: The AGBW row confirmation service.
 *     run: The run number.
 *     dashboard_name: The dashboard name.
 *
 * Returns:
 *     List of confirmations for the dashboard.
 */
export const getConfirmationsForDashboardOptions = (options: Options<GetConfirmationsForDashboardData>) => queryOptions<GetConfirmationsForDashboardResponse, GetConfirmationsForDashboardError, GetConfirmationsForDashboardResponse, ReturnType<typeof getConfirmationsForDashboardQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getConfirmationsForDashboard({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getConfirmationsForDashboardQueryKey(options)
});

/**
 * Create Or Update Confirmation
 *
 * Create a new confirmation or update an existing one.
 *
 * If a confirmation already exists for the same row, it will be updated
 * with the current user and timestamp.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     current_user: The current user.
 *     service: The AGBW row confirmation service.
 *     confirmation_data: The confirmation data.
 *
 * Returns:
 *     The created or updated confirmation.
 */
export const createOrUpdateConfirmationMutation = (options?: Partial<Options<CreateOrUpdateConfirmationData>>): UseMutationOptions<CreateOrUpdateConfirmationResponse, CreateOrUpdateConfirmationError, Options<CreateOrUpdateConfirmationData>> => {
  const mutationOptions: UseMutationOptions<CreateOrUpdateConfirmationResponse, CreateOrUpdateConfirmationError, Options<CreateOrUpdateConfirmationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOrUpdateConfirmation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getConfirmationQueryKey = (options: Options<GetConfirmationData>) => createQueryKey('getConfirmation', options);

/**
 * Get Confirmation
 *
 * Get a specific confirmation by ID.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row confirmation service.
 *     confirmation_id: The confirmation ID.
 *
 * Returns:
 *     The confirmation.
 */
export const getConfirmationOptions = (options: Options<GetConfirmationData>) => queryOptions<GetConfirmationResponse, GetConfirmationError, GetConfirmationResponse, ReturnType<typeof getConfirmationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getConfirmation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getConfirmationQueryKey(options)
});

export const getAccountsSummaryQueryKey = (options: Options<GetAccountsSummaryData>) => createQueryKey('getAccountsSummary', options);

/**
 * Get Accounts Summary
 *
 * Get accounts summary (bank balance) data. Caching is handled at the DAO level.
 *
 * Args:
 *     dao: Injected AccountsDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     page: Page number for pagination.
 *     page_size: Number of items per page.
 *     sort_by: Column to sort by.
 *     sort_direction: Sort direction ("asc" or "desc").
 *
 * Returns:
 *     AccountsSummaryResponse containing paginated account summary information.
 */
export const getAccountsSummaryOptions = (options: Options<GetAccountsSummaryData>) => queryOptions<GetAccountsSummaryResponse, GetAccountsSummaryError, GetAccountsSummaryResponse, ReturnType<typeof getAccountsSummaryQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAccountsSummary({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAccountsSummaryQueryKey(options)
});

export const getAccountsSummaryInfiniteQueryKey = (options: Options<GetAccountsSummaryData>): QueryKey<Options<GetAccountsSummaryData>> => createQueryKey('getAccountsSummary', options, true);

/**
 * Get Accounts Summary
 *
 * Get accounts summary (bank balance) data. Caching is handled at the DAO level.
 *
 * Args:
 *     dao: Injected AccountsDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     page: Page number for pagination.
 *     page_size: Number of items per page.
 *     sort_by: Column to sort by.
 *     sort_direction: Sort direction ("asc" or "desc").
 *
 * Returns:
 *     AccountsSummaryResponse containing paginated account summary information.
 */
export const getAccountsSummaryInfiniteOptions = (options: Options<GetAccountsSummaryData>) => {
  const opts = infiniteQueryOptions<GetAccountsSummaryResponse, GetAccountsSummaryError, InfiniteData<GetAccountsSummaryResponse>, QueryKey<Options<GetAccountsSummaryData>>, number | Pick<QueryKey<Options<GetAccountsSummaryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetAccountsSummaryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getAccountsSummary({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getAccountsSummaryInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getAccountsDrilldownQueryKey = (options: Options<GetAccountsDrilldownData>) => createQueryKey('getAccountsDrilldown', options);

/**
 * Get Accounts Drilldown
 *
 * Get accounts drilldown (detailed bank balance information). Caching is handled at the DAO level.
 *
 * Returns detailed balance information including trial balance amounts,
 * opening/closing dates, and impact amounts for reconciliation analysis.
 *
 * Args:
 *     dao: Injected AccountsDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     page: Page number for pagination.
 *     page_size: Number of items per page.
 *     sort_by: Column to sort by.
 *     sort_direction: Sort direction ("asc" or "desc").
 *
 * Returns:
 *     AccountsDrilldownResponse containing paginated detailed account information.
 */
export const getAccountsDrilldownOptions = (options: Options<GetAccountsDrilldownData>) => queryOptions<GetAccountsDrilldownResponse, GetAccountsDrilldownError, GetAccountsDrilldownResponse, ReturnType<typeof getAccountsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAccountsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAccountsDrilldownQueryKey(options)
});

export const getAccountsDrilldownInfiniteQueryKey = (options: Options<GetAccountsDrilldownData>): QueryKey<Options<GetAccountsDrilldownData>> => createQueryKey('getAccountsDrilldown', options, true);

/**
 * Get Accounts Drilldown
 *
 * Get accounts drilldown (detailed bank balance information). Caching is handled at the DAO level.
 *
 * Returns detailed balance information including trial balance amounts,
 * opening/closing dates, and impact amounts for reconciliation analysis.
 *
 * Args:
 *     dao: Injected AccountsDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     page: Page number for pagination.
 *     page_size: Number of items per page.
 *     sort_by: Column to sort by.
 *     sort_direction: Sort direction ("asc" or "desc").
 *
 * Returns:
 *     AccountsDrilldownResponse containing paginated detailed account information.
 */
export const getAccountsDrilldownInfiniteOptions = (options: Options<GetAccountsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetAccountsDrilldownResponse, GetAccountsDrilldownError, InfiniteData<GetAccountsDrilldownResponse>, QueryKey<Options<GetAccountsDrilldownData>>, number | Pick<QueryKey<Options<GetAccountsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetAccountsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getAccountsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getAccountsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportAccountsDrilldownQueryKey = (options: Options<ExportAccountsDrilldownData>) => createQueryKey('exportAccountsDrilldown', options);

/**
 * Export Accounts Drilldown
 *
 * Export all accounts drilldown rows as a styled Excel file.
 */
export const exportAccountsDrilldownOptions = (options: Options<ExportAccountsDrilldownData>) => queryOptions<unknown, ExportAccountsDrilldownError, unknown, ReturnType<typeof exportAccountsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportAccountsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportAccountsDrilldownQueryKey(options)
});

export const getBatchPurchaseOverviewQueryKey = (options: Options<GetBatchPurchaseOverviewData>) => createQueryKey('getBatchPurchaseOverview', options);

/**
 * Get Batch Purchase Overview
 *
 * Get batch purchase overview data. Caching is handled at the DAO level.
 *
 * Args:
 *     dao: Injected BatchDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *
 * Returns:
 *     BatchPurchaseOverviewResponse containing batch purchase overview rows.
 */
export const getBatchPurchaseOverviewOptions = (options: Options<GetBatchPurchaseOverviewData>) => queryOptions<GetBatchPurchaseOverviewResponse, GetBatchPurchaseOverviewError, GetBatchPurchaseOverviewResponse, ReturnType<typeof getBatchPurchaseOverviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getBatchPurchaseOverview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBatchPurchaseOverviewQueryKey(options)
});

export const getBatchSalaryOverviewQueryKey = (options: Options<GetBatchSalaryOverviewData>) => createQueryKey('getBatchSalaryOverview', options);

/**
 * Get Batch Salary Overview
 *
 * Get batch salary overview data. Caching is handled at the DAO level.
 *
 * Args:
 *     dao: Injected BatchDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *
 * Returns:
 *     BatchSalaryOverviewResponse containing batch salary overview rows.
 */
export const getBatchSalaryOverviewOptions = (options: Options<GetBatchSalaryOverviewData>) => queryOptions<GetBatchSalaryOverviewResponse, GetBatchSalaryOverviewError, GetBatchSalaryOverviewResponse, ReturnType<typeof getBatchSalaryOverviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getBatchSalaryOverview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBatchSalaryOverviewQueryKey(options)
});

export const getBatchDrilldownQueryKey = (options: Options<GetBatchDrilldownData>) => createQueryKey('getBatchDrilldown', options);

/**
 * Get Batch Drilldown
 *
 * Get batch drilldown transactions. Caching is handled at the DAO level.
 *
 * Returns detailed batch information including entity, IBAN, bank batch ID,
 * posting date, batch category, batch indicator, currency, total amount,
 * and transaction count.
 *
 * Args:
 *     dao: Injected BatchDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     category: Batch category filter ("Purchase" or "Salary").
 *     status: Batch status filter ("Available" or "Missing").
 *     page: Page number for pagination (default: 1).
 *     page_size: Number of items per page (default: 5000, max: 5000).
 *     sort_by: Column to sort by (optional).
 *     sort_direction: Sort direction ("asc" or "desc", default: "asc").
 *
 * Returns:
 *     BatchDrilldownResponse containing paginated batch details.
 */
export const getBatchDrilldownOptions = (options: Options<GetBatchDrilldownData>) => queryOptions<GetBatchDrilldownResponse, GetBatchDrilldownError, GetBatchDrilldownResponse, ReturnType<typeof getBatchDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getBatchDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBatchDrilldownQueryKey(options)
});

export const getBatchDrilldownInfiniteQueryKey = (options: Options<GetBatchDrilldownData>): QueryKey<Options<GetBatchDrilldownData>> => createQueryKey('getBatchDrilldown', options, true);

/**
 * Get Batch Drilldown
 *
 * Get batch drilldown transactions. Caching is handled at the DAO level.
 *
 * Returns detailed batch information including entity, IBAN, bank batch ID,
 * posting date, batch category, batch indicator, currency, total amount,
 * and transaction count.
 *
 * Args:
 *     dao: Injected BatchDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     category: Batch category filter ("Purchase" or "Salary").
 *     status: Batch status filter ("Available" or "Missing").
 *     page: Page number for pagination (default: 1).
 *     page_size: Number of items per page (default: 5000, max: 5000).
 *     sort_by: Column to sort by (optional).
 *     sort_direction: Sort direction ("asc" or "desc", default: "asc").
 *
 * Returns:
 *     BatchDrilldownResponse containing paginated batch details.
 */
export const getBatchDrilldownInfiniteOptions = (options: Options<GetBatchDrilldownData>) => {
  const opts = infiniteQueryOptions<GetBatchDrilldownResponse, GetBatchDrilldownError, InfiniteData<GetBatchDrilldownResponse>, QueryKey<Options<GetBatchDrilldownData>>, number | Pick<QueryKey<Options<GetBatchDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetBatchDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getBatchDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getBatchDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportBatchDrilldownQueryKey = (options: Options<ExportBatchDrilldownData>) => createQueryKey('exportBatchDrilldown', options);

/**
 * Export Batch Drilldown
 *
 * Export all batch drilldown rows as a styled Excel file.
 */
export const exportBatchDrilldownOptions = (options: Options<ExportBatchDrilldownData>) => queryOptions<unknown, ExportBatchDrilldownError, unknown, ReturnType<typeof exportBatchDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportBatchDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportBatchDrilldownQueryKey(options)
});

export const getPaymentOverviewQueryKey = (options: Options<GetPaymentOverviewData>) => createQueryKey('getPaymentOverview', options);

/**
 * Get Payment Overview
 *
 * Get payment overview data. Caching is handled at the DAO level.
 */
export const getPaymentOverviewOptions = (options: Options<GetPaymentOverviewData>) => queryOptions<GetPaymentOverviewResponse, GetPaymentOverviewError, GetPaymentOverviewResponse, ReturnType<typeof getPaymentOverviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPaymentOverview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPaymentOverviewQueryKey(options)
});

export const getPaymentCategoryPivotQueryKey = (options: Options<GetPaymentCategoryPivotData>) => createQueryKey('getPaymentCategoryPivot', options);

/**
 * Get Payment Category Pivot
 *
 * Get payment overview data pivoted by CategoryManualBatch.
 *
 * This endpoint implements dynamic SQL pivoting where columns
 * are determined by distinct payment categories in the data. The response
 * structure varies between audit runs based on available categories.
 * Caching is handled at the DAO level.
 *
 * The response includes:
 * - category_columns: List of distinct payment category names
 * - rows: Pivoted payment data with Entity IBAN and category amounts
 * - Last row has 'Total' in Entity IBAN column with grand totals
 *
 * Args:
 *     dao: Injected AGBW output DAO.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: The fiscal year.
 *     run: The run number.
 *
 * Returns:
 *     PaymentCategoryPivotResponse with dynamic pivoted payment data.
 *
 * Raises:
 *     AgbwLatestProgressNotFoundException: If no AGBW progress exists for the client.
 *     AgbwClientParametersNotConfiguredException: If client parameters are not configured.
 *     AgbwCompanyIdNotSetException: If the company ID is missing from client parameters.
 */
export const getPaymentCategoryPivotOptions = (options: Options<GetPaymentCategoryPivotData>) => queryOptions<GetPaymentCategoryPivotResponse, GetPaymentCategoryPivotError, GetPaymentCategoryPivotResponse, ReturnType<typeof getPaymentCategoryPivotQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPaymentCategoryPivot({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPaymentCategoryPivotQueryKey(options)
});

export const getReceivablesByCounterpartyOverviewQueryKey = (options: Options<GetReceivablesByCounterpartyOverviewData>) => createQueryKey('getReceivablesByCounterpartyOverview', options);

/**
 * Get Receivables By Counterparty Overview
 *
 * Get receivables grouped by counterparty overview data.
 */
export const getReceivablesByCounterpartyOverviewOptions = (options: Options<GetReceivablesByCounterpartyOverviewData>) => queryOptions<GetReceivablesByCounterpartyOverviewResponse, GetReceivablesByCounterpartyOverviewError, GetReceivablesByCounterpartyOverviewResponse, ReturnType<typeof getReceivablesByCounterpartyOverviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getReceivablesByCounterpartyOverview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getReceivablesByCounterpartyOverviewQueryKey(options)
});

export const getNewPartyAggregationQueryKey = (options: Options<GetNewPartyAggregationData>) => createQueryKey('getNewPartyAggregation', options);

/**
 * Get New Party Aggregation
 *
 * Get new party aggregation data. Caching is handled at the DAO level.
 */
export const getNewPartyAggregationOptions = (options: Options<GetNewPartyAggregationData>) => queryOptions<GetNewPartyAggregationResponse, GetNewPartyAggregationError, GetNewPartyAggregationResponse, ReturnType<typeof getNewPartyAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getNewPartyAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getNewPartyAggregationQueryKey(options)
});

export const getNewPartyAggregationInfiniteQueryKey = (options: Options<GetNewPartyAggregationData>): QueryKey<Options<GetNewPartyAggregationData>> => createQueryKey('getNewPartyAggregation', options, true);

/**
 * Get New Party Aggregation
 *
 * Get new party aggregation data. Caching is handled at the DAO level.
 */
export const getNewPartyAggregationInfiniteOptions = (options: Options<GetNewPartyAggregationData>) => {
  const opts = infiniteQueryOptions<GetNewPartyAggregationResponse, GetNewPartyAggregationError, InfiniteData<GetNewPartyAggregationResponse>, QueryKey<Options<GetNewPartyAggregationData>>, number | Pick<QueryKey<Options<GetNewPartyAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetNewPartyAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getNewPartyAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getNewPartyAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getNewPartyDrilldownQueryKey = (options: Options<GetNewPartyDrilldownData>) => createQueryKey('getNewPartyDrilldown', options);

/**
 * Get New Party Drilldown
 *
 * Get new party drilldown transactions. Caching is handled at the DAO level.
 */
export const getNewPartyDrilldownOptions = (options: Options<GetNewPartyDrilldownData>) => queryOptions<GetNewPartyDrilldownResponse, GetNewPartyDrilldownError, GetNewPartyDrilldownResponse, ReturnType<typeof getNewPartyDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getNewPartyDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getNewPartyDrilldownQueryKey(options)
});

export const getNewPartyDrilldownInfiniteQueryKey = (options: Options<GetNewPartyDrilldownData>): QueryKey<Options<GetNewPartyDrilldownData>> => createQueryKey('getNewPartyDrilldown', options, true);

/**
 * Get New Party Drilldown
 *
 * Get new party drilldown transactions. Caching is handled at the DAO level.
 */
export const getNewPartyDrilldownInfiniteOptions = (options: Options<GetNewPartyDrilldownData>) => {
  const opts = infiniteQueryOptions<GetNewPartyDrilldownResponse, GetNewPartyDrilldownError, InfiniteData<GetNewPartyDrilldownResponse>, QueryKey<Options<GetNewPartyDrilldownData>>, number | Pick<QueryKey<Options<GetNewPartyDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetNewPartyDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getNewPartyDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getNewPartyDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportNewPartyDrilldownQueryKey = (options: Options<ExportNewPartyDrilldownData>) => createQueryKey('exportNewPartyDrilldown', options);

/**
 * Export New Party Drilldown
 *
 * Export all new party drilldown transactions as a styled Excel file.
 */
export const exportNewPartyDrilldownOptions = (options: Options<ExportNewPartyDrilldownData>) => queryOptions<unknown, ExportNewPartyDrilldownError, unknown, ReturnType<typeof exportNewPartyDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportNewPartyDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportNewPartyDrilldownQueryKey(options)
});

export const getNameChangeAggregationQueryKey = (options: Options<GetNameChangeAggregationData>) => createQueryKey('getNameChangeAggregation', options);

/**
 * Get Name Change Aggregation
 *
 * Get name change aggregation data (all rows, no pagination).
 *
 * Returns IBANs with multiple counter-party names (name variations).
 * Includes subtotal rows per IBAN group.
 *
 * Pagination is intentionally omitted: the underlying query uses GROUPING SETS
 * which produces paired subtotal + detail rows per IBAN. SQL-level OFFSET/FETCH
 * pagination splits those groups across pages, causing the frontend grouping
 * logic to show incomplete groups (e.g. an IBAN with 2 party names appears
 * to have only 1). Caching is handled at the DAO level.
 */
export const getNameChangeAggregationOptions = (options: Options<GetNameChangeAggregationData>) => queryOptions<GetNameChangeAggregationResponse, GetNameChangeAggregationError, GetNameChangeAggregationResponse, ReturnType<typeof getNameChangeAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getNameChangeAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getNameChangeAggregationQueryKey(options)
});

export const getNameChangeDrilldownQueryKey = (options: Options<GetNameChangeDrilldownData>) => createQueryKey('getNameChangeDrilldown', options);

/**
 * Get Name Change Drilldown
 *
 * Get name change drilldown transactions. Caching is handled at the DAO level.
 */
export const getNameChangeDrilldownOptions = (options: Options<GetNameChangeDrilldownData>) => queryOptions<GetNameChangeDrilldownResponse, GetNameChangeDrilldownError, GetNameChangeDrilldownResponse, ReturnType<typeof getNameChangeDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getNameChangeDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getNameChangeDrilldownQueryKey(options)
});

export const getNameChangeDrilldownInfiniteQueryKey = (options: Options<GetNameChangeDrilldownData>): QueryKey<Options<GetNameChangeDrilldownData>> => createQueryKey('getNameChangeDrilldown', options, true);

/**
 * Get Name Change Drilldown
 *
 * Get name change drilldown transactions. Caching is handled at the DAO level.
 */
export const getNameChangeDrilldownInfiniteOptions = (options: Options<GetNameChangeDrilldownData>) => {
  const opts = infiniteQueryOptions<GetNameChangeDrilldownResponse, GetNameChangeDrilldownError, InfiniteData<GetNameChangeDrilldownResponse>, QueryKey<Options<GetNameChangeDrilldownData>>, number | Pick<QueryKey<Options<GetNameChangeDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetNameChangeDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getNameChangeDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getNameChangeDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportNameChangeDrilldownQueryKey = (options: Options<ExportNameChangeDrilldownData>) => createQueryKey('exportNameChangeDrilldown', options);

/**
 * Export Name Change Drilldown
 *
 * Export all name change drilldown transactions as a styled Excel file.
 */
export const exportNameChangeDrilldownOptions = (options: Options<ExportNameChangeDrilldownData>) => queryOptions<unknown, ExportNameChangeDrilldownError, unknown, ReturnType<typeof exportNameChangeDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportNameChangeDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportNameChangeDrilldownQueryKey(options)
});

export const getChangedIbanAggregationQueryKey = (options: Options<GetChangedIbanAggregationData>) => createQueryKey('getChangedIbanAggregation', options);

/**
 * Get Changed Iban Aggregation
 *
 * Get changed IBAN aggregation data (all rows, no pagination).
 *
 * Pagination is intentionally omitted: the underlying query uses GROUPING SETS
 * which produces paired subtotal + detail rows per counterparty. SQL-level
 * OFFSET/FETCH pagination splits those groups across pages, causing the frontend
 * grouping logic to show incomplete groups (e.g. a party with 2 IBANs appears
 * to have only 1). Caching is handled at the DAO level.
 */
export const getChangedIbanAggregationOptions = (options: Options<GetChangedIbanAggregationData>) => queryOptions<GetChangedIbanAggregationResponse, GetChangedIbanAggregationError, GetChangedIbanAggregationResponse, ReturnType<typeof getChangedIbanAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getChangedIbanAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getChangedIbanAggregationQueryKey(options)
});

export const getChangedIbanDrilldownQueryKey = (options: Options<GetChangedIbanDrilldownData>) => createQueryKey('getChangedIbanDrilldown', options);

/**
 * Get Changed Iban Drilldown
 *
 * Get changed IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getChangedIbanDrilldownOptions = (options: Options<GetChangedIbanDrilldownData>) => queryOptions<GetChangedIbanDrilldownResponse, GetChangedIbanDrilldownError, GetChangedIbanDrilldownResponse, ReturnType<typeof getChangedIbanDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getChangedIbanDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getChangedIbanDrilldownQueryKey(options)
});

export const getChangedIbanDrilldownInfiniteQueryKey = (options: Options<GetChangedIbanDrilldownData>): QueryKey<Options<GetChangedIbanDrilldownData>> => createQueryKey('getChangedIbanDrilldown', options, true);

/**
 * Get Changed Iban Drilldown
 *
 * Get changed IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getChangedIbanDrilldownInfiniteOptions = (options: Options<GetChangedIbanDrilldownData>) => {
  const opts = infiniteQueryOptions<GetChangedIbanDrilldownResponse, GetChangedIbanDrilldownError, InfiniteData<GetChangedIbanDrilldownResponse>, QueryKey<Options<GetChangedIbanDrilldownData>>, number | Pick<QueryKey<Options<GetChangedIbanDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetChangedIbanDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getChangedIbanDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getChangedIbanDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportChangedIbanDrilldownQueryKey = (options: Options<ExportChangedIbanDrilldownData>) => createQueryKey('exportChangedIbanDrilldown', options);

/**
 * Export Changed Iban Drilldown
 *
 * Export all changed IBAN drilldown transactions as a styled Excel file.
 */
export const exportChangedIbanDrilldownOptions = (options: Options<ExportChangedIbanDrilldownData>) => queryOptions<unknown, ExportChangedIbanDrilldownError, unknown, ReturnType<typeof exportChangedIbanDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportChangedIbanDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportChangedIbanDrilldownQueryKey(options)
});

export const getSpecialDescriptionAggregationQueryKey = (options: Options<GetSpecialDescriptionAggregationData>) => createQueryKey('getSpecialDescriptionAggregation', options);

/**
 * Get Special Description Aggregation
 *
 * Get special description aggregation data. Caching is handled at the DAO level.
 */
export const getSpecialDescriptionAggregationOptions = (options: Options<GetSpecialDescriptionAggregationData>) => queryOptions<GetSpecialDescriptionAggregationResponse, GetSpecialDescriptionAggregationError, GetSpecialDescriptionAggregationResponse, ReturnType<typeof getSpecialDescriptionAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSpecialDescriptionAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSpecialDescriptionAggregationQueryKey(options)
});

export const getSpecialDescriptionAggregationInfiniteQueryKey = (options: Options<GetSpecialDescriptionAggregationData>): QueryKey<Options<GetSpecialDescriptionAggregationData>> => createQueryKey('getSpecialDescriptionAggregation', options, true);

/**
 * Get Special Description Aggregation
 *
 * Get special description aggregation data. Caching is handled at the DAO level.
 */
export const getSpecialDescriptionAggregationInfiniteOptions = (options: Options<GetSpecialDescriptionAggregationData>) => {
  const opts = infiniteQueryOptions<GetSpecialDescriptionAggregationResponse, GetSpecialDescriptionAggregationError, InfiniteData<GetSpecialDescriptionAggregationResponse>, QueryKey<Options<GetSpecialDescriptionAggregationData>>, number | Pick<QueryKey<Options<GetSpecialDescriptionAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetSpecialDescriptionAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getSpecialDescriptionAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getSpecialDescriptionAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getSpecialDescriptionDrilldownQueryKey = (options: Options<GetSpecialDescriptionDrilldownData>) => createQueryKey('getSpecialDescriptionDrilldown', options);

/**
 * Get Special Description Drilldown
 *
 * Get special description drilldown transactions. Caching is handled at the DAO level.
 */
export const getSpecialDescriptionDrilldownOptions = (options: Options<GetSpecialDescriptionDrilldownData>) => queryOptions<GetSpecialDescriptionDrilldownResponse, GetSpecialDescriptionDrilldownError, GetSpecialDescriptionDrilldownResponse, ReturnType<typeof getSpecialDescriptionDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSpecialDescriptionDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSpecialDescriptionDrilldownQueryKey(options)
});

export const getSpecialDescriptionDrilldownInfiniteQueryKey = (options: Options<GetSpecialDescriptionDrilldownData>): QueryKey<Options<GetSpecialDescriptionDrilldownData>> => createQueryKey('getSpecialDescriptionDrilldown', options, true);

/**
 * Get Special Description Drilldown
 *
 * Get special description drilldown transactions. Caching is handled at the DAO level.
 */
export const getSpecialDescriptionDrilldownInfiniteOptions = (options: Options<GetSpecialDescriptionDrilldownData>) => {
  const opts = infiniteQueryOptions<GetSpecialDescriptionDrilldownResponse, GetSpecialDescriptionDrilldownError, InfiniteData<GetSpecialDescriptionDrilldownResponse>, QueryKey<Options<GetSpecialDescriptionDrilldownData>>, number | Pick<QueryKey<Options<GetSpecialDescriptionDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetSpecialDescriptionDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getSpecialDescriptionDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getSpecialDescriptionDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportNotableDescriptionDrilldownQueryKey = (options: Options<ExportNotableDescriptionDrilldownData>) => createQueryKey('exportNotableDescriptionDrilldown', options);

/**
 * Export Notable Description Drilldown
 *
 * Export all notable description drilldown transactions as a styled Excel file.
 */
export const exportNotableDescriptionDrilldownOptions = (options: Options<ExportNotableDescriptionDrilldownData>) => queryOptions<unknown, ExportNotableDescriptionDrilldownError, unknown, ReturnType<typeof exportNotableDescriptionDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportNotableDescriptionDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportNotableDescriptionDrilldownQueryKey(options)
});

export const getCpiPaymentsAggregationQueryKey = (options: Options<GetCpiPaymentsAggregationData>) => createQueryKey('getCpiPaymentsAggregation', options);

/**
 * Get Cpi Payments Aggregation
 *
 * Get CPI Score Payments aggregation. Caching is handled at the DAO level.
 */
export const getCpiPaymentsAggregationOptions = (options: Options<GetCpiPaymentsAggregationData>) => queryOptions<GetCpiPaymentsAggregationResponse, GetCpiPaymentsAggregationError, GetCpiPaymentsAggregationResponse, ReturnType<typeof getCpiPaymentsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCpiPaymentsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCpiPaymentsAggregationQueryKey(options)
});

export const getCpiPaymentsAggregationInfiniteQueryKey = (options: Options<GetCpiPaymentsAggregationData>): QueryKey<Options<GetCpiPaymentsAggregationData>> => createQueryKey('getCpiPaymentsAggregation', options, true);

/**
 * Get Cpi Payments Aggregation
 *
 * Get CPI Score Payments aggregation. Caching is handled at the DAO level.
 */
export const getCpiPaymentsAggregationInfiniteOptions = (options: Options<GetCpiPaymentsAggregationData>) => {
  const opts = infiniteQueryOptions<GetCpiPaymentsAggregationResponse, GetCpiPaymentsAggregationError, InfiniteData<GetCpiPaymentsAggregationResponse>, QueryKey<Options<GetCpiPaymentsAggregationData>>, number | Pick<QueryKey<Options<GetCpiPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetCpiPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getCpiPaymentsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getCpiPaymentsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getCpiPaymentsDrilldownQueryKey = (options: Options<GetCpiPaymentsDrilldownData>) => createQueryKey('getCpiPaymentsDrilldown', options);

/**
 * Get Cpi Payments Drilldown
 *
 * Get CPI Payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getCpiPaymentsDrilldownOptions = (options: Options<GetCpiPaymentsDrilldownData>) => queryOptions<GetCpiPaymentsDrilldownResponse, GetCpiPaymentsDrilldownError, GetCpiPaymentsDrilldownResponse, ReturnType<typeof getCpiPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCpiPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCpiPaymentsDrilldownQueryKey(options)
});

export const getCpiPaymentsDrilldownInfiniteQueryKey = (options: Options<GetCpiPaymentsDrilldownData>): QueryKey<Options<GetCpiPaymentsDrilldownData>> => createQueryKey('getCpiPaymentsDrilldown', options, true);

/**
 * Get Cpi Payments Drilldown
 *
 * Get CPI Payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getCpiPaymentsDrilldownInfiniteOptions = (options: Options<GetCpiPaymentsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetCpiPaymentsDrilldownResponse, GetCpiPaymentsDrilldownError, InfiniteData<GetCpiPaymentsDrilldownResponse>, QueryKey<Options<GetCpiPaymentsDrilldownData>>, number | Pick<QueryKey<Options<GetCpiPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetCpiPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getCpiPaymentsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getCpiPaymentsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportCpiPaymentsDrilldownQueryKey = (options: Options<ExportCpiPaymentsDrilldownData>) => createQueryKey('exportCpiPaymentsDrilldown', options);

/**
 * Export Cpi Payments Drilldown
 *
 * Export all CPI payments drilldown transactions as a styled Excel file.
 */
export const exportCpiPaymentsDrilldownOptions = (options: Options<ExportCpiPaymentsDrilldownData>) => queryOptions<unknown, ExportCpiPaymentsDrilldownError, unknown, ReturnType<typeof exportCpiPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportCpiPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportCpiPaymentsDrilldownQueryKey(options)
});

export const getCpiReceivementsAggregationQueryKey = (options: Options<GetCpiReceivementsAggregationData>) => createQueryKey('getCpiReceivementsAggregation', options);

/**
 * Get Cpi Receivements Aggregation
 *
 * Get CPI Score Receivements aggregation. Caching is handled at the DAO level.
 */
export const getCpiReceivementsAggregationOptions = (options: Options<GetCpiReceivementsAggregationData>) => queryOptions<GetCpiReceivementsAggregationResponse, GetCpiReceivementsAggregationError, GetCpiReceivementsAggregationResponse, ReturnType<typeof getCpiReceivementsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCpiReceivementsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCpiReceivementsAggregationQueryKey(options)
});

export const getCpiReceivementsAggregationInfiniteQueryKey = (options: Options<GetCpiReceivementsAggregationData>): QueryKey<Options<GetCpiReceivementsAggregationData>> => createQueryKey('getCpiReceivementsAggregation', options, true);

/**
 * Get Cpi Receivements Aggregation
 *
 * Get CPI Score Receivements aggregation. Caching is handled at the DAO level.
 */
export const getCpiReceivementsAggregationInfiniteOptions = (options: Options<GetCpiReceivementsAggregationData>) => {
  const opts = infiniteQueryOptions<GetCpiReceivementsAggregationResponse, GetCpiReceivementsAggregationError, InfiniteData<GetCpiReceivementsAggregationResponse>, QueryKey<Options<GetCpiReceivementsAggregationData>>, number | Pick<QueryKey<Options<GetCpiReceivementsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetCpiReceivementsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getCpiReceivementsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getCpiReceivementsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getCpiReceivementsDrilldownQueryKey = (options: Options<GetCpiReceivementsDrilldownData>) => createQueryKey('getCpiReceivementsDrilldown', options);

/**
 * Get Cpi Receivements Drilldown
 *
 * Get CPI Receivements drilldown transactions. Caching is handled at the DAO level.
 */
export const getCpiReceivementsDrilldownOptions = (options: Options<GetCpiReceivementsDrilldownData>) => queryOptions<GetCpiReceivementsDrilldownResponse, GetCpiReceivementsDrilldownError, GetCpiReceivementsDrilldownResponse, ReturnType<typeof getCpiReceivementsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCpiReceivementsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCpiReceivementsDrilldownQueryKey(options)
});

export const getCpiReceivementsDrilldownInfiniteQueryKey = (options: Options<GetCpiReceivementsDrilldownData>): QueryKey<Options<GetCpiReceivementsDrilldownData>> => createQueryKey('getCpiReceivementsDrilldown', options, true);

/**
 * Get Cpi Receivements Drilldown
 *
 * Get CPI Receivements drilldown transactions. Caching is handled at the DAO level.
 */
export const getCpiReceivementsDrilldownInfiniteOptions = (options: Options<GetCpiReceivementsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetCpiReceivementsDrilldownResponse, GetCpiReceivementsDrilldownError, InfiniteData<GetCpiReceivementsDrilldownResponse>, QueryKey<Options<GetCpiReceivementsDrilldownData>>, number | Pick<QueryKey<Options<GetCpiReceivementsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetCpiReceivementsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getCpiReceivementsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getCpiReceivementsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportCpiReceivedDrilldownQueryKey = (options: Options<ExportCpiReceivedDrilldownData>) => createQueryKey('exportCpiReceivedDrilldown', options);

/**
 * Export Cpi Received Drilldown
 *
 * Export all CPI received drilldown transactions as a styled Excel file.
 */
export const exportCpiReceivedDrilldownOptions = (options: Options<ExportCpiReceivedDrilldownData>) => queryOptions<unknown, ExportCpiReceivedDrilldownError, unknown, ReturnType<typeof exportCpiReceivedDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportCpiReceivedDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportCpiReceivedDrilldownQueryKey(options)
});

export const getRecurrentPaymentsAggregationQueryKey = (options: Options<GetRecurrentPaymentsAggregationData>) => createQueryKey('getRecurrentPaymentsAggregation', options);

/**
 * Get Recurrent Payments Aggregation
 *
 * Get recurrent payments aggregation data. Caching is handled at the DAO level.
 */
export const getRecurrentPaymentsAggregationOptions = (options: Options<GetRecurrentPaymentsAggregationData>) => queryOptions<GetRecurrentPaymentsAggregationResponse, GetRecurrentPaymentsAggregationError, GetRecurrentPaymentsAggregationResponse, ReturnType<typeof getRecurrentPaymentsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getRecurrentPaymentsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRecurrentPaymentsAggregationQueryKey(options)
});

export const getRecurrentPaymentsAggregationInfiniteQueryKey = (options: Options<GetRecurrentPaymentsAggregationData>): QueryKey<Options<GetRecurrentPaymentsAggregationData>> => createQueryKey('getRecurrentPaymentsAggregation', options, true);

/**
 * Get Recurrent Payments Aggregation
 *
 * Get recurrent payments aggregation data. Caching is handled at the DAO level.
 */
export const getRecurrentPaymentsAggregationInfiniteOptions = (options: Options<GetRecurrentPaymentsAggregationData>) => {
  const opts = infiniteQueryOptions<GetRecurrentPaymentsAggregationResponse, GetRecurrentPaymentsAggregationError, InfiniteData<GetRecurrentPaymentsAggregationResponse>, QueryKey<Options<GetRecurrentPaymentsAggregationData>>, number | Pick<QueryKey<Options<GetRecurrentPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetRecurrentPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getRecurrentPaymentsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getRecurrentPaymentsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getRecurrentPaymentsDrilldownQueryKey = (options: Options<GetRecurrentPaymentsDrilldownData>) => createQueryKey('getRecurrentPaymentsDrilldown', options);

/**
 * Get Recurrent Payments Drilldown
 *
 * Get recurrent payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getRecurrentPaymentsDrilldownOptions = (options: Options<GetRecurrentPaymentsDrilldownData>) => queryOptions<GetRecurrentPaymentsDrilldownResponse, GetRecurrentPaymentsDrilldownError, GetRecurrentPaymentsDrilldownResponse, ReturnType<typeof getRecurrentPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getRecurrentPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRecurrentPaymentsDrilldownQueryKey(options)
});

export const getRecurrentPaymentsDrilldownInfiniteQueryKey = (options: Options<GetRecurrentPaymentsDrilldownData>): QueryKey<Options<GetRecurrentPaymentsDrilldownData>> => createQueryKey('getRecurrentPaymentsDrilldown', options, true);

/**
 * Get Recurrent Payments Drilldown
 *
 * Get recurrent payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getRecurrentPaymentsDrilldownInfiniteOptions = (options: Options<GetRecurrentPaymentsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetRecurrentPaymentsDrilldownResponse, GetRecurrentPaymentsDrilldownError, InfiniteData<GetRecurrentPaymentsDrilldownResponse>, QueryKey<Options<GetRecurrentPaymentsDrilldownData>>, number | Pick<QueryKey<Options<GetRecurrentPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetRecurrentPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getRecurrentPaymentsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getRecurrentPaymentsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportRecurrentPaymentsDrilldownQueryKey = (options: Options<ExportRecurrentPaymentsDrilldownData>) => createQueryKey('exportRecurrentPaymentsDrilldown', options);

/**
 * Export Recurrent Payments Drilldown
 *
 * Export all recurrent payments drilldown rows as a styled Excel file.
 */
export const exportRecurrentPaymentsDrilldownOptions = (options: Options<ExportRecurrentPaymentsDrilldownData>) => queryOptions<unknown, ExportRecurrentPaymentsDrilldownError, unknown, ReturnType<typeof exportRecurrentPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportRecurrentPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportRecurrentPaymentsDrilldownQueryKey(options)
});

export const getMissingIbanPaymentsAggregationQueryKey = (options: Options<GetMissingIbanPaymentsAggregationData>) => createQueryKey('getMissingIbanPaymentsAggregation', options);

/**
 * Get Missing Iban Payments Aggregation
 *
 * Get missing IBAN aggregation data.
 *
 * Returns payments with missing or invalid IBAN information.
 * Caching is handled at the DAO level.
 */
export const getMissingIbanPaymentsAggregationOptions = (options: Options<GetMissingIbanPaymentsAggregationData>) => queryOptions<GetMissingIbanPaymentsAggregationResponse, GetMissingIbanPaymentsAggregationError, GetMissingIbanPaymentsAggregationResponse, ReturnType<typeof getMissingIbanPaymentsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getMissingIbanPaymentsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMissingIbanPaymentsAggregationQueryKey(options)
});

export const getMissingIbanPaymentsAggregationInfiniteQueryKey = (options: Options<GetMissingIbanPaymentsAggregationData>): QueryKey<Options<GetMissingIbanPaymentsAggregationData>> => createQueryKey('getMissingIbanPaymentsAggregation', options, true);

/**
 * Get Missing Iban Payments Aggregation
 *
 * Get missing IBAN aggregation data.
 *
 * Returns payments with missing or invalid IBAN information.
 * Caching is handled at the DAO level.
 */
export const getMissingIbanPaymentsAggregationInfiniteOptions = (options: Options<GetMissingIbanPaymentsAggregationData>) => {
  const opts = infiniteQueryOptions<GetMissingIbanPaymentsAggregationResponse, GetMissingIbanPaymentsAggregationError, InfiniteData<GetMissingIbanPaymentsAggregationResponse>, QueryKey<Options<GetMissingIbanPaymentsAggregationData>>, number | Pick<QueryKey<Options<GetMissingIbanPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetMissingIbanPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getMissingIbanPaymentsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getMissingIbanPaymentsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getMissingIbanPaymentsDrilldownQueryKey = (options: Options<GetMissingIbanPaymentsDrilldownData>) => createQueryKey('getMissingIbanPaymentsDrilldown', options);

/**
 * Get Missing Iban Payments Drilldown
 *
 * Get missing IBAN drilldown transactions.
 *
 * Click-through from aggregation row by tc_description and payment_type.
 * Note: Missing IBAN drilldown has different columns than standard drilldown.
 * Caching is handled at the DAO level.
 */
export const getMissingIbanPaymentsDrilldownOptions = (options: Options<GetMissingIbanPaymentsDrilldownData>) => queryOptions<GetMissingIbanPaymentsDrilldownResponse, GetMissingIbanPaymentsDrilldownError, GetMissingIbanPaymentsDrilldownResponse, ReturnType<typeof getMissingIbanPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getMissingIbanPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMissingIbanPaymentsDrilldownQueryKey(options)
});

export const getMissingIbanPaymentsDrilldownInfiniteQueryKey = (options: Options<GetMissingIbanPaymentsDrilldownData>): QueryKey<Options<GetMissingIbanPaymentsDrilldownData>> => createQueryKey('getMissingIbanPaymentsDrilldown', options, true);

/**
 * Get Missing Iban Payments Drilldown
 *
 * Get missing IBAN drilldown transactions.
 *
 * Click-through from aggregation row by tc_description and payment_type.
 * Note: Missing IBAN drilldown has different columns than standard drilldown.
 * Caching is handled at the DAO level.
 */
export const getMissingIbanPaymentsDrilldownInfiniteOptions = (options: Options<GetMissingIbanPaymentsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetMissingIbanPaymentsDrilldownResponse, GetMissingIbanPaymentsDrilldownError, InfiniteData<GetMissingIbanPaymentsDrilldownResponse>, QueryKey<Options<GetMissingIbanPaymentsDrilldownData>>, number | Pick<QueryKey<Options<GetMissingIbanPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetMissingIbanPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getMissingIbanPaymentsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getMissingIbanPaymentsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportMissingIbanPaymentsDrilldownQueryKey = (options: Options<ExportMissingIbanPaymentsDrilldownData>) => createQueryKey('exportMissingIbanPaymentsDrilldown', options);

/**
 * Export Missing Iban Payments Drilldown
 *
 * Export all missing IBAN payments drilldown rows as a styled Excel file.
 */
export const exportMissingIbanPaymentsDrilldownOptions = (options: Options<ExportMissingIbanPaymentsDrilldownData>) => queryOptions<unknown, ExportMissingIbanPaymentsDrilldownError, unknown, ReturnType<typeof exportMissingIbanPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportMissingIbanPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportMissingIbanPaymentsDrilldownQueryKey(options)
});

export const getMissingIbanReceivedAggregationQueryKey = (options: Options<GetMissingIbanReceivedAggregationData>) => createQueryKey('getMissingIbanReceivedAggregation', options);

/**
 * Get Missing Iban Received Aggregation
 *
 * Get Receivements without IBAN aggregation. Caching is handled at the DAO level.
 */
export const getMissingIbanReceivedAggregationOptions = (options: Options<GetMissingIbanReceivedAggregationData>) => queryOptions<GetMissingIbanReceivedAggregationResponse, GetMissingIbanReceivedAggregationError, GetMissingIbanReceivedAggregationResponse, ReturnType<typeof getMissingIbanReceivedAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getMissingIbanReceivedAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMissingIbanReceivedAggregationQueryKey(options)
});

export const getMissingIbanReceivedAggregationInfiniteQueryKey = (options: Options<GetMissingIbanReceivedAggregationData>): QueryKey<Options<GetMissingIbanReceivedAggregationData>> => createQueryKey('getMissingIbanReceivedAggregation', options, true);

/**
 * Get Missing Iban Received Aggregation
 *
 * Get Receivements without IBAN aggregation. Caching is handled at the DAO level.
 */
export const getMissingIbanReceivedAggregationInfiniteOptions = (options: Options<GetMissingIbanReceivedAggregationData>) => {
  const opts = infiniteQueryOptions<GetMissingIbanReceivedAggregationResponse, GetMissingIbanReceivedAggregationError, InfiniteData<GetMissingIbanReceivedAggregationResponse>, QueryKey<Options<GetMissingIbanReceivedAggregationData>>, number | Pick<QueryKey<Options<GetMissingIbanReceivedAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetMissingIbanReceivedAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getMissingIbanReceivedAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getMissingIbanReceivedAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getMissingIbanReceivedDrilldownQueryKey = (options: Options<GetMissingIbanReceivedDrilldownData>) => createQueryKey('getMissingIbanReceivedDrilldown', options);

/**
 * Get Missing Iban Received Drilldown
 *
 * Get Receivements without IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getMissingIbanReceivedDrilldownOptions = (options: Options<GetMissingIbanReceivedDrilldownData>) => queryOptions<GetMissingIbanReceivedDrilldownResponse, GetMissingIbanReceivedDrilldownError, GetMissingIbanReceivedDrilldownResponse, ReturnType<typeof getMissingIbanReceivedDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getMissingIbanReceivedDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMissingIbanReceivedDrilldownQueryKey(options)
});

export const getMissingIbanReceivedDrilldownInfiniteQueryKey = (options: Options<GetMissingIbanReceivedDrilldownData>): QueryKey<Options<GetMissingIbanReceivedDrilldownData>> => createQueryKey('getMissingIbanReceivedDrilldown', options, true);

/**
 * Get Missing Iban Received Drilldown
 *
 * Get Receivements without IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getMissingIbanReceivedDrilldownInfiniteOptions = (options: Options<GetMissingIbanReceivedDrilldownData>) => {
  const opts = infiniteQueryOptions<GetMissingIbanReceivedDrilldownResponse, GetMissingIbanReceivedDrilldownError, InfiniteData<GetMissingIbanReceivedDrilldownResponse>, QueryKey<Options<GetMissingIbanReceivedDrilldownData>>, number | Pick<QueryKey<Options<GetMissingIbanReceivedDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetMissingIbanReceivedDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getMissingIbanReceivedDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getMissingIbanReceivedDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportMissingIbanReceivedDrilldownQueryKey = (options: Options<ExportMissingIbanReceivedDrilldownData>) => createQueryKey('exportMissingIbanReceivedDrilldown', options);

/**
 * Export Missing Iban Received Drilldown
 *
 * Export all missing IBAN received drilldown rows as a styled Excel file.
 */
export const exportMissingIbanReceivedDrilldownOptions = (options: Options<ExportMissingIbanReceivedDrilldownData>) => queryOptions<unknown, ExportMissingIbanReceivedDrilldownError, unknown, ReturnType<typeof exportMissingIbanReceivedDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportMissingIbanReceivedDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportMissingIbanReceivedDrilldownQueryKey(options)
});

export const getWeekVacationDaysAggregationQueryKey = (options: Options<GetWeekVacationDaysAggregationData>) => createQueryKey('getWeekVacationDaysAggregation', options);

/**
 * Get Week Vacation Days Aggregation
 *
 * Get week vacation days aggregation data for pivot table. Caching is handled at the DAO level.
 */
export const getWeekVacationDaysAggregationOptions = (options: Options<GetWeekVacationDaysAggregationData>) => queryOptions<GetWeekVacationDaysAggregationResponse, GetWeekVacationDaysAggregationError, GetWeekVacationDaysAggregationResponse, ReturnType<typeof getWeekVacationDaysAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getWeekVacationDaysAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWeekVacationDaysAggregationQueryKey(options)
});

export const getWeekVacationDaysAggregationInfiniteQueryKey = (options: Options<GetWeekVacationDaysAggregationData>): QueryKey<Options<GetWeekVacationDaysAggregationData>> => createQueryKey('getWeekVacationDaysAggregation', options, true);

/**
 * Get Week Vacation Days Aggregation
 *
 * Get week vacation days aggregation data for pivot table. Caching is handled at the DAO level.
 */
export const getWeekVacationDaysAggregationInfiniteOptions = (options: Options<GetWeekVacationDaysAggregationData>) => {
  const opts = infiniteQueryOptions<GetWeekVacationDaysAggregationResponse, GetWeekVacationDaysAggregationError, InfiniteData<GetWeekVacationDaysAggregationResponse>, QueryKey<Options<GetWeekVacationDaysAggregationData>>, number | Pick<QueryKey<Options<GetWeekVacationDaysAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetWeekVacationDaysAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getWeekVacationDaysAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getWeekVacationDaysAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getWeekVacationDaysDrilldownQueryKey = (options: Options<GetWeekVacationDaysDrilldownData>) => createQueryKey('getWeekVacationDaysDrilldown', options);

/**
 * Get Week Vacation Days Drilldown
 *
 * Get week vacation days drilldown transactions. Caching is handled at the DAO level.
 */
export const getWeekVacationDaysDrilldownOptions = (options: Options<GetWeekVacationDaysDrilldownData>) => queryOptions<GetWeekVacationDaysDrilldownResponse, GetWeekVacationDaysDrilldownError, GetWeekVacationDaysDrilldownResponse, ReturnType<typeof getWeekVacationDaysDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getWeekVacationDaysDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWeekVacationDaysDrilldownQueryKey(options)
});

export const getWeekVacationDaysDrilldownInfiniteQueryKey = (options: Options<GetWeekVacationDaysDrilldownData>): QueryKey<Options<GetWeekVacationDaysDrilldownData>> => createQueryKey('getWeekVacationDaysDrilldown', options, true);

/**
 * Get Week Vacation Days Drilldown
 *
 * Get week vacation days drilldown transactions. Caching is handled at the DAO level.
 */
export const getWeekVacationDaysDrilldownInfiniteOptions = (options: Options<GetWeekVacationDaysDrilldownData>) => {
  const opts = infiniteQueryOptions<GetWeekVacationDaysDrilldownResponse, GetWeekVacationDaysDrilldownError, InfiniteData<GetWeekVacationDaysDrilldownResponse>, QueryKey<Options<GetWeekVacationDaysDrilldownData>>, number | Pick<QueryKey<Options<GetWeekVacationDaysDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetWeekVacationDaysDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getWeekVacationDaysDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getWeekVacationDaysDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportWeekVacationDaysDrilldownQueryKey = (options: Options<ExportWeekVacationDaysDrilldownData>) => createQueryKey('exportWeekVacationDaysDrilldown', options);

/**
 * Export Week Vacation Days Drilldown
 *
 * Export all week/vacation days drilldown rows as a styled Excel file.
 */
export const exportWeekVacationDaysDrilldownOptions = (options: Options<ExportWeekVacationDaysDrilldownData>) => queryOptions<unknown, ExportWeekVacationDaysDrilldownError, unknown, ReturnType<typeof exportWeekVacationDaysDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportWeekVacationDaysDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportWeekVacationDaysDrilldownQueryKey(options)
});

export const getCreditcardStatementsAggregationQueryKey = (options: Options<GetCreditcardStatementsAggregationData>) => createQueryKey('getCreditcardStatementsAggregation', options);

/**
 * Get Creditcard Statements Aggregation
 *
 * Get credit card statements aggregation data. Caching is handled at the DAO level.
 */
export const getCreditcardStatementsAggregationOptions = (options: Options<GetCreditcardStatementsAggregationData>) => queryOptions<GetCreditcardStatementsAggregationResponse, GetCreditcardStatementsAggregationError, GetCreditcardStatementsAggregationResponse, ReturnType<typeof getCreditcardStatementsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCreditcardStatementsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCreditcardStatementsAggregationQueryKey(options)
});

export const getCreditcardStatementsAggregationInfiniteQueryKey = (options: Options<GetCreditcardStatementsAggregationData>): QueryKey<Options<GetCreditcardStatementsAggregationData>> => createQueryKey('getCreditcardStatementsAggregation', options, true);

/**
 * Get Creditcard Statements Aggregation
 *
 * Get credit card statements aggregation data. Caching is handled at the DAO level.
 */
export const getCreditcardStatementsAggregationInfiniteOptions = (options: Options<GetCreditcardStatementsAggregationData>) => {
  const opts = infiniteQueryOptions<GetCreditcardStatementsAggregationResponse, GetCreditcardStatementsAggregationError, InfiniteData<GetCreditcardStatementsAggregationResponse>, QueryKey<Options<GetCreditcardStatementsAggregationData>>, number | Pick<QueryKey<Options<GetCreditcardStatementsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetCreditcardStatementsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getCreditcardStatementsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getCreditcardStatementsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getCreditcardStatementsDrilldownQueryKey = (options: Options<GetCreditcardStatementsDrilldownData>) => createQueryKey('getCreditcardStatementsDrilldown', options);

/**
 * Get Creditcard Statements Drilldown
 *
 * Get credit card statements drilldown transactions. Caching is handled at the DAO level.
 */
export const getCreditcardStatementsDrilldownOptions = (options: Options<GetCreditcardStatementsDrilldownData>) => queryOptions<GetCreditcardStatementsDrilldownResponse, GetCreditcardStatementsDrilldownError, GetCreditcardStatementsDrilldownResponse, ReturnType<typeof getCreditcardStatementsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCreditcardStatementsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCreditcardStatementsDrilldownQueryKey(options)
});

export const getCreditcardStatementsDrilldownInfiniteQueryKey = (options: Options<GetCreditcardStatementsDrilldownData>): QueryKey<Options<GetCreditcardStatementsDrilldownData>> => createQueryKey('getCreditcardStatementsDrilldown', options, true);

/**
 * Get Creditcard Statements Drilldown
 *
 * Get credit card statements drilldown transactions. Caching is handled at the DAO level.
 */
export const getCreditcardStatementsDrilldownInfiniteOptions = (options: Options<GetCreditcardStatementsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetCreditcardStatementsDrilldownResponse, GetCreditcardStatementsDrilldownError, InfiniteData<GetCreditcardStatementsDrilldownResponse>, QueryKey<Options<GetCreditcardStatementsDrilldownData>>, number | Pick<QueryKey<Options<GetCreditcardStatementsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetCreditcardStatementsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getCreditcardStatementsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getCreditcardStatementsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportCreditcardStatementsDrilldownQueryKey = (options: Options<ExportCreditcardStatementsDrilldownData>) => createQueryKey('exportCreditcardStatementsDrilldown', options);

/**
 * Export Creditcard Statements Drilldown
 *
 * Export all credit card statements drilldown rows as a styled Excel file.
 */
export const exportCreditcardStatementsDrilldownOptions = (options: Options<ExportCreditcardStatementsDrilldownData>) => queryOptions<unknown, ExportCreditcardStatementsDrilldownError, unknown, ReturnType<typeof exportCreditcardStatementsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportCreditcardStatementsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportCreditcardStatementsDrilldownQueryKey(options)
});

export const getIbanSalaryOtherPaymentsAggregationQueryKey = (options: Options<GetIbanSalaryOtherPaymentsAggregationData>) => createQueryKey('getIbanSalaryOtherPaymentsAggregation', options);

/**
 * Get Iban Salary Other Payments Aggregation
 *
 * Get IBANs that received both salary and non-salary payments.
 */
export const getIbanSalaryOtherPaymentsAggregationOptions = (options: Options<GetIbanSalaryOtherPaymentsAggregationData>) => queryOptions<GetIbanSalaryOtherPaymentsAggregationResponse, GetIbanSalaryOtherPaymentsAggregationError, GetIbanSalaryOtherPaymentsAggregationResponse, ReturnType<typeof getIbanSalaryOtherPaymentsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getIbanSalaryOtherPaymentsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getIbanSalaryOtherPaymentsAggregationQueryKey(options)
});

export const getIbanSalaryOtherPaymentsAggregationInfiniteQueryKey = (options: Options<GetIbanSalaryOtherPaymentsAggregationData>): QueryKey<Options<GetIbanSalaryOtherPaymentsAggregationData>> => createQueryKey('getIbanSalaryOtherPaymentsAggregation', options, true);

/**
 * Get Iban Salary Other Payments Aggregation
 *
 * Get IBANs that received both salary and non-salary payments.
 */
export const getIbanSalaryOtherPaymentsAggregationInfiniteOptions = (options: Options<GetIbanSalaryOtherPaymentsAggregationData>) => {
  const opts = infiniteQueryOptions<GetIbanSalaryOtherPaymentsAggregationResponse, GetIbanSalaryOtherPaymentsAggregationError, InfiniteData<GetIbanSalaryOtherPaymentsAggregationResponse>, QueryKey<Options<GetIbanSalaryOtherPaymentsAggregationData>>, number | Pick<QueryKey<Options<GetIbanSalaryOtherPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetIbanSalaryOtherPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getIbanSalaryOtherPaymentsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getIbanSalaryOtherPaymentsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getIbanSalaryOtherPaymentsDrilldownQueryKey = (options: Options<GetIbanSalaryOtherPaymentsDrilldownData>) => createQueryKey('getIbanSalaryOtherPaymentsDrilldown', options);

/**
 * Get Iban Salary Other Payments Drilldown
 *
 * Get non-salary drilldown transactions for a selected IBAN.
 */
export const getIbanSalaryOtherPaymentsDrilldownOptions = (options: Options<GetIbanSalaryOtherPaymentsDrilldownData>) => queryOptions<GetIbanSalaryOtherPaymentsDrilldownResponse, GetIbanSalaryOtherPaymentsDrilldownError, GetIbanSalaryOtherPaymentsDrilldownResponse, ReturnType<typeof getIbanSalaryOtherPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getIbanSalaryOtherPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getIbanSalaryOtherPaymentsDrilldownQueryKey(options)
});

export const getIbanSalaryOtherPaymentsDrilldownInfiniteQueryKey = (options: Options<GetIbanSalaryOtherPaymentsDrilldownData>): QueryKey<Options<GetIbanSalaryOtherPaymentsDrilldownData>> => createQueryKey('getIbanSalaryOtherPaymentsDrilldown', options, true);

/**
 * Get Iban Salary Other Payments Drilldown
 *
 * Get non-salary drilldown transactions for a selected IBAN.
 */
export const getIbanSalaryOtherPaymentsDrilldownInfiniteOptions = (options: Options<GetIbanSalaryOtherPaymentsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetIbanSalaryOtherPaymentsDrilldownResponse, GetIbanSalaryOtherPaymentsDrilldownError, InfiniteData<GetIbanSalaryOtherPaymentsDrilldownResponse>, QueryKey<Options<GetIbanSalaryOtherPaymentsDrilldownData>>, number | Pick<QueryKey<Options<GetIbanSalaryOtherPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetIbanSalaryOtherPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getIbanSalaryOtherPaymentsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getIbanSalaryOtherPaymentsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportIbanSalaryOtherPaymentsDrilldownQueryKey = (options: Options<ExportIbanSalaryOtherPaymentsDrilldownData>) => createQueryKey('exportIbanSalaryOtherPaymentsDrilldown', options);

/**
 * Export Iban Salary Other Payments Drilldown
 *
 * Export all IBAN salary/other payments drilldown rows as a styled Excel file.
 */
export const exportIbanSalaryOtherPaymentsDrilldownOptions = (options: Options<ExportIbanSalaryOtherPaymentsDrilldownData>) => queryOptions<unknown, ExportIbanSalaryOtherPaymentsDrilldownError, unknown, ReturnType<typeof exportIbanSalaryOtherPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportIbanSalaryOtherPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportIbanSalaryOtherPaymentsDrilldownQueryKey(options)
});

export const getGovernmentAggregationQueryKey = (options: Options<GetGovernmentAggregationData>) => createQueryKey('getGovernmentAggregation', options);

/**
 * Get Government Aggregation
 *
 * Get Government aggregation. Caching is handled at the DAO level.
 */
export const getGovernmentAggregationOptions = (options: Options<GetGovernmentAggregationData>) => queryOptions<GetGovernmentAggregationResponse, GetGovernmentAggregationError, GetGovernmentAggregationResponse, ReturnType<typeof getGovernmentAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getGovernmentAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGovernmentAggregationQueryKey(options)
});

export const getGovernmentAggregationInfiniteQueryKey = (options: Options<GetGovernmentAggregationData>): QueryKey<Options<GetGovernmentAggregationData>> => createQueryKey('getGovernmentAggregation', options, true);

/**
 * Get Government Aggregation
 *
 * Get Government aggregation. Caching is handled at the DAO level.
 */
export const getGovernmentAggregationInfiniteOptions = (options: Options<GetGovernmentAggregationData>) => {
  const opts = infiniteQueryOptions<GetGovernmentAggregationResponse, GetGovernmentAggregationError, InfiniteData<GetGovernmentAggregationResponse>, QueryKey<Options<GetGovernmentAggregationData>>, number | Pick<QueryKey<Options<GetGovernmentAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetGovernmentAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getGovernmentAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getGovernmentAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getGovernmentDrilldownQueryKey = (options: Options<GetGovernmentDrilldownData>) => createQueryKey('getGovernmentDrilldown', options);

/**
 * Get Government Drilldown
 *
 * Get Government drilldown transactions. Caching is handled at the DAO level.
 */
export const getGovernmentDrilldownOptions = (options: Options<GetGovernmentDrilldownData>) => queryOptions<GetGovernmentDrilldownResponse, GetGovernmentDrilldownError, GetGovernmentDrilldownResponse, ReturnType<typeof getGovernmentDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getGovernmentDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getGovernmentDrilldownQueryKey(options)
});

export const getGovernmentDrilldownInfiniteQueryKey = (options: Options<GetGovernmentDrilldownData>): QueryKey<Options<GetGovernmentDrilldownData>> => createQueryKey('getGovernmentDrilldown', options, true);

/**
 * Get Government Drilldown
 *
 * Get Government drilldown transactions. Caching is handled at the DAO level.
 */
export const getGovernmentDrilldownInfiniteOptions = (options: Options<GetGovernmentDrilldownData>) => {
  const opts = infiniteQueryOptions<GetGovernmentDrilldownResponse, GetGovernmentDrilldownError, InfiniteData<GetGovernmentDrilldownResponse>, QueryKey<Options<GetGovernmentDrilldownData>>, number | Pick<QueryKey<Options<GetGovernmentDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetGovernmentDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getGovernmentDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getGovernmentDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportGovernmentDrilldownQueryKey = (options: Options<ExportGovernmentDrilldownData>) => createQueryKey('exportGovernmentDrilldown', options);

/**
 * Export Government Drilldown
 *
 * Export all government payments drilldown rows as a styled Excel file.
 */
export const exportGovernmentDrilldownOptions = (options: Options<ExportGovernmentDrilldownData>) => queryOptions<unknown, ExportGovernmentDrilldownError, unknown, ReturnType<typeof exportGovernmentDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportGovernmentDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportGovernmentDrilldownQueryKey(options)
});

export const getIntercompanyPaymentsAggregationQueryKey = (options: Options<GetIntercompanyPaymentsAggregationData>) => createQueryKey('getIntercompanyPaymentsAggregation', options);

/**
 * Get Intercompany Payments Aggregation
 *
 * Get Intercompany Payments aggregation. Caching is handled at the DAO level.
 */
export const getIntercompanyPaymentsAggregationOptions = (options: Options<GetIntercompanyPaymentsAggregationData>) => queryOptions<GetIntercompanyPaymentsAggregationResponse, GetIntercompanyPaymentsAggregationError, GetIntercompanyPaymentsAggregationResponse, ReturnType<typeof getIntercompanyPaymentsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getIntercompanyPaymentsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getIntercompanyPaymentsAggregationQueryKey(options)
});

export const getIntercompanyPaymentsAggregationInfiniteQueryKey = (options: Options<GetIntercompanyPaymentsAggregationData>): QueryKey<Options<GetIntercompanyPaymentsAggregationData>> => createQueryKey('getIntercompanyPaymentsAggregation', options, true);

/**
 * Get Intercompany Payments Aggregation
 *
 * Get Intercompany Payments aggregation. Caching is handled at the DAO level.
 */
export const getIntercompanyPaymentsAggregationInfiniteOptions = (options: Options<GetIntercompanyPaymentsAggregationData>) => {
  const opts = infiniteQueryOptions<GetIntercompanyPaymentsAggregationResponse, GetIntercompanyPaymentsAggregationError, InfiniteData<GetIntercompanyPaymentsAggregationResponse>, QueryKey<Options<GetIntercompanyPaymentsAggregationData>>, number | Pick<QueryKey<Options<GetIntercompanyPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetIntercompanyPaymentsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getIntercompanyPaymentsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getIntercompanyPaymentsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getIntercompanyPaymentsDrilldownQueryKey = (options: Options<GetIntercompanyPaymentsDrilldownData>) => createQueryKey('getIntercompanyPaymentsDrilldown', options);

/**
 * Get Intercompany Payments Drilldown
 *
 * Get Intercompany Payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getIntercompanyPaymentsDrilldownOptions = (options: Options<GetIntercompanyPaymentsDrilldownData>) => queryOptions<GetIntercompanyPaymentsDrilldownResponse, GetIntercompanyPaymentsDrilldownError, GetIntercompanyPaymentsDrilldownResponse, ReturnType<typeof getIntercompanyPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getIntercompanyPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getIntercompanyPaymentsDrilldownQueryKey(options)
});

export const getIntercompanyPaymentsDrilldownInfiniteQueryKey = (options: Options<GetIntercompanyPaymentsDrilldownData>): QueryKey<Options<GetIntercompanyPaymentsDrilldownData>> => createQueryKey('getIntercompanyPaymentsDrilldown', options, true);

/**
 * Get Intercompany Payments Drilldown
 *
 * Get Intercompany Payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getIntercompanyPaymentsDrilldownInfiniteOptions = (options: Options<GetIntercompanyPaymentsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetIntercompanyPaymentsDrilldownResponse, GetIntercompanyPaymentsDrilldownError, InfiniteData<GetIntercompanyPaymentsDrilldownResponse>, QueryKey<Options<GetIntercompanyPaymentsDrilldownData>>, number | Pick<QueryKey<Options<GetIntercompanyPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetIntercompanyPaymentsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getIntercompanyPaymentsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getIntercompanyPaymentsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportIntercompanyPaymentsDrilldownQueryKey = (options: Options<ExportIntercompanyPaymentsDrilldownData>) => createQueryKey('exportIntercompanyPaymentsDrilldown', options);

/**
 * Export Intercompany Payments Drilldown
 *
 * Export all intercompany payments drilldown rows as a styled Excel file.
 */
export const exportIntercompanyPaymentsDrilldownOptions = (options: Options<ExportIntercompanyPaymentsDrilldownData>) => queryOptions<unknown, ExportIntercompanyPaymentsDrilldownError, unknown, ReturnType<typeof exportIntercompanyPaymentsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportIntercompanyPaymentsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportIntercompanyPaymentsDrilldownQueryKey(options)
});

export const getSameIbanTransactionsAggregationQueryKey = (options: Options<GetSameIbanTransactionsAggregationData>) => createQueryKey('getSameIbanTransactionsAggregation', options);

/**
 * Get Same Iban Transactions Aggregation
 *
 * Get Same IBAN aggregation. Caching is handled at the DAO level.
 */
export const getSameIbanTransactionsAggregationOptions = (options: Options<GetSameIbanTransactionsAggregationData>) => queryOptions<GetSameIbanTransactionsAggregationResponse, GetSameIbanTransactionsAggregationError, GetSameIbanTransactionsAggregationResponse, ReturnType<typeof getSameIbanTransactionsAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSameIbanTransactionsAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSameIbanTransactionsAggregationQueryKey(options)
});

export const getSameIbanTransactionsAggregationInfiniteQueryKey = (options: Options<GetSameIbanTransactionsAggregationData>): QueryKey<Options<GetSameIbanTransactionsAggregationData>> => createQueryKey('getSameIbanTransactionsAggregation', options, true);

/**
 * Get Same Iban Transactions Aggregation
 *
 * Get Same IBAN aggregation. Caching is handled at the DAO level.
 */
export const getSameIbanTransactionsAggregationInfiniteOptions = (options: Options<GetSameIbanTransactionsAggregationData>) => {
  const opts = infiniteQueryOptions<GetSameIbanTransactionsAggregationResponse, GetSameIbanTransactionsAggregationError, InfiniteData<GetSameIbanTransactionsAggregationResponse>, QueryKey<Options<GetSameIbanTransactionsAggregationData>>, number | Pick<QueryKey<Options<GetSameIbanTransactionsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetSameIbanTransactionsAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getSameIbanTransactionsAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getSameIbanTransactionsAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getSameIbanTransactionsDrilldownQueryKey = (options: Options<GetSameIbanTransactionsDrilldownData>) => createQueryKey('getSameIbanTransactionsDrilldown', options);

/**
 * Get Same Iban Transactions Drilldown
 *
 * Get Same IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getSameIbanTransactionsDrilldownOptions = (options: Options<GetSameIbanTransactionsDrilldownData>) => queryOptions<GetSameIbanTransactionsDrilldownResponse, GetSameIbanTransactionsDrilldownError, GetSameIbanTransactionsDrilldownResponse, ReturnType<typeof getSameIbanTransactionsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSameIbanTransactionsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSameIbanTransactionsDrilldownQueryKey(options)
});

export const getSameIbanTransactionsDrilldownInfiniteQueryKey = (options: Options<GetSameIbanTransactionsDrilldownData>): QueryKey<Options<GetSameIbanTransactionsDrilldownData>> => createQueryKey('getSameIbanTransactionsDrilldown', options, true);

/**
 * Get Same Iban Transactions Drilldown
 *
 * Get Same IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getSameIbanTransactionsDrilldownInfiniteOptions = (options: Options<GetSameIbanTransactionsDrilldownData>) => {
  const opts = infiniteQueryOptions<GetSameIbanTransactionsDrilldownResponse, GetSameIbanTransactionsDrilldownError, InfiniteData<GetSameIbanTransactionsDrilldownResponse>, QueryKey<Options<GetSameIbanTransactionsDrilldownData>>, number | Pick<QueryKey<Options<GetSameIbanTransactionsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetSameIbanTransactionsDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getSameIbanTransactionsDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getSameIbanTransactionsDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportSameIbanTransactionsDrilldownQueryKey = (options: Options<ExportSameIbanTransactionsDrilldownData>) => createQueryKey('exportSameIbanTransactionsDrilldown', options);

/**
 * Export Same Iban Transactions Drilldown
 *
 * Export all same-IBAN drilldown rows as a styled Excel file.
 */
export const exportSameIbanTransactionsDrilldownOptions = (options: Options<ExportSameIbanTransactionsDrilldownData>) => queryOptions<unknown, ExportSameIbanTransactionsDrilldownError, unknown, ReturnType<typeof exportSameIbanTransactionsDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportSameIbanTransactionsDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportSameIbanTransactionsDrilldownQueryKey(options)
});

export const getForeignCurrencyAggregationQueryKey = (options: Options<GetForeignCurrencyAggregationData>) => createQueryKey('getForeignCurrencyAggregation', options);

/**
 * Get Foreign Currency Aggregation
 *
 * Get Foreign Currency Transactions aggregation.
 *
 * Caching is handled automatically by the DAO layer.
 */
export const getForeignCurrencyAggregationOptions = (options: Options<GetForeignCurrencyAggregationData>) => queryOptions<GetForeignCurrencyAggregationResponse, GetForeignCurrencyAggregationError, GetForeignCurrencyAggregationResponse, ReturnType<typeof getForeignCurrencyAggregationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getForeignCurrencyAggregation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getForeignCurrencyAggregationQueryKey(options)
});

export const getForeignCurrencyAggregationInfiniteQueryKey = (options: Options<GetForeignCurrencyAggregationData>): QueryKey<Options<GetForeignCurrencyAggregationData>> => createQueryKey('getForeignCurrencyAggregation', options, true);

/**
 * Get Foreign Currency Aggregation
 *
 * Get Foreign Currency Transactions aggregation.
 *
 * Caching is handled automatically by the DAO layer.
 */
export const getForeignCurrencyAggregationInfiniteOptions = (options: Options<GetForeignCurrencyAggregationData>) => {
  const opts = infiniteQueryOptions<GetForeignCurrencyAggregationResponse, GetForeignCurrencyAggregationError, InfiniteData<GetForeignCurrencyAggregationResponse>, QueryKey<Options<GetForeignCurrencyAggregationData>>, number | Pick<QueryKey<Options<GetForeignCurrencyAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetForeignCurrencyAggregationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getForeignCurrencyAggregation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getForeignCurrencyAggregationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getForeignCurrencyDrilldownQueryKey = (options: Options<GetForeignCurrencyDrilldownData>) => createQueryKey('getForeignCurrencyDrilldown', options);

/**
 * Get Foreign Currency Drilldown
 *
 * Get Foreign Currency Transactions drilldown.
 *
 * Caching is handled automatically by the DAO layer.
 */
export const getForeignCurrencyDrilldownOptions = (options: Options<GetForeignCurrencyDrilldownData>) => queryOptions<GetForeignCurrencyDrilldownResponse, GetForeignCurrencyDrilldownError, GetForeignCurrencyDrilldownResponse, ReturnType<typeof getForeignCurrencyDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getForeignCurrencyDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getForeignCurrencyDrilldownQueryKey(options)
});

export const getForeignCurrencyDrilldownInfiniteQueryKey = (options: Options<GetForeignCurrencyDrilldownData>): QueryKey<Options<GetForeignCurrencyDrilldownData>> => createQueryKey('getForeignCurrencyDrilldown', options, true);

/**
 * Get Foreign Currency Drilldown
 *
 * Get Foreign Currency Transactions drilldown.
 *
 * Caching is handled automatically by the DAO layer.
 */
export const getForeignCurrencyDrilldownInfiniteOptions = (options: Options<GetForeignCurrencyDrilldownData>) => {
  const opts = infiniteQueryOptions<GetForeignCurrencyDrilldownResponse, GetForeignCurrencyDrilldownError, InfiniteData<GetForeignCurrencyDrilldownResponse>, QueryKey<Options<GetForeignCurrencyDrilldownData>>, number | Pick<QueryKey<Options<GetForeignCurrencyDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetForeignCurrencyDrilldownData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getForeignCurrencyDrilldown({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getForeignCurrencyDrilldownInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const exportForeignCurrencyDrilldownQueryKey = (options: Options<ExportForeignCurrencyDrilldownData>) => createQueryKey('exportForeignCurrencyDrilldown', options);

/**
 * Export Foreign Currency Drilldown
 *
 * Export all foreign currency drilldown rows as a styled Excel file.
 */
export const exportForeignCurrencyDrilldownOptions = (options: Options<ExportForeignCurrencyDrilldownData>) => queryOptions<unknown, ExportForeignCurrencyDrilldownError, unknown, ReturnType<typeof exportForeignCurrencyDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportForeignCurrencyDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportForeignCurrencyDrilldownQueryKey(options)
});

export const getMultipleIbansPerKvkQueryKey = (options: Options<GetMultipleIbansPerKvkData>) => createQueryKey('getMultipleIbansPerKvk', options);

/**
 * Get Multiple Ibans Per Kvk
 *
 * Return complete KvK groups after scoped filtering, sorting, and pagination.
 */
export const getMultipleIbansPerKvkOptions = (options: Options<GetMultipleIbansPerKvkData>) => queryOptions<GetMultipleIbansPerKvkResponse, GetMultipleIbansPerKvkError, GetMultipleIbansPerKvkResponse, ReturnType<typeof getMultipleIbansPerKvkQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getMultipleIbansPerKvk({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMultipleIbansPerKvkQueryKey(options)
});

export const getMultipleIbansPerKvkInfiniteQueryKey = (options: Options<GetMultipleIbansPerKvkData>): QueryKey<Options<GetMultipleIbansPerKvkData>> => createQueryKey('getMultipleIbansPerKvk', options, true);

/**
 * Get Multiple Ibans Per Kvk
 *
 * Return complete KvK groups after scoped filtering, sorting, and pagination.
 */
export const getMultipleIbansPerKvkInfiniteOptions = (options: Options<GetMultipleIbansPerKvkData>) => {
  const opts = infiniteQueryOptions<GetMultipleIbansPerKvkResponse, GetMultipleIbansPerKvkError, InfiniteData<GetMultipleIbansPerKvkResponse>, QueryKey<Options<GetMultipleIbansPerKvkData>>, number | Pick<QueryKey<Options<GetMultipleIbansPerKvkData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetMultipleIbansPerKvkData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getMultipleIbansPerKvk({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getMultipleIbansPerKvkInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getPossibleDuplicatePaymentsQueryKey = (options: Options<GetPossibleDuplicatePaymentsData>) => createQueryKey('getPossibleDuplicatePayments', options);

/**
 * Get Possible Duplicate Payments
 *
 * Return complete counterparty-IBAN groups for possible duplicate payments.
 */
export const getPossibleDuplicatePaymentsOptions = (options: Options<GetPossibleDuplicatePaymentsData>) => queryOptions<GetPossibleDuplicatePaymentsResponse, GetPossibleDuplicatePaymentsError, GetPossibleDuplicatePaymentsResponse, ReturnType<typeof getPossibleDuplicatePaymentsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPossibleDuplicatePayments({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPossibleDuplicatePaymentsQueryKey(options)
});

export const getPossibleDuplicatePaymentsInfiniteQueryKey = (options: Options<GetPossibleDuplicatePaymentsData>): QueryKey<Options<GetPossibleDuplicatePaymentsData>> => createQueryKey('getPossibleDuplicatePayments', options, true);

/**
 * Get Possible Duplicate Payments
 *
 * Return complete counterparty-IBAN groups for possible duplicate payments.
 */
export const getPossibleDuplicatePaymentsInfiniteOptions = (options: Options<GetPossibleDuplicatePaymentsData>) => {
  const opts = infiniteQueryOptions<GetPossibleDuplicatePaymentsResponse, GetPossibleDuplicatePaymentsError, InfiniteData<GetPossibleDuplicatePaymentsResponse>, QueryKey<Options<GetPossibleDuplicatePaymentsData>>, number | Pick<QueryKey<Options<GetPossibleDuplicatePaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetPossibleDuplicatePaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getPossibleDuplicatePayments({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getPossibleDuplicatePaymentsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getUniqueCounterpartiesMultipleIbansQueryKey = (options: Options<GetUniqueCounterpartiesMultipleIbansData>) => createQueryKey('getUniqueCounterpartiesMultipleIbans', options);

/**
 * Get Unique Counterparties Multiple Ibans
 *
 * Return complete counterparty-name groups that contain multiple IBANs.
 */
export const getUniqueCounterpartiesMultipleIbansOptions = (options: Options<GetUniqueCounterpartiesMultipleIbansData>) => queryOptions<GetUniqueCounterpartiesMultipleIbansResponse, GetUniqueCounterpartiesMultipleIbansError, GetUniqueCounterpartiesMultipleIbansResponse, ReturnType<typeof getUniqueCounterpartiesMultipleIbansQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getUniqueCounterpartiesMultipleIbans({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getUniqueCounterpartiesMultipleIbansQueryKey(options)
});

export const getUniqueCounterpartiesMultipleIbansInfiniteQueryKey = (options: Options<GetUniqueCounterpartiesMultipleIbansData>): QueryKey<Options<GetUniqueCounterpartiesMultipleIbansData>> => createQueryKey('getUniqueCounterpartiesMultipleIbans', options, true);

/**
 * Get Unique Counterparties Multiple Ibans
 *
 * Return complete counterparty-name groups that contain multiple IBANs.
 */
export const getUniqueCounterpartiesMultipleIbansInfiniteOptions = (options: Options<GetUniqueCounterpartiesMultipleIbansData>) => {
  const opts = infiniteQueryOptions<GetUniqueCounterpartiesMultipleIbansResponse, GetUniqueCounterpartiesMultipleIbansError, InfiniteData<GetUniqueCounterpartiesMultipleIbansResponse>, QueryKey<Options<GetUniqueCounterpartiesMultipleIbansData>>, number | Pick<QueryKey<Options<GetUniqueCounterpartiesMultipleIbansData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetUniqueCounterpartiesMultipleIbansData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getUniqueCounterpartiesMultipleIbans({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getUniqueCounterpartiesMultipleIbansInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getPaymentTypesQueryKey = (options: Options<GetPaymentTypesData>) => createQueryKey('getPaymentTypes', options);

/**
 * Get Payment Types
 *
 * Return a flat physical-row page of payment-type hierarchy results.
 */
export const getPaymentTypesOptions = (options: Options<GetPaymentTypesData>) => queryOptions<GetPaymentTypesResponse, GetPaymentTypesError, GetPaymentTypesResponse, ReturnType<typeof getPaymentTypesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPaymentTypes({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPaymentTypesQueryKey(options)
});

export const getPaymentTypesInfiniteQueryKey = (options: Options<GetPaymentTypesData>): QueryKey<Options<GetPaymentTypesData>> => createQueryKey('getPaymentTypes', options, true);

/**
 * Get Payment Types
 *
 * Return a flat physical-row page of payment-type hierarchy results.
 */
export const getPaymentTypesInfiniteOptions = (options: Options<GetPaymentTypesData>) => {
  const opts = infiniteQueryOptions<GetPaymentTypesResponse, GetPaymentTypesError, InfiniteData<GetPaymentTypesResponse>, QueryKey<Options<GetPaymentTypesData>>, number | Pick<QueryKey<Options<GetPaymentTypesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetPaymentTypesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getPaymentTypes({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getPaymentTypesInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getDashboardFilterValuesQueryKey = (options: Options<GetDashboardFilterValuesData>) => createQueryKey('getDashboardFilterValues', options);

/**
 * Get Dashboard Filter Values
 *
 * Return company/year-scoped values for one of the four dashboard tables.
 */
export const getDashboardFilterValuesOptions = (options: Options<GetDashboardFilterValuesData>) => queryOptions<GetDashboardFilterValuesResponse, GetDashboardFilterValuesError, GetDashboardFilterValuesResponse, ReturnType<typeof getDashboardFilterValuesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDashboardFilterValues({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDashboardFilterValuesQueryKey(options)
});

export const getDashboardFilterValuesInfiniteQueryKey = (options: Options<GetDashboardFilterValuesData>): QueryKey<Options<GetDashboardFilterValuesData>> => createQueryKey('getDashboardFilterValues', options, true);

/**
 * Get Dashboard Filter Values
 *
 * Return company/year-scoped values for one of the four dashboard tables.
 */
export const getDashboardFilterValuesInfiniteOptions = (options: Options<GetDashboardFilterValuesData>) => {
  const opts = infiniteQueryOptions<GetDashboardFilterValuesResponse, GetDashboardFilterValuesError, InfiniteData<GetDashboardFilterValuesResponse>, QueryKey<Options<GetDashboardFilterValuesData>>, number | Pick<QueryKey<Options<GetDashboardFilterValuesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetDashboardFilterValuesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getDashboardFilterValues({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getDashboardFilterValuesInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getTransactionsQueryKey = (options: Options<GetTransactionsData>) => createQueryKey('getTransactions', options);

/**
 * Get Transactions
 *
 * Return individual transactions scoped to the authorized company's booking year.
 */
export const getTransactionsOptions = (options: Options<GetTransactionsData>) => queryOptions<GetTransactionsResponse, GetTransactionsError, GetTransactionsResponse, ReturnType<typeof getTransactionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTransactions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTransactionsQueryKey(options)
});

export const getTransactionsInfiniteQueryKey = (options: Options<GetTransactionsData>): QueryKey<Options<GetTransactionsData>> => createQueryKey('getTransactions', options, true);

/**
 * Get Transactions
 *
 * Return individual transactions scoped to the authorized company's booking year.
 */
export const getTransactionsInfiniteOptions = (options: Options<GetTransactionsData>) => {
  const opts = infiniteQueryOptions<GetTransactionsResponse, GetTransactionsError, InfiniteData<GetTransactionsResponse>, QueryKey<Options<GetTransactionsData>>, number | Pick<QueryKey<Options<GetTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getTransactions({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getTransactionsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getTransactionOverviewQueryKey = (options: Options<GetTransactionOverviewData>) => createQueryKey('getTransactionOverview', options);

/**
 * Get Transaction Overview
 *
 * Return flat or complete grouped transactions with all matching currency totals.
 */
export const getTransactionOverviewOptions = (options: Options<GetTransactionOverviewData>) => queryOptions<GetTransactionOverviewResponse, GetTransactionOverviewError, GetTransactionOverviewResponse, ReturnType<typeof getTransactionOverviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTransactionOverview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTransactionOverviewQueryKey(options)
});

export const getTransactionOverviewInfiniteQueryKey = (options: Options<GetTransactionOverviewData>): QueryKey<Options<GetTransactionOverviewData>> => createQueryKey('getTransactionOverview', options, true);

/**
 * Get Transaction Overview
 *
 * Return flat or complete grouped transactions with all matching currency totals.
 */
export const getTransactionOverviewInfiniteOptions = (options: Options<GetTransactionOverviewData>) => {
  const opts = infiniteQueryOptions<GetTransactionOverviewResponse, GetTransactionOverviewError, InfiniteData<GetTransactionOverviewResponse>, QueryKey<Options<GetTransactionOverviewData>>, number | Pick<QueryKey<Options<GetTransactionOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetTransactionOverviewData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        body: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getTransactionOverview({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getTransactionOverviewInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getTransactionDrilldownQueryKey = (options: Options<GetTransactionDrilldownData>) => createQueryKey('getTransactionDrilldown', options);

/**
 * Get Transaction Drilldown
 *
 * Inspect rows contributing to a selected aggregate under the same project permission.
 */
export const getTransactionDrilldownOptions = (options: Options<GetTransactionDrilldownData>) => queryOptions<GetTransactionDrilldownResponse, GetTransactionDrilldownError, GetTransactionDrilldownResponse, ReturnType<typeof getTransactionDrilldownQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTransactionDrilldown({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTransactionDrilldownQueryKey(options)
});

export const getTransactionFilterValuesQueryKey = (options: Options<GetTransactionFilterValuesData>) => createQueryKey('getTransactionFilterValues', options);

/**
 * Get Transaction Filter Values
 *
 * List exact available column values within the authorized company and booking year.
 */
export const getTransactionFilterValuesOptions = (options: Options<GetTransactionFilterValuesData>) => queryOptions<GetTransactionFilterValuesResponse, GetTransactionFilterValuesError, GetTransactionFilterValuesResponse, ReturnType<typeof getTransactionFilterValuesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTransactionFilterValues({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTransactionFilterValuesQueryKey(options)
});

export const getTransactionFilterValuesInfiniteQueryKey = (options: Options<GetTransactionFilterValuesData>): QueryKey<Options<GetTransactionFilterValuesData>> => createQueryKey('getTransactionFilterValues', options, true);

/**
 * Get Transaction Filter Values
 *
 * List exact available column values within the authorized company and booking year.
 */
export const getTransactionFilterValuesInfiniteOptions = (options: Options<GetTransactionFilterValuesData>) => {
  const opts = infiniteQueryOptions<GetTransactionFilterValuesResponse, GetTransactionFilterValuesError, InfiniteData<GetTransactionFilterValuesResponse>, QueryKey<Options<GetTransactionFilterValuesData>>, number | Pick<QueryKey<Options<GetTransactionFilterValuesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetTransactionFilterValuesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        body: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getTransactionFilterValues({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getTransactionFilterValuesInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Export Continuous Auditor Transactions
 *
 * Download every filtered result, with supporting transactions for aggregations.
 */
export const exportContinuousAuditorTransactionsMutation = (options?: Partial<Options<ExportContinuousAuditorTransactionsData>>): UseMutationOptions<ExportContinuousAuditorTransactionsResponse, ExportContinuousAuditorTransactionsError, Options<ExportContinuousAuditorTransactionsData>> => {
  const mutationOptions: UseMutationOptions<ExportContinuousAuditorTransactionsResponse, ExportContinuousAuditorTransactionsError, Options<ExportContinuousAuditorTransactionsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportContinuousAuditorTransactions({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Run Refresh Afas Data Pipeline
 */
export const runRefreshAfasDataPipelineMutation = (options?: Partial<Options<RunRefreshAfasDataPipelineData>>): UseMutationOptions<unknown, RunRefreshAfasDataPipelineError, Options<RunRefreshAfasDataPipelineData>> => {
  const mutationOptions: UseMutationOptions<unknown, RunRefreshAfasDataPipelineError, Options<RunRefreshAfasDataPipelineData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await runRefreshAfasDataPipeline({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getRefreshAfasDataPipelineStatusQueryKey = (options: Options<GetRefreshAfasDataPipelineStatusData>) => createQueryKey('getRefreshAfasDataPipelineStatus', options);

/**
 * Get Refresh Afas Data Pipeline Status
 */
export const getRefreshAfasDataPipelineStatusOptions = (options: Options<GetRefreshAfasDataPipelineStatusData>) => queryOptions<GetRefreshAfasDataPipelineStatusResponse, GetRefreshAfasDataPipelineStatusError, GetRefreshAfasDataPipelineStatusResponse, ReturnType<typeof getRefreshAfasDataPipelineStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getRefreshAfasDataPipelineStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRefreshAfasDataPipelineStatusQueryKey(options)
});

/**
 * Run Continuous Auditor Refresh Pipeline
 *
 * Accept a company refresh; the existing Fabric queue dispatches it asynchronously.
 */
export const runContinuousAuditorRefreshPipelineMutation = (options?: Partial<Options<RunContinuousAuditorRefreshPipelineData>>): UseMutationOptions<unknown, RunContinuousAuditorRefreshPipelineError, Options<RunContinuousAuditorRefreshPipelineData>> => {
  const mutationOptions: UseMutationOptions<unknown, RunContinuousAuditorRefreshPipelineError, Options<RunContinuousAuditorRefreshPipelineData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await runContinuousAuditorRefreshPipeline({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getContinuousAuditorRefreshPipelineStatusQueryKey = (options: Options<GetContinuousAuditorRefreshPipelineStatusData>) => createQueryKey('getContinuousAuditorRefreshPipelineStatus', options);

/**
 * Get Continuous Auditor Refresh Pipeline Status
 *
 * Read refresh progress without granting permission to trigger a pipeline.
 */
export const getContinuousAuditorRefreshPipelineStatusOptions = (options: Options<GetContinuousAuditorRefreshPipelineStatusData>) => queryOptions<GetContinuousAuditorRefreshPipelineStatusResponse, GetContinuousAuditorRefreshPipelineStatusError, GetContinuousAuditorRefreshPipelineStatusResponse, ReturnType<typeof getContinuousAuditorRefreshPipelineStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getContinuousAuditorRefreshPipelineStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getContinuousAuditorRefreshPipelineStatusQueryKey(options)
});

export const getActiveProjectPipelineQueryKey = (options: Options<GetActiveProjectPipelineData>) => createQueryKey('getActiveProjectPipeline', options);

/**
 * Get Active Project Pipeline
 *
 * Return an execution still blocking this project's mutations, or null.
 *
 * Costs one query and no Fabric call when nothing is running. Otherwise each
 * candidate is refreshed in turn until one is still non-terminal; refreshing
 * the newest can reveal it has just finished, and stopping there would report
 * "idle" while an older run still blocks the project.
 */
export const getActiveProjectPipelineOptions = (options: Options<GetActiveProjectPipelineData>) => queryOptions<GetActiveProjectPipelineResponse, GetActiveProjectPipelineError, GetActiveProjectPipelineResponse, ReturnType<typeof getActiveProjectPipelineQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getActiveProjectPipeline({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getActiveProjectPipelineQueryKey(options)
});

/**
 * Set Pipeline Execution Status
 *
 * Repair an app-side execution status without cancelling the Fabric run.
 *
 * This superuser-only operation changes the stored application status so a
 * stale execution no longer blocks its project. It does not contact Fabric
 * or cancel an upstream Fabric job.
 */
export const setPipelineExecutionStatusMutation = (options?: Partial<Options<SetPipelineExecutionStatusData>>): UseMutationOptions<SetPipelineExecutionStatusResponse, SetPipelineExecutionStatusError, Options<SetPipelineExecutionStatusData>> => {
  const mutationOptions: UseMutationOptions<SetPipelineExecutionStatusResponse, SetPipelineExecutionStatusError, Options<SetPipelineExecutionStatusData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setPipelineExecutionStatus({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Export Audit Reconciliation
 *
 * Queue the fiscal-year ledger and linked journals in one Data Platform export.
 */
export const exportAuditReconciliationMutation = (options?: Partial<Options<ExportAuditReconciliationData>>): UseMutationOptions<ExportAuditReconciliationResponse, ExportAuditReconciliationError, Options<ExportAuditReconciliationData>> => {
  const mutationOptions: UseMutationOptions<ExportAuditReconciliationResponse, ExportAuditReconciliationError, Options<ExportAuditReconciliationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportAuditReconciliation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getAuditReconciliationExportStatusQueryKey = (options: Options<GetAuditReconciliationExportStatusData>) => createQueryKey('getAuditReconciliationExportStatus', options);

/**
 * Get Audit Reconciliation Export Status
 *
 * Read combined-export status for the project's current classification bindings.
 */
export const getAuditReconciliationExportStatusOptions = (options: Options<GetAuditReconciliationExportStatusData>) => queryOptions<GetAuditReconciliationExportStatusResponse, GetAuditReconciliationExportStatusError, GetAuditReconciliationExportStatusResponse, ReturnType<typeof getAuditReconciliationExportStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAuditReconciliationExportStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAuditReconciliationExportStatusQueryKey(options)
});

/**
 * Export Audit Reconciliation Excel
 *
 * Download selected displayed reconciliations without changing persisted state.
 */
export const exportAuditReconciliationExcelMutation = (options?: Partial<Options<ExportAuditReconciliationExcelData>>): UseMutationOptions<ExportAuditReconciliationExcelResponse, ExportAuditReconciliationExcelError, Options<ExportAuditReconciliationExcelData>> => {
  const mutationOptions: UseMutationOptions<ExportAuditReconciliationExcelResponse, ExportAuditReconciliationExcelError, Options<ExportAuditReconciliationExcelData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportAuditReconciliationExcel({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Start Audit Statement Extraction
 *
 * Queue balance sheet and profit-and-loss extraction for the current report.
 */
export const startAuditStatementExtractionMutation = (options?: Partial<Options<StartAuditStatementExtractionData>>): UseMutationOptions<StartAuditStatementExtractionResponse, StartAuditStatementExtractionError, Options<StartAuditStatementExtractionData>> => {
  const mutationOptions: UseMutationOptions<StartAuditStatementExtractionResponse, StartAuditStatementExtractionError, Options<StartAuditStatementExtractionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await startAuditStatementExtraction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const latestAuditStatementExtractionQueryKey = (options: Options<LatestAuditStatementExtractionData>) => createQueryKey('latestAuditStatementExtraction', options);

/**
 * Latest Audit Statement Extraction
 *
 * Return the audit dossier's current extraction run.
 */
export const latestAuditStatementExtractionOptions = (options: Options<LatestAuditStatementExtractionData>) => queryOptions<LatestAuditStatementExtractionResponse, LatestAuditStatementExtractionError, LatestAuditStatementExtractionResponse, ReturnType<typeof latestAuditStatementExtractionQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await latestAuditStatementExtraction({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: latestAuditStatementExtractionQueryKey(options)
});

export const latestAuditStatementReferenceReconciliationQueryKey = (options: Options<LatestAuditStatementReferenceReconciliationData>) => createQueryKey('latestAuditStatementReferenceReconciliation', options);

/**
 * Latest Audit Statement Reference Reconciliation
 *
 * Return T-1 report-to-report checks when both independent sides exist.
 */
export const latestAuditStatementReferenceReconciliationOptions = (options: Options<LatestAuditStatementReferenceReconciliationData>) => queryOptions<LatestAuditStatementReferenceReconciliationResponse, LatestAuditStatementReferenceReconciliationError, LatestAuditStatementReferenceReconciliationResponse, ReturnType<typeof latestAuditStatementReferenceReconciliationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await latestAuditStatementReferenceReconciliation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: latestAuditStatementReferenceReconciliationQueryKey(options)
});

export const latestAuditBudgetReconciliationQueryKey = (options: Options<LatestAuditBudgetReconciliationData>) => createQueryKey('latestAuditBudgetReconciliation', options);

/**
 * Latest Audit Budget Reconciliation
 *
 * Return optional P&L budget values and their variance from actuals.
 */
export const latestAuditBudgetReconciliationOptions = (options: Options<LatestAuditBudgetReconciliationData>) => queryOptions<LatestAuditBudgetReconciliationResponse, LatestAuditBudgetReconciliationError, LatestAuditBudgetReconciliationResponse, ReturnType<typeof latestAuditBudgetReconciliationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await latestAuditBudgetReconciliation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: latestAuditBudgetReconciliationQueryKey(options)
});

export const latestAuditStatementExtractionJobsQueryKey = (options: Options<LatestAuditStatementExtractionJobsData>) => createQueryKey('latestAuditStatementExtractionJobs', options);

/**
 * Latest Audit Statement Extraction Jobs
 *
 * Return source-bound current and previous background job state.
 */
export const latestAuditStatementExtractionJobsOptions = (options: Options<LatestAuditStatementExtractionJobsData>) => queryOptions<LatestAuditStatementExtractionJobsResponse, LatestAuditStatementExtractionJobsError, LatestAuditStatementExtractionJobsResponse, ReturnType<typeof latestAuditStatementExtractionJobsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await latestAuditStatementExtractionJobs({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: latestAuditStatementExtractionJobsQueryKey(options)
});

/**
 * Start Audit Previous Report Extraction
 *
 * Queue extraction of the linked previous annual report.
 */
export const startAuditPreviousReportExtractionMutation = (options?: Partial<Options<StartAuditPreviousReportExtractionData>>): UseMutationOptions<StartAuditPreviousReportExtractionResponse, StartAuditPreviousReportExtractionError, Options<StartAuditPreviousReportExtractionData>> => {
  const mutationOptions: UseMutationOptions<StartAuditPreviousReportExtractionResponse, StartAuditPreviousReportExtractionError, Options<StartAuditPreviousReportExtractionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await startAuditPreviousReportExtraction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Restart Audit Statement Extraction Job
 *
 * Requeue one current-source job after validating its report and taxonomy.
 */
export const restartAuditStatementExtractionJobMutation = (options?: Partial<Options<RestartAuditStatementExtractionJobData>>): UseMutationOptions<RestartAuditStatementExtractionJobResponse, RestartAuditStatementExtractionJobError, Options<RestartAuditStatementExtractionJobData>> => {
  const mutationOptions: UseMutationOptions<RestartAuditStatementExtractionJobResponse, RestartAuditStatementExtractionJobError, Options<RestartAuditStatementExtractionJobData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await restartAuditStatementExtractionJob({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Replace Audit Previous Report Stage
 *
 * Save one complete T-1 statement and its reported controls.
 */
export const replaceAuditPreviousReportStageMutation = (options?: Partial<Options<ReplaceAuditPreviousReportStageData>>): UseMutationOptions<ReplaceAuditPreviousReportStageResponse, ReplaceAuditPreviousReportStageError, Options<ReplaceAuditPreviousReportStageData>> => {
  const mutationOptions: UseMutationOptions<ReplaceAuditPreviousReportStageResponse, ReplaceAuditPreviousReportStageError, Options<ReplaceAuditPreviousReportStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await replaceAuditPreviousReportStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirm Audit Previous Report Stage
 *
 * Confirm one T-1 statement after its controls pass.
 */
export const confirmAuditPreviousReportStageMutation = (options?: Partial<Options<ConfirmAuditPreviousReportStageData>>): UseMutationOptions<ConfirmAuditPreviousReportStageResponse, ConfirmAuditPreviousReportStageError, Options<ConfirmAuditPreviousReportStageData>> => {
  const mutationOptions: UseMutationOptions<ConfirmAuditPreviousReportStageResponse, ConfirmAuditPreviousReportStageError, Options<ConfirmAuditPreviousReportStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmAuditPreviousReportStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Deconfirm Audit Previous Report Stage
 *
 * Return one confirmed T-1 statement to review.
 */
export const deconfirmAuditPreviousReportStageMutation = (options?: Partial<Options<DeconfirmAuditPreviousReportStageData>>): UseMutationOptions<DeconfirmAuditPreviousReportStageResponse, DeconfirmAuditPreviousReportStageError, Options<DeconfirmAuditPreviousReportStageData>> => {
  const mutationOptions: UseMutationOptions<DeconfirmAuditPreviousReportStageResponse, DeconfirmAuditPreviousReportStageError, Options<DeconfirmAuditPreviousReportStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deconfirmAuditPreviousReportStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Replace Audit Statement Extraction Stage
 *
 * Replace one complete fixed-statement snapshot.
 */
export const replaceAuditStatementExtractionStageMutation = (options?: Partial<Options<ReplaceAuditStatementExtractionStageData>>): UseMutationOptions<ReplaceAuditStatementExtractionStageResponse, ReplaceAuditStatementExtractionStageError, Options<ReplaceAuditStatementExtractionStageData>> => {
  const mutationOptions: UseMutationOptions<ReplaceAuditStatementExtractionStageResponse, ReplaceAuditStatementExtractionStageError, Options<ReplaceAuditStatementExtractionStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await replaceAuditStatementExtractionStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Replace Audit Statement Extraction Categories
 *
 * Save a complete review snapshot, preserving references for moved Level 2 categories.
 *
 * Targets must be existing empty categories in the same statement/sign section.
 * Source categories must be cleared in the supplied snapshot. Confirmation and
 * latest-run locks follow the regular stage replacement contract.
 */
export const replaceAuditStatementExtractionCategoriesMutation = (options?: Partial<Options<ReplaceAuditStatementExtractionCategoriesData>>): UseMutationOptions<ReplaceAuditStatementExtractionCategoriesResponse, ReplaceAuditStatementExtractionCategoriesError, Options<ReplaceAuditStatementExtractionCategoriesData>> => {
  const mutationOptions: UseMutationOptions<ReplaceAuditStatementExtractionCategoriesResponse, ReplaceAuditStatementExtractionCategoriesError, Options<ReplaceAuditStatementExtractionCategoriesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await replaceAuditStatementExtractionCategories({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirm Audit Statement Extraction Stage
 *
 * Confirm one audit statement independently after its controls pass.
 */
export const confirmAuditStatementExtractionStageMutation = (options?: Partial<Options<ConfirmAuditStatementExtractionStageData>>): UseMutationOptions<ConfirmAuditStatementExtractionStageResponse, ConfirmAuditStatementExtractionStageError, Options<ConfirmAuditStatementExtractionStageData>> => {
  const mutationOptions: UseMutationOptions<ConfirmAuditStatementExtractionStageResponse, ConfirmAuditStatementExtractionStageError, Options<ConfirmAuditStatementExtractionStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmAuditStatementExtractionStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Deconfirm Audit Statement Extraction Stage
 *
 * Return one confirmed audit statement to review.
 */
export const deconfirmAuditStatementExtractionStageMutation = (options?: Partial<Options<DeconfirmAuditStatementExtractionStageData>>): UseMutationOptions<DeconfirmAuditStatementExtractionStageResponse, DeconfirmAuditStatementExtractionStageError, Options<DeconfirmAuditStatementExtractionStageData>> => {
  const mutationOptions: UseMutationOptions<DeconfirmAuditStatementExtractionStageResponse, DeconfirmAuditStatementExtractionStageError, Options<DeconfirmAuditStatementExtractionStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deconfirmAuditStatementExtractionStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Audit Files
 *
 * Delete specific audit files from a folder.
 */
export const deleteAuditFilesMutation = (options?: Partial<Options<DeleteAuditFilesData>>): UseMutationOptions<unknown, DeleteAuditFilesError, Options<DeleteAuditFilesData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteAuditFilesError, Options<DeleteAuditFilesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteAuditFiles({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listAuditFilesQueryKey = (options: Options<ListAuditFilesData>) => createQueryKey('listAuditFiles', options);

/**
 * List Audit Files
 *
 * List all audit files in a folder.
 */
export const listAuditFilesOptions = (options: Options<ListAuditFilesData>) => queryOptions<ListAuditFilesResponse2, ListAuditFilesError, ListAuditFilesResponse2, ReturnType<typeof listAuditFilesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listAuditFiles({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listAuditFilesQueryKey(options)
});

/**
 * Upload Audit Files
 *
 * Upload audit files to Fabric; processing is started through the run endpoint.
 */
export const uploadAuditFilesMutation = (options?: Partial<Options<UploadAuditFilesData>>): UseMutationOptions<UploadAuditFilesResponse2, UploadAuditFilesError, Options<UploadAuditFilesData>> => {
  const mutationOptions: UseMutationOptions<UploadAuditFilesResponse2, UploadAuditFilesError, Options<UploadAuditFilesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadAuditFiles({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const downloadAuditFileQueryKey = (options: Options<DownloadAuditFileData>) => createQueryKey('downloadAuditFile', options);

/**
 * Download Audit File
 *
 * Stream one uploaded audit file from Fabric.
 */
export const downloadAuditFileOptions = (options: Options<DownloadAuditFileData>) => queryOptions<unknown, DownloadAuditFileError, unknown, ReturnType<typeof downloadAuditFileQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await downloadAuditFile({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: downloadAuditFileQueryKey(options)
});

/**
 * Run Refresh Audit File Pipeline
 *
 * Trigger audit-file processing for the resolved project scope.
 */
export const runRefreshAuditFilePipelineMutation = (options?: Partial<Options<RunRefreshAuditFilePipelineData>>): UseMutationOptions<unknown, RunRefreshAuditFilePipelineError, Options<RunRefreshAuditFilePipelineData>> => {
  const mutationOptions: UseMutationOptions<unknown, RunRefreshAuditFilePipelineError, Options<RunRefreshAuditFilePipelineData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await runRefreshAuditFilePipeline({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getRefreshAuditFilePipelineStatusQueryKey = (options: Options<GetRefreshAuditFilePipelineStatusData>) => createQueryKey('getRefreshAuditFilePipelineStatus', options);

/**
 * Get Refresh Audit File Pipeline Status
 *
 * Return audit-file processing status for the resolved project scope.
 */
export const getRefreshAuditFilePipelineStatusOptions = (options: Options<GetRefreshAuditFilePipelineStatusData>) => queryOptions<GetRefreshAuditFilePipelineStatusResponse, GetRefreshAuditFilePipelineStatusError, GetRefreshAuditFilePipelineStatusResponse, ReturnType<typeof getRefreshAuditFilePipelineStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getRefreshAuditFilePipelineStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRefreshAuditFilePipelineStatusQueryKey(options)
});

export const getProjectAuditFileGlCoverageQueryKey = (options: Options<GetProjectAuditFileGlCoverageData>) => createQueryKey('getProjectAuditFileGlCoverage', options);

/**
 * Get Project Audit File Gl Coverage
 *
 * Report transaction output presence for the project's accepted upload years.
 */
export const getProjectAuditFileGlCoverageOptions = (options: Options<GetProjectAuditFileGlCoverageData>) => queryOptions<GetProjectAuditFileGlCoverageResponse, GetProjectAuditFileGlCoverageError, GetProjectAuditFileGlCoverageResponse, ReturnType<typeof getProjectAuditFileGlCoverageQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjectAuditFileGlCoverage({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectAuditFileGlCoverageQueryKey(options)
});

/**
 * Request Upload Urls
 *
 * Generate SAS URLs for direct client upload of one or more files.
 */
export const requestUploadUrlsMutation = (options?: Partial<Options<RequestUploadUrlsData>>): UseMutationOptions<RequestUploadUrlsResponse, RequestUploadUrlsError, Options<RequestUploadUrlsData>> => {
  const mutationOptions: UseMutationOptions<RequestUploadUrlsResponse, RequestUploadUrlsError, Options<RequestUploadUrlsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestUploadUrls({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirm Upload
 *
 * Confirm multiple direct uploads.
 */
export const confirmUploadMutation = (options?: Partial<Options<ConfirmUploadData>>): UseMutationOptions<ConfirmUploadResponse, ConfirmUploadError, Options<ConfirmUploadData>> => {
  const mutationOptions: UseMutationOptions<ConfirmUploadResponse, ConfirmUploadError, Options<ConfirmUploadData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmUpload({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getOrganizationFileQueryKey = (options: Options<GetOrganizationFileData>) => createQueryKey('getOrganizationFile', options);

/**
 * Get Organization File
 */
export const getOrganizationFileOptions = (options: Options<GetOrganizationFileData>) => queryOptions<GetOrganizationFileResponse, GetOrganizationFileError, GetOrganizationFileResponse, ReturnType<typeof getOrganizationFileQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrganizationFile({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOrganizationFileQueryKey(options)
});

/**
 * Delete Organization File
 *
 * Delete a file from organization's blob storage.
 *
 * The blob_name is normalized to the organization's storage prefix before checks.
 *
 * Args:
 *     organization_id: The organization ID from the path.
 *     blob_name: The blob path relative to the organization prefix.
 *     organization: The current user's organization (from dependency).
 *     file_service: The file service instance.
 *
 * Returns:
 *     dict: Confirmation message.
 *
 * Raises:
 *     FileForbiddenException: If organization mismatch or file doesn't belong to org.
 *     FileNotFoundException: If file not found.
 *     FileDeleteException: If deletion fails.
 */
export const deleteOrganizationFileMutation = (options?: Partial<Options<DeleteOrganizationFileData>>): UseMutationOptions<DeleteOrganizationFileResponse, DeleteOrganizationFileError, Options<DeleteOrganizationFileData>> => {
  const mutationOptions: UseMutationOptions<DeleteOrganizationFileResponse, DeleteOrganizationFileError, Options<DeleteOrganizationFileData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteOrganizationFile({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Create Feedback
 */
export const createFeedbackMutation = (options?: Partial<Options<CreateFeedbackData>>): UseMutationOptions<CreateFeedbackResponse, CreateFeedbackError, Options<CreateFeedbackData>> => {
  const mutationOptions: UseMutationOptions<CreateFeedbackResponse, CreateFeedbackError, Options<CreateFeedbackData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * New Message Feedback
 *
 * Submits feedback for a chat message.
 *
 * Args:
 *     user: The authenticated user submitting feedback.
 *     data: Feedback data including message_id, rating, and text.
 *     session: Database session.
 *
 * Returns:
 *     InChatFeedback: The created or updated feedback.
 *
 * Raises:
 *     MessageFeedbackNotFoundException: If the message is not part of a
 *         conversation the caller owns.
 */
export const newMessageFeedbackMutation = (options?: Partial<Options<NewMessageFeedbackData>>): UseMutationOptions<NewMessageFeedbackResponse, NewMessageFeedbackError, Options<NewMessageFeedbackData>> => {
  const mutationOptions: UseMutationOptions<NewMessageFeedbackResponse, NewMessageFeedbackError, Options<NewMessageFeedbackData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await newMessageFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPromptLibraryQueryKey = (options: Options<GetPromptLibraryData>) => createQueryKey('getPromptLibrary', options);

/**
 * Get Prompt Library
 *
 * List one prompt library tab, paged out of the relation the caller may read.
 */
export const getPromptLibraryOptions = (options: Options<GetPromptLibraryData>) => queryOptions<GetPromptLibraryResponse, GetPromptLibraryError, GetPromptLibraryResponse, ReturnType<typeof getPromptLibraryQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPromptLibrary({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPromptLibraryQueryKey(options)
});

export const getPromptLibraryInfiniteQueryKey = (options: Options<GetPromptLibraryData>): QueryKey<Options<GetPromptLibraryData>> => createQueryKey('getPromptLibrary', options, true);

/**
 * Get Prompt Library
 *
 * List one prompt library tab, paged out of the relation the caller may read.
 */
export const getPromptLibraryInfiniteOptions = (options: Options<GetPromptLibraryData>) => {
  const opts = infiniteQueryOptions<GetPromptLibraryResponse, GetPromptLibraryError, InfiniteData<GetPromptLibraryResponse>, QueryKey<Options<GetPromptLibraryData>>, number | Pick<QueryKey<Options<GetPromptLibraryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetPromptLibraryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getPromptLibrary({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getPromptLibraryInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Prompt
 *
 * Create a personal prompt owned by the caller.
 */
export const createPromptMutation = (options?: Partial<Options<CreatePromptData>>): UseMutationOptions<CreatePromptResponse, CreatePromptError, Options<CreatePromptData>> => {
  const mutationOptions: UseMutationOptions<CreatePromptResponse, CreatePromptError, Options<CreatePromptData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPrompt({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Prompt
 *
 * Delete a prompt the caller may delete.
 */
export const deletePromptMutation = (options?: Partial<Options<DeletePromptData>>): UseMutationOptions<unknown, DeletePromptError, Options<DeletePromptData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeletePromptError, Options<DeletePromptData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deletePrompt({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPromptQueryKey = (options: Options<GetPromptData>) => createQueryKey('getPrompt', options);

/**
 * Get Prompt
 *
 * Read one prompt the caller may see.
 */
export const getPromptOptions = (options: Options<GetPromptData>) => queryOptions<GetPromptResponse, GetPromptError, GetPromptResponse, ReturnType<typeof getPromptQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPrompt({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPromptQueryKey(options)
});

/**
 * Update Prompt
 *
 * Replace a prompt's text, name, tags and datasource links.
 */
export const updatePromptMutation = (options?: Partial<Options<UpdatePromptData>>): UseMutationOptions<UpdatePromptResponse, UpdatePromptError, Options<UpdatePromptData>> => {
  const mutationOptions: UseMutationOptions<UpdatePromptResponse, UpdatePromptError, Options<UpdatePromptData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePrompt({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPromptSharesQueryKey = (options: Options<GetPromptSharesData>) => createQueryKey('getPromptShares', options);

/**
 * Get Prompt Shares
 *
 * List the users a personal prompt is shared with; only its owner may ask.
 */
export const getPromptSharesOptions = (options: Options<GetPromptSharesData>) => queryOptions<GetPromptSharesResponse, GetPromptSharesError, GetPromptSharesResponse, ReturnType<typeof getPromptSharesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPromptShares({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPromptSharesQueryKey(options)
});

/**
 * Patch Prompt Shares
 *
 * Grant or revoke view-only shares with users of the same organization.
 */
export const patchPromptSharesMutation = (options?: Partial<Options<PatchPromptSharesData>>): UseMutationOptions<PatchPromptSharesResponse, PatchPromptSharesError, Options<PatchPromptSharesData>> => {
  const mutationOptions: UseMutationOptions<PatchPromptSharesResponse, PatchPromptSharesError, Options<PatchPromptSharesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await patchPromptShares({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Publish Prompt
 *
 * Publish the caller's personal prompt to a department they administer or to their organization.
 *
 * The gate answers for the prompt; `PROMPT_FORBIDDEN` is left for the
 * destination, which is a department or the organization rather than this
 * prompt. The prompt's individual shares are removed in the same transaction.
 */
export const publishPromptMutation = (options?: Partial<Options<PublishPromptData>>): UseMutationOptions<PublishPromptResponse, PublishPromptError, Options<PublishPromptData>> => {
  const mutationOptions: UseMutationOptions<PublishPromptResponse, PublishPromptError, Options<PublishPromptData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishPrompt({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Export Data
 */
export const exportDataMutation = (options?: Partial<Options<ExportDataData>>): UseMutationOptions<ExportDataResponse, ExportDataError, Options<ExportDataData>> => {
  const mutationOptions: UseMutationOptions<ExportDataResponse, ExportDataError, Options<ExportDataData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportData({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getArticlesQueryKey = (options?: Options<GetArticlesData>) => createQueryKey('getArticles', options);

/**
 * Get Articles
 *
 * Get a list of articles with optional filtering.
 *
 * **Authentication required.**
 * - Regular users can only see published articles
 * - Help-center managers can see all articles (including unpublished)
 */
export const getArticlesOptions = (options?: Options<GetArticlesData>) => queryOptions<GetArticlesResponse, GetArticlesError, GetArticlesResponse, ReturnType<typeof getArticlesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getArticles({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getArticlesQueryKey(options)
});

/**
 * Create Article
 *
 * Create a new article.
 *
 * **Requires help-center management access.**
 */
export const createArticleMutation = (options?: Partial<Options<CreateArticleData>>): UseMutationOptions<CreateArticleResponse, CreateArticleError, Options<CreateArticleData>> => {
  const mutationOptions: UseMutationOptions<CreateArticleResponse, CreateArticleError, Options<CreateArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createArticle({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Article
 *
 * Delete an article by ID.
 *
 * **Requires help-center management access.**
 */
export const deleteArticleMutation = (options?: Partial<Options<DeleteArticleData>>): UseMutationOptions<DeleteArticleResponse, DeleteArticleError, Options<DeleteArticleData>> => {
  const mutationOptions: UseMutationOptions<DeleteArticleResponse, DeleteArticleError, Options<DeleteArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteArticle({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getArticleQueryKey = (options: Options<GetArticleData>) => createQueryKey('getArticle', options);

/**
 * Get Article
 *
 * Get a specific article by ID.
 *
 * **Authentication required.**
 * - Regular users can only view published articles
 * - Help-center managers can view all articles
 */
export const getArticleOptions = (options: Options<GetArticleData>) => queryOptions<GetArticleResponse, GetArticleError, GetArticleResponse, ReturnType<typeof getArticleQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getArticle({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getArticleQueryKey(options)
});

/**
 * Update Article
 *
 * Update an existing article.
 *
 * **Requires help-center management access.**
 */
export const updateArticleMutation = (options?: Partial<Options<UpdateArticleData>>): UseMutationOptions<UpdateArticleResponse, UpdateArticleError, Options<UpdateArticleData>> => {
  const mutationOptions: UseMutationOptions<UpdateArticleResponse, UpdateArticleError, Options<UpdateArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateArticle({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Publish Article
 *
 * Publish an article.
 *
 * **Requires help-center management access.**
 */
export const publishArticleMutation = (options?: Partial<Options<PublishArticleData>>): UseMutationOptions<PublishArticleResponse, PublishArticleError, Options<PublishArticleData>> => {
  const mutationOptions: UseMutationOptions<PublishArticleResponse, PublishArticleError, Options<PublishArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishArticle({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Unpublish Article
 *
 * Unpublish an article.
 *
 * **Requires help-center management access.**
 */
export const unpublishArticleMutation = (options?: Partial<Options<UnpublishArticleData>>): UseMutationOptions<UnpublishArticleResponse, UnpublishArticleError, Options<UnpublishArticleData>> => {
  const mutationOptions: UseMutationOptions<UnpublishArticleResponse, UnpublishArticleError, Options<UnpublishArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await unpublishArticle({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Increment Article Views
 *
 * Increment the view count for an article.
 *
 * **Authentication required.**
 */
export const incrementArticleViewsMutation = (options?: Partial<Options<IncrementArticleViewsData>>): UseMutationOptions<IncrementArticleViewsResponse, IncrementArticleViewsError, Options<IncrementArticleViewsData>> => {
  const mutationOptions: UseMutationOptions<IncrementArticleViewsResponse, IncrementArticleViewsError, Options<IncrementArticleViewsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await incrementArticleViews({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Like Article
 *
 * Increment the like count for an article.
 *
 * **Authentication required.**
 */
export const likeArticleMutation = (options?: Partial<Options<LikeArticleData>>): UseMutationOptions<LikeArticleResponse, LikeArticleError, Options<LikeArticleData>> => {
  const mutationOptions: UseMutationOptions<LikeArticleResponse, LikeArticleError, Options<LikeArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await likeArticle({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Dislike Article
 *
 * Increment the dislike count for an article.
 *
 * **Authentication required.**
 */
export const dislikeArticleMutation = (options?: Partial<Options<DislikeArticleData>>): UseMutationOptions<DislikeArticleResponse, DislikeArticleError, Options<DislikeArticleData>> => {
  const mutationOptions: UseMutationOptions<DislikeArticleResponse, DislikeArticleError, Options<DislikeArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await dislikeArticle({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getFaqsQueryKey = (options?: Options<GetFaqsData>) => createQueryKey('getFaqs', options);

/**
 * Get Faqs
 *
 * Get a list of FAQs.
 *
 * **Authentication required.**
 * - Regular users can only see published FAQs
 * - Help-center managers can see all FAQs
 */
export const getFaqsOptions = (options?: Options<GetFaqsData>) => queryOptions<GetFaqsResponse, GetFaqsError, GetFaqsResponse, ReturnType<typeof getFaqsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getFaqs({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getFaqsQueryKey(options)
});

/**
 * Create Faq
 *
 * Create a new FAQ.
 *
 * **Requires help-center management access.**
 */
export const createFaqMutation = (options?: Partial<Options<CreateFaqData>>): UseMutationOptions<CreateFaqResponse, CreateFaqError, Options<CreateFaqData>> => {
  const mutationOptions: UseMutationOptions<CreateFaqResponse, CreateFaqError, Options<CreateFaqData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createFaq({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Faq
 *
 * Delete a FAQ by ID.
 *
 * **Requires help-center management access.**
 */
export const deleteFaqMutation = (options?: Partial<Options<DeleteFaqData>>): UseMutationOptions<DeleteFaqResponse, DeleteFaqError, Options<DeleteFaqData>> => {
  const mutationOptions: UseMutationOptions<DeleteFaqResponse, DeleteFaqError, Options<DeleteFaqData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteFaq({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Faq
 *
 * Update an existing FAQ.
 *
 * **Requires help-center management access.**
 */
export const updateFaqMutation = (options?: Partial<Options<UpdateFaqData>>): UseMutationOptions<UpdateFaqResponse, UpdateFaqError, Options<UpdateFaqData>> => {
  const mutationOptions: UseMutationOptions<UpdateFaqResponse, UpdateFaqError, Options<UpdateFaqData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateFaq({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Publish Faq
 *
 * Publish a FAQ.
 *
 * **Requires help-center management access.**
 */
export const publishFaqMutation = (options?: Partial<Options<PublishFaqData>>): UseMutationOptions<PublishFaqResponse, PublishFaqError, Options<PublishFaqData>> => {
  const mutationOptions: UseMutationOptions<PublishFaqResponse, PublishFaqError, Options<PublishFaqData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishFaq({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Unpublish Faq
 *
 * Unpublish a FAQ.
 *
 * **Requires help-center management access.**
 */
export const unpublishFaqMutation = (options?: Partial<Options<UnpublishFaqData>>): UseMutationOptions<UnpublishFaqResponse, UnpublishFaqError, Options<UnpublishFaqData>> => {
  const mutationOptions: UseMutationOptions<UnpublishFaqResponse, UnpublishFaqError, Options<UnpublishFaqData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await unpublishFaq({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Increment Faq Views
 *
 * Increment the view count for a FAQ.
 *
 * **Authentication required.**
 */
export const incrementFaqViewsMutation = (options?: Partial<Options<IncrementFaqViewsData>>): UseMutationOptions<IncrementFaqViewsResponse, IncrementFaqViewsError, Options<IncrementFaqViewsData>> => {
  const mutationOptions: UseMutationOptions<IncrementFaqViewsResponse, IncrementFaqViewsError, Options<IncrementFaqViewsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await incrementFaqViews({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getTopicsQueryKey = (options?: Options<GetTopicsData>) => createQueryKey('getTopics', options);

/**
 * Get Topics
 *
 * Get all article topics.
 */
export const getTopicsOptions = (options?: Options<GetTopicsData>) => queryOptions<GetTopicsResponse, GetTopicsError, GetTopicsResponse, ReturnType<typeof getTopicsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTopics({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTopicsQueryKey(options)
});

/**
 * Create Topic
 *
 * Create a new custom article topic.
 */
export const createTopicMutation = (options?: Partial<Options<CreateTopicData>>): UseMutationOptions<CreateTopicResponse, CreateTopicError, Options<CreateTopicData>> => {
  const mutationOptions: UseMutationOptions<CreateTopicResponse, CreateTopicError, Options<CreateTopicData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTopic({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Topic
 *
 * Delete a custom article topic that is not in use.
 */
export const deleteTopicMutation = (options?: Partial<Options<DeleteTopicData>>): UseMutationOptions<DeleteTopicResponse, DeleteTopicError, Options<DeleteTopicData>> => {
  const mutationOptions: UseMutationOptions<DeleteTopicResponse, DeleteTopicError, Options<DeleteTopicData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTopic({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Topic
 *
 * Rename a custom article topic.
 */
export const updateTopicMutation = (options?: Partial<Options<UpdateTopicData>>): UseMutationOptions<UpdateTopicResponse, UpdateTopicError, Options<UpdateTopicData>> => {
  const mutationOptions: UseMutationOptions<UpdateTopicResponse, UpdateTopicError, Options<UpdateTopicData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTopic({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getArticleTemplatesQueryKey = (options?: Options<GetArticleTemplatesData>) => createQueryKey('getArticleTemplates', options);

/**
 * Get Article Templates
 *
 * Get all article templates.
 *
 * **Authentication required.**
 */
export const getArticleTemplatesOptions = (options?: Options<GetArticleTemplatesData>) => queryOptions<GetArticleTemplatesResponse, GetArticleTemplatesError, GetArticleTemplatesResponse, ReturnType<typeof getArticleTemplatesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getArticleTemplates({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getArticleTemplatesQueryKey(options)
});

/**
 * Create Article Template
 *
 * Create a new article template.
 *
 * **Requires help-center management access.**
 */
export const createArticleTemplateMutation = (options?: Partial<Options<CreateArticleTemplateData>>): UseMutationOptions<CreateArticleTemplateResponse, CreateArticleTemplateError, Options<CreateArticleTemplateData>> => {
  const mutationOptions: UseMutationOptions<CreateArticleTemplateResponse, CreateArticleTemplateError, Options<CreateArticleTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createArticleTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Article Template
 *
 * Delete a template by ID.
 *
 * **Requires help-center management access.**
 */
export const deleteArticleTemplateMutation = (options?: Partial<Options<DeleteArticleTemplateData>>): UseMutationOptions<DeleteArticleTemplateResponse, DeleteArticleTemplateError, Options<DeleteArticleTemplateData>> => {
  const mutationOptions: UseMutationOptions<DeleteArticleTemplateResponse, DeleteArticleTemplateError, Options<DeleteArticleTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteArticleTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getArticleTemplateQueryKey = (options: Options<GetArticleTemplateData>) => createQueryKey('getArticleTemplate', options);

/**
 * Get Article Template
 *
 * Get a specific template by ID.
 *
 * **Authentication required.**
 */
export const getArticleTemplateOptions = (options: Options<GetArticleTemplateData>) => queryOptions<GetArticleTemplateResponse, GetArticleTemplateError, GetArticleTemplateResponse, ReturnType<typeof getArticleTemplateQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getArticleTemplate({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getArticleTemplateQueryKey(options)
});

/**
 * Update Article Template
 *
 * Update an existing template.
 *
 * **Requires help-center management access.**
 */
export const updateArticleTemplateMutation = (options?: Partial<Options<UpdateArticleTemplateData>>): UseMutationOptions<UpdateArticleTemplateResponse, UpdateArticleTemplateError, Options<UpdateArticleTemplateData>> => {
  const mutationOptions: UseMutationOptions<UpdateArticleTemplateResponse, UpdateArticleTemplateError, Options<UpdateArticleTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateArticleTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Use Article Template
 *
 * Increment template usage count when used to create an article.
 *
 * **Authentication required.**
 */
export const useArticleTemplateMutation = (options?: Partial<Options<UseArticleTemplateData>>): UseMutationOptions<UseArticleTemplateResponse, UseArticleTemplateError, Options<UseArticleTemplateData>> => {
  const mutationOptions: UseMutationOptions<UseArticleTemplateResponse, UseArticleTemplateError, Options<UseArticleTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await useArticleTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Upload Help Center Media
 *
 * Upload a media file (image or video).
 *
 * **Requires help-center management access.**
 */
export const uploadHelpCenterMediaMutation = (options?: Partial<Options<UploadHelpCenterMediaData>>): UseMutationOptions<UploadHelpCenterMediaResponse, UploadHelpCenterMediaError, Options<UploadHelpCenterMediaData>> => {
  const mutationOptions: UseMutationOptions<UploadHelpCenterMediaResponse, UploadHelpCenterMediaError, Options<UploadHelpCenterMediaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadHelpCenterMedia({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Media
 *
 * Delete a media file and its metadata.
 *
 * **Requires help-center management access.**
 */
export const deleteMediaMutation = (options?: Partial<Options<DeleteMediaData>>): UseMutationOptions<DeleteMediaResponse, DeleteMediaError, Options<DeleteMediaData>> => {
  const mutationOptions: UseMutationOptions<DeleteMediaResponse, DeleteMediaError, Options<DeleteMediaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteMedia({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getMediaMetadataQueryKey = (options: Options<GetMediaMetadataData>) => createQueryKey('getMediaMetadata', options);

/**
 * Get Media Metadata
 *
 * Retrieve metadata for a specific media file by its ID.
 *
 * **Authentication required.**
 */
export const getMediaMetadataOptions = (options: Options<GetMediaMetadataData>) => queryOptions<GetMediaMetadataResponse, GetMediaMetadataError, GetMediaMetadataResponse, ReturnType<typeof getMediaMetadataQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getMediaMetadata({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getMediaMetadataQueryKey(options)
});

export const downloadMediaQueryKey = (options: Options<DownloadMediaData>) => createQueryKey('downloadMedia', options);

/**
 * Download Media
 *
 * Streams or downloads a media file.
 *
 * **Authentication required.**
 */
export const downloadMediaOptions = (options: Options<DownloadMediaData>) => queryOptions<unknown, DownloadMediaError, unknown, ReturnType<typeof downloadMediaQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await downloadMedia({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: downloadMediaQueryKey(options)
});

/**
 * Send Contact Message
 *
 * Send a contact message to the help center team.
 *
 * **Authentication required.**
 */
export const sendContactMessageMutation = (options?: Partial<Options<SendContactMessageData>>): UseMutationOptions<SendContactMessageResponse, SendContactMessageError, Options<SendContactMessageData>> => {
  const mutationOptions: UseMutationOptions<SendContactMessageResponse, SendContactMessageError, Options<SendContactMessageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendContactMessage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getReleaseNotesQueryKey = (options?: Options<GetReleaseNotesData>) => createQueryKey('getReleaseNotes', options);

/**
 * Get Release Notes
 *
 * Get a list of release notes.
 */
export const getReleaseNotesOptions = (options?: Options<GetReleaseNotesData>) => queryOptions<GetReleaseNotesResponse, GetReleaseNotesError, GetReleaseNotesResponse, ReturnType<typeof getReleaseNotesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getReleaseNotes({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getReleaseNotesQueryKey(options)
});

/**
 * Create Release Note
 *
 * Create a new release note.
 */
export const createReleaseNoteMutation = (options?: Partial<Options<CreateReleaseNoteData>>): UseMutationOptions<CreateReleaseNoteResponse, CreateReleaseNoteError, Options<CreateReleaseNoteData>> => {
  const mutationOptions: UseMutationOptions<CreateReleaseNoteResponse, CreateReleaseNoteError, Options<CreateReleaseNoteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createReleaseNote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Release Note
 *
 * Delete a release note by ID.
 */
export const deleteReleaseNoteMutation = (options?: Partial<Options<DeleteReleaseNoteData>>): UseMutationOptions<DeleteReleaseNoteResponse, DeleteReleaseNoteError, Options<DeleteReleaseNoteData>> => {
  const mutationOptions: UseMutationOptions<DeleteReleaseNoteResponse, DeleteReleaseNoteError, Options<DeleteReleaseNoteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteReleaseNote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getReleaseNoteByIdQueryKey = (options: Options<GetReleaseNoteByIdData>) => createQueryKey('getReleaseNoteById', options);

/**
 * Get Release Note By Id
 *
 * Get a specific release note by ID.
 */
export const getReleaseNoteByIdOptions = (options: Options<GetReleaseNoteByIdData>) => queryOptions<GetReleaseNoteByIdResponse, GetReleaseNoteByIdError, GetReleaseNoteByIdResponse, ReturnType<typeof getReleaseNoteByIdQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getReleaseNoteById({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getReleaseNoteByIdQueryKey(options)
});

/**
 * Update Release Note
 *
 * Update an existing release note.
 */
export const updateReleaseNoteMutation = (options?: Partial<Options<UpdateReleaseNoteData>>): UseMutationOptions<UpdateReleaseNoteResponse, UpdateReleaseNoteError, Options<UpdateReleaseNoteData>> => {
  const mutationOptions: UseMutationOptions<UpdateReleaseNoteResponse, UpdateReleaseNoteError, Options<UpdateReleaseNoteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateReleaseNote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Publish Release Note
 *
 * Publish a release note.
 */
export const publishReleaseNoteMutation = (options?: Partial<Options<PublishReleaseNoteData>>): UseMutationOptions<PublishReleaseNoteResponse, PublishReleaseNoteError, Options<PublishReleaseNoteData>> => {
  const mutationOptions: UseMutationOptions<PublishReleaseNoteResponse, PublishReleaseNoteError, Options<PublishReleaseNoteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishReleaseNote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Unpublish Release Note
 *
 * Unpublish a release note.
 */
export const unpublishReleaseNoteMutation = (options?: Partial<Options<UnpublishReleaseNoteData>>): UseMutationOptions<UnpublishReleaseNoteResponse, UnpublishReleaseNoteError, Options<UnpublishReleaseNoteData>> => {
  const mutationOptions: UseMutationOptions<UnpublishReleaseNoteResponse, UnpublishReleaseNoteError, Options<UnpublishReleaseNoteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await unpublishReleaseNote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listClassificationsQueryKey = (options: Options<ListClassificationsData>) => createQueryKey('listClassifications', options);

/**
 * List Classifications
 */
export const listClassificationsOptions = (options: Options<ListClassificationsData>) => queryOptions<ListClassificationsResponse, ListClassificationsError, ListClassificationsResponse, ReturnType<typeof listClassificationsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listClassifications({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listClassificationsQueryKey(options)
});

/**
 * Save Classifications
 */
export const saveClassificationsMutation = (options?: Partial<Options<SaveClassificationsData>>): UseMutationOptions<SaveClassificationsResponse, SaveClassificationsError, Options<SaveClassificationsData>> => {
  const mutationOptions: UseMutationOptions<SaveClassificationsResponse, SaveClassificationsError, Options<SaveClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Snapshot Classifications
 *
 * Load the current-year warehouse row set once into local classification rows.
 */
export const snapshotClassificationsMutation = (options?: Partial<Options<SnapshotClassificationsData>>): UseMutationOptions<SnapshotClassificationsResponse, SnapshotClassificationsError, Options<SnapshotClassificationsData>> => {
  const mutationOptions: UseMutationOptions<SnapshotClassificationsResponse, SnapshotClassificationsError, Options<SnapshotClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await snapshotClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Refresh Classifications
 *
 * Re-read current-year gold: additive identity updates plus gold-match verdicts.
 */
export const refreshClassificationsMutation = (options?: Partial<Options<RefreshClassificationsData>>): UseMutationOptions<RefreshClassificationsResponse2, RefreshClassificationsError, Options<RefreshClassificationsData>> => {
  const mutationOptions: UseMutationOptions<RefreshClassificationsResponse2, RefreshClassificationsError, Options<RefreshClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Import Prior Year Classifications
 *
 * Fill unclassified local rows from T-1 gold. Does not stamp gold_verified_at.
 */
export const importPriorYearClassificationsMutation = (options?: Partial<Options<ImportPriorYearClassificationsData>>): UseMutationOptions<ImportPriorYearClassificationsResponse, ImportPriorYearClassificationsError, Options<ImportPriorYearClassificationsData>> => {
  const mutationOptions: UseMutationOptions<ImportPriorYearClassificationsResponse, ImportPriorYearClassificationsError, Options<ImportPriorYearClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await importPriorYearClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Copy Classifications
 *
 * Copy a readable sibling project's classifications into this project's unclassified rows.
 */
export const copyClassificationsMutation = (options?: Partial<Options<CopyClassificationsData>>): UseMutationOptions<CopyClassificationsResponse2, CopyClassificationsError, Options<CopyClassificationsData>> => {
  const mutationOptions: UseMutationOptions<CopyClassificationsResponse2, CopyClassificationsError, Options<CopyClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await copyClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listCopyClassificationSourcesQueryKey = (options: Options<ListCopyClassificationSourcesData>) => createQueryKey('listCopyClassificationSources', options);

/**
 * List Copy Classification Sources
 *
 * List the projects this project can copy classifications from, busiest first.
 */
export const listCopyClassificationSourcesOptions = (options: Options<ListCopyClassificationSourcesData>) => queryOptions<ListCopyClassificationSourcesResponse, ListCopyClassificationSourcesError, ListCopyClassificationSourcesResponse, ReturnType<typeof listCopyClassificationSourcesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listCopyClassificationSources({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listCopyClassificationSourcesQueryKey(options)
});

export const getClassificationStatsQueryKey = (options: Options<GetClassificationStatsData>) => createQueryKey('getClassificationStats', options);

/**
 * Get Classification Stats
 */
export const getClassificationStatsOptions = (options: Options<GetClassificationStatsData>) => queryOptions<GetClassificationStatsResponse, GetClassificationStatsError, GetClassificationStatsResponse, ReturnType<typeof getClassificationStatsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getClassificationStats({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getClassificationStatsQueryKey(options)
});

/**
 * Export Classifications
 *
 * Export local classification rows to the external system.
 */
export const exportClassificationsMutation = (options?: Partial<Options<ExportClassificationsData>>): UseMutationOptions<unknown, ExportClassificationsError, Options<ExportClassificationsData>> => {
  const mutationOptions: UseMutationOptions<unknown, ExportClassificationsError, Options<ExportClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const exportClassificationResultsExcelQueryKey = (options: Options<ExportClassificationResultsExcelData>) => createQueryKey('exportClassificationResultsExcel', options);

/**
 * Export Classification Results Excel
 *
 * Export classification results to an Excel file for local download.
 */
export const exportClassificationResultsExcelOptions = (options: Options<ExportClassificationResultsExcelData>) => queryOptions<unknown, ExportClassificationResultsExcelError, unknown, ReturnType<typeof exportClassificationResultsExcelQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportClassificationResultsExcel({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportClassificationResultsExcelQueryKey(options)
});

export const getClassificationPipelineStatusQueryKey = (options: Options<GetClassificationPipelineStatusData>) => createQueryKey('getClassificationPipelineStatus', options);

/**
 * Get Classification Pipeline Status
 *
 * Get classification export pipeline execution status.
 */
export const getClassificationPipelineStatusOptions = (options: Options<GetClassificationPipelineStatusData>) => queryOptions<GetClassificationPipelineStatusResponse, GetClassificationPipelineStatusError, GetClassificationPipelineStatusResponse, ReturnType<typeof getClassificationPipelineStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getClassificationPipelineStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getClassificationPipelineStatusQueryKey(options)
});

/**
 * Predict Classifications
 *
 * Predict classifications for rows using AI.
 *
 * Uses the latest template version and LLM to automatically classify rows.
 * Returns only valid predictions that exactly match allowed combinations.
 * Invalid predictions are counted for feedback.
 *
 * The response includes the model name used for provenance tracking.
 *
 * The gate resolves the project inside the caller's organization and decides in
 * one statement, so the row reached here is both authorized and the one the
 * template is checked against, and the id that books the usage reservation is
 * its own. A project outside the organization is denied like an unknown one.
 *
 * The applicability check stays in the handler rather than coming from
 * `get_project_template`: this route reads its template id out of the path for
 * the prediction call, and routing it through the shared dependency would add a
 * second template fetch for the same row.
 */
export const predictClassificationsMutation = (options?: Partial<Options<PredictClassificationsData>>): UseMutationOptions<PredictClassificationsResponse2, PredictClassificationsError, Options<PredictClassificationsData>> => {
  const mutationOptions: UseMutationOptions<PredictClassificationsResponse2, PredictClassificationsError, Options<PredictClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await predictClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Clear Ledger Classifications
 *
 * Remove every target of the project's resolved ledger binding, keeping revision history.
 */
export const clearLedgerClassificationsMutation = (options?: Partial<Options<ClearLedgerClassificationsData>>): UseMutationOptions<ClearLedgerClassificationsResponse2, ClearLedgerClassificationsError, Options<ClearLedgerClassificationsData>> => {
  const mutationOptions: UseMutationOptions<ClearLedgerClassificationsResponse2, ClearLedgerClassificationsError, Options<ClearLedgerClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearLedgerClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listLedgerAccountsQueryKey = (options: Options<ListLedgerAccountsData>) => createQueryKey('listLedgerAccounts', options);

/**
 * List Ledger Accounts
 *
 * Read the grid columns and one local row per account with evidence for the project's booking year.
 */
export const listLedgerAccountsOptions = (options: Options<ListLedgerAccountsData>) => queryOptions<ListLedgerAccountsResponse, ListLedgerAccountsError, ListLedgerAccountsResponse, ReturnType<typeof listLedgerAccountsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listLedgerAccounts({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listLedgerAccountsQueryKey(options)
});

/**
 * Save Ledger Classifications
 *
 * Save manual classifications against the audit project's resolved ledger binding.
 */
export const saveLedgerClassificationsMutation = (options?: Partial<Options<SaveLedgerClassificationsData>>): UseMutationOptions<SaveLedgerClassificationsResponse2, SaveLedgerClassificationsError, Options<SaveLedgerClassificationsData>> => {
  const mutationOptions: UseMutationOptions<SaveLedgerClassificationsResponse2, SaveLedgerClassificationsError, Options<SaveLedgerClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveLedgerClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Predict Ledger Classifications
 *
 * Predict targets for the typed ledger's current unclassified accounts.
 */
export const predictLedgerClassificationsMutation = (options?: Partial<Options<PredictLedgerClassificationsData>>): UseMutationOptions<PredictLedgerClassificationsResponse, PredictLedgerClassificationsError, Options<PredictLedgerClassificationsData>> => {
  const mutationOptions: UseMutationOptions<PredictLedgerClassificationsResponse, PredictLedgerClassificationsError, Options<PredictLedgerClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await predictLedgerClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Accept Ledger Predictions
 *
 * Accept selected server-issued predictions without overwriting later edits.
 */
export const acceptLedgerPredictionsMutation = (options?: Partial<Options<AcceptLedgerPredictionsData>>): UseMutationOptions<AcceptLedgerPredictionsResponse, AcceptLedgerPredictionsError, Options<AcceptLedgerPredictionsData>> => {
  const mutationOptions: UseMutationOptions<AcceptLedgerPredictionsResponse, AcceptLedgerPredictionsError, Options<AcceptLedgerPredictionsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptLedgerPredictions({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listLedgerTargetsQueryKey = (options: Options<ListLedgerTargetsData>) => createQueryKey('listLedgerTargets', options);

/**
 * List Ledger Targets
 *
 * Read the resolved published taxonomy offered by the ledger classification picker.
 */
export const listLedgerTargetsOptions = (options: Options<ListLedgerTargetsData>) => queryOptions<ListLedgerTargetsResponse, ListLedgerTargetsError, ListLedgerTargetsResponse, ReturnType<typeof listLedgerTargetsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listLedgerTargets({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listLedgerTargetsQueryKey(options)
});

export const getLedgerStatsQueryKey = (options: Options<GetLedgerStatsData>) => createQueryKey('getLedgerStats', options);

/**
 * Get Ledger Stats
 *
 * Read local account counts and completeness using the ledger grid's status rules.
 */
export const getLedgerStatsOptions = (options: Options<GetLedgerStatsData>) => queryOptions<GetLedgerStatsResponse, GetLedgerStatsError, GetLedgerStatsResponse, ReturnType<typeof getLedgerStatsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getLedgerStats({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLedgerStatsQueryKey(options)
});

/**
 * Snapshot Ledger Accounts
 *
 * Explicitly snapshot the bound ledger's account evidence for the project's booking year.
 */
export const snapshotLedgerAccountsMutation = (options?: Partial<Options<SnapshotLedgerAccountsData>>): UseMutationOptions<SnapshotLedgerAccountsResponse, SnapshotLedgerAccountsError, Options<SnapshotLedgerAccountsData>> => {
  const mutationOptions: UseMutationOptions<SnapshotLedgerAccountsResponse, SnapshotLedgerAccountsError, Options<SnapshotLedgerAccountsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await snapshotLedgerAccounts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Refresh Ledger Accounts
 *
 * Explicitly refresh the bound ledger's account list for the project's booking year.
 */
export const refreshLedgerAccountsMutation = (options?: Partial<Options<RefreshLedgerAccountsData>>): UseMutationOptions<RefreshLedgerAccountsResponse, RefreshLedgerAccountsError, Options<RefreshLedgerAccountsData>> => {
  const mutationOptions: UseMutationOptions<RefreshLedgerAccountsResponse, RefreshLedgerAccountsError, Options<RefreshLedgerAccountsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshLedgerAccounts({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Copy Ledger Classifications
 *
 * Fill unclassified accounts from another audit project the caller can read, never the warehouse.
 */
export const copyLedgerClassificationsMutation = (options?: Partial<Options<CopyLedgerClassificationsData>>): UseMutationOptions<CopyLedgerClassificationsResponse, CopyLedgerClassificationsError, Options<CopyLedgerClassificationsData>> => {
  const mutationOptions: UseMutationOptions<CopyLedgerClassificationsResponse, CopyLedgerClassificationsError, Options<CopyLedgerClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await copyLedgerClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listLedgerCopySourcesQueryKey = (options: Options<ListLedgerCopySourcesData>) => createQueryKey('listLedgerCopySources', options);

/**
 * List Ledger Copy Sources
 *
 * List the audit projects this project can copy classifications from, busiest first.
 */
export const listLedgerCopySourcesOptions = (options: Options<ListLedgerCopySourcesData>) => queryOptions<ListLedgerCopySourcesResponse, ListLedgerCopySourcesError, ListLedgerCopySourcesResponse, ReturnType<typeof listLedgerCopySourcesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listLedgerCopySources({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listLedgerCopySourcesQueryKey(options)
});

/**
 * Export Ledger Classifications
 *
 * Send the fiscal year's typed classifications to gold and record that the batch was sent.
 */
export const exportLedgerClassificationsMutation = (options?: Partial<Options<ExportLedgerClassificationsData>>): UseMutationOptions<unknown, ExportLedgerClassificationsError, Options<ExportLedgerClassificationsData>> => {
  const mutationOptions: UseMutationOptions<unknown, ExportLedgerClassificationsError, Options<ExportLedgerClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportLedgerClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getLedgerExportStatusQueryKey = (options: Options<GetLedgerExportStatusData>) => createQueryKey('getLedgerExportStatus', options);

/**
 * Get Ledger Export Status
 *
 * Report the latest export of the ledger the project is bound to, or null before the first one.
 */
export const getLedgerExportStatusOptions = (options: Options<GetLedgerExportStatusData>) => queryOptions<GetLedgerExportStatusResponse, GetLedgerExportStatusError, GetLedgerExportStatusResponse, ReturnType<typeof getLedgerExportStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getLedgerExportStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLedgerExportStatusQueryKey(options)
});

export const listClassificationTemplatesQueryKey = (options: Options<ListClassificationTemplatesData>) => createQueryKey('listClassificationTemplates', options);

/**
 * List Classification Templates
 */
export const listClassificationTemplatesOptions = (options: Options<ListClassificationTemplatesData>) => queryOptions<ListClassificationTemplatesResponse, ListClassificationTemplatesError, ListClassificationTemplatesResponse, ReturnType<typeof listClassificationTemplatesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listClassificationTemplates({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listClassificationTemplatesQueryKey(options)
});

/**
 * Create Classification Template
 */
export const createClassificationTemplateMutation = (options?: Partial<Options<CreateClassificationTemplateData>>): UseMutationOptions<CreateClassificationTemplateResponse, CreateClassificationTemplateError, Options<CreateClassificationTemplateData>> => {
  const mutationOptions: UseMutationOptions<CreateClassificationTemplateResponse, CreateClassificationTemplateError, Options<CreateClassificationTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClassificationTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Classification Template
 *
 * Delete a classification template.
 *
 * Deleting a template will:
 * - Remove all template versions
 * - Remove all classifications associated with the template
 * - Remove all client-template associations
 *
 * No `require_locked_row`: a catalog's authority is organization-level, so no
 * row serializes a revocation against this write and the change takes effect on
 * the next request, which is the residual window RFC 5.11 already describes.
 */
export const deleteClassificationTemplateMutation = (options?: Partial<Options<DeleteClassificationTemplateData>>): UseMutationOptions<unknown, DeleteClassificationTemplateError, Options<DeleteClassificationTemplateData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteClassificationTemplateError, Options<DeleteClassificationTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteClassificationTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getClassificationTemplateQueryKey = (options: Options<GetClassificationTemplateData>) => createQueryKey('getClassificationTemplate', options);

/**
 * Get Classification Template
 *
 * Return one template of this organization's catalog.
 */
export const getClassificationTemplateOptions = (options: Options<GetClassificationTemplateData>) => queryOptions<GetClassificationTemplateResponse, GetClassificationTemplateError, GetClassificationTemplateResponse, ReturnType<typeof getClassificationTemplateQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getClassificationTemplate({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getClassificationTemplateQueryKey(options)
});

export const getLatestClassificationTemplateVersionQueryKey = (options: Options<GetLatestClassificationTemplateVersionData>) => createQueryKey('getLatestClassificationTemplateVersion', options);

/**
 * Get Latest Classification Template Version
 */
export const getLatestClassificationTemplateVersionOptions = (options: Options<GetLatestClassificationTemplateVersionData>) => queryOptions<GetLatestClassificationTemplateVersionResponse, GetLatestClassificationTemplateVersionError, GetLatestClassificationTemplateVersionResponse, ReturnType<typeof getLatestClassificationTemplateVersionQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getLatestClassificationTemplateVersion({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getLatestClassificationTemplateVersionQueryKey(options)
});

export const listClassificationTemplateVersionsQueryKey = (options: Options<ListClassificationTemplateVersionsData>) => createQueryKey('listClassificationTemplateVersions', options);

/**
 * List Classification Template Versions
 */
export const listClassificationTemplateVersionsOptions = (options: Options<ListClassificationTemplateVersionsData>) => queryOptions<ListClassificationTemplateVersionsResponse, ListClassificationTemplateVersionsError, ListClassificationTemplateVersionsResponse, ReturnType<typeof listClassificationTemplateVersionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listClassificationTemplateVersions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listClassificationTemplateVersionsQueryKey(options)
});

/**
 * Create Template Version
 */
export const createTemplateVersionMutation = (options?: Partial<Options<CreateTemplateVersionData>>): UseMutationOptions<CreateTemplateVersionResponse, CreateTemplateVersionError, Options<CreateTemplateVersionData>> => {
  const mutationOptions: UseMutationOptions<CreateTemplateVersionResponse, CreateTemplateVersionError, Options<CreateTemplateVersionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTemplateVersion({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const queryClassificationTemplateDataQueryKey = (options: Options<QueryClassificationTemplateDataData>) => createQueryKey('queryClassificationTemplateData', options);

/**
 * Query Classification Template Data
 *
 * Read one page of a template's source rows for one project.
 *
 * Three different questions, and a gate answers two of them. *May this actor
 * reach this template?* is the catalog policy's. *May they classify this
 * project?* is the project policy's. *Does this template apply to the project
 * the url names?* is neither: it is a predicate over the two authorized rows,
 * so `resolve_template_context` keeps it, exactly as widget containment stays
 * on its routes.
 */
export const queryClassificationTemplateDataOptions = (options: Options<QueryClassificationTemplateDataData>) => queryOptions<QueryClassificationTemplateDataResponse, QueryClassificationTemplateDataError, QueryClassificationTemplateDataResponse, ReturnType<typeof queryClassificationTemplateDataQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await queryClassificationTemplateData({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: queryClassificationTemplateDataQueryKey(options)
});

/**
 * Create Ledger Classification Template
 *
 * Create an audit ledger template on the shared statement tree.
 *
 * Journals continue using `/classification_template` and the legacy tables.
 */
export const createLedgerClassificationTemplateMutation = (options?: Partial<Options<CreateLedgerClassificationTemplateData>>): UseMutationOptions<CreateLedgerClassificationTemplateResponse, CreateLedgerClassificationTemplateError, Options<CreateLedgerClassificationTemplateData>> => {
  const mutationOptions: UseMutationOptions<CreateLedgerClassificationTemplateResponse, CreateLedgerClassificationTemplateError, Options<CreateLedgerClassificationTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createLedgerClassificationTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const readLedgerTemplateQueryQueryKey = (options: Options<ReadLedgerTemplateQueryData>) => createQueryKey('readLedgerTemplateQuery', options);

/**
 * Read Ledger Template Query
 *
 * Read the source query of an audit ledger template.
 */
export const readLedgerTemplateQueryOptions = (options: Options<ReadLedgerTemplateQueryData>) => queryOptions<ReadLedgerTemplateQueryResponse, ReadLedgerTemplateQueryError, ReadLedgerTemplateQueryResponse, ReturnType<typeof readLedgerTemplateQueryQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await readLedgerTemplateQuery({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: readLedgerTemplateQueryQueryKey(options)
});

/**
 * Update Ledger Template Query
 *
 * Save source configuration for subsequent account loads and refreshes.
 */
export const updateLedgerTemplateQueryMutation = (options?: Partial<Options<UpdateLedgerTemplateQueryData>>): UseMutationOptions<UpdateLedgerTemplateQueryResponse, UpdateLedgerTemplateQueryError, Options<UpdateLedgerTemplateQueryData>> => {
  const mutationOptions: UseMutationOptions<UpdateLedgerTemplateQueryResponse, UpdateLedgerTemplateQueryError, Options<UpdateLedgerTemplateQueryData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLedgerTemplateQuery({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPersonalAnalysisRunsQueryKey = (options: Options<GetPersonalAnalysisRunsData>) => createQueryKey('getPersonalAnalysisRuns', options);

/**
 * Get Personal Analysis Runs
 *
 * List the caller's personal runs across every personal template they own.
 *
 * A "personal run" is a record with no `project_id` against a
 * template the caller created at `scope_type="personal"`. Returned
 * flat (one entry per `(template, datasource, run_number)` triple),
 * sorted by most recent first. Avoids the N+1 fan-out of calling
 * `/{template_id}/runs` per template.
 */
export const getPersonalAnalysisRunsOptions = (options: Options<GetPersonalAnalysisRunsData>) => queryOptions<GetPersonalAnalysisRunsResponse, GetPersonalAnalysisRunsError, GetPersonalAnalysisRunsResponse, ReturnType<typeof getPersonalAnalysisRunsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPersonalAnalysisRuns({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPersonalAnalysisRunsQueryKey(options)
});

export const getAnalysisRunResultsQueryKey = (options: Options<GetAnalysisRunResultsData>) => createQueryKey('getAnalysisRunResults', options);

/**
 * Get Analysis Run Results
 *
 * Get analysis results for a specific run.
 *
 * A run is uniquely identified by (project_id, template_id, datasource_id, run_number)
 * because run numbers restart at 1 per (project, template, datasource) triple. All four
 * must be passed to avoid leaking records from other runs that happen to share the same
 * counter value.
 *
 * Records are returned in the same order as questions appear in the template.
 *
 * When project_id is omitted the caller's personal run (project_id IS NULL, owned by
 * the caller) is returned. No project-level permission is required in that case.
 */
export const getAnalysisRunResultsOptions = (options: Options<GetAnalysisRunResultsData>) => queryOptions<GetAnalysisRunResultsResponse, GetAnalysisRunResultsError, GetAnalysisRunResultsResponse, ReturnType<typeof getAnalysisRunResultsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAnalysisRunResults({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAnalysisRunResultsQueryKey(options)
});

export const getBatchSummaryQueryKey = (options: Options<GetBatchSummaryData>) => createQueryKey('getBatchSummary', options);

/**
 * Get Batch Summary
 *
 * Resolve a batch to the documents it produced.
 *
 * A batch groups N per-document runs under one batch_id; this returns the
 * distinct (datasource_id, run_number) pairs plus the shared template/project
 * so the client can reuse the per-run results endpoint for each document.
 *
 * Authorization mirrors the results endpoint: a project batch requires the
 * project permission; a personal batch (project_id IS NULL) must belong to the
 * caller (their personal template in this org).
 */
export const getBatchSummaryOptions = (options: Options<GetBatchSummaryData>) => queryOptions<GetBatchSummaryResponse, GetBatchSummaryError, GetBatchSummaryResponse, ReturnType<typeof getBatchSummaryQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getBatchSummary({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getBatchSummaryQueryKey(options)
});

/**
 * Delete Analysis Run
 *
 * Delete all records for a specific analysis run.
 *
 * A run is uniquely identified by (project_id, template_id, datasource_id, run_number).
 * Without the full identity, deleting "run 1" would also delete unrelated runs that
 * share the counter value across templates or datasources.
 *
 * When project_id is provided the caller must hold
 * `delete_document_analysis_run` on the specific project resource
 * (i.e. be assigned to that audit client team) to delete records.
 * When omitted,
 * only the caller's own personal run (project_id IS NULL) can be deleted;
 * no extra permission is required beyond org membership.
 */
export const deleteAnalysisRunMutation = (options?: Partial<Options<DeleteAnalysisRunData>>): UseMutationOptions<unknown, DeleteAnalysisRunError, Options<DeleteAnalysisRunData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteAnalysisRunError, Options<DeleteAnalysisRunData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteAnalysisRun({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Document Analysis Search
 *
 * Run a checklist against one or more documents.
 *
 * Streams NDJSON: per-document run-number and record events tagged with their
 * datasource_id, then a terminal complete event summarizing every document.
 * Each document is an independent run; the records share one batch_id. A single
 * document is just a run of one.
 *
 * Every supplied datasource must be readable by the caller and, when a project
 * is supplied, the caller must hold `perform_document_analysis` on that exact
 * project: its company/year context drives the run's row-level security. List
 * semantics are all-or-nothing — one denied document fails the whole request
 * rather than silently narrowing the run.
 */
export const documentAnalysisSearchMutation = (options?: Partial<Options<DocumentAnalysisSearchData>>): UseMutationOptions<DocumentAnalysisSearchResponse, DocumentAnalysisSearchError, Options<DocumentAnalysisSearchData>> => {
  const mutationOptions: UseMutationOptions<DocumentAnalysisSearchResponse, DocumentAnalysisSearchError, Options<DocumentAnalysisSearchData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await documentAnalysisSearch({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getTemplateAnalysisRunsQueryKey = (options: Options<GetTemplateAnalysisRunsData>) => createQueryKey('getTemplateAnalysisRuns', options);

/**
 * Get Template Analysis Runs
 *
 * List all analysis runs produced from this template, across projects and personal runs.
 *
 * Visibility tracks the template: the path dependency already gates
 * "can the caller see this template" via the scope-aware permission
 * check, so any record sharing the template's id is fair game.
 * Runs are grouped per `(project_id, datasource_id, run_number)`.
 */
export const getTemplateAnalysisRunsOptions = (options: Options<GetTemplateAnalysisRunsData>) => queryOptions<GetTemplateAnalysisRunsResponse, GetTemplateAnalysisRunsError, GetTemplateAnalysisRunsResponse, ReturnType<typeof getTemplateAnalysisRunsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getTemplateAnalysisRuns({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getTemplateAnalysisRunsQueryKey(options)
});

export const getClientAnalysisRunsQueryKey = (options: Options<GetClientAnalysisRunsData>) => createQueryKey('getClientAnalysisRuns', options);

/**
 * Get Client Analysis Runs
 *
 * Get all analysis runs for a client.
 *
 * Bound to the project in the path: a role on another project does not list
 * this one's runs.
 *
 * Each run represents a complete, independent analysis of one datasource with one template.
 * Returns all runs sorted by run_number (most recent first).
 * Supports multiple runs per template-datasource combination.
 *
 * Only returns runs that were explicitly connected to this client (have project_id set).
 * Test runs (created from template overview without a client) are excluded.
 */
export const getClientAnalysisRunsOptions = (options: Options<GetClientAnalysisRunsData>) => queryOptions<GetClientAnalysisRunsResponse, GetClientAnalysisRunsError, GetClientAnalysisRunsResponse, ReturnType<typeof getClientAnalysisRunsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getClientAnalysisRuns({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getClientAnalysisRunsQueryKey(options)
});

export const exportDocumentAnalysisRunResultsAsExcelQueryKey = (options: Options<ExportDocumentAnalysisRunResultsAsExcelData>) => createQueryKey('exportDocumentAnalysisRunResultsAsExcel', options);

/**
 * Export Document Analysis Run Results As Excel
 *
 * Export document analysis run results as an Excel file.
 *
 * Only available when all records in the run are confirmed. When project_id is omitted
 * the caller's personal run is exported; when supplied it must resolve inside the
 * caller's organization, because its company and booking year name the download.
 */
export const exportDocumentAnalysisRunResultsAsExcelOptions = (options: Options<ExportDocumentAnalysisRunResultsAsExcelData>) => queryOptions<unknown, ExportDocumentAnalysisRunResultsAsExcelError, unknown, ReturnType<typeof exportDocumentAnalysisRunResultsAsExcelQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportDocumentAnalysisRunResultsAsExcel({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportDocumentAnalysisRunResultsAsExcelQueryKey(options)
});

export const exportDocumentAnalysisRunResultsAsPdfQueryKey = (options: Options<ExportDocumentAnalysisRunResultsAsPdfData>) => createQueryKey('exportDocumentAnalysisRunResultsAsPdf', options);

/**
 * Export Document Analysis Run Results As Pdf
 *
 * Export document analysis run results as a PDF with bounding box overlays.
 *
 * Same project binding as the Excel export: a project id outside the caller's
 * organization is denied before the document is read.
 */
export const exportDocumentAnalysisRunResultsAsPdfOptions = (options: Options<ExportDocumentAnalysisRunResultsAsPdfData>) => queryOptions<unknown, ExportDocumentAnalysisRunResultsAsPdfError, unknown, ReturnType<typeof exportDocumentAnalysisRunResultsAsPdfQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportDocumentAnalysisRunResultsAsPdf({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportDocumentAnalysisRunResultsAsPdfQueryKey(options)
});

/**
 * Toggle Confirmation
 *
 * Toggle confirmation state for a document analysis record.
 */
export const toggleConfirmationMutation = (options?: Partial<Options<ToggleConfirmationData>>): UseMutationOptions<ToggleConfirmationResponse, ToggleConfirmationError, Options<ToggleConfirmationData>> => {
  const mutationOptions: UseMutationOptions<ToggleConfirmationResponse, ToggleConfirmationError, Options<ToggleConfirmationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await toggleConfirmation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Document Analysis Record
 *
 * Update a document analysis record with editable Q&A.
 *
 * Note: template_id in the path pins the record's identity, it does not
 * authorize the edit; the record's stored project (or its template, for a
 * project-less run) does.
 */
export const updateDocumentAnalysisRecordMutation = (options?: Partial<Options<UpdateDocumentAnalysisRecordData>>): UseMutationOptions<UpdateDocumentAnalysisRecordResponse, UpdateDocumentAnalysisRecordError, Options<UpdateDocumentAnalysisRecordData>> => {
  const mutationOptions: UseMutationOptions<UpdateDocumentAnalysisRecordResponse, UpdateDocumentAnalysisRecordError, Options<UpdateDocumentAnalysisRecordData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDocumentAnalysisRecord({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Document Analysis Template
 *
 * Delete a template (and its analysis records).
 *
 * Personal: requires the per-resource `ResourcePermission` owner-action bundle on this template id.
 * Promoted: requires `delete_document_analysis_template` on the
 * template's scope (project / project_type).
 */
export const deleteDocumentAnalysisTemplateMutation = (options?: Partial<Options<DeleteDocumentAnalysisTemplateData>>): UseMutationOptions<unknown, DeleteDocumentAnalysisTemplateError, Options<DeleteDocumentAnalysisTemplateData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteDocumentAnalysisTemplateError, Options<DeleteDocumentAnalysisTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteDocumentAnalysisTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getDocumentAnalysisTemplateQueryKey = (options: Options<GetDocumentAnalysisTemplateData>) => createQueryKey('getDocumentAnalysisTemplate', options);

/**
 * Get Document Analysis Template
 *
 * Read a document analysis template.
 *
 * Visibility is enforced by the path dependency: personal templates
 * are visible only to their owner (and superusers); org-wide
 * templates to anyone in the org.
 */
export const getDocumentAnalysisTemplateOptions = (options: Options<GetDocumentAnalysisTemplateData>) => queryOptions<GetDocumentAnalysisTemplateResponse, GetDocumentAnalysisTemplateError, GetDocumentAnalysisTemplateResponse, ReturnType<typeof getDocumentAnalysisTemplateQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDocumentAnalysisTemplate({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDocumentAnalysisTemplateQueryKey(options)
});

/**
 * Update Document Analysis Template
 *
 * Update a template by archiving and creating a new version.
 *
 * Personal: requires the per-resource `ResourcePermission` owner-action bundle on this template id.
 * Promoted: requires `update_document_analysis_template` on the
 * template's scope (project / project_type). The new version
 * inherits scope and creator.
 */
export const updateDocumentAnalysisTemplateMutation = (options?: Partial<Options<UpdateDocumentAnalysisTemplateData>>): UseMutationOptions<UpdateDocumentAnalysisTemplateResponse, UpdateDocumentAnalysisTemplateError, Options<UpdateDocumentAnalysisTemplateData>> => {
  const mutationOptions: UseMutationOptions<UpdateDocumentAnalysisTemplateResponse, UpdateDocumentAnalysisTemplateError, Options<UpdateDocumentAnalysisTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDocumentAnalysisTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getDocumentAnalysisTemplatesQueryKey = (options: Options<GetDocumentAnalysisTemplatesData>) => createQueryKey('getDocumentAnalysisTemplates', options);

/**
 * Get Document Analysis Templates
 *
 * List active (non-archived) templates the caller can see.
 *
 * `scope="all"` (default) -> caller's personal + every promoted template.
 * `scope="personal"` -> caller's personal templates only.
 * `scope="promoted"` -> templates promoted to a project / project_type.
 */
export const getDocumentAnalysisTemplatesOptions = (options: Options<GetDocumentAnalysisTemplatesData>) => queryOptions<GetDocumentAnalysisTemplatesResponse, GetDocumentAnalysisTemplatesError, GetDocumentAnalysisTemplatesResponse, ReturnType<typeof getDocumentAnalysisTemplatesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDocumentAnalysisTemplates({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDocumentAnalysisTemplatesQueryKey(options)
});

/**
 * Create Document Analysis Template
 *
 * Create a template at one of three scope tiers.
 *
 * Personal (`scope.type="personal"`): authored by the calling user;
 * visible and writable only to them via the per-resource
 * `ResourcePermission` owner-action bundle scoped to the new
 * template id. No project-level grant required.
 *
 * Project (`scope.type="project"`): requires
 * `("project.<project_id>", "create_document_analysis_template")`
 * on each project supplied, held by `project_editor` (and inherited
 * by `project_admin` / `org_admin` via the type-scope cascade). Every
 * id must also resolve inside the caller's organization; one that does
 * not fails the whole request, like one that does not exist.
 *
 * Project-type (`scope.type="project_type"`): library template
 * promoted to every project of the type. Requires
 * `("project_type.<type_uuid>", "create_document_analysis_template")`;
 * held by `project_admin` scoped to the type.
 */
export const createDocumentAnalysisTemplateMutation = (options?: Partial<Options<CreateDocumentAnalysisTemplateData>>): UseMutationOptions<CreateDocumentAnalysisTemplateResponse, CreateDocumentAnalysisTemplateError, Options<CreateDocumentAnalysisTemplateData>> => {
  const mutationOptions: UseMutationOptions<CreateDocumentAnalysisTemplateResponse, CreateDocumentAnalysisTemplateError, Options<CreateDocumentAnalysisTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDocumentAnalysisTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Duplicate Document Analysis Template
 *
 * Duplicate a template the caller can see.
 *
 * The duplicate is always personal (owned by the caller via a fresh
 * the per-resource `ResourcePermission` owner-action bundle grant). To turn a duplicate into a promoted
 * template, follow with the (future) promotion flow.
 */
export const duplicateDocumentAnalysisTemplateMutation = (options?: Partial<Options<DuplicateDocumentAnalysisTemplateData>>): UseMutationOptions<DuplicateDocumentAnalysisTemplateResponse, DuplicateDocumentAnalysisTemplateError, Options<DuplicateDocumentAnalysisTemplateData>> => {
  const mutationOptions: UseMutationOptions<DuplicateDocumentAnalysisTemplateResponse, DuplicateDocumentAnalysisTemplateError, Options<DuplicateDocumentAnalysisTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await duplicateDocumentAnalysisTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const compareDocumentsQueryKey = (options: Options<CompareDocumentsData>) => createQueryKey('compareDocuments', options);

/**
 * Compare Documents
 *
 * Compare two stored documents and return their structured differences.
 *
 * Requires ``read_datasource`` on both documents: organization membership alone
 * does not grant access to an arbitrary datasource by id.
 */
export const compareDocumentsOptions = (options: Options<CompareDocumentsData>) => queryOptions<CompareDocumentsResponse, CompareDocumentsError, CompareDocumentsResponse, ReturnType<typeof compareDocumentsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await compareDocuments({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: compareDocumentsQueryKey(options)
});

/**
 * Run Document Analysis Pipeline
 *
 * Run document analysis export pipeline.
 *
 * The decorator binds `document_analysis_annotate` to the exact project, the
 * project is resolved inside the caller's organization, and the exported
 * document arrives already tenant-scoped and read-authorized.
 */
export const runDocumentAnalysisPipelineMutation = (options?: Partial<Options<RunDocumentAnalysisPipelineData>>): UseMutationOptions<unknown, RunDocumentAnalysisPipelineError, Options<RunDocumentAnalysisPipelineData>> => {
  const mutationOptions: UseMutationOptions<unknown, RunDocumentAnalysisPipelineError, Options<RunDocumentAnalysisPipelineData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await runDocumentAnalysisPipeline({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getAnnualReportPipelineStatusQueryKey = (options: Options<GetAnnualReportPipelineStatusData>) => createQueryKey('getAnnualReportPipelineStatus', options);

/**
 * Get Annual Report Pipeline Status
 *
 * Get aggregated annual report pipeline status across templates. Returns null when no execution exists.
 */
export const getAnnualReportPipelineStatusOptions = (options: Options<GetAnnualReportPipelineStatusData>) => queryOptions<GetAnnualReportPipelineStatusResponse, GetAnnualReportPipelineStatusError, GetAnnualReportPipelineStatusResponse, ReturnType<typeof getAnnualReportPipelineStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAnnualReportPipelineStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAnnualReportPipelineStatusQueryKey(options)
});

/**
 * Create Workflow
 *
 * Create a task inside a task set.
 *
 * The caller must have `create_workflow` on the parent task set's
 * scope: the per-resource `ResourcePermission` owner-action bundle for personal task sets, project-scoped role
 * for project-promoted ones, project_type cascade otherwise.
 */
export const createWorkflowMutation = (options?: Partial<Options<CreateWorkflowData>>): UseMutationOptions<CreateWorkflowResponse, CreateWorkflowError, Options<CreateWorkflowData>> => {
  const mutationOptions: UseMutationOptions<CreateWorkflowResponse, CreateWorkflowError, Options<CreateWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Workflow
 *
 * Delete a task. Owner-only for personal parent task set; project-scoped gate for org-wide.
 */
export const deleteWorkflowMutation = (options?: Partial<Options<DeleteWorkflowData>>): UseMutationOptions<unknown, DeleteWorkflowError, Options<DeleteWorkflowData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteWorkflowError, Options<DeleteWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Workflow
 *
 * Update a task.
 *
 * The factory dependency authorizes against the *current* parent
 * task set. If `workflow_set_id` moves the task to a different parent,
 * that new parent is also checked here.
 */
export const updateWorkflowMutation = (options?: Partial<Options<UpdateWorkflowData>>): UseMutationOptions<UpdateWorkflowResponse, UpdateWorkflowError, Options<UpdateWorkflowData>> => {
  const mutationOptions: UseMutationOptions<UpdateWorkflowResponse, UpdateWorkflowError, Options<UpdateWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reorder Workflow
 *
 * Reorder a task relative to another task (before/after).
 *
 * Owner-only for personal parent task set; project-scoped gate for org-wide.
 * Uses float-based fractional indexing; rebalances on precision exhaustion.
 */
export const reorderWorkflowMutation = (options?: Partial<Options<ReorderWorkflowData>>): UseMutationOptions<ReorderWorkflowResponse, ReorderWorkflowError, Options<ReorderWorkflowData>> => {
  const mutationOptions: UseMutationOptions<ReorderWorkflowResponse, ReorderWorkflowError, Options<ReorderWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await reorderWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Set Workflow Excel Template
 *
 * Set the excel template for the latest task version.
 *
 * Approved -> forks a new draft with the template; draft -> updates in place.
 * Owner-only for personal parent task set.
 */
export const setWorkflowExcelTemplateMutation = (options?: Partial<Options<SetWorkflowExcelTemplateData>>): UseMutationOptions<SetWorkflowExcelTemplateResponse, SetWorkflowExcelTemplateError, Options<SetWorkflowExcelTemplateData>> => {
  const mutationOptions: UseMutationOptions<SetWorkflowExcelTemplateResponse, SetWorkflowExcelTemplateError, Options<SetWorkflowExcelTemplateData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setWorkflowExcelTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Set Workflow Client Tags
 *
 * Replace the client tags a task applies to. An empty list makes it global.
 *
 * A dedicated sub-resource so the task payload stays untouched, and
 * deliberately outside the approved-set freeze: which clients a task is
 * meant for is targeting, not reviewed content, so it mints no new version.
 * The caller picks from the vocabulary of each type the task set serves;
 * creating tags stays with whoever governs it.
 */
export const setWorkflowClientTagsMutation = (options?: Partial<Options<SetWorkflowClientTagsData>>): UseMutationOptions<SetWorkflowClientTagsResponse, SetWorkflowClientTagsError, Options<SetWorkflowClientTagsData>> => {
  const mutationOptions: UseMutationOptions<SetWorkflowClientTagsResponse, SetWorkflowClientTagsError, Options<SetWorkflowClientTagsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setWorkflowClientTags({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Place Workflow
 *
 * Move or reorder an item in the combined workflow tree atomically.
 */
export const placeWorkflowMutation = (options?: Partial<Options<PlaceWorkflowData>>): UseMutationOptions<unknown, PlaceWorkflowError, Options<PlaceWorkflowData>> => {
  const mutationOptions: UseMutationOptions<unknown, PlaceWorkflowError, Options<PlaceWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await placeWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Clone Workflow
 *
 * Copy a task in place, into new personal/domain containers, or both.
 *
 * Preserves actions, parameters, datasource links, client tags, content language
 * and the Excel template. Personal copies need source visibility; domain
 * copies need create rights on every target. All copies need direct read
 * access to attached datasources. Current-workflow copies require an editable
 * parent; copying to new sets does not modify the approved source.
 */
export const cloneWorkflowMutation = (options?: Partial<Options<CloneWorkflowData>>): UseMutationOptions<CloneWorkflowResponse, CloneWorkflowError, Options<CloneWorkflowData>> => {
  const mutationOptions: UseMutationOptions<CloneWorkflowResponse, CloneWorkflowError, Options<CloneWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await cloneWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getWorkflowSetsQueryKey = (options: Options<GetWorkflowSetsData>) => createQueryKey('getWorkflowSets', options);

/**
 * Get Workflow Sets
 */
export const getWorkflowSetsOptions = (options: Options<GetWorkflowSetsData>) => queryOptions<GetWorkflowSetsResponse, GetWorkflowSetsError, GetWorkflowSetsResponse, ReturnType<typeof getWorkflowSetsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getWorkflowSets({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWorkflowSetsQueryKey(options)
});

export const getWorkflowSetsInfiniteQueryKey = (options: Options<GetWorkflowSetsData>): QueryKey<Options<GetWorkflowSetsData>> => createQueryKey('getWorkflowSets', options, true);

/**
 * Get Workflow Sets
 */
export const getWorkflowSetsInfiniteOptions = (options: Options<GetWorkflowSetsData>) => {
  const opts = infiniteQueryOptions<GetWorkflowSetsResponse, GetWorkflowSetsError, InfiniteData<GetWorkflowSetsResponse>, QueryKey<Options<GetWorkflowSetsData>>, number | Pick<QueryKey<Options<GetWorkflowSetsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetWorkflowSetsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getWorkflowSets({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getWorkflowSetsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Workflow Set
 *
 * Create a task set at one of three scope tiers.
 *
 * Personal (`scope.type="personal"`): authored by the caller;
 * ownership held via the per-resource `ResourcePermission` owner-action
 * bundle scoped to the new task set id.
 *
 * Project (`scope.type="project"`): attached to one or more projects.
 * Requires `("project.<project_id>", "create_workflow")` on
 * every project supplied (held by `project_editor` and inherited by
 * `project_admin` / `org_admin` via the type-scope cascade). Container
 * nodes of a structural type (audit_client) are rejected; work lives on
 * the dossiers beneath them.
 * Every id must also resolve inside the caller's organization; one that
 * does not fails the whole request, like one that does not exist.
 *
 * Project-type (`scope.type="project_type"`): library task set
 * promoted to every project of the type. Structural types (audit_client)
 * are rejected; they group projects rather than hold work. Requires
 * `("project_type.<type_uuid>", "create_workflow")`; held by
 * `project_admin` scoped to the type and `org_admin` / `org_owner`
 * via YAML wildcards.
 */
export const createWorkflowSetMutation = (options?: Partial<Options<CreateWorkflowSetData>>): UseMutationOptions<CreateWorkflowSetResponse, CreateWorkflowSetError, Options<CreateWorkflowSetData>> => {
  const mutationOptions: UseMutationOptions<CreateWorkflowSetResponse, CreateWorkflowSetError, Options<CreateWorkflowSetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWorkflowSet({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Workflow Set
 *
 * Delete a task set. Owner-only for personal; project-scoped gate for org-wide.
 */
export const deleteWorkflowSetMutation = (options?: Partial<Options<DeleteWorkflowSetData>>): UseMutationOptions<unknown, DeleteWorkflowSetError, Options<DeleteWorkflowSetData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteWorkflowSetError, Options<DeleteWorkflowSetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteWorkflowSet({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Workflow Set
 *
 * Update a task set. Owner-only for personal; project-scoped gate for org-wide.
 */
export const updateWorkflowSetMutation = (options?: Partial<Options<UpdateWorkflowSetData>>): UseMutationOptions<UpdateWorkflowSetResponse, UpdateWorkflowSetError, Options<UpdateWorkflowSetData>> => {
  const mutationOptions: UseMutationOptions<UpdateWorkflowSetResponse, UpdateWorkflowSetError, Options<UpdateWorkflowSetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWorkflowSet({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reorder Workflow Set
 *
 * Reorder a task set relative to another task set (before/after).
 *
 * Owner-only for personal task sets;
 * `("project", "update_workflow")` for org-wide.
 */
export const reorderWorkflowSetMutation = (options?: Partial<Options<ReorderWorkflowSetData>>): UseMutationOptions<ReorderWorkflowSetResponse, ReorderWorkflowSetError, Options<ReorderWorkflowSetData>> => {
  const mutationOptions: UseMutationOptions<ReorderWorkflowSetResponse, ReorderWorkflowSetError, Options<ReorderWorkflowSetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await reorderWorkflowSet({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Place Workflow Set
 *
 * Move or reorder a set in the combined workflow tree atomically.
 */
export const placeWorkflowSetMutation = (options?: Partial<Options<PlaceWorkflowSetData>>): UseMutationOptions<unknown, PlaceWorkflowSetError, Options<PlaceWorkflowSetData>> => {
  const mutationOptions: UseMutationOptions<unknown, PlaceWorkflowSetError, Options<PlaceWorkflowSetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await placeWorkflowSet({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Clone Workflow Set
 *
 * Copy a hierarchy into Personal, domain proposals at the same audience, or both.
 *
 * Each domain copy has an independent approval request; personal copies are
 * owned by the caller without review. Latest task definitions are copied;
 * execution history and schedules are excluded. All modes require source
 * visibility and datasource read access. Domain copies also require create
 * rights on every target. Both destinations are created in one transaction.
 * The source remains unchanged.
 */
export const cloneWorkflowSetMutation = (options?: Partial<Options<CloneWorkflowSetData>>): UseMutationOptions<CloneWorkflowSetResponse, CloneWorkflowSetError, Options<CloneWorkflowSetData>> => {
  const mutationOptions: UseMutationOptions<CloneWorkflowSetResponse, CloneWorkflowSetError, Options<CloneWorkflowSetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await cloneWorkflowSet({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Submit For Approval
 */
export const submitForApprovalMutation = (options?: Partial<Options<SubmitForApprovalData>>): UseMutationOptions<SubmitForApprovalResponse, SubmitForApprovalError, Options<SubmitForApprovalData>> => {
  const mutationOptions: UseMutationOptions<SubmitForApprovalResponse, SubmitForApprovalError, Options<SubmitForApprovalData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitForApproval({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Approve
 */
export const approveMutation = (options?: Partial<Options<ApproveData>>): UseMutationOptions<ApproveResponse, ApproveError, Options<ApproveData>> => {
  const mutationOptions: UseMutationOptions<ApproveResponse, ApproveError, Options<ApproveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await approve({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reject
 */
export const rejectMutation = (options?: Partial<Options<RejectData>>): UseMutationOptions<RejectResponse, RejectError, Options<RejectData>> => {
  const mutationOptions: UseMutationOptions<RejectResponse, RejectError, Options<RejectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await reject({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Cancel
 */
export const cancelMutation = (options?: Partial<Options<CancelData>>): UseMutationOptions<CancelResponse, CancelError, Options<CancelData>> => {
  const mutationOptions: UseMutationOptions<CancelResponse, CancelError, Options<CancelData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancel({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Demote
 */
export const demoteMutation = (options?: Partial<Options<DemoteData>>): UseMutationOptions<DemoteResponse, DemoteError, Options<DemoteData>> => {
  const mutationOptions: UseMutationOptions<DemoteResponse, DemoteError, Options<DemoteData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await demote({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Unapprove
 */
export const unapproveMutation = (options?: Partial<Options<UnapproveData>>): UseMutationOptions<UnapproveResponse, UnapproveError, Options<UnapproveData>> => {
  const mutationOptions: UseMutationOptions<UnapproveResponse, UnapproveError, Options<UnapproveData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await unapprove({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * To Maintenance
 */
export const toMaintenanceMutation = (options?: Partial<Options<ToMaintenanceData>>): UseMutationOptions<ToMaintenanceResponse, ToMaintenanceError, Options<ToMaintenanceData>> => {
  const mutationOptions: UseMutationOptions<ToMaintenanceResponse, ToMaintenanceError, Options<ToMaintenanceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await toMaintenance({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Resume
 */
export const resumeMutation = (options?: Partial<Options<ResumeData>>): UseMutationOptions<ResumeResponse, ResumeError, Options<ResumeData>> => {
  const mutationOptions: UseMutationOptions<ResumeResponse, ResumeError, Options<ResumeData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await resume({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Submit Individual Workflow
 */
export const submitIndividualWorkflowMutation = (options?: Partial<Options<SubmitIndividualWorkflowData>>): UseMutationOptions<SubmitIndividualWorkflowResponse, SubmitIndividualWorkflowError, Options<SubmitIndividualWorkflowData>> => {
  const mutationOptions: UseMutationOptions<SubmitIndividualWorkflowResponse, SubmitIndividualWorkflowError, Options<SubmitIndividualWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitIndividualWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Approve Individual Workflow
 */
export const approveIndividualWorkflowMutation = (options?: Partial<Options<ApproveIndividualWorkflowData>>): UseMutationOptions<ApproveIndividualWorkflowResponse, ApproveIndividualWorkflowError, Options<ApproveIndividualWorkflowData>> => {
  const mutationOptions: UseMutationOptions<ApproveIndividualWorkflowResponse, ApproveIndividualWorkflowError, Options<ApproveIndividualWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await approveIndividualWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reset Individual Workflow Approval
 */
export const resetIndividualWorkflowApprovalMutation = (options?: Partial<Options<ResetIndividualWorkflowApprovalData>>): UseMutationOptions<ResetIndividualWorkflowApprovalResponse, ResetIndividualWorkflowApprovalError, Options<ResetIndividualWorkflowApprovalData>> => {
  const mutationOptions: UseMutationOptions<ResetIndividualWorkflowApprovalResponse, ResetIndividualWorkflowApprovalError, Options<ResetIndividualWorkflowApprovalData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetIndividualWorkflowApproval({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reject Individual Workflow
 */
export const rejectIndividualWorkflowMutation = (options?: Partial<Options<RejectIndividualWorkflowData>>): UseMutationOptions<RejectIndividualWorkflowResponse, RejectIndividualWorkflowError, Options<RejectIndividualWorkflowData>> => {
  const mutationOptions: UseMutationOptions<RejectIndividualWorkflowResponse, RejectIndividualWorkflowError, Options<RejectIndividualWorkflowData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await rejectIndividualWorkflow({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getWorkflowActionsQueryKey = (options: Options<GetWorkflowActionsData>) => createQueryKey('getWorkflowActions', options);

/**
 * Get Workflow Actions
 *
 * List actions for a task. Visibility is enforced by the path dependency.
 */
export const getWorkflowActionsOptions = (options: Options<GetWorkflowActionsData>) => queryOptions<GetWorkflowActionsResponse, GetWorkflowActionsError, GetWorkflowActionsResponse, ReturnType<typeof getWorkflowActionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getWorkflowActions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWorkflowActionsQueryKey(options)
});

/**
 * Create Workflow Action
 */
export const createWorkflowActionMutation = (options?: Partial<Options<CreateWorkflowActionData>>): UseMutationOptions<CreateWorkflowActionResponse, CreateWorkflowActionError, Options<CreateWorkflowActionData>> => {
  const mutationOptions: UseMutationOptions<CreateWorkflowActionResponse, CreateWorkflowActionError, Options<CreateWorkflowActionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWorkflowAction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Analyze Workflow Action Sql Parameters
 *
 * Report how unsaved SQL binds line up with an unsaved parameters schema.
 *
 * Side-effect free so the editor can call it while the user types; the
 * action update and execute routes enforce the same rule.
 */
export const analyzeWorkflowActionSqlParametersMutation = (options?: Partial<Options<AnalyzeWorkflowActionSqlParametersData>>): UseMutationOptions<AnalyzeWorkflowActionSqlParametersResponse, AnalyzeWorkflowActionSqlParametersError, Options<AnalyzeWorkflowActionSqlParametersData>> => {
  const mutationOptions: UseMutationOptions<AnalyzeWorkflowActionSqlParametersResponse, AnalyzeWorkflowActionSqlParametersError, Options<AnalyzeWorkflowActionSqlParametersData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await analyzeWorkflowActionSqlParameters({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Workflow Action
 */
export const deleteWorkflowActionMutation = (options?: Partial<Options<DeleteWorkflowActionData>>): UseMutationOptions<unknown, DeleteWorkflowActionError, Options<DeleteWorkflowActionData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteWorkflowActionError, Options<DeleteWorkflowActionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteWorkflowAction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getWorkflowActionQueryKey = (options: Options<GetWorkflowActionData>) => createQueryKey('getWorkflowAction', options);

/**
 * Get Workflow Action
 */
export const getWorkflowActionOptions = (options: Options<GetWorkflowActionData>) => queryOptions<GetWorkflowActionResponse, GetWorkflowActionError, GetWorkflowActionResponse, ReturnType<typeof getWorkflowActionQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getWorkflowAction({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getWorkflowActionQueryKey(options)
});

/**
 * Update Workflow Action
 */
export const updateWorkflowActionMutation = (options?: Partial<Options<UpdateWorkflowActionData>>): UseMutationOptions<UpdateWorkflowActionResponse, UpdateWorkflowActionError, Options<UpdateWorkflowActionData>> => {
  const mutationOptions: UseMutationOptions<UpdateWorkflowActionResponse, UpdateWorkflowActionError, Options<UpdateWorkflowActionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateWorkflowAction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Generate Action Technical Explanation
 *
 * Generate a technical explanation for an audit action using AI.
 *
 * Analyzes the action's workflow and SQL queries to generate a line-by-line
 * explanation suitable for documentation purposes.
 *
 * Returns:
 *     WorkflowAction: The action with updated technical_explanation field.
 */
export const generateActionTechnicalExplanationMutation = (options?: Partial<Options<GenerateActionTechnicalExplanationData>>): UseMutationOptions<GenerateActionTechnicalExplanationResponse, GenerateActionTechnicalExplanationError, Options<GenerateActionTechnicalExplanationData>> => {
  const mutationOptions: UseMutationOptions<GenerateActionTechnicalExplanationResponse, GenerateActionTechnicalExplanationError, Options<GenerateActionTechnicalExplanationData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateActionTechnicalExplanation({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reorder Workflow Action
 *
 * Reorder an action relative to another action (before/after).
 *
 * Owner-only for personal parent task set; project-scoped gate for
 * org-wide. Uses float-based fractional indexing.
 */
export const reorderWorkflowActionMutation = (options?: Partial<Options<ReorderWorkflowActionData>>): UseMutationOptions<ReorderWorkflowActionResponse, ReorderWorkflowActionError, Options<ReorderWorkflowActionData>> => {
  const mutationOptions: UseMutationOptions<ReorderWorkflowActionResponse, ReorderWorkflowActionError, Options<ReorderWorkflowActionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await reorderWorkflowAction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Clone Workflow Action
 *
 * Clone an action into a different task.
 *
 * The source task is authorized via the path dependency; the target
 * task (resolved from the request body) is authorized inline. Both
 * must be writable by the caller; owner for personal task sets,
 * `project:update_workflow` for org-wide.
 */
export const cloneWorkflowActionMutation = (options?: Partial<Options<CloneWorkflowActionData>>): UseMutationOptions<CloneWorkflowActionResponse, CloneWorkflowActionError, Options<CloneWorkflowActionData>> => {
  const mutationOptions: UseMutationOptions<CloneWorkflowActionResponse, CloneWorkflowActionError, Options<CloneWorkflowActionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await cloneWorkflowAction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Move Workflow Action
 *
 * Move an action into a different task.
 *
 * Source task is authorized via the path dependency; target task is
 * authorized inline. Both task sets must be writable by the caller.
 */
export const moveWorkflowActionMutation = (options?: Partial<Options<MoveWorkflowActionData>>): UseMutationOptions<MoveWorkflowActionResponse, MoveWorkflowActionError, Options<MoveWorkflowActionData>> => {
  const mutationOptions: UseMutationOptions<MoveWorkflowActionResponse, MoveWorkflowActionError, Options<MoveWorkflowActionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await moveWorkflowAction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Copy Workflow Action
 *
 * Copy a leaf action into explicitly selected existing workflows, atomically.
 *
 * Targets may include the current workflow or workflows in Personal and any
 * domain in the same organization. Every destination must be visible,
 * writable and editable. Attached datasources require direct read access;
 * parameter schemas must be compatible with each destination. No parent
 * workflow sets or workflows are created.
 */
export const copyWorkflowActionMutation = (options?: Partial<Options<CopyWorkflowActionData>>): UseMutationOptions<CopyWorkflowActionResponse, CopyWorkflowActionError, Options<CopyWorkflowActionData>> => {
  const mutationOptions: UseMutationOptions<CopyWorkflowActionResponse, CopyWorkflowActionError, Options<CopyWorkflowActionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await copyWorkflowAction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getProjectExecutionHistoryQueryKey = (options: Options<GetProjectExecutionHistoryData>) => createQueryKey('getProjectExecutionHistory', options);

/**
 * Get Project Execution History
 *
 * Every workflow run performed in this project, newest first.
 *
 * Independent of the workflow catalogue by design: runs whose
 * workflow was edited, deleted or demoted are returned exactly like
 * any other, carrying the name, version and action list they had when
 * they ran. That is what makes this the dossier's audit trail rather
 * than a decoration on the task tree.
 */
export const getProjectExecutionHistoryOptions = (options: Options<GetProjectExecutionHistoryData>) => queryOptions<GetProjectExecutionHistoryResponse, GetProjectExecutionHistoryError, GetProjectExecutionHistoryResponse, ReturnType<typeof getProjectExecutionHistoryQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getProjectExecutionHistory({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getProjectExecutionHistoryQueryKey(options)
});

export const getExecutionResultsQueryKey = (options: Options<GetExecutionResultsData>) => createQueryKey('getExecutionResults', options);

/**
 * Get Execution Results
 *
 * Read one past run's stored output, addressed by the run itself.
 *
 * The caller supplies only the execution id: which actions ran, and
 * which threads hold their output, come from the record rather than
 * from the workflow's current definition. That is what makes an edited
 * or deleted workflow's history still readable.
 */
export const getExecutionResultsOptions = (options: Options<GetExecutionResultsData>) => queryOptions<GetExecutionResultsResponse, GetExecutionResultsError, GetExecutionResultsResponse, ReturnType<typeof getExecutionResultsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getExecutionResults({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getExecutionResultsQueryKey(options)
});

/**
 * Create Chat From Execution
 *
 * Continue a past action's transcript as a chat.
 *
 * Addressed by the run and the thread it wrote, never by the workflow,
 * so a run whose workflow or actions were deleted is still openable.
 * The thread must belong to this run, which is what stops the parameter
 * being a way to read arbitrary conversations.
 */
export const createChatFromExecutionMutation = (options?: Partial<Options<CreateChatFromExecutionData>>): UseMutationOptions<CreateChatFromExecutionResponse, CreateChatFromExecutionError, Options<CreateChatFromExecutionData>> => {
  const mutationOptions: UseMutationOptions<CreateChatFromExecutionResponse, CreateChatFromExecutionError, Options<CreateChatFromExecutionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createChatFromExecution({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listSchedulesQueryKey = (options: Options<ListSchedulesData>) => createQueryKey('listSchedules', options);

/**
 * List Schedules
 *
 * List the schedules in the caller's organization the caller may read.
 */
export const listSchedulesOptions = (options: Options<ListSchedulesData>) => queryOptions<ListSchedulesResponse, ListSchedulesError, ListSchedulesResponse, ReturnType<typeof listSchedulesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listSchedules({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listSchedulesQueryKey(options)
});

export const listSchedulesInfiniteQueryKey = (options: Options<ListSchedulesData>): QueryKey<Options<ListSchedulesData>> => createQueryKey('listSchedules', options, true);

/**
 * List Schedules
 *
 * List the schedules in the caller's organization the caller may read.
 */
export const listSchedulesInfiniteOptions = (options: Options<ListSchedulesData>) => {
  const opts = infiniteQueryOptions<ListSchedulesResponse, ListSchedulesError, InfiniteData<ListSchedulesResponse>, QueryKey<Options<ListSchedulesData>>, number | Pick<QueryKey<Options<ListSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<ListSchedulesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await listSchedules({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listSchedulesInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Schedule
 *
 * Create a new workflow schedule owned by the caller.
 *
 * Authorization mirrors `/task/{workflow_id}/execute`: a schedule is just
 * "future execution under these conditions", so the caller must already
 * be allowed to execute the task immediately. Cross-org / unreachable
 * tasks 404; visible-but-unauthorized 403.
 */
export const createScheduleMutation = (options?: Partial<Options<CreateScheduleData>>): UseMutationOptions<CreateScheduleResponse, CreateScheduleError, Options<CreateScheduleData>> => {
  const mutationOptions: UseMutationOptions<CreateScheduleResponse, CreateScheduleError, Options<CreateScheduleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSchedule({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Schedule
 *
 * Delete a schedule. Queued runs for this schedule are cancelled first.
 */
export const deleteScheduleMutation = (options?: Partial<Options<DeleteScheduleData>>): UseMutationOptions<DeleteScheduleResponse, DeleteScheduleError, Options<DeleteScheduleData>> => {
  const mutationOptions: UseMutationOptions<DeleteScheduleResponse, DeleteScheduleError, Options<DeleteScheduleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteSchedule({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getScheduleQueryKey = (options: Options<GetScheduleData>) => createQueryKey('getSchedule', options);

/**
 * Get Schedule
 *
 * Fetch one schedule by id (403 unless the caller may run its parent).
 */
export const getScheduleOptions = (options: Options<GetScheduleData>) => queryOptions<GetScheduleResponse, GetScheduleError, GetScheduleResponse, ReturnType<typeof getScheduleQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSchedule({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getScheduleQueryKey(options)
});

/**
 * Update Schedule
 *
 * Patch a schedule. Only the fields you pass are touched.
 */
export const updateScheduleMutation = (options?: Partial<Options<UpdateScheduleData>>): UseMutationOptions<UpdateScheduleResponse, UpdateScheduleError, Options<UpdateScheduleData>> => {
  const mutationOptions: UseMutationOptions<UpdateScheduleResponse, UpdateScheduleError, Options<UpdateScheduleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateSchedule({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listRunsQueryKey = (options: Options<ListRunsData>) => createQueryKey('listRuns', options);

/**
 * List Runs
 *
 * Run history for one schedule.
 */
export const listRunsOptions = (options: Options<ListRunsData>) => queryOptions<ListRunsResponse, ListRunsError, ListRunsResponse, ReturnType<typeof listRunsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listRuns({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listRunsQueryKey(options)
});

export const listRunsInfiniteQueryKey = (options: Options<ListRunsData>): QueryKey<Options<ListRunsData>> => createQueryKey('listRuns', options, true);

/**
 * List Runs
 *
 * Run history for one schedule.
 */
export const listRunsInfiniteOptions = (options: Options<ListRunsData>) => {
  const opts = infiniteQueryOptions<ListRunsResponse, ListRunsError, InfiniteData<ListRunsResponse>, QueryKey<Options<ListRunsData>>, number | Pick<QueryKey<Options<ListRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<ListRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await listRuns({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listRunsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Trigger Manual Run
 *
 * Queue an ad-hoc run of the schedule's workflow under the caller's identity.
 *
 * Auth mirrors `create_schedule`; the caller must be allowed to execute
 * the underlying task under the schedule's scope, not merely belong to
 * the schedule's org. Without this check any org member could trigger a
 * same-org schedule for a personal/project-scoped task they otherwise
 * couldn't execute.
 */
export const triggerManualRunMutation = (options?: Partial<Options<TriggerManualRunData>>): UseMutationOptions<TriggerManualRunResponse, TriggerManualRunError, Options<TriggerManualRunData>> => {
  const mutationOptions: UseMutationOptions<TriggerManualRunResponse, TriggerManualRunError, Options<TriggerManualRunData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerManualRun({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listOrgRunsQueryKey = (options: Options<ListOrgRunsData>) => createQueryKey('listOrgRuns', options);

/**
 * List Org Runs
 *
 * Org-wide run history, newest scheduled_fire_at first.
 *
 * Backs the Workflow results tab. Scoped to the caller's organization;
 * finer scope-aware filtering is not yet implemented.
 */
export const listOrgRunsOptions = (options: Options<ListOrgRunsData>) => queryOptions<ListOrgRunsResponse, ListOrgRunsError, ListOrgRunsResponse, ReturnType<typeof listOrgRunsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listOrgRuns({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listOrgRunsQueryKey(options)
});

export const listOrgRunsInfiniteQueryKey = (options: Options<ListOrgRunsData>): QueryKey<Options<ListOrgRunsData>> => createQueryKey('listOrgRuns', options, true);

/**
 * List Org Runs
 *
 * Org-wide run history, newest scheduled_fire_at first.
 *
 * Backs the Workflow results tab. Scoped to the caller's organization;
 * finer scope-aware filtering is not yet implemented.
 */
export const listOrgRunsInfiniteOptions = (options: Options<ListOrgRunsData>) => {
  const opts = infiniteQueryOptions<ListOrgRunsResponse, ListOrgRunsError, InfiniteData<ListOrgRunsResponse>, QueryKey<Options<ListOrgRunsData>>, number | Pick<QueryKey<Options<ListOrgRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<ListOrgRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await listOrgRuns({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listOrgRunsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getRunQueryKey = (options: Options<GetRunData>) => createQueryKey('getRun', options);

/**
 * Get Run
 *
 * Fetch one run by id (403 unless the caller may run its parent).
 */
export const getRunOptions = (options: Options<GetRunData>) => queryOptions<GetRunResponse, GetRunError, GetRunResponse, ReturnType<typeof getRunQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getRun({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getRunQueryKey(options)
});

/**
 * Cancel Run
 *
 * Cancel a queued run.
 *
 * Returns 409 for `running` runs; v1 has no cooperative cancellation
 * path into the executor, so flipping a running row to `cancelled`
 * used to be cosmetic (side effects continued). No-op on terminal
 * states (`succeeded`, `failed`, `cancelled`).
 */
export const cancelRunMutation = (options?: Partial<Options<CancelRunData>>): UseMutationOptions<CancelRunResponse, CancelRunError, Options<CancelRunData>> => {
  const mutationOptions: UseMutationOptions<CancelRunResponse, CancelRunError, Options<CancelRunData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelRun({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listNotificationsQueryKey = (options: Options<ListNotificationsData>) => createQueryKey('listNotifications', options);

/**
 * List Notifications
 *
 * The current user's notifications in this org, newest first.
 */
export const listNotificationsOptions = (options: Options<ListNotificationsData>) => queryOptions<ListNotificationsResponse, ListNotificationsError, ListNotificationsResponse, ReturnType<typeof listNotificationsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listNotifications({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listNotificationsQueryKey(options)
});

export const listNotificationsInfiniteQueryKey = (options: Options<ListNotificationsData>): QueryKey<Options<ListNotificationsData>> => createQueryKey('listNotifications', options, true);

/**
 * List Notifications
 *
 * The current user's notifications in this org, newest first.
 */
export const listNotificationsInfiniteOptions = (options: Options<ListNotificationsData>) => {
  const opts = infiniteQueryOptions<ListNotificationsResponse, ListNotificationsError, InfiniteData<ListNotificationsResponse>, QueryKey<Options<ListNotificationsData>>, number | Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await listNotifications({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listNotificationsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const unreadCountQueryKey = (options: Options<UnreadCountData>) => createQueryKey('unreadCount', options);

/**
 * Unread Count
 *
 * Cheap badge poll; unread count only.
 */
export const unreadCountOptions = (options: Options<UnreadCountData>) => queryOptions<UnreadCountResponse2, UnreadCountError, UnreadCountResponse2, ReturnType<typeof unreadCountQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await unreadCount({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: unreadCountQueryKey(options)
});

/**
 * Mark Read
 *
 * Mark one notification read (404 if it isn't the caller's).
 */
export const markReadMutation = (options?: Partial<Options<MarkReadData>>): UseMutationOptions<MarkReadResponse, MarkReadError, Options<MarkReadData>> => {
  const mutationOptions: UseMutationOptions<MarkReadResponse, MarkReadError, Options<MarkReadData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await markRead({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Mark All Read
 *
 * Mark all the caller's unread notifications read.
 */
export const markAllReadMutation = (options?: Partial<Options<MarkAllReadData>>): UseMutationOptions<MarkAllReadResponse2, MarkAllReadError, Options<MarkAllReadData>> => {
  const mutationOptions: UseMutationOptions<MarkAllReadResponse2, MarkAllReadError, Options<MarkAllReadData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await markAllRead({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getExecutionReportQueryKey = (options: Options<GetExecutionReportData>) => createQueryKey('getExecutionReport', options);

/**
 * Get Execution Report
 *
 * Download the workbook for a past run, addressed by the run itself.
 *
 * Every label in the workbook (task name, action names and
 * descriptions) is read from the record, so deleting or editing the
 * workflow afterwards cannot change or empty a report that has
 * already been filed.
 */
export const getExecutionReportOptions = (options: Options<GetExecutionReportData>) => queryOptions<unknown, GetExecutionReportError, unknown, ReturnType<typeof getExecutionReportQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getExecutionReport({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getExecutionReportQueryKey(options)
});

export const listProjectTypesQueryKey = (options: Options<ListProjectTypesData>) => createQueryKey('listProjectTypes', options);

/**
 * List Project Types
 *
 * Public registry of project types; used to render dynamic create forms.
 */
export const listProjectTypesOptions = (options: Options<ListProjectTypesData>) => queryOptions<ListProjectTypesResponse, ListProjectTypesError, ListProjectTypesResponse, ReturnType<typeof listProjectTypesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listProjectTypes({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listProjectTypesQueryKey(options)
});

export const listClientTagsQueryKey = (options: Options<ListClientTagsData>) => createQueryKey('listClientTags', options);

/**
 * List Client Tags
 *
 * The organization's tag vocabularies, or only the one serving `project_type`.
 */
export const listClientTagsOptions = (options: Options<ListClientTagsData>) => queryOptions<ListClientTagsResponse, ListClientTagsError, ListClientTagsResponse, ReturnType<typeof listClientTagsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listClientTags({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listClientTagsQueryKey(options)
});

/**
 * Create Client Tag
 *
 * Create a tag, or return the existing one with that name in the same vocabulary.
 *
 * Idempotent on the trimmed, case-insensitive name, so a combobox that
 * creates before it attaches never has to distinguish the two cases.
 */
export const createClientTagMutation = (options?: Partial<Options<CreateClientTagData>>): UseMutationOptions<CreateClientTagResponse, CreateClientTagError, Options<CreateClientTagData>> => {
  const mutationOptions: UseMutationOptions<CreateClientTagResponse, CreateClientTagError, Options<CreateClientTagData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClientTag({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Client Tag
 *
 * Delete a tag that nothing references.
 */
export const deleteClientTagMutation = (options?: Partial<Options<DeleteClientTagData>>): UseMutationOptions<unknown, DeleteClientTagError, Options<DeleteClientTagData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteClientTagError, Options<DeleteClientTagData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteClientTag({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Rename Client Tag
 *
 * Rename a tag. A name another tag of its type already holds is a conflict, not a merge.
 */
export const renameClientTagMutation = (options?: Partial<Options<RenameClientTagData>>): UseMutationOptions<RenameClientTagResponse, RenameClientTagError, Options<RenameClientTagData>> => {
  const mutationOptions: UseMutationOptions<RenameClientTagResponse, RenameClientTagError, Options<RenameClientTagData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await renameClientTag({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Disconnect Project Vectorized Datasource
 *
 * Disconnect a project vectorized datasource, soft-deleting it when no projects remain.
 *
 * Unlinking from the project is a project-management action gated by
 * `delete_project_datasource`. The org-wide soft-delete that follows once the
 * last link is gone is destructive to the datasource itself, so it also
 * requires `delete_datasource` on the datasource. Without it the link is
 * removed but the datasource is left intact for its owner.
 */
export const disconnectProjectVectorizedDatasourceMutation = (options?: Partial<Options<DisconnectProjectVectorizedDatasourceData>>): UseMutationOptions<unknown, DisconnectProjectVectorizedDatasourceError, Options<DisconnectProjectVectorizedDatasourceData>> => {
  const mutationOptions: UseMutationOptions<unknown, DisconnectProjectVectorizedDatasourceError, Options<DisconnectProjectVectorizedDatasourceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await disconnectProjectVectorizedDatasource({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listProjectVectorizedDatasourcesQueryKey = (options: Options<ListProjectVectorizedDatasourcesData>) => createQueryKey('listProjectVectorizedDatasources', options);

/**
 * List Project Vectorized Datasources
 *
 * List vectorized datasources attached to a project.
 */
export const listProjectVectorizedDatasourcesOptions = (options: Options<ListProjectVectorizedDatasourcesData>) => queryOptions<ListProjectVectorizedDatasourcesResponse, ListProjectVectorizedDatasourcesError, ListProjectVectorizedDatasourcesResponse, ReturnType<typeof listProjectVectorizedDatasourcesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listProjectVectorizedDatasources({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listProjectVectorizedDatasourcesQueryKey(options)
});

/**
 * Upsert Project File Datasource
 *
 * Create or update a vectorized datasource for a project.
 *
 * Linking is a share-DOWN: the caller must already hold `read_datasource`
 * on the target datasource. `update_project_datasource` on the project is
 * not enough; otherwise a project member could pull a datasource they were
 * never granted into the project and read it via workflow execution.
 */
export const upsertProjectFileDatasourceMutation = (options?: Partial<Options<UpsertProjectFileDatasourceData>>): UseMutationOptions<UpsertProjectFileDatasourceResponse, UpsertProjectFileDatasourceError, Options<UpsertProjectFileDatasourceData>> => {
  const mutationOptions: UseMutationOptions<UpsertProjectFileDatasourceResponse, UpsertProjectFileDatasourceError, Options<UpsertProjectFileDatasourceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertProjectFileDatasource({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getFinancialExplorerQueryKey = (options: Options<GetFinancialExplorerData>) => createQueryKey('getFinancialExplorer', options);

/**
 * Get Financial Explorer
 *
 * Return financial explorer rows for the selected project scope and display period.
 */
export const getFinancialExplorerOptions = (options: Options<GetFinancialExplorerData>) => queryOptions<GetFinancialExplorerResponse, GetFinancialExplorerError, GetFinancialExplorerResponse, ReturnType<typeof getFinancialExplorerQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getFinancialExplorer({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getFinancialExplorerQueryKey(options)
});

export const getFinancialExplorerInfiniteQueryKey = (options: Options<GetFinancialExplorerData>): QueryKey<Options<GetFinancialExplorerData>> => createQueryKey('getFinancialExplorer', options, true);

/**
 * Get Financial Explorer
 *
 * Return financial explorer rows for the selected project scope and display period.
 */
export const getFinancialExplorerInfiniteOptions = (options: Options<GetFinancialExplorerData>) => {
  const opts = infiniteQueryOptions<GetFinancialExplorerResponse, GetFinancialExplorerError, InfiniteData<GetFinancialExplorerResponse>, QueryKey<Options<GetFinancialExplorerData>>, number | Pick<QueryKey<Options<GetFinancialExplorerData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetFinancialExplorerData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getFinancialExplorer({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getFinancialExplorerInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getFinancialExplorerReconciliationQueryKey = (options: Options<GetFinancialExplorerReconciliationData>) => createQueryKey('getFinancialExplorerReconciliation', options);

/**
 * Get Financial Explorer Reconciliation
 *
 * Return Audit balance evidence with the latest saved local classification.
 */
export const getFinancialExplorerReconciliationOptions = (options: Options<GetFinancialExplorerReconciliationData>) => queryOptions<GetFinancialExplorerReconciliationResponse, GetFinancialExplorerReconciliationError, GetFinancialExplorerReconciliationResponse, ReturnType<typeof getFinancialExplorerReconciliationQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getFinancialExplorerReconciliation({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getFinancialExplorerReconciliationQueryKey(options)
});

export const getFinancialExplorerReconciliationInfiniteQueryKey = (options: Options<GetFinancialExplorerReconciliationData>): QueryKey<Options<GetFinancialExplorerReconciliationData>> => createQueryKey('getFinancialExplorerReconciliation', options, true);

/**
 * Get Financial Explorer Reconciliation
 *
 * Return Audit balance evidence with the latest saved local classification.
 */
export const getFinancialExplorerReconciliationInfiniteOptions = (options: Options<GetFinancialExplorerReconciliationData>) => {
  const opts = infiniteQueryOptions<GetFinancialExplorerReconciliationResponse, GetFinancialExplorerReconciliationError, InfiniteData<GetFinancialExplorerReconciliationResponse>, QueryKey<Options<GetFinancialExplorerReconciliationData>>, number | Pick<QueryKey<Options<GetFinancialExplorerReconciliationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetFinancialExplorerReconciliationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getFinancialExplorerReconciliation({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getFinancialExplorerReconciliationInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getFinancialExplorerTransactionsQueryKey = (options: Options<GetFinancialExplorerTransactionsData>) => createQueryKey('getFinancialExplorerTransactions', options);

/**
 * Get Financial Explorer Transactions
 *
 * Return paged transactions and period totals for one booking year, both under the filters.
 */
export const getFinancialExplorerTransactionsOptions = (options: Options<GetFinancialExplorerTransactionsData>) => queryOptions<GetFinancialExplorerTransactionsResponse, GetFinancialExplorerTransactionsError, GetFinancialExplorerTransactionsResponse, ReturnType<typeof getFinancialExplorerTransactionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getFinancialExplorerTransactions({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getFinancialExplorerTransactionsQueryKey(options)
});

export const getFinancialExplorerTransactionsInfiniteQueryKey = (options: Options<GetFinancialExplorerTransactionsData>): QueryKey<Options<GetFinancialExplorerTransactionsData>> => createQueryKey('getFinancialExplorerTransactions', options, true);

/**
 * Get Financial Explorer Transactions
 *
 * Return paged transactions and period totals for one booking year, both under the filters.
 */
export const getFinancialExplorerTransactionsInfiniteOptions = (options: Options<GetFinancialExplorerTransactionsData>) => {
  const opts = infiniteQueryOptions<GetFinancialExplorerTransactionsResponse, GetFinancialExplorerTransactionsError, InfiniteData<GetFinancialExplorerTransactionsResponse>, QueryKey<Options<GetFinancialExplorerTransactionsData>>, number | Pick<QueryKey<Options<GetFinancialExplorerTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetFinancialExplorerTransactionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getFinancialExplorerTransactions({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getFinancialExplorerTransactionsInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getFinancialExplorerTransactionFilterValuesQueryKey = (options: Options<GetFinancialExplorerTransactionFilterValuesData>) => createQueryKey('getFinancialExplorerTransactionFilterValues', options);

/**
 * Get Financial Explorer Transaction Filter Values
 *
 * Return one page of a column's distinct values under every filter except the column's own.
 */
export const getFinancialExplorerTransactionFilterValuesOptions = (options: Options<GetFinancialExplorerTransactionFilterValuesData>) => queryOptions<GetFinancialExplorerTransactionFilterValuesResponse, GetFinancialExplorerTransactionFilterValuesError, GetFinancialExplorerTransactionFilterValuesResponse, ReturnType<typeof getFinancialExplorerTransactionFilterValuesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getFinancialExplorerTransactionFilterValues({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getFinancialExplorerTransactionFilterValuesQueryKey(options)
});

export const getFinancialExplorerTransactionFilterValuesInfiniteQueryKey = (options: Options<GetFinancialExplorerTransactionFilterValuesData>): QueryKey<Options<GetFinancialExplorerTransactionFilterValuesData>> => createQueryKey('getFinancialExplorerTransactionFilterValues', options, true);

/**
 * Get Financial Explorer Transaction Filter Values
 *
 * Return one page of a column's distinct values under every filter except the column's own.
 */
export const getFinancialExplorerTransactionFilterValuesInfiniteOptions = (options: Options<GetFinancialExplorerTransactionFilterValuesData>) => {
  const opts = infiniteQueryOptions<GetFinancialExplorerTransactionFilterValuesResponse, GetFinancialExplorerTransactionFilterValuesError, InfiniteData<GetFinancialExplorerTransactionFilterValuesResponse>, QueryKey<Options<GetFinancialExplorerTransactionFilterValuesData>>, number | Pick<QueryKey<Options<GetFinancialExplorerTransactionFilterValuesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetFinancialExplorerTransactionFilterValuesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          page: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getFinancialExplorerTransactionFilterValues({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getFinancialExplorerTransactionFilterValuesInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Financial Explorer Chat
 *
 * Open a chat about the Financial Explorer with the whole explorer, and optionally one account's transactions.
 *
 * Nothing is attached: the explorer's tables are mostly not registered
 * datasources, so its rows travel with the chat, and anything further is left
 * to datasource discovery.
 */
export const createFinancialExplorerChatMutation = (options?: Partial<Options<CreateFinancialExplorerChatData>>): UseMutationOptions<CreateFinancialExplorerChatResponse, CreateFinancialExplorerChatError, Options<CreateFinancialExplorerChatData>> => {
  const mutationOptions: UseMutationOptions<CreateFinancialExplorerChatResponse, CreateFinancialExplorerChatError, Options<CreateFinancialExplorerChatData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createFinancialExplorerChat({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Clear Account Mappings
 *
 * Remove every AI and manual mapping of the project.
 */
export const clearAccountMappingsMutation = (options?: Partial<Options<ClearAccountMappingsData>>): UseMutationOptions<ClearAccountMappingsResponse, ClearAccountMappingsError, Options<ClearAccountMappingsData>> => {
  const mutationOptions: UseMutationOptions<ClearAccountMappingsResponse, ClearAccountMappingsError, Options<ClearAccountMappingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearAccountMappings({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listAccountMappingsQueryKey = (options: Options<ListAccountMappingsData>) => createQueryKey('listAccountMappings', options);

/**
 * List Account Mappings
 *
 * Return the project mapping targets and per-year accounts, or null when none exist.
 */
export const listAccountMappingsOptions = (options: Options<ListAccountMappingsData>) => queryOptions<ListAccountMappingsResponse, ListAccountMappingsError, ListAccountMappingsResponse, ReturnType<typeof listAccountMappingsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listAccountMappings({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listAccountMappingsQueryKey(options)
});

/**
 * Save Account Mappings
 *
 * Persist complete manual mapping selections for the project.
 */
export const saveAccountMappingsMutation = (options?: Partial<Options<SaveAccountMappingsData>>): UseMutationOptions<SaveAccountMappingsResponse, SaveAccountMappingsError, Options<SaveAccountMappingsData>> => {
  const mutationOptions: UseMutationOptions<SaveAccountMappingsResponse, SaveAccountMappingsError, Options<SaveAccountMappingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveAccountMappings({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Classify Account Mappings
 *
 * Classify and persist the project AI account-mapping overlay.
 */
export const classifyAccountMappingsMutation = (options?: Partial<Options<ClassifyAccountMappingsData>>): UseMutationOptions<ClassifyAccountMappingsResponse, ClassifyAccountMappingsError, Options<ClassifyAccountMappingsData>> => {
  const mutationOptions: UseMutationOptions<ClassifyAccountMappingsResponse, ClassifyAccountMappingsError, Options<ClassifyAccountMappingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await classifyAccountMappings({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Classify Scoped Account Mappings
 *
 * Reclassify selected ledger-account codes across the project.
 */
export const classifyScopedAccountMappingsMutation = (options?: Partial<Options<ClassifyScopedAccountMappingsData>>): UseMutationOptions<ClassifyScopedAccountMappingsResponse, ClassifyScopedAccountMappingsError, Options<ClassifyScopedAccountMappingsData>> => {
  const mutationOptions: UseMutationOptions<ClassifyScopedAccountMappingsResponse, ClassifyScopedAccountMappingsError, Options<ClassifyScopedAccountMappingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await classifyScopedAccountMappings({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Add Account Mapping Level 3 Target
 *
 * Add a Level-3 target beneath a current confirmed statement path.
 */
export const addAccountMappingLevel3TargetMutation = (options?: Partial<Options<AddAccountMappingLevel3TargetData>>): UseMutationOptions<AddAccountMappingLevel3TargetResponse, AddAccountMappingLevel3TargetError, Options<AddAccountMappingLevel3TargetData>> => {
  const mutationOptions: UseMutationOptions<AddAccountMappingLevel3TargetResponse, AddAccountMappingLevel3TargetError, Options<AddAccountMappingLevel3TargetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addAccountMappingLevel3Target({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Copy Account Mappings
 *
 * Copy a readable sibling entity's mappings into the target project.
 */
export const copyAccountMappingsMutation = (options?: Partial<Options<CopyAccountMappingsData>>): UseMutationOptions<CopyAccountMappingsResponse, CopyAccountMappingsError, Options<CopyAccountMappingsData>> => {
  const mutationOptions: UseMutationOptions<CopyAccountMappingsResponse, CopyAccountMappingsError, Options<CopyAccountMappingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await copyAccountMappings({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Export Account Mappings
 *
 * Export the selected project-year account-mapping snapshot to Fabric.
 */
export const exportAccountMappingsMutation = (options?: Partial<Options<ExportAccountMappingsData>>): UseMutationOptions<ExportAccountMappingsResponse, ExportAccountMappingsError, Options<ExportAccountMappingsData>> => {
  const mutationOptions: UseMutationOptions<ExportAccountMappingsResponse, ExportAccountMappingsError, Options<ExportAccountMappingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await exportAccountMappings({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getAccountMappingExportStatusQueryKey = (options: Options<GetAccountMappingExportStatusData>) => createQueryKey('getAccountMappingExportStatus', options);

/**
 * Get Account Mapping Export Status
 *
 * Return the latest Corporate Finance classification export status.
 */
export const getAccountMappingExportStatusOptions = (options: Options<GetAccountMappingExportStatusData>) => queryOptions<GetAccountMappingExportStatusResponse, GetAccountMappingExportStatusError, GetAccountMappingExportStatusResponse, ReturnType<typeof getAccountMappingExportStatusQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAccountMappingExportStatus({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAccountMappingExportStatusQueryKey(options)
});

export const readProjectStatementTaxonomyQueryKey = (options: Options<ReadProjectStatementTaxonomyData>) => createQueryKey('readProjectStatementTaxonomy', options);

/**
 * Read Project Statement Taxonomy
 *
 * Return the taxonomy this project's extraction runs are built from.
 */
export const readProjectStatementTaxonomyOptions = (options: Options<ReadProjectStatementTaxonomyData>) => queryOptions<ReadProjectStatementTaxonomyResponse, ReadProjectStatementTaxonomyError, ReadProjectStatementTaxonomyResponse, ReturnType<typeof readProjectStatementTaxonomyQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await readProjectStatementTaxonomy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: readProjectStatementTaxonomyQueryKey(options)
});

/**
 * Select Project Statement Taxonomy
 *
 * Choose the taxonomy this project's future extraction runs are built from.
 */
export const selectProjectStatementTaxonomyMutation = (options?: Partial<Options<SelectProjectStatementTaxonomyData>>): UseMutationOptions<SelectProjectStatementTaxonomyResponse, SelectProjectStatementTaxonomyError, Options<SelectProjectStatementTaxonomyData>> => {
  const mutationOptions: UseMutationOptions<SelectProjectStatementTaxonomyResponse, SelectProjectStatementTaxonomyError, Options<SelectProjectStatementTaxonomyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await selectProjectStatementTaxonomy({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Start Statement Extraction
 *
 * Run Stage 1A and Stage 1B for all configured project years.
 */
export const startStatementExtractionMutation = (options?: Partial<Options<StartStatementExtractionData>>): UseMutationOptions<StartStatementExtractionResponse, StartStatementExtractionError, Options<StartStatementExtractionData>> => {
  const mutationOptions: UseMutationOptions<StartStatementExtractionResponse, StartStatementExtractionError, Options<StartStatementExtractionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await startStatementExtraction({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const latestStatementExtractionQueryKey = (options: Options<LatestStatementExtractionData>) => createQueryKey('latestStatementExtraction', options);

/**
 * Latest Statement Extraction
 *
 * Return the current statement-extraction run.
 */
export const latestStatementExtractionOptions = (options: Options<LatestStatementExtractionData>) => queryOptions<LatestStatementExtractionResponse, LatestStatementExtractionError, LatestStatementExtractionResponse, ReturnType<typeof latestStatementExtractionQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await latestStatementExtraction({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: latestStatementExtractionQueryKey(options)
});

/**
 * Start Statement Extraction Deep Stage
 *
 * Run one deep stage for every configured project year.
 */
export const startStatementExtractionDeepStageMutation = (options?: Partial<Options<StartStatementExtractionDeepStageData>>): UseMutationOptions<StartStatementExtractionDeepStageResponse, StartStatementExtractionDeepStageError, Options<StartStatementExtractionDeepStageData>> => {
  const mutationOptions: UseMutationOptions<StartStatementExtractionDeepStageResponse, StartStatementExtractionDeepStageError, Options<StartStatementExtractionDeepStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await startStatementExtractionDeepStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Replace Statement Extraction Stage
 *
 * Replace one stage with a complete manual snapshot.
 */
export const replaceStatementExtractionStageMutation = (options?: Partial<Options<ReplaceStatementExtractionStageData>>): UseMutationOptions<ReplaceStatementExtractionStageResponse, ReplaceStatementExtractionStageError, Options<ReplaceStatementExtractionStageData>> => {
  const mutationOptions: UseMutationOptions<ReplaceStatementExtractionStageResponse, ReplaceStatementExtractionStageError, Options<ReplaceStatementExtractionStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await replaceStatementExtractionStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Confirm Statement Extraction Stage
 *
 * Confirm one stage after every exact control passes.
 */
export const confirmStatementExtractionStageMutation = (options?: Partial<Options<ConfirmStatementExtractionStageData>>): UseMutationOptions<ConfirmStatementExtractionStageResponse, ConfirmStatementExtractionStageError, Options<ConfirmStatementExtractionStageData>> => {
  const mutationOptions: UseMutationOptions<ConfirmStatementExtractionStageResponse, ConfirmStatementExtractionStageError, Options<ConfirmStatementExtractionStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmStatementExtractionStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Deconfirm Statement Extraction Stage
 *
 * Return one confirmed stage to review while retaining its snapshot.
 */
export const deconfirmStatementExtractionStageMutation = (options?: Partial<Options<DeconfirmStatementExtractionStageData>>): UseMutationOptions<DeconfirmStatementExtractionStageResponse, DeconfirmStatementExtractionStageError, Options<DeconfirmStatementExtractionStageData>> => {
  const mutationOptions: UseMutationOptions<DeconfirmStatementExtractionStageResponse, DeconfirmStatementExtractionStageError, Options<DeconfirmStatementExtractionStageData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deconfirmStatementExtractionStage({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listStatementTaxonomiesQueryKey = (options: Options<ListStatementTaxonomiesData>) => createQueryKey('listStatementTaxonomies', options);

/**
 * List Statement Taxonomies
 *
 * Return the library or the template choices for an audit or CF project.
 */
export const listStatementTaxonomiesOptions = (options: Options<ListStatementTaxonomiesData>) => queryOptions<ListStatementTaxonomiesResponse, ListStatementTaxonomiesError, ListStatementTaxonomiesResponse, ReturnType<typeof listStatementTaxonomiesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listStatementTaxonomies({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listStatementTaxonomiesQueryKey(options)
});

/**
 * Create Statement Taxonomy
 *
 * Open a draft seeded from the default taxonomy or from an existing one.
 */
export const createStatementTaxonomyMutation = (options?: Partial<Options<CreateStatementTaxonomyData>>): UseMutationOptions<CreateStatementTaxonomyResponse, CreateStatementTaxonomyError, Options<CreateStatementTaxonomyData>> => {
  const mutationOptions: UseMutationOptions<CreateStatementTaxonomyResponse, CreateStatementTaxonomyError, Options<CreateStatementTaxonomyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createStatementTaxonomy({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const readDefaultStatementTaxonomyQueryKey = (options: Options<ReadDefaultStatementTaxonomyData>) => createQueryKey('readDefaultStatementTaxonomy', options);

/**
 * Read Default Statement Taxonomy
 *
 * Return the packaged default taxonomy, which every organization can copy.
 */
export const readDefaultStatementTaxonomyOptions = (options: Options<ReadDefaultStatementTaxonomyData>) => queryOptions<ReadDefaultStatementTaxonomyResponse, ReadDefaultStatementTaxonomyError, ReadDefaultStatementTaxonomyResponse, ReturnType<typeof readDefaultStatementTaxonomyQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await readDefaultStatementTaxonomy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: readDefaultStatementTaxonomyQueryKey(options)
});

/**
 * Archive Statement Taxonomy
 *
 * Retire a taxonomy that no project selects.
 *
 * Takes its locks inside the service, in the order `publish` explains.
 */
export const archiveStatementTaxonomyMutation = (options?: Partial<Options<ArchiveStatementTaxonomyData>>): UseMutationOptions<ArchiveStatementTaxonomyResponse, ArchiveStatementTaxonomyError, Options<ArchiveStatementTaxonomyData>> => {
  const mutationOptions: UseMutationOptions<ArchiveStatementTaxonomyResponse, ArchiveStatementTaxonomyError, Options<ArchiveStatementTaxonomyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await archiveStatementTaxonomy({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const readStatementTaxonomyQueryKey = (options: Options<ReadStatementTaxonomyData>) => createQueryKey('readStatementTaxonomy', options);

/**
 * Read Statement Taxonomy
 *
 * Return one taxonomy's current rows.
 *
 * The 404 survives the gate: the tenant select deliberately keeps an archived
 * taxonomy, so an archived id reaches the service and is answered there, as it
 * was before.
 */
export const readStatementTaxonomyOptions = (options: Options<ReadStatementTaxonomyData>) => queryOptions<ReadStatementTaxonomyResponse, ReadStatementTaxonomyError, ReadStatementTaxonomyResponse, ReturnType<typeof readStatementTaxonomyQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await readStatementTaxonomy({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: readStatementTaxonomyQueryKey(options)
});

/**
 * Update Statement Taxonomy
 *
 * Replace the taxonomy's draft rows.
 */
export const updateStatementTaxonomyMutation = (options?: Partial<Options<UpdateStatementTaxonomyData>>): UseMutationOptions<UpdateStatementTaxonomyResponse, UpdateStatementTaxonomyError, Options<UpdateStatementTaxonomyData>> => {
  const mutationOptions: UseMutationOptions<UpdateStatementTaxonomyResponse, UpdateStatementTaxonomyError, Options<UpdateStatementTaxonomyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateStatementTaxonomy({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Publish Statement Taxonomy
 *
 * Publish the tree while preserving completed results and excluding active extraction.
 *
 * No `require_locked_row` here, deliberately. The service already opens its own
 * transaction and takes `guard_hierarchy` *before* the taxonomy row, and a lock
 * taken out here would invert that order against every other writer of the
 * pair. There is also nothing row-scoped to re-prove: a catalog's authority is
 * organization-level, so a revocation takes effect on the next request (the
 * residual window RFC 5.11 already describes for the organization prompt
 * shelf).
 */
export const publishStatementTaxonomyMutation = (options?: Partial<Options<PublishStatementTaxonomyData>>): UseMutationOptions<PublishStatementTaxonomyResponse, PublishStatementTaxonomyError, Options<PublishStatementTaxonomyData>> => {
  const mutationOptions: UseMutationOptions<PublishStatementTaxonomyResponse, PublishStatementTaxonomyError, Options<PublishStatementTaxonomyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishStatementTaxonomy({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const exportCorporateFinanceWorkbookQueryKey = (options: Options<ExportCorporateFinanceWorkbookData>) => createQueryKey('exportCorporateFinanceWorkbook', options);

/**
 * Exportcorporatefinanceworkbook
 *
 * Export selected Corporate Finance worksheets as an XLSX workbook.
 */
export const exportCorporateFinanceWorkbookOptions = (options: Options<ExportCorporateFinanceWorkbookData>) => queryOptions<ExportCorporateFinanceWorkbookResponse, ExportCorporateFinanceWorkbookError, ExportCorporateFinanceWorkbookResponse, ReturnType<typeof exportCorporateFinanceWorkbookQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportCorporateFinanceWorkbook({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportCorporateFinanceWorkbookQueryKey(options)
});

export const getAuditChecksQueryKey = (options?: Options<GetAuditChecksData>) => createQueryKey('getAuditChecks', options);

/**
 * Get Audit Checks
 */
export const getAuditChecksOptions = (options?: Options<GetAuditChecksData>) => queryOptions<GetAuditChecksResponse, GetAuditChecksError, GetAuditChecksResponse, ReturnType<typeof getAuditChecksQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getAuditChecks({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getAuditChecksQueryKey(options)
});

/**
 * Set Audit Check
 */
export const setAuditCheckMutation = (options?: Partial<Options<SetAuditCheckData>>): UseMutationOptions<SetAuditCheckResponse, SetAuditCheckError, Options<SetAuditCheckData>> => {
  const mutationOptions: UseMutationOptions<SetAuditCheckResponse, SetAuditCheckError, Options<SetAuditCheckData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setAuditCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Audit Check
 */
export const deleteAuditCheckMutation = (options?: Partial<Options<DeleteAuditCheckData>>): UseMutationOptions<unknown, DeleteAuditCheckError, Options<DeleteAuditCheckData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteAuditCheckError, Options<DeleteAuditCheckData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteAuditCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Rerun Validation Check
 *
 * Rerun a validation check for all its associated clients.
 */
export const rerunValidationCheckMutation = (options?: Partial<Options<RerunValidationCheckData>>): UseMutationOptions<unknown, RerunValidationCheckError, Options<RerunValidationCheckData>> => {
  const mutationOptions: UseMutationOptions<unknown, RerunValidationCheckError, Options<RerunValidationCheckData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await rerunValidationCheck({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Run Debug Query
 */
export const runDebugQueryMutation = (options?: Partial<Options<RunDebugQueryData>>): UseMutationOptions<RunDebugQueryResponse, RunDebugQueryError, Options<RunDebugQueryData>> => {
  const mutationOptions: UseMutationOptions<RunDebugQueryResponse, RunDebugQueryError, Options<RunDebugQueryData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await runDebugQuery({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const readFasClassificationsQueryKey = (options: Options<ReadFasClassificationsData>) => createQueryKey('readFasClassifications', options);

/**
 * Read Fas Classifications
 *
 * Read FAS ledger accounts and choices from their assigned published FAS tree.
 */
export const readFasClassificationsOptions = (options: Options<ReadFasClassificationsData>) => queryOptions<ReadFasClassificationsResponse, ReadFasClassificationsError, ReadFasClassificationsResponse, ReturnType<typeof readFasClassificationsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await readFasClassifications({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: readFasClassificationsQueryKey(options)
});

/**
 * Save Fas Classifications
 *
 * Save manual account overrides locally without changing warehouse source classifications.
 */
export const saveFasClassificationsMutation = (options?: Partial<Options<SaveFasClassificationsData>>): UseMutationOptions<SaveFasClassificationsResponse, SaveFasClassificationsError, Options<SaveFasClassificationsData>> => {
  const mutationOptions: UseMutationOptions<SaveFasClassificationsResponse, SaveFasClassificationsError, Options<SaveFasClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveFasClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Predict Fas Classifications
 *
 * Preview typed predictions for unclassified accounts against the assigned FAS tree.
 */
export const predictFasClassificationsMutation = (options?: Partial<Options<PredictFasClassificationsData>>): UseMutationOptions<PredictFasClassificationsResponse, PredictFasClassificationsError, Options<PredictFasClassificationsData>> => {
  const mutationOptions: UseMutationOptions<PredictFasClassificationsResponse, PredictFasClassificationsError, Options<PredictFasClassificationsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await predictFasClassifications({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Accept Fas Predictions
 *
 * Accept server-issued predictions against the acceptance-time source read and local revisions.
 */
export const acceptFasPredictionsMutation = (options?: Partial<Options<AcceptFasPredictionsData>>): UseMutationOptions<AcceptFasPredictionsResponse, AcceptFasPredictionsError, Options<AcceptFasPredictionsData>> => {
  const mutationOptions: UseMutationOptions<AcceptFasPredictionsResponse, AcceptFasPredictionsError, Options<AcceptFasPredictionsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await acceptFasPredictions({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPreviewQueryKey = (options: Options<GetPreviewData>) => createQueryKey('getPreview', options);

/**
 * Get Preview
 */
export const getPreviewOptions = (options: Options<GetPreviewData>) => queryOptions<GetPreviewResponse, GetPreviewError, GetPreviewResponse, ReturnType<typeof getPreviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPreview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPreviewQueryKey(options)
});

export const getPreviewInfiniteQueryKey = (options: Options<GetPreviewData>): QueryKey<Options<GetPreviewData>> => createQueryKey('getPreview', options, true);

/**
 * Get Preview
 */
export const getPreviewInfiniteOptions = (options: Options<GetPreviewData>) => {
  const opts = infiniteQueryOptions<GetPreviewResponse, GetPreviewError, InfiniteData<GetPreviewResponse>, QueryKey<Options<GetPreviewData>>, number | null | Pick<QueryKey<Options<GetPreviewData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetPreviewData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getPreview({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getPreviewInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getDatasourceFileQueryKey = (options: Options<GetDatasourceFileData>) => createQueryKey('getDatasourceFile', options);

/**
 * Get Datasource File
 *
 * Stream the file a blob-backed datasource was created from.
 */
export const getDatasourceFileOptions = (options: Options<GetDatasourceFileData>) => queryOptions<GetDatasourceFileResponse, GetDatasourceFileError, GetDatasourceFileResponse, ReturnType<typeof getDatasourceFileQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDatasourceFile({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDatasourceFileQueryKey(options)
});

export const exportDatasourceQueryKey = (options: Options<ExportDatasourceData>) => createQueryKey('exportDatasource', options);

/**
 * Export Datasource
 *
 * Stream every row of a view-backed datasource as CSV.
 */
export const exportDatasourceOptions = (options: Options<ExportDatasourceData>) => queryOptions<ExportDatasourceResponse, ExportDatasourceError, ExportDatasourceResponse, ReturnType<typeof exportDatasourceQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await exportDatasource({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: exportDatasourceQueryKey(options)
});

/**
 * Delete Datasources
 *
 * Soft-delete every named datasource, or none of them.
 *
 * The gate is all-or-nothing over the whole query list, which is the per-id
 * refusal the loop here used to do in N reads. Two things it cannot answer are
 * left, and both are read here rather than in the gate because both are
 * product state rather than authority.
 *
 * **A repeated id.** The gate keys its rows by id, so duplicates collapse. The
 * loop this replaced compared the count of rows it loaded against the count of
 * ids it was given, so `?datasource_ids=X&datasource_ids=X` answered 404 with
 * an empty id list. Reproducing that comparison here is what keeps the answer
 * the one callers already get; it runs after the gate because nothing of the
 * handler's own may resolve before a gate does, and the precedence is
 * unchanged either way (the old loop authorized first too).
 *
 * **`deleted_at`.** The tenant select deliberately keeps a soft-deleted row
 * (see the policy), so an already-deleted id passes the gate. It is checked on
 * the **locked** rows, not on the gate's snapshot: `soft_delete_datasources`
 * ignores a row that is already gone, so a caller whose authority survives the
 * delete - a blanket YAML grant, where a tier is wiped with the row - would
 * otherwise be told a delete succeeded that did nothing.
 *
 * Each row is locked in id order and `delete_datasource` proved again on the
 * locked version, so a revocation committing between the gate and the write
 * cannot be overtaken. One order for every writer of several datasources,
 * which is what stops two bulk deletes deadlocking.
 */
export const deleteDatasourcesMutation = (options?: Partial<Options<DeleteDatasourcesData>>): UseMutationOptions<unknown, DeleteDatasourcesError, Options<DeleteDatasourcesData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteDatasourcesError, Options<DeleteDatasourcesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteDatasources({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getDatasourcesQueryKey = (options: Options<GetDatasourcesData>) => createQueryKey('getDatasources', options);

/**
 * Get Datasources
 *
 * List datasources accessible to the user.
 *
 * By default returns only general data-management datasources (those NOT linked
 * to an audit client). Audit-client-linked datasources live in the dossier
 * context and are surfaced through the audit client endpoints instead, so that
 * data management stays separate from dossier-specific documents.
 *
 * Access rules:
 *     - Owner access: user owns the datasource
 *     - Shared access: explicitly shared via `ResourcePermission`
 *     - Role access: role-level wildcard grant (e.g. `org_admin`)
 *     - Superuser: unrestricted
 */
export const getDatasourcesOptions = (options: Options<GetDatasourcesData>) => queryOptions<GetDatasourcesResponse, GetDatasourcesError, GetDatasourcesResponse, ReturnType<typeof getDatasourcesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDatasources({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDatasourcesQueryKey(options)
});

/**
 * Create Datasource
 *
 * Create a new datasource within the specified organization.
 */
export const createDatasourceMutation = (options?: Partial<Options<CreateDatasourceData>>): UseMutationOptions<CreateDatasourceResponse, CreateDatasourceError, Options<CreateDatasourceData>> => {
  const mutationOptions: UseMutationOptions<CreateDatasourceResponse, CreateDatasourceError, Options<CreateDatasourceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDatasource({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getDatasourcesPageQueryKey = (options: Options<GetDatasourcesPageData>) => createQueryKey('getDatasourcesPage', options);

/**
 * Get Datasources Page
 *
 * One page of the datasources the list endpoint returns, with the same filters and access rules.
 *
 * The authorized relation is the base, and the filters, the sort and the page
 * are layered on top of it: there is no wider statement to page by accident,
 * and `total` counts the same relation after the caller's own filters rather
 * than the table.
 *
 * Sorting happens here rather than in the client so the order holds across
 * pages.
 */
export const getDatasourcesPageOptions = (options: Options<GetDatasourcesPageData>) => queryOptions<GetDatasourcesPageResponse, GetDatasourcesPageError, GetDatasourcesPageResponse, ReturnType<typeof getDatasourcesPageQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDatasourcesPage({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDatasourcesPageQueryKey(options)
});

export const getDatasourcesPageInfiniteQueryKey = (options: Options<GetDatasourcesPageData>): QueryKey<Options<GetDatasourcesPageData>> => createQueryKey('getDatasourcesPage', options, true);

/**
 * Get Datasources Page
 *
 * One page of the datasources the list endpoint returns, with the same filters and access rules.
 *
 * The authorized relation is the base, and the filters, the sort and the page
 * are layered on top of it: there is no wider statement to page by accident,
 * and `total` counts the same relation after the caller's own filters rather
 * than the table.
 *
 * Sorting happens here rather than in the client so the order holds across
 * pages.
 */
export const getDatasourcesPageInfiniteOptions = (options: Options<GetDatasourcesPageData>) => {
  const opts = infiniteQueryOptions<GetDatasourcesPageResponse, GetDatasourcesPageError, InfiniteData<GetDatasourcesPageResponse>, QueryKey<Options<GetDatasourcesPageData>>, number | Pick<QueryKey<Options<GetDatasourcesPageData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<GetDatasourcesPageData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await getDatasourcesPage({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getDatasourcesPageInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

export const getDatasourceFiltersQueryKey = (options: Options<GetDatasourceFiltersData>) => createQueryKey('getDatasourceFilters', options);

/**
 * Get Datasource Filters
 *
 * Return the filter options the UI offers for data-management datasources.
 *
 * Only considers datasources the user can see, and excludes any linked to an
 * audit client (those belong to the dossier context).
 */
export const getDatasourceFiltersOptions = (options: Options<GetDatasourceFiltersData>) => queryOptions<GetDatasourceFiltersResponse, GetDatasourceFiltersError, GetDatasourceFiltersResponse, ReturnType<typeof getDatasourceFiltersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDatasourceFilters({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDatasourceFiltersQueryKey(options)
});

export const getDatasourceByIdQueryKey = (options: Options<GetDatasourceByIdData>) => createQueryKey('getDatasourceById', options);

/**
 * Get Datasource By Id
 *
 * Return a datasource by ID, honouring both RBAC and audit-member access paths.
 *
 * Access is granted through two paths:
 *
 * - **Data management (RBAC):** owner, explicit per-resource grant, role-level
 *   wildcard, or superuser.
 * - **Project membership:** the caller holds a project-scoped audit role on a
 *   project that links to this datasource via `ProjectDatasource`.
 *   This lets audit executors open datasources for document analysis without
 *   requiring explicit RBAC shares.
 *
 * Raises:
 *     DatasourceNotFoundException: If the datasource is not found or user lacks access.
 */
export const getDatasourceByIdOptions = (options: Options<GetDatasourceByIdData>) => queryOptions<GetDatasourceByIdResponse, GetDatasourceByIdError, GetDatasourceByIdResponse, ReturnType<typeof getDatasourceByIdQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDatasourceById({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDatasourceByIdQueryKey(options)
});

/**
 * Update Datasource
 *
 * Rename a datasource, retype its data, or replace its context block.
 *
 * The gate answered about a snapshot, so the row is locked and
 * `update_datasource` proved again on the version that got locked: concurrent
 * PATCHes serialize and a caller whose tier was withdrawn in between writes
 * nothing.
 */
export const updateDatasourceMutation = (options?: Partial<Options<UpdateDatasourceData>>): UseMutationOptions<UpdateDatasourceResponse, UpdateDatasourceError, Options<UpdateDatasourceData>> => {
  const mutationOptions: UseMutationOptions<UpdateDatasourceResponse, UpdateDatasourceError, Options<UpdateDatasourceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDatasource({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getSharedDatasourceQueryKey = (options: Options<GetSharedDatasourceData>) => createQueryKey('getSharedDatasource', options);

/**
 * Get Shared Datasource
 *
 * Return tiered grantees plus the caller's own effective tier.
 *
 * `users` and `roles` are the revocable surfaces (per-user scoped tiers and
 * group grants); `role_derived_users` is informational so the UI can explain
 * why a user has access without offering a no-op revoke.
 */
export const getSharedDatasourceOptions = (options: Options<GetSharedDatasourceData>) => queryOptions<GetSharedDatasourceResponse, GetSharedDatasourceError, GetSharedDatasourceResponse, ReturnType<typeof getSharedDatasourceQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSharedDatasource({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSharedDatasourceQueryKey(options)
});

/**
 * Patch Shared Datasource
 *
 * Apply tier deltas to user grants and role grants, enforcing Rule B.
 *
 * The gate decides whether the caller may share at all; Rule B decides what
 * they may hand out, and the two are not interchangeable. Between them comes
 * the shared write step: the departments this delta writes grants for are
 * taken exclusively, the datasource row is locked, and `share_datasource` is
 * proved again on the version that got locked - so concurrent PATCHes
 * serialize and a caller whose own tier was withdrawn in between confers
 * nothing.
 */
export const patchSharedDatasourceMutation = (options?: Partial<Options<PatchSharedDatasourceData>>): UseMutationOptions<PatchSharedDatasourceResponse, PatchSharedDatasourceError, Options<PatchSharedDatasourceData>> => {
  const mutationOptions: UseMutationOptions<PatchSharedDatasourceResponse, PatchSharedDatasourceError, Options<PatchSharedDatasourceData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await patchSharedDatasource({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getDocumentAnalysisSettingsQueryKey = (options: Options<GetDocumentAnalysisSettingsData>) => createQueryKey('getDocumentAnalysisSettings', options);

/**
 * Get Document Analysis Settings
 *
 * Read the document's page scope for future statement extractions.
 */
export const getDocumentAnalysisSettingsOptions = (options: Options<GetDocumentAnalysisSettingsData>) => queryOptions<GetDocumentAnalysisSettingsResponse, GetDocumentAnalysisSettingsError, GetDocumentAnalysisSettingsResponse, ReturnType<typeof getDocumentAnalysisSettingsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDocumentAnalysisSettings({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDocumentAnalysisSettingsQueryKey(options)
});

/**
 * Update Document Analysis Settings
 *
 * Save page selection without changing results or scheduling work.
 */
export const updateDocumentAnalysisSettingsMutation = (options?: Partial<Options<UpdateDocumentAnalysisSettingsData>>): UseMutationOptions<UpdateDocumentAnalysisSettingsResponse, UpdateDocumentAnalysisSettingsError, Options<UpdateDocumentAnalysisSettingsData>> => {
  const mutationOptions: UseMutationOptions<UpdateDocumentAnalysisSettingsResponse, UpdateDocumentAnalysisSettingsError, Options<UpdateDocumentAnalysisSettingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDocumentAnalysisSettings({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCollectionFiltersQueryKey = (options: Options<GetCollectionFiltersData>) => createQueryKey('getCollectionFilters', options);

/**
 * Get Collection Filters
 *
 * Return available filter values scoped to the collections the user can read.
 */
export const getCollectionFiltersOptions = (options: Options<GetCollectionFiltersData>) => queryOptions<GetCollectionFiltersResponse, GetCollectionFiltersError, GetCollectionFiltersResponse, ReturnType<typeof getCollectionFiltersQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCollectionFilters({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCollectionFiltersQueryKey(options)
});

export const listCollectionsQueryKey = (options: Options<ListCollectionsData>) => createQueryKey('listCollections', options);

/**
 * List Collections
 *
 * List datasource collections the user can read.
 */
export const listCollectionsOptions = (options: Options<ListCollectionsData>) => queryOptions<ListCollectionsResponse, ListCollectionsError, ListCollectionsResponse, ReturnType<typeof listCollectionsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listCollections({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listCollectionsQueryKey(options)
});

/**
 * Create Collection
 *
 * Create a new datasource collection; the creator becomes its admin.
 */
export const createCollectionMutation = (options?: Partial<Options<CreateCollectionData>>): UseMutationOptions<CreateCollectionResponse, CreateCollectionError, Options<CreateCollectionData>> => {
  const mutationOptions: UseMutationOptions<CreateCollectionResponse, CreateCollectionError, Options<CreateCollectionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCollection({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listCollectionsPageQueryKey = (options: Options<ListCollectionsPageData>) => createQueryKey('listCollectionsPage', options);

/**
 * List Collections Page
 *
 * One page of the collections the user can read, with the list's filters.
 *
 * `datasource_ids` keeps collections holding any of those datasources. Access is
 * narrowed in the query, so `total` counts only readable collections.
 */
export const listCollectionsPageOptions = (options: Options<ListCollectionsPageData>) => queryOptions<ListCollectionsPageResponse, ListCollectionsPageError, ListCollectionsPageResponse, ReturnType<typeof listCollectionsPageQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listCollectionsPage({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listCollectionsPageQueryKey(options)
});

export const listCollectionsPageInfiniteQueryKey = (options: Options<ListCollectionsPageData>): QueryKey<Options<ListCollectionsPageData>> => createQueryKey('listCollectionsPage', options, true);

/**
 * List Collections Page
 *
 * One page of the collections the user can read, with the list's filters.
 *
 * `datasource_ids` keeps collections holding any of those datasources. Access is
 * narrowed in the query, so `total` counts only readable collections.
 */
export const listCollectionsPageInfiniteOptions = (options: Options<ListCollectionsPageData>) => {
  const opts = infiniteQueryOptions<ListCollectionsPageResponse, ListCollectionsPageError, InfiniteData<ListCollectionsPageResponse>, QueryKey<Options<ListCollectionsPageData>>, number | Pick<QueryKey<Options<ListCollectionsPageData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
  // @ts-ignore
  {
    queryFn: async ({ pageParam, queryKey, signal }) => {
      // @ts-ignore
      const page: Pick<QueryKey<Options<ListCollectionsPageData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
        query: {
          offset: pageParam
        }
      };
      const params = createInfiniteParams(queryKey, page);
      const { data } = await listCollectionsPage({
        ...options,
        ...params,
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listCollectionsPageInfiniteQueryKey(options)
  });
  return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Delete Collection
 *
 * Delete a datasource collection and its per-resource grants.
 */
export const deleteCollectionMutation = (options?: Partial<Options<DeleteCollectionData>>): UseMutationOptions<DeleteCollectionResponse, DeleteCollectionError, Options<DeleteCollectionData>> => {
  const mutationOptions: UseMutationOptions<DeleteCollectionResponse, DeleteCollectionError, Options<DeleteCollectionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteCollection({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCollectionQueryKey = (options: Options<GetCollectionData>) => createQueryKey('getCollection', options);

/**
 * Get Collection
 *
 * Get a single datasource collection by ID.
 */
export const getCollectionOptions = (options: Options<GetCollectionData>) => queryOptions<GetCollectionResponse, GetCollectionError, GetCollectionResponse, ReturnType<typeof getCollectionQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCollection({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCollectionQueryKey(options)
});

/**
 * Update Collection
 *
 * Update a datasource collection (name and datasource membership).
 *
 * Membership is a datasource-exposure door, so the datasources joining the
 * collection keep their own guard: a caller must already hold `read_datasource`
 * on each one. That is a different contract from reaching this collection, and
 * routing it through the collection policy would make a collection grant the
 * key to every datasource anyone adds to it (RFC 0001 section 5.5).
 */
export const updateCollectionMutation = (options?: Partial<Options<UpdateCollectionData>>): UseMutationOptions<UpdateCollectionResponse, UpdateCollectionError, Options<UpdateCollectionData>> => {
  const mutationOptions: UseMutationOptions<UpdateCollectionResponse, UpdateCollectionError, Options<UpdateCollectionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCollection({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getCollectionShareQueryKey = (options: Options<GetCollectionShareData>) => createQueryKey('getCollectionShare', options);

/**
 * Get Collection Share
 *
 * Return tiered grantees plus the caller's own effective tier on the collection.
 */
export const getCollectionShareOptions = (options: Options<GetCollectionShareData>) => queryOptions<GetCollectionShareResponse, GetCollectionShareError, GetCollectionShareResponse, ReturnType<typeof getCollectionShareQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getCollectionShare({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getCollectionShareQueryKey(options)
});

/**
 * Patch Collection Share
 *
 * Apply tier deltas to collection grants and cascade them onto its datasources.
 *
 * The gate answered about a snapshot, so the row is locked and
 * `share_datasource_collection` proved again on the version that got locked:
 * concurrent PATCHes serialize and a caller whose own tier was withdrawn in
 * between confers nothing. Then org membership of grantees and known role names
 * are validated, Rule B is enforced on the collection, and the caller must be
 * able to confer the mirrored tier on every datasource in it (strict block, no
 * partial writes).
 */
export const patchCollectionShareMutation = (options?: Partial<Options<PatchCollectionShareData>>): UseMutationOptions<PatchCollectionShareResponse, PatchCollectionShareError, Options<PatchCollectionShareData>> => {
  const mutationOptions: UseMutationOptions<PatchCollectionShareResponse, PatchCollectionShareError, Options<PatchCollectionShareData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await patchCollectionShare({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listOriginsQueryKey = (options: Options<ListOriginsData>) => createQueryKey('listOrigins', options);

/**
 * List Origins
 */
export const listOriginsOptions = (options: Options<ListOriginsData>) => queryOptions<ListOriginsResponse, ListOriginsError, ListOriginsResponse, ReturnType<typeof listOriginsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listOrigins({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listOriginsQueryKey(options)
});

/**
 * Create Origin
 */
export const createOriginMutation = (options?: Partial<Options<CreateOriginData>>): UseMutationOptions<CreateOriginResponse, CreateOriginError, Options<CreateOriginData>> => {
  const mutationOptions: UseMutationOptions<CreateOriginResponse, CreateOriginError, Options<CreateOriginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOrigin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Origin
 */
export const deleteOriginMutation = (options?: Partial<Options<DeleteOriginData>>): UseMutationOptions<unknown, DeleteOriginError, Options<DeleteOriginData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteOriginError, Options<DeleteOriginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteOrigin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getOriginQueryKey = (options: Options<GetOriginData>) => createQueryKey('getOrigin', options);

/**
 * Get Origin
 */
export const getOriginOptions = (options: Options<GetOriginData>) => queryOptions<GetOriginResponse, GetOriginError, GetOriginResponse, ReturnType<typeof getOriginQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getOrigin({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getOriginQueryKey(options)
});

/**
 * Update Origin
 */
export const updateOriginMutation = (options?: Partial<Options<UpdateOriginData>>): UseMutationOptions<UpdateOriginResponse, UpdateOriginError, Options<UpdateOriginData>> => {
  const mutationOptions: UseMutationOptions<UpdateOriginResponse, UpdateOriginError, Options<UpdateOriginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOrigin({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listOriginTablesQueryKey = (options: Options<ListOriginTablesData>) => createQueryKey('listOriginTables', options);

/**
 * List Origin Tables
 *
 * List schemas & tables on a MSSQL origin, marking which are already datasources.
 *
 * `already_used=True` + `datasource_id` lets the UI link existing picks back to
 * their datasource and grey them out on the select list without a second
 * round-trip.
 */
export const listOriginTablesOptions = (options: Options<ListOriginTablesData>) => queryOptions<ListOriginTablesResponse, ListOriginTablesError, ListOriginTablesResponse, ReturnType<typeof listOriginTablesQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listOriginTables({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listOriginTablesQueryKey(options)
});

/**
 * Bulk Create Origin Datasources
 *
 * Bulk-create MSSQL datasources that reuse an existing origin.
 *
 * Unlike `POST /datasource`, this does NOT create a new origin per datasource.
 * The batch is atomic: if any table conflicts with an existing active
 * datasource on this origin, the whole request is rejected with 409 and the
 * list of conflicts.
 */
export const bulkCreateOriginDatasourcesMutation = (options?: Partial<Options<BulkCreateOriginDatasourcesData>>): UseMutationOptions<BulkCreateOriginDatasourcesResponse, BulkCreateOriginDatasourcesError, Options<BulkCreateOriginDatasourcesData>> => {
  const mutationOptions: UseMutationOptions<BulkCreateOriginDatasourcesResponse, BulkCreateOriginDatasourcesError, Options<BulkCreateOriginDatasourcesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkCreateOriginDatasources({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const testOriginConnectionQueryKey = (options: Options<TestOriginConnectionData>) => createQueryKey('testOriginConnection', options);

/**
 * Test Origin Connection
 *
 * Probe connectivity to a MSSQL origin by running `SELECT 1`.
 *
 * Always returns HTTP 200 even when the probe itself fails; the outcome is
 * carried in `ok`, so the UI can render a status chip from a uniform shape.
 * Engine creation / connection errors are captured into `error` rather than
 * bubbled up to the global exception handler.
 */
export const testOriginConnectionOptions = (options: Options<TestOriginConnectionData>) => queryOptions<TestOriginConnectionResponse, TestOriginConnectionError, TestOriginConnectionResponse, ReturnType<typeof testOriginConnectionQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await testOriginConnection({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: testOriginConnectionQueryKey(options)
});

export const getDashboardsQueryKey = (options: Options<GetDashboardsData>) => createQueryKey('getDashboards', options);

/**
 * Get Dashboards
 */
export const getDashboardsOptions = (options: Options<GetDashboardsData>) => queryOptions<GetDashboardsResponse, GetDashboardsError, GetDashboardsResponse, ReturnType<typeof getDashboardsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDashboards({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDashboardsQueryKey(options)
});

/**
 * Create Dashboard
 */
export const createDashboardMutation = (options?: Partial<Options<CreateDashboardData>>): UseMutationOptions<CreateDashboardResponse, CreateDashboardError, Options<CreateDashboardData>> => {
  const mutationOptions: UseMutationOptions<CreateDashboardResponse, CreateDashboardError, Options<CreateDashboardData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDashboard({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Dashboard
 */
export const deleteDashboardMutation = (options?: Partial<Options<DeleteDashboardData>>): UseMutationOptions<unknown, DeleteDashboardError, Options<DeleteDashboardData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteDashboardError, Options<DeleteDashboardData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteDashboard({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getDashboardQueryKey = (options: Options<GetDashboardData>) => createQueryKey('getDashboard', options);

/**
 * Get Dashboard
 */
export const getDashboardOptions = (options: Options<GetDashboardData>) => queryOptions<GetDashboardResponse, GetDashboardError, GetDashboardResponse, ReturnType<typeof getDashboardQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getDashboard({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getDashboardQueryKey(options)
});

/**
 * Update Dashboard
 */
export const updateDashboardMutation = (options?: Partial<Options<UpdateDashboardData>>): UseMutationOptions<UpdateDashboardResponse, UpdateDashboardError, Options<UpdateDashboardData>> => {
  const mutationOptions: UseMutationOptions<UpdateDashboardResponse, UpdateDashboardError, Options<UpdateDashboardData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDashboard({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Create Dashboard Widget
 */
export const createDashboardWidgetMutation = (options?: Partial<Options<CreateDashboardWidgetData>>): UseMutationOptions<CreateDashboardWidgetResponse, CreateDashboardWidgetError, Options<CreateDashboardWidgetData>> => {
  const mutationOptions: UseMutationOptions<CreateDashboardWidgetResponse, CreateDashboardWidgetError, Options<CreateDashboardWidgetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDashboardWidget({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Create Dashboard Chain Widget
 *
 * Pin a chat chart/table as a live widget by capturing its tool-call chain.
 *
 * The chain is extracted deterministically from the conversation's dataframe
 * lineage (no LLM), then replayed once to populate the widget.
 *
 * The replay runs before the lock, not under it. It may spin up a sandbox, so
 * holding the dashboard across it would block every other write on that
 * dashboard for the length of a foreign round trip. The authority is proved
 * again immediately before the one write, which is what it has to be newer
 * than.
 */
export const createDashboardChainWidgetMutation = (options?: Partial<Options<CreateDashboardChainWidgetData>>): UseMutationOptions<CreateDashboardChainWidgetResponse, CreateDashboardChainWidgetError, Options<CreateDashboardChainWidgetData>> => {
  const mutationOptions: UseMutationOptions<CreateDashboardChainWidgetResponse, CreateDashboardChainWidgetError, Options<CreateDashboardChainWidgetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDashboardChainWidget({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Delete Dashboard Widget
 */
export const deleteDashboardWidgetMutation = (options?: Partial<Options<DeleteDashboardWidgetData>>): UseMutationOptions<unknown, DeleteDashboardWidgetError, Options<DeleteDashboardWidgetData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteDashboardWidgetError, Options<DeleteDashboardWidgetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteDashboardWidget({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Dashboard Widget Position
 */
export const updateDashboardWidgetPositionMutation = (options?: Partial<Options<UpdateDashboardWidgetPositionData>>): UseMutationOptions<UpdateDashboardWidgetPositionResponse, UpdateDashboardWidgetPositionError, Options<UpdateDashboardWidgetPositionData>> => {
  const mutationOptions: UseMutationOptions<UpdateDashboardWidgetPositionResponse, UpdateDashboardWidgetPositionError, Options<UpdateDashboardWidgetPositionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDashboardWidgetPosition({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Dashboard Widget Name
 */
export const updateDashboardWidgetNameMutation = (options?: Partial<Options<UpdateDashboardWidgetNameData>>): UseMutationOptions<UpdateDashboardWidgetNameResponse, UpdateDashboardWidgetNameError, Options<UpdateDashboardWidgetNameData>> => {
  const mutationOptions: UseMutationOptions<UpdateDashboardWidgetNameResponse, UpdateDashboardWidgetNameError, Options<UpdateDashboardWidgetNameData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDashboardWidgetName({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Update Dashboard Widget Type
 *
 * Only allow changing between chart types, not between chart and table.
 */
export const updateDashboardWidgetTypeMutation = (options?: Partial<Options<UpdateDashboardWidgetTypeData>>): UseMutationOptions<UpdateDashboardWidgetTypeResponse, UpdateDashboardWidgetTypeError, Options<UpdateDashboardWidgetTypeData>> => {
  const mutationOptions: UseMutationOptions<UpdateDashboardWidgetTypeResponse, UpdateDashboardWidgetTypeError, Options<UpdateDashboardWidgetTypeData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateDashboardWidgetType({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Refresh Dashboard
 *
 * Re-execute every widget in a dashboard and update its data.
 *
 * SQL widgets re-run their query; chain widgets replay their tool calls. Each
 * widget refreshes one at a time on purpose: chain widgets may spin up a
 * sandbox per replay, and the datasources are bound to the request session
 * (lazy `origin` loads), which is not concurrency-safe. A broken widget is
 * isolated so it doesn't abort the rest.
 *
 * The write authorization is rechecked at the end rather than up front. The
 * refresh loop releases the request transaction and then runs external queries
 * and sandbox replays, so a lock taken before it would either be dropped by
 * that release or held across minutes of foreign I/O.
 *
 * So the loop produces values rather than writes. Its results are staged, the
 * in-memory mutations are discarded, and only then does the request take its
 * locks - the dashboard for the authority recheck, then each refreshed widget -
 * and replay the staged fields onto the rows it is holding. A widget edit locks
 * the widget and not the dashboard, so persisting the loop's objects directly
 * would write a stale title or type over a rename that committed while the
 * loop ran, and would try to persist a widget that was deleted in the same
 * window.
 */
export const refreshDashboardMutation = (options?: Partial<Options<RefreshDashboardData>>): UseMutationOptions<RefreshDashboardResponse, RefreshDashboardError, Options<RefreshDashboardData>> => {
  const mutationOptions: UseMutationOptions<RefreshDashboardResponse, RefreshDashboardError, Options<RefreshDashboardData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshDashboard({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Refresh Dashboard Widget
 *
 * Refresh a single widget: re-run its SQL query or replay its tool-call chain.
 *
 * The query or the replay runs before the lock, for the same reason the
 * dashboard-wide refresh does: it is external work of unbounded length, and
 * holding the widget and its dashboard across it would block every other write
 * on either. So the result is staged, the in-memory mutation is dropped, and
 * the request takes its locks and replays only the refreshed fields - which is
 * also what keeps a rename that landed meanwhile.
 */
export const refreshDashboardWidgetMutation = (options?: Partial<Options<RefreshDashboardWidgetData>>): UseMutationOptions<RefreshDashboardWidgetResponse, RefreshDashboardWidgetError, Options<RefreshDashboardWidgetData>> => {
  const mutationOptions: UseMutationOptions<RefreshDashboardWidgetResponse, RefreshDashboardWidgetError, Options<RefreshDashboardWidgetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshDashboardWidget({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getSharedDashboardQueryKey = (options: Options<GetSharedDashboardData>) => createQueryKey('getSharedDashboard', options);

/**
 * Get Shared Dashboard
 *
 * Return tiered grantees plus the caller's own effective tier.
 *
 * `users` and `roles` are the revocable surfaces; `role_derived_users` is
 * informational so the UI can explain access without offering a no-op revoke.
 */
export const getSharedDashboardOptions = (options: Options<GetSharedDashboardData>) => queryOptions<GetSharedDashboardResponse, GetSharedDashboardError, GetSharedDashboardResponse, ReturnType<typeof getSharedDashboardQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getSharedDashboard({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getSharedDashboardQueryKey(options)
});

/**
 * Patch Shared Dashboard
 *
 * Apply tier deltas to user and role grants, enforcing Rule B.
 *
 * The gate answered about a snapshot, so the row is locked and `share_dashboard`
 * proved again on the version that got locked: concurrent PATCHes serialize and
 * a caller whose own tier was withdrawn in between confers nothing. Then org
 * membership and known role names are validated, and Rule B enforces "grant at
 * most your own tier" (admin only to users) over both grants and revokes; any
 * violation rejects the whole request.
 */
export const patchSharedDashboardMutation = (options?: Partial<Options<PatchSharedDashboardData>>): UseMutationOptions<PatchSharedDashboardResponse, PatchSharedDashboardError, Options<PatchSharedDashboardData>> => {
  const mutationOptions: UseMutationOptions<PatchSharedDashboardResponse, PatchSharedDashboardError, Options<PatchSharedDashboardData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await patchSharedDashboard({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Create Widget Chat
 *
 * Create a new chat conversation with a widget's data prefilled.
 *
 * No row lock: this mutates neither the dashboard nor the widget, it creates a
 * conversation seeded from them, so there is no write whose authority could go
 * stale between the gate and the commit.
 */
export const createWidgetChatMutation = (options?: Partial<Options<CreateWidgetChatData>>): UseMutationOptions<CreateWidgetChatResponse, CreateWidgetChatError, Options<CreateWidgetChatData>> => {
  const mutationOptions: UseMutationOptions<CreateWidgetChatResponse, CreateWidgetChatError, Options<CreateWidgetChatData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createWidgetChat({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Submit a bug report
 *
 * Submits a new bug report for the provided project context and optionally uploads attachments.
 */
export const createBugReportMutation = (options?: Partial<Options<CreateBugReportData>>): UseMutationOptions<CreateBugReportResponse, CreateBugReportError, Options<CreateBugReportData>> => {
  const mutationOptions: UseMutationOptions<CreateBugReportResponse, CreateBugReportError, Options<CreateBugReportData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createBugReport({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const listPromotionRequestsQueryKey = (options: Options<ListPromotionRequestsData>) => createQueryKey('listPromotionRequests', options);

/**
 * List Promotion Requests
 */
export const listPromotionRequestsOptions = (options: Options<ListPromotionRequestsData>) => queryOptions<ListPromotionRequestsResponse, ListPromotionRequestsError, ListPromotionRequestsResponse, ReturnType<typeof listPromotionRequestsQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await listPromotionRequests({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: listPromotionRequestsQueryKey(options)
});

/**
 * Create Promotion Request
 */
export const createPromotionRequestMutation = (options?: Partial<Options<CreatePromotionRequestData>>): UseMutationOptions<CreatePromotionRequestResponse, CreatePromotionRequestError, Options<CreatePromotionRequestData>> => {
  const mutationOptions: UseMutationOptions<CreatePromotionRequestResponse, CreatePromotionRequestError, Options<CreatePromotionRequestData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPromotionRequest({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPendingDocumentAnalysisTemplateForPromotionReviewQueryKey = (options: Options<GetPendingDocumentAnalysisTemplateForPromotionReviewData>) => createQueryKey('getPendingDocumentAnalysisTemplateForPromotionReview', options);

/**
 * Get Pending Document Analysis Template For Promotion Review
 *
 * Read the exact pending document-analysis template an approver may decide.
 */
export const getPendingDocumentAnalysisTemplateForPromotionReviewOptions = (options: Options<GetPendingDocumentAnalysisTemplateForPromotionReviewData>) => queryOptions<GetPendingDocumentAnalysisTemplateForPromotionReviewResponse, GetPendingDocumentAnalysisTemplateForPromotionReviewError, GetPendingDocumentAnalysisTemplateForPromotionReviewResponse, ReturnType<typeof getPendingDocumentAnalysisTemplateForPromotionReviewQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPendingDocumentAnalysisTemplateForPromotionReview({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPendingDocumentAnalysisTemplateForPromotionReviewQueryKey(options)
});

/**
 * Update Pending Document Analysis Template For Promotion Review
 *
 * Version a pending review resource without closing or superseding its request.
 */
export const updatePendingDocumentAnalysisTemplateForPromotionReviewMutation = (options?: Partial<Options<UpdatePendingDocumentAnalysisTemplateForPromotionReviewData>>): UseMutationOptions<UpdatePendingDocumentAnalysisTemplateForPromotionReviewResponse, UpdatePendingDocumentAnalysisTemplateForPromotionReviewError, Options<UpdatePendingDocumentAnalysisTemplateForPromotionReviewData>> => {
  const mutationOptions: UseMutationOptions<UpdatePendingDocumentAnalysisTemplateForPromotionReviewResponse, UpdatePendingDocumentAnalysisTemplateForPromotionReviewError, Options<UpdatePendingDocumentAnalysisTemplateForPromotionReviewData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePendingDocumentAnalysisTemplateForPromotionReview({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Cancel Promotion Request
 */
export const cancelPromotionRequestMutation = (options?: Partial<Options<CancelPromotionRequestData>>): UseMutationOptions<CancelPromotionRequestResponse, CancelPromotionRequestError, Options<CancelPromotionRequestData>> => {
  const mutationOptions: UseMutationOptions<CancelPromotionRequestResponse, CancelPromotionRequestError, Options<CancelPromotionRequestData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelPromotionRequest({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const getPromotionRequestQueryKey = (options: Options<GetPromotionRequestData>) => createQueryKey('getPromotionRequest', options);

/**
 * Get Promotion Request
 */
export const getPromotionRequestOptions = (options: Options<GetPromotionRequestData>) => queryOptions<GetPromotionRequestResponse, GetPromotionRequestError, GetPromotionRequestResponse, ReturnType<typeof getPromotionRequestQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await getPromotionRequest({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: getPromotionRequestQueryKey(options)
});

/**
 * Approve Promotion Request
 */
export const approvePromotionRequestMutation = (options?: Partial<Options<ApprovePromotionRequestData>>): UseMutationOptions<ApprovePromotionRequestResponse, ApprovePromotionRequestError, Options<ApprovePromotionRequestData>> => {
  const mutationOptions: UseMutationOptions<ApprovePromotionRequestResponse, ApprovePromotionRequestError, Options<ApprovePromotionRequestData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await approvePromotionRequest({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Reject Promotion Request
 */
export const rejectPromotionRequestMutation = (options?: Partial<Options<RejectPromotionRequestData>>): UseMutationOptions<RejectPromotionRequestResponse, RejectPromotionRequestError, Options<RejectPromotionRequestData>> => {
  const mutationOptions: UseMutationOptions<RejectPromotionRequestResponse, RejectPromotionRequestError, Options<RejectPromotionRequestData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await rejectPromotionRequest({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Revert Promotion Request
 *
 * Undo an approved promotion, restoring the resource's pre-promotion scope.
 *
 * Requires `delete_promotion_request` on the request's target scope (the
 * same authority as a hard delete). Only approved requests carrying a
 * captured snapshot can be reverted, and only while the resource still
 * sits at the scope this request promoted it to.
 */
export const revertPromotionRequestMutation = (options?: Partial<Options<RevertPromotionRequestData>>): UseMutationOptions<RevertPromotionRequestResponse, RevertPromotionRequestError, Options<RevertPromotionRequestData>> => {
  const mutationOptions: UseMutationOptions<RevertPromotionRequestResponse, RevertPromotionRequestError, Options<RevertPromotionRequestData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await revertPromotionRequest({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Hard Delete Promotion Request
 *
 * Permanently remove a promotion request row.
 *
 * Requires `delete_promotion_request` on the request's target scope;
 * granted to `project_admin` on `project_type.*` (and to project-scoped
 * admins via the `project.*: *` wildcard). Distinct from the soft-cancel
 * `DELETE /promotion-requests/{id}` endpoint: this erases the audit row
 * entirely. Works on pending/rejected/cancelled/superseded rows, but an
 * approved request must be reverted (`POST .../revert`) instead; deleting
 * it would orphan the applied scope swap.
 */
export const hardDeletePromotionRequestMutation = (options?: Partial<Options<HardDeletePromotionRequestData>>): UseMutationOptions<HardDeletePromotionRequestResponse, HardDeletePromotionRequestError, Options<HardDeletePromotionRequestData>> => {
  const mutationOptions: UseMutationOptions<HardDeletePromotionRequestResponse, HardDeletePromotionRequestError, Options<HardDeletePromotionRequestData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await hardDeletePromotionRequest({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

export const workosAuthorizeQueryKey = (options?: Options<WorkosAuthorizeData>) => createQueryKey('workosAuthorize', options);

/**
 * Workos Authorize
 */
export const workosAuthorizeOptions = (options?: Options<WorkosAuthorizeData>) => queryOptions<WorkosAuthorizeResponse, WorkosAuthorizeError, WorkosAuthorizeResponse, ReturnType<typeof workosAuthorizeQueryKey>>({
  queryFn: async ({ queryKey, signal }) => {
    const { data } = await workosAuthorize({
      ...options,
      ...queryKey[0],
      signal,
      throwOnError: true
    });
    return data;
  },
  queryKey: workosAuthorizeQueryKey(options)
});

/**
 * Workos Callback
 */
export const workosCallbackMutation = (options?: Partial<Options<WorkosCallbackData>>): UseMutationOptions<WorkosCallbackResponse, WorkosCallbackError, Options<WorkosCallbackData>> => {
  const mutationOptions: UseMutationOptions<WorkosCallbackResponse, WorkosCallbackError, Options<WorkosCallbackData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await workosCallback({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Workos Refresh
 */
export const workosRefreshMutation = (options?: Partial<Options<WorkosRefreshData>>): UseMutationOptions<WorkosRefreshResponse, WorkosRefreshError, Options<WorkosRefreshData>> => {
  const mutationOptions: UseMutationOptions<WorkosRefreshResponse, WorkosRefreshError, Options<WorkosRefreshData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await workosRefresh({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};

/**
 * Workos Logout
 */
export const workosLogoutMutation = (options?: Partial<Options<WorkosLogoutData>>): UseMutationOptions<WorkosLogoutResponse, WorkosLogoutError, Options<WorkosLogoutData>> => {
  const mutationOptions: UseMutationOptions<WorkosLogoutResponse, WorkosLogoutError, Options<WorkosLogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await workosLogout({
        ...options,
        ...fnOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
